(function() {
    'use strict';

    angular
        .module('quilinkApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'duScroll',
            'angularMoment',
            'angular.filter',
            'cgBusy',
            'chart.js',
            'ds.objectDiff',
            'angular-clipboard'
        ])
        .config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
            cfpLoadingBarProvider.spinnerTemplate = '';
          }])
        .config(['ChartJsProvider', function (ChartJsProvider) {
            // Configure all charts
            ChartJsProvider.setOptions({
                colors: ['#97BBCD', '#DCDCDC', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'],
                responsive: false
            });
        }])
        .run(run)
        .value('duScrollBottomSpy', true) // make the last du-scrollspy link active when scroll reaches page/container bottom
        .value('cgBusyDefaults',{
          message:'Loading Stuff',
          templateUrl: 'cgbusy.html'
        });

    run.$inject = ['stateHandler', '$rootScope', '$state', 'amMoment'];

    function run(stateHandler, $rootScope, $state, amMoment) {
        stateHandler.initialize();
        amMoment.changeLocale('fr', {
            relativeTime : {
                future: "dans %s",
                past:   "il y a %s",
                s:  "quelques secondes",
                ss : "%d secondes",
                m:  "une minute",
                mm: "%d minutes",
                h:  "une heure",
                hh: "%d heures",
                d:  "un jour",
                dd: "%d jours",
                M:  "un mois",
                MM: "%d mois",
                y:  "un an",
                yy: "%d ans"
            }
        });

        $rootScope.$on('$stateChangeStart', function (evt, to, params) {
            if (to.redirectTo) {
                evt.preventDefault();
                $state.go(to.redirectTo, params, {location: 'replace'});
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('whoswho', {
            parent: 'app',
            url: '/whoswho',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL']
            },
            views: {
                'content@': {
                    templateUrl: 'app/whoswho/whoswho.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('whoswho-map', {
            parent: 'whoswho',
            url: '/whoswho-map?page&sort',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL'],
                pageTitle: 'Axenteev | Who\s Who'
            },
            views: {
                'content@whoswho': {
                    templateUrl: 'app/whoswho/map/whoswho-map.html',
                    controller: 'WhoswhoMapController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        })

        .state('whoswho-map.message-libre', {
            parent: 'whoswho-map',
            url: '/message-libre/{userId}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message-libre/message-libre-dialog.html',
                    controller: 'MessageLibreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Whoswho', function(Whoswho) {
                            return Whoswho.getUser({userId : $stateParams.userId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('whoswho-map', null, { reload: false });
                }, function() {
                    $state.go('whoswho-map');
                });

            }]
        })
       ;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('WhoswhoMapController', WhoswhoMapController);

    WhoswhoMapController.$inject = ['Principal', 'Whoswho', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'EquipeCommerciale', 'Picture'];

    function WhoswhoMapController(Principal, Whoswho, ParseLinks, AlertService, $state, pagingParams, paginationConstants, EquipeCommerciale, Picture) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.persons = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.ec;
        vm.firstLetter = firstLetter;
        vm.geoJson;
        vm.loadAll();
        vm.flyToPerson = flyToPerson;
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            EquipeCommerciale.getByEmail({email: account.email}, function(result) {
                vm.ec = result;
            });
        });

        function loadAll () {
            Whoswho.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            Whoswho.queryMap({}, onSuccessMap, onErrorMap);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.page = pagingParams.page;
            vm.persons = data;
            vm.persons.forEach(function(p) {
                loadPicture(p);
            });
        }

        function onErrorMap(error) {
            AlertService.error(error.data.message);
        }


        function onSuccessMap(data) {
            vm.geoJson = data;
            loadMap(vm.geoJson);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        function clear () {
            vm.user = {
                id: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') + ', ignoreCase'];
            if (vm.predicate !== 'lastName') {
                result.push('lastName');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function firstLetter(name) {
            return name && name.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('æ', 'ae').charAt(0).toUpperCase();
        }

        function flyToPerson(personToFly) {
            var feature = vm.geoJson.features.find(function(el) {
                return el.properties.id === personToFly.user.id;
            })
            flyTo(feature.geometry.coordinates[0], feature.geometry.coordinates[1], feature.properties.message);
        }

        function loadPicture(person){
            if (person.profile && person.profile.pictureContentType){
                Picture.getProfilePicture(person.profile.id).then(function (response) {
                    person.profile.picture=response;
                }, function (response) {
                });
            }
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('whoswho-list', {
            parent: 'whoswho',
            url: '/whoswho-list?page&sort',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL'],
                pageTitle: 'Axenteev | Who\s Who'
            },
            views: {
                'content@whoswho': {
                    templateUrl: 'app/whoswho/list/whoswho-list.html',
                    controller: 'WhoswhoListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('WhoswhoListController', WhoswhoListController);

    WhoswhoListController.$inject = ['Principal', 'User', 'Whoswho', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'EquipeCommerciale'];

    function WhoswhoListController(Principal, User, Whoswho, ParseLinks, AlertService, $state, pagingParams, paginationConstants, EquipeCommerciale) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.sales = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.ec;
        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            EquipeCommerciale.getByEmail({email: account.email}, function(result) {
                vm.ec = result;
            });
        });

        function loadAll () {
            Whoswho.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.page = pagingParams.page;
            vm.sales = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('super-loop', {
            parent: 'app',
            url: '/super-loop?isCompany&collectivitySize&city&sector&companyStatus',
            data: {
                pageTitle: 'Axenteev | Super loop',
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/super-loop/super-loop.html',
                    controller: 'SuperLoopController',
                    controllerAs: 'vm'
                }
            },
            params: {
                'collectivitySize': null,
                'city': null,
                'sector': null,
                'companyStatus': null,
                'isCompany': null
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SuperLoopController', SuperLoopController);

    SuperLoopController.$inject = ['Collectivity', 'Company', 'CollectivitySize', 'CompanyStatus', 'Sector', 'Profile', 'Search'];

    function SuperLoopController(Collectivity, Company, CollectivitySize, CompanyStatus, Sector, Profile, Search) {
        var vm = this;

        vm.mode = null;
        vm.companyStatus = null;
        vm.sector = null;
        vm.collectivitySize = null;
        vm.keyword = '';
        vm.companyStatuses = [];
        vm.sectors = [];
        vm.collectivitySizes = [];
        vm.results = [];
        vm.search = search;

        CollectivitySize.query(storeCollectivitySizes);
        CompanyStatus.query(storeCompanyStatuses);
        Sector.query(storeSectors);
        search();

        function search() {
            switch (vm.mode) {
                case 'company':
                    if (vm.keyword) {
                        Company.search({
                            query: vm.keyword,
                            companyStatusId: vm.companyStatus,
                            sectorId: vm.sector
                        }, function (companies) {
                            vm.results = companies.map(function (el) {
                                el.searchType = 'company';
                                return el;
                            });
                        });
                    } else {
                        Company.query({
                            page: 0,
                            count: 30,
                            companyStatusId: vm.companyStatus,
                            sectorId: vm.sector
                        }, function (companies) {
                            vm.results = companies.map(function (el) {
                                el.searchType = 'company';
                                return el;
                            });
                        });
                    }
                    break;
                case 'collectivity':
                    if (vm.keyword) {
                        Collectivity.search({
                            query: vm.keyword,
                            cityId: vm.city,
                            collectivitySizeId: vm.collectivitySize
                        }, function (collectivities) {
                            vm.results = collectivities.map(function (el) {
                                el.searchType = 'collectivity';
                                return el;
                            });
                        });
                    } else {
                        Collectivity.query({
                            page: 0,
                            size: 30,
                            cityId: vm.city,
                            collectivitySizeId: vm.collectivitySize
                        }, function (collectivities) {
                            vm.results = collectivities.map(function (el) {
                                el.searchType = 'collectivity';
                                return el;
                            });
                        });
                    }
                    break;
                case 'profile':
                    if (vm.keyword) {
                        Profile.search({
                            query: vm.keyword
                        }, function (profiles) {
                            vm.results = profiles.map(function (el) {
                                el.searchType = 'profile';
                                return el;
                            });
                        });
                    } else {
                        Profile.query({
                            page: 0,
                            cityId: vm.city,
                            collectivitySizeId: vm.collectivitySize,
                            size: 30
                        }, function (profiles) {
                            vm.results = profiles.map(function (el) {
                                el.searchType = 'profile';
                                return el;
                            });
                        });
                    }
                    break;
                case null:
                    if (vm.keyword) {
                        Search.query(vm.keyword).then(function (response) {
                            var data = response.data;
                            var collectivities = data.collectivities.map(function (el) {
                                el.searchType = 'collectivity';
                                return el;
                            });
                            var companies = data.companies.map(function (el) {
                                el.searchType = 'company';
                                return el;
                            });
                            var profiles1 = data.profiles['1'].map(function (el) {
                                el.name = el.firstName + ' ' + el.lastName;
                                el.searchType = 'profile';
                                return el;
                            });
                            var profiles2 = data.profiles['2'].map(function (el) {
                                el.name = el.firstName + ' ' + el.lastName;
                                el.searchType = 'profile';
                                return el;
                            });
                            var profiles3 = data.profiles['3'].map(function (el) {
                                el.name = el.firstName + ' ' + el.lastName;
                                el.searchType = 'profile';
                                return el;
                            });
                            vm.results = profiles1
                                .concat(profiles2)
                                .concat(profiles3)
                                .concat(companies)
                                .concat(collectivities)
                        });
                    } else {
                        vm.results = null;
                    }
                    break;
            }
        }

        function storeCollectivitySizes(collectivitySizes) {
            vm.collectivitySizes = collectivitySizes;
        }

        function storeCompanyStatuses(companyStatuses) {
            vm.companyStatuses = companyStatuses;
        }

        function storeSectors(sectors) {
            vm.sectors = sectors;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:email', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: 'api/users/:email/email',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'deactivate': {
                method: 'GET',
                url: 'api/users/:email/deactivate'

            },
            'activate': {
                method: 'GET',
                url: 'api/users/:email/activate'

            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{
                method:'DELETE',
                url: 'api/users/:email/email'
            },
            'importContacts':{
                method:'POST',
                url: 'api/import/profiles/linkedin',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            },
            'mySuperior': {
                method: 'GET',
                isArray: false,
                url: 'api/users/mySuperior'
            },
            'sameSuperior': {
                method: 'GET',
                isArray: true,
                url: 'api/users/sameSuperior'
            },
            'getProfilePicture': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    var profile = data[0];
                    return ['data:' + profile.pictureContentType + ';base64,' + profile.picture];
                },
                url: 'api/profiles?email=:email'
            },
            'search': {
                method: 'GET',
                url: 'api/users/search/:query',
                isArray: true
            },

            'updateMyEquipeCommerciale':{
                method:'PUT',
                url: 'api/users/updateMyEquipeCommerciale',
            },
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Linkedin', Linkedin);

    Linkedin.$inject = ['$resource'];

    function Linkedin ($resource) {
        return $resource('api/import/profiles/linkedin', {}, {
            importContacts: {
                method: "POST",
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Suggestions', Suggestions);

    Suggestions.$inject = ['$http'];

    function Suggestions($http) {

        var service = {
            get : get
        };

        return service;

        function get(count) {
            if (!angular.isNumber(count)) {
                count = 8;
            }
            return $http.get('api/profiles/suggestions/' + count).then(function (res) {
                if (res && res.data) {
                    return res.data;
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Picture', Picture);

    Picture.$inject = ['$http'];

    function Picture($http) {

        var service = {
            getProfilePicture : getProfilePicture, getProfilePictureByEmail : getProfilePictureByEmail
        };
        return service;

        function getProfilePicture(id) {
            return $http.get('api/profiles/'+id+'/picture',{ignoreLoadingBar: true}).then(function (res) {
                if (res && res.data) {
                    return res.data;
                }
            });
        }

        function getProfilePictureByEmail(email) {
            return $http.get('api/profiles/email/'+email+'/picture',{ignoreLoadingBar: true}).then(function (res) {
                if (res && res.data) {
                    return res.data;
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('ModerationOrganisation', ModerationOrganisation);

        ModerationOrganisation.$inject = ['$resource'];

    function ModerationOrganisation ($resource) {
        var service = $resource('api/moderation/organisation/:id', {}, {
            'queryCompany': {method: 'GET', isArray: true, url: '/api/moderation/organisation/company'},
            'queryCollectivity': {method: 'GET', isArray: true, url: '/api/moderation/organisation/collectivity'},
            'get': {
                method: 'GET',
                url: 'api/moderation/organisation/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'mupdate': { 
                method:'POST',
                url: '/api/moderation/organisation/update'
            },
            'msave': { 
                method:'POST',
                url: '/api/moderation/organisation/add'
            },
            
            'reject':{
                method:'DELETE',
                url: 'api/moderation/organisation/:id/reject'
            },
            'createAndApprove': { 
                method:'POST',
                url: '/api/moderation/organisation/:id/createAndApprove'
            },
            'updateAndApprove': { 
                method:'PUT',
                url: '/api/moderation/organisation/:id/updateAndApprove'
            },
            'directCreateAndApprove': { 
                method:'POST',
                url: '/api/moderation/organisation/directCreateAndApprove'
            },
            'directUpdateAndApprove': { 
                method:'PUT',
                url: '/api/moderation/organisation/directUpdateAndApprove'
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'Profile'];

    function Principal ($q, Account, Profile) {
        var _identity,
            _profile,
            _hasProfile = false,
            _hasError = false,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            profile: profile,
            hasProfile: hasProfile,
            hasError: hasError,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity, profile) {
            _identity = identity;
            _profile = profile;
            _authenticated = identity !== null;
            _hasProfile = profile !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                _hasError = false;
                deferred.resolve(_identity);
            }
        }

        function profile(forceIdentity, forceProfile) {
            var deferred = $q.defer();

            if (forceProfile === true) {
                _profile = undefined;
            }

            // check and see if we have retrieved the profile data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_profile)) {
                deferred.resolve(_profile);
                return deferred.promise;
            }

            // retrieve the identity data from the server and then get the profile.
            identity(forceIdentity)
                .then(getIdentityThen)
                .catch(getIdentityCatch);

            return deferred.promise;

            function getIdentityThen (account) {
                if (account) {
                    Profile.myProfile().$promise
                        .then(getProfileThen)
                        .catch(getProfileCatch);
                } else {
                    getProfileCatch();
                }
            }

            function getIdentityCatch () {
                _profile = null;
                _hasProfile = false;
                _hasError = false;
                deferred.resolve(_profile);
            }

            function getProfileThen(_profile) {
                if (_profile) {
                    _hasProfile = true;
                    _hasError = false;
                    deferred.resolve(_profile);
                } else {
                    _profile = null;
                    _hasError = false;
                    _hasProfile = false;
                    deferred.resolve(_profile);
                }
            }

            function getProfileCatch () {
                _profile = null;
                _hasProfile = false;
                deferred.resolve(_profile);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function hasProfile() {
            return _hasProfile;
        }

        function hasError() {
            return _hasError;
        }


        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', '$uibModalStack'];
    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, $uibModalStack) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            loginWithKey: loginWithKey,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (forceIdentity, forceProfile) {
            var authReturn = Principal.profile(forceIdentity, forceProfile).then(authThen);

            return authReturn;

            function authThen (profile) {
                var isAuthenticated = Principal.isAuthenticated();
                var hasProfile = Principal.hasProfile();
                var hasError = Principal.hasError();
                // a user without profile is redirected to the profile-init page to create its own
                if (isAuthenticated) {
                    if (!hasProfile) {
                        $uibModalStack.dismissAll();
                        if (hasError) {
                            if ($rootScope.toState.name !== 'error') {
                                $state.go('error', {}, {reload:true});
                            }
                        } else {
                            if ($rootScope.toState.name === 'home' ) {
                                $state.go('profile-init', {}, {reload:true});
                                //AuthServerProvider.logout();
                                //Principal.authenticate(null, null);
                                // $state.go('error', {}, {reload:true});
                            } else if ($rootScope.toState.name !== 'login' && $rootScope.toState.name !== 'profile-init') {
                                $state.go('login', {}, {reload:true});
                            }
                        }
                    } else {
                        if ($rootScope.toState.name === 'profile-init') {
                            $state.go('home', {}, {reload:true});
                        }
                    }
                }

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home', {}, {reload:true});
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        /*
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                        */
                        $state.go('accessdenied');
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                authorize(true, true);
                Principal.profile(true, true).then(function (profile) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithKey(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.loginWithKey(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null, null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            loginWithKey: loginWithKey,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).then(authenticateSuccess);

            function authenticateSuccess (response) {
                var headers = response.headers;
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithKey (credentials) {

            var data = {
                key: credentials.key
            };
            return $http.post('api/authenticateWithKey', data).then(authenticateSuccess);

            function authenticateSuccess (response) {
                var headers = response.headers;
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }


        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
            $http.post('api/logout', {}).then(function(response){
                console.log("Session invalidated");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            },
            'getByKey': { method: 'GET', params: {}, isArray: false, url: 'api/account/key',
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Search', Search);

    Search.$inject = ['$http'];

    function Search($http) {

        var service = {
            query : query
        };

        return service;

        function query(q) {
            if (!angular.isString(q) || !q) {
                return;
            }
            return $http.get('api/search/' + q);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('quilist', {
            parent: 'app',
            url: '/database',
            data: {
                pageTitle: 'Axenteev | La database',
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/quilist/quilist.html',
                    controller: 'QuilistController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('QuilistController', QuilistController);

    QuilistController.$inject = ['$state', '$timeout', 'Company', 'Collectivity', 'AlertService', 'paginationConstants'];

    function QuilistController($state, $timeout, Company, Collectivity, AlertService, paginationConstants) {
        var vm = this;

        vm.companies = [];
        vm.collectivities = [];
        vm.companiesActive = false;
        vm.collectivitiesActive = false;
        vm.searchTextCompanies = '';
        vm.searchTextCollectivities = '';
        vm.pageCompanies = 1;
        vm.pageCollectivities = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.searchCompanies = searchCompanies;
        vm.searchCollectivities = searchCollectivities;
        vm.loadMoreCompanies = loadMoreCompanies;
        vm.loadMoreCollectivities = loadMoreCollectivities;
        vm.choose = choose;
        vm.firstLetter = firstLetter;

        init();

        // Prevent inbox pop-up from window scrolling
        $timeout(function () {
            angular.element('#company-container').bind('DOMMouseScroll mousewheel', preventScrollPropagation);
            angular.element('#collectivity-container').bind('DOMMouseScroll mousewheel', preventScrollPropagation);
        });

        function init() {
            Company.query({
                page: 0,
                size: vm.itemsPerPage
            }, onCompaniesSuccess, onFetchError);

            Collectivity.query({
                page: 0,
                size: vm.itemsPerPage
            }, onCollectivitiesSuccess, onFetchError);

            function onCompaniesSuccess(data, headers) {
                data = data.filter(function(val) {
                    return val.nameNormalized !== 'independant';
                });
                vm.companies = data;
                vm.hasNextPageCompanies = headers('X-Has-Next-Page') === "true";
            }
            function onCollectivitiesSuccess(data, headers) {
                vm.collectivities = data;
                vm.hasNextPageCollectivities = headers('X-Has-Next-Page') === "true";
            }
        }

        function searchCompanies() {
            vm.pageCompanies = 1;
            if (vm.searchTextCompanies) {
                Company.search({
                    query: vm.searchTextCompanies,
                    page: vm.pageCompanies - 1,
                    size: vm.itemsPerPage
                }, onCompaniesSuccess, onFetchError);
            } else {
                Company.query({
                    page: vm.pageCompanies - 1,
                    size: vm.itemsPerPage
                }, onCompaniesSuccess, onFetchError);
            }

            function onCompaniesSuccess(data, headers) {
                data = data.filter(function(val) {
                    return val.nameNormalized !== 'independant';
                });
                vm.companies = data;
                vm.hasNextPageCompanies = headers('X-Has-Next-Page') === "true";
            }
        }

        function searchCollectivities() {
            vm.pageCollectivities = 1;
            if (vm.searchTextCollectivities) {
                Collectivity.search({
                    query: vm.searchTextCollectivities,
                    page: vm.pageCollectivities - 1,
                    size: vm.itemsPerPage
                }, onCollectivitiesSuccess, onFetchError);
            } else {
                Collectivity.query({
                    page: vm.pageCollectivities - 1,
                    size: vm.itemsPerPage
                }, onCollectivitiesSuccess, onFetchError);
            }

            function onCollectivitiesSuccess(data, headers) {
                vm.collectivities = data;
                vm.hasNextPageCollectivities = headers('X-Has-Next-Page') === "true";
            }
        }

        function loadMoreCompanies() {
            vm.pageCompanies += 1;

            if (vm.searchTextCompanies) {
                Company.search({
                    query: vm.searchTextCompanies,
                    page: vm.pageCompanies - 1,
                    size: vm.itemsPerPage
                }, onCompaniesSuccess, onFetchError);
            } else {
                Company.query({
                    page: vm.pageCompanies - 1,
                    size: vm.itemsPerPage
                }, onCompaniesSuccess, onFetchError);
            }

            function onCompaniesSuccess(data, headers) {
                data = data.filter(function(val) {
                    return val.nameNormalized !== 'independant';
                });
                vm.companies = vm.companies.concat(data);
                vm.hasNextPageCompanies = headers('X-Has-Next-Page') === "true";
            }
        }

        function loadMoreCollectivities() {
            vm.pageCollectivities += 1;

            if (vm.searchTextCollectivities) {
                Collectivity.search({
                    query: vm.searchTextCollectivities,
                    page: vm.pageCollectivities - 1,
                    size: vm.itemsPerPage
                }, onCollectivitiesSuccess, onFetchError);
            } else {
                Collectivity.query({
                    page: vm.pageCollectivities - 1,
                    size: vm.itemsPerPage
                }, onCollectivitiesSuccess, onFetchError);
            }

            function onCollectivitiesSuccess(data, headers) {
                vm.collectivities = vm.collectivities.concat(data);
                vm.hasNextPageCollectivities = headers('X-Has-Next-Page') === "true";
            }
        }

        function choose(sectionName) {
            vm.companiesActive = (sectionName === 'companies');
            vm.collectivitiesActive = (sectionName === 'collectivities');
        }

        function firstLetter(name) {
            return name && name.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('æ', 'ae').charAt(0).toUpperCase();
        }

        function onFetchError(error) {
            AlertService.error(error.data.message);
        }

        function preventScrollPropagation(ev) {
            var $this = $(this),
                scrollTop = this.scrollTop,
                scrollHeight = this.scrollHeight,
                height = $this.innerHeight(),
                delta = (ev.type == 'DOMMouseScroll' ?
                ev.originalEvent.detail * -40 :
                    ev.originalEvent.wheelDelta),
                up = delta > 0;

            var prevent = function() {
                ev.stopPropagation();
                ev.preventDefault();
                ev.returnValue = false;
                return false;
            };

            if (!up && -delta > scrollHeight - height - scrollTop) {
                // Scrolling down, but this will take us past the bottom.
                $this.scrollTop(scrollHeight);
                return prevent();
            } else if (up && delta > scrollTop) {
                // Scrolling up, but this will take us past the top.
                $this.scrollTop(0);
                return prevent();
            }
        }
    }
})();

window.global = window;

(function() {
    'use strict';

    angular
    .module('quilinkApp')
    .factory('Oauth2LoginService', Oauth2LoginService);

    Oauth2LoginService.$inject = ['$resource'];

    function Oauth2LoginService ($resource) {
        var resourceUrl =  'api/oauth2';

        return $resource(resourceUrl, {}, {
          'logout': {
            method: 'POST',
            url: 'api/oauth2/logout'
        }
    });
}
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('network', {
                parent: 'app',
                url: '/my-network',
                redirectTo: 'my-connections',
                data: {
                    pageTitle: 'Axenteev | Mon Network',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/network/network.html',
                        controller: 'NetworkController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('my-connections', {
                parent: 'network',
                url: '/connections',
                data: {
                    pageTitle: 'Axenteev | Mon Network',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/connections/my-connections.html'
                    }
                }
            })
            .state('contributions-menu', {
                parent: 'network',
                url: '/contributions',
                redirectTo: 'my-contributions-profile',
                data: {
                    pageTitle: 'Axenteev | Mes contributions',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/contributions/contributions-menu.html'
                    }
                }
            })
            .state('contributions-pending-profile', {
                parent: 'network',
                url: '/contributions-pending',
                data: {
                    pageTitle: 'Axenteev | Mes contributions à valider',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/contributions-pending/my-contributions-pending-profile.html'
                    }
                }
            })
            .state('homonyms-pending-profile', {
                parent: 'network',
                url: '/homonyms-pending',
                data: {
                    pageTitle: 'Axenteev | Mes homonymes à valider',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/homonyms-pending/my-homonyms-pending-profile.html'
                    }
                }
            })
            .state('my-contributions-profile', {
                parent: 'contributions-menu',
                url: '/all',
                data: {
                    pageTitle: 'Axenteev | Mes contributions de profile',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@contributions-menu': {
                        templateUrl: 'app/network/contributions/my-contributions-profile.html'
                    }
                }
            })
            .state('my-contributions-organisation', {
                parent: 'contributions-menu',
                url: '/all',
                data: {
                    pageTitle: "Axenteev | Mes contributions d'organisation",
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@contributions-menu': {
                        templateUrl: 'app/network/contributions/my-contributions-organisation.html'
                    }
                }
            })
            .state('contributions-later', {
                parent: 'contributions-menu',
                url: '/later',
                data: {
                    pageTitle: 'Axenteev | Contributions à modifier plus tard',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@contributions-menu': {
                        templateUrl: 'app/network/contributions/contributions-later.html'
                    }
                }
            })
            .state('internal-network', {
                parent: 'network',
                url: '/sales',
                redirectTo: 'registered-sales',
                data: {
                    pageTitle: 'Axenteev | Mon Internal Network',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/internal-network/sales-menu.html'
                    }
                }
            })
            .state('registered-sales', {
                parent: 'internal-network',
                url: '/registered',
                data: {
                    pageTitle: 'Axenteev | Mes commerciaux enregistrés',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@internal-network': {
                        templateUrl: 'app/network/internal-network/registered-sales.html'
                    }
                }
            })
            .state('invited-sales', {
                parent: 'internal-network',
                url: '/invited',
                data: {
                    pageTitle: 'Axenteev | Mes commerciaux invités',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@internal-network': {
                        templateUrl: 'app/network/internal-network/invited-sales.html'
                    }
                }
            })
            .state('archived-sales', {
                parent: 'internal-network',
                url: '/archived',
                data: {
                    pageTitle: 'Axenteev | Mon commerciaux archivés',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@internal-network': {
                        templateUrl: 'app/network/internal-network/archived-sales.html'
                    }
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Network', Network);

    Network.$inject = ['$resource'];

    function Network($resource) {
        var service = $resource('api/connexions/network', {}, {
            'getList': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/network?size=100'
            },
            'getListConnuParConsultant': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/network/connuParConsultant?size=200&organizationId=:organizationId'
            },
            'networkSearch': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/network/search/:query'
            },
            'getByOrganizationId': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions?organizationId=:organizationId'
            },
            'getInternalNetwork': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/internalnetwork'
            },
            'getInternalNetworkOrganisation': {
                method: 'GET',
                isArray: true,
                url: 'api/connexions/internalnetworkorganisation?size=200&organizationId=:organizationId'
            },


        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('NetworkController', NetworkController);

    NetworkController.$inject = ['$scope', '$state', 'Network', 'Principal', 'Connexion', 'Picture', 'Dashboard', 'Profile', 'Organisation', 'DoublonProfile'];

    function NetworkController($scope, $state, Network, Principal, Connexion, Picture, Dashboard, Profile, Organisation, DoublonProfile) {
        var vm = this;
        vm.hide=true;
        vm.isOpen = false;
        vm.accordionArray = [];
        vm.profile = null;
        vm.profileId = null;
        vm.people = [];
        vm.connections = [];

        vm.contributionsLater = [];
        vm.registeredSales = [];
        vm.invitedSales = [];
        vm.archivedSales = [];
        vm.searchText = '';
        vm.pageConnexion = 0;
        vm.hasNextPageConnexion = true;
        vm.connexionsParPage = 20;
        vm.sortingTypes = [{
            label: 'Nom',
            value: 'target.lastName'
        }, {
            label: 'Indice',
            value: 'grade'
        }];
        vm.sortBy = vm.sortingTypes[0];
        vm.search = search;
        vm.updateGrade = updateGrade;
        vm.connect = connect;
        vm.loadMoreConnexions = loadMoreConnexions;
        vm.networkCount = 0;
        vm.networkCountWithGrade3 = 0;


        // Les deux sont liés
        vm.contributionsProfileMap = new Map();
        vm.contributionsProfileValues =  [];

        vm.pageContributionProfile = 0;
        vm.hasNextPageContributionsProfile = true;
        vm.contributionsProfileParPage = 20;
        vm.loadMoreContributionsProfile = loadMoreContributionsProfile;
        vm.busyLoadingContributionsProfile = false;

        vm.contributionsOrganisation= [];
        vm.pageContributionOrganisation = 0;
        vm.hasNextPageContributionsOrganisation = true;
        vm.contributionsOrganisationParPage = 20;
        vm.loadMoreContributionsOrganisation= loadMoreContributionsOrganisation;
        vm.busyLoadingContributionsOrganisation = false;
        vm.busyLoadingConnexions = false;
        vm.aConnecterCount = 0;


        vm.pendingContributionsProfile = [];
        vm.pagePendingContributionProfile = 0;
        vm.hasNextPagePendingContributionsProfile = true;
        vm.pendingContributionsProfileParPage = 20;
        vm.loadMorePendingContributionsProfile = loadMorePendingContributionsProfile;
        vm.busyLoadingPendingContributionsProfile = false;
        vm.myPendingContributionsCount = 0;

        vm.createProfileFromPendingContribution = createProfileFromPendingContribution;
        vm.deletePendingContribution = deletePendingContribution;



        vm.pendingHomonymsProfile = [];
        vm.pagePendingHomonymProfile = 0;
        vm.hasNextPagePendingHomonymsProfile = true;
        vm.pendingHomonymsProfileParPage = 20;
        vm.loadMorePendingHomonymsProfile = loadMorePendingHomonymsProfile;
        vm.busyLoadingPendingHomonymsProfile = false;
        vm.myPendingHomonymsCount = 0;

        vm.createProfileFromPendingHomonym = createProfileFromPendingHomonym;
        vm.deletePendingHomonym = deletePendingHomonym;

        vm.connectProfileFromPendingHomonym = connectProfileFromPendingHomonym;

        vm.deleteAQualifierProfile = deleteAQualifierProfile;

        vm.memePersonne = memePersonne;

        // Connections, people
        $scope.networkBusyPromise =
        Principal.profile().then(function (profile) {
            vm.profile = profile;
            if (profile)
                vm.profileId = profile.id;
        }).then(function(result) {
            return Dashboard.get();
        }).then(function (data) {
            vm.networkCount = data.myNetwork;
            vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
            vm.aConnecterCount = data.aConnecter;
            vm.myPendingContributionsCount = data.pendingContributions;
            vm.myPendingHomonymsCount = data.pendingHomonyms;
        }).then(function (data) {
            //return loadMoreConnexions(true);
        }).then(function (data) {
           //return loadMoreContributions(true);
        }).then(function (data) {
            // registeredSales();
            // invitedSales();
            // archivedSales();
        }).then(function(result) {
            vm.hide = false;
        });



        // Sales
        // Director.querySales({}).$promise.then(function (sales) {
        //     vm.sales = sales;
        // });

        function updateGrade(profile, newGrade, refreshMonReseau) {
            vm.connecting = true;
            var connection = findConnectionById(profile.connectionId);
            connection.grade = newGrade;
            Connexion.update(connection, function (res) {
                profile.grade = newGrade;
                Dashboard.get().then(function (data) {
                    vm.networkCount = data.myNetwork;
                    vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                    vm.aConnecterCount = data.aConnecter;
                    vm.myPendingContributionsCount = data.pendingContributions;
                    vm.myPendingHomonymsCount = data.pendingHomonyms;
                });
                vm.contributionsProfileMap.delete(profile.id);
                vm.contributionsProfileValues = Array.from(vm.contributionsProfileMap.values());
                $scope.$emit('contributionsProfile:updated')

                // Refresh de l'onglet réseau lorsqu'on est sur les autres onglets
                if (refreshMonReseau) {
                    loadMoreConnexions(true);
                }
                vm.connecting = false;
                //vm.loadMoreContributionsProfile(true);
            });
        }

        vm.connecting = false;

        function connect(profile, grade, index) {
            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            var connection = findConnectionById(profile.connectionId);

            if (connection){
                updateGrade(profile, grade, true);
            } else {
                insertGrade(profile, grade);
            }
        }


        function connectFromPendingHomonym(profile, grade) {
            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            insertGrade(profile, grade);

        }

        function insertGrade(profile, grade){
            vm.profileToConnect = profile.id;
            var connection = {
                creator: {
                    id: vm.profileId
                },
                grade: grade,
                target: {
                    id: profile.id
                }
            };
            Connexion.save(connection, function (res) {
                profile.grade = res.grade;
                profile.connectionId = res.id;
                vm.connections.push(res);
                Dashboard.get().then(function (data) {
                    vm.networkCount = data.myNetwork;
                    vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                    vm.aConnecterCount = data.aConnecter;
                    vm.myPendingContributionsCount = data.pendingContributions;
                    vm.myPendingHomonymsCount = data.pendingHomonyms;
                });
                vm.contributionsProfileMap.delete(profile.id);
                vm.contributionsProfileValues = Array.from(vm.contributionsProfileMap.values());
                $scope.$emit('contributionsProfile:updated')
                loadMoreConnexions(true);
                vm.connecting = false;

            }, angular.noop);
        }

        function findConnectionById(id) {
            var connection = null;
            for (var i = 0; i < vm.connections.length; i++) {
                if (vm.connections[i].id === id) {
                    connection = vm.connections[i];
                }
            }
            return connection;
        }

        function search() {
            vm.pageConnexion = 0;
            if (!vm.searchText) {
                loadMoreConnexions(true);
            } else {
                Network.networkSearch({
                    page: vm.pageConnexion,
                    size: vm.connexionsParPage,
                    query: vm.searchText,
                    sort: vm.sortBy.value
                }, function (connections) {
                    vm.people = [];
                    vm.connections = [];
                    connections.forEach(function (connection) {
                        var people;
                        if (connection.target.id === vm.profileId) {
                            people = connection.creator;
                        } else {
                            people = connection.target;
                        }
                        people.grade = connection.grade;
                        people.connectionId = connection.id;
                        loadPicture(people);
                        vm.connections.push(connection);
                        vm.people.push(people);
                    });
                });
                vm.pageConnexion += 1;
            }
        }

        // Mon réseau
        function loadMoreConnexions(reset) {
            if (reset) vm.pageConnexion = 0;
            if (vm.busyLoadingConnexions) {
                return;
            }
            vm.busyLoadingConnexions = true;
            return Network.getList({
                page: vm.pageConnexion,
                size: vm.connexionsParPage,
                sort: vm.sortBy.value
            }, function (connections, headers) {
                if (reset) {
                    vm.people = [];
                    vm.connections = [];
                }
                vm.hasNextPageConnexion = headers('X-Has-Next-Page') === "true";
                connections.forEach(function (connection) {
                    var people;
                    if (connection.target.id === vm.profileId) {
                        people = connection.creator;
                    } else {
                        people = connection.target;
                    }
                    people.grade = connection.grade;
                    people.connectionId = connection.id;
                    loadPicture(people);
                    var existingConnection = findConnectionById(connection.id);
                    if (!existingConnection){
                        vm.connections.push(connection);
                        vm.people.push(people);
                    }

                });
                vm.pageConnexion += 1;
                vm.busyLoadingConnexions = false;
            }).$promise;

        }


        // A Qualifier/Connecter
        function loadMoreContributionsProfile(reset) {

            if (vm.busyLoadingContributionsProfile) {
                return;
            }
            vm.busyLoadingContributionsProfile = true;

            if (reset) vm.pageContributionProfile = 0;

            return Profile.aConnecter({
                page: vm.pageContributionProfile,
                size: vm.contributionsProfileParPage
            }, function (contributionsProfile, headers) {

                vm.hasNextPageContributionsProfile = headers('X-Has-Next-Page') === "true";
                if (reset) {
                    vm.contributionsProfileMap = new Map();
                    vm.contributionsProfileValues = Array.from(vm.contributionsProfileMap.values());

                }
                contributionsProfile.forEach(function (profile) {
                    loadPicture(profile);
                    vm.contributionsProfileMap.set(profile.id, profile);

                    // Alimentation de l'onglet connexion à partir des contribs
                    /*
                    if (profile.connectionId){
                        var connection = findConnectionById(profile.connectionId);
                        if (!connection){
                            var connection = {};
                            connection.target = profile;
                            connection.creator = vm.profile;
                            connection.grade = profile.grade;
                            connection.id = profile.connectionId;

                            var people;
                            if (connection.target.id === vm.profileId) {
                                people = vm.profile;
                            } else {
                                people = profile;
                            }
                            people.grade = profile.grade;
                            people.connectionId = profile.connectionId;
                            loadPicture(people);
                            vm.connections.push(connection);
                            vm.people.push(people);
                        }
                    }
                    */


                });
                vm.contributionsProfileValues = Array.from(vm.contributionsProfileMap.values());
                vm.pageContributionProfile += 1;
                vm.busyLoadingContributionsProfile = false;
            }).$promise;
        }

        function loadMoreContributionsOrganisation(reset) {
            if (vm.busyLoadingContributionsOrganisation) {
                return;
            }
            vm.busyLoadingContributionsOrganisation = true;

            if (reset) vm.pageContributionOrganisation = 0;

            return Organisation.myContributions({
                page: vm.pageContributionOrganisation,
                size: vm.contributionsOrganisationParPage
            }, function (contributionsOrga, headers) {
                vm.hasNextPageContributionsOrganisation = headers('X-Has-Next-Page') === "true";
                if (reset) {
                    vm.contributionsOrganisation = [];
                }
                contributionsOrga.forEach(function (orga) {
                    vm.contributionsOrganisation.push(orga);
                });
                vm.pageContributionOrganisation += 1;
                vm.busyLoadingContributionsOrganisation = false;
            }).$promise;
        }



        function invitedSales() {
            var isDgOrAdmin = Principal.hasAnyAuthority(['ROLE_DG', 'ROLE_ADMIN']);
            if (vm.profile && isDgOrAdmin) {
                Connexion.allInternalNetworkDGInvited({}, function (users) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    users.forEach(function (user) {
                        vm.invitedSales.push(user);
                    });
                });
            }
            /*
            else if (vm.profile && !isDgOrAdmin) {
                Connexion.allInternalNetworkCommercial({}, function (connections) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            } else {
                Network.getList({
                    organisationId: vm.organisation.id
                }, function (connections) {
                    //var network = organisationNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            }
            */
        }


        function registeredSales() {
            var isDgOrAdmin = Principal.hasAnyAuthority(['ROLE_DG', 'ROLE_ADMIN']);
            if (vm.profile && isDgOrAdmin) {
                Connexion.allInternalNetworkDG({}, function (connections) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    connections.forEach(function (connection) {
                        var people;
                        if (connection.target.id === vm.profileId) {
                            people = connection.creator;
                        } else {
                            people = connection.target;
                        }

                        people.grade = connection.grade;
                        people.connectionId = connection.id;
                        people.creator = connection.creator;
                        loadPicture(people);
                        vm.registeredSales.push(people);
                    });
                });
            }
            /*
            else if (vm.profile && !isDgOrAdmin) {
                Connexion.allInternalNetworkCommercial({}, function (connections) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            } else {
                Network.getList({
                    organisationId: vm.organisation.id
                }, function (connections) {
                    //var network = organisationNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            }
            */
        }

        function archivedSales() {
            var isDgOrAdmin = Principal.hasAnyAuthority(['ROLE_DG', 'ROLE_ADMIN']);
            if (vm.profile && isDgOrAdmin) {
                Connexion.allInternalNetworkDGArchived({}, function (users) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    users.forEach(function (user) {
                        vm.archivedSales.push(user);
                    });
                });
            }
            /*
            else if (vm.profile && !isDgOrAdmin) {
                Connexion.allInternalNetworkCommercial({}, function (connections) {
                    //var network = internalNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            } else {
                Network.getList({
                    organisationId: vm.organisation.id
                }, function (connections) {
                    //var network = organisationNetwork(connections, myProfile.id);
                    //vm.people = network.people;
                    vm.registeredSales = connections;
                });
            }
            */
        }

        // A Valider (en attente de création, job non safe)
        function loadMorePendingContributionsProfile(reset) {
            if (vm.busyLoadingPendingContributionsProfile) {
                return;
            }
            vm.busyLoadingPendingContributionsProfile = true;

            if (reset) vm.pagePendingContributionProfile = 0;

            return DoublonProfile.myPendingContributions({
                page: vm.pagePendingContributionProfile,
                size: vm.pendingContributionsProfileParPage
            }, function (pendingContributionsProfile, headers) {

                vm.hasNextPagePendingContributionsProfile = headers('X-Has-Next-Page') === "true";
                if (reset) {
                    vm.pendingContributionsProfile = [];
                }
                pendingContributionsProfile.forEach(function (profile) {
                    loadPicture(profile);
                    vm.pendingContributionsProfile.push(profile);
                });
                vm.pagePendingContributionProfile += 1;
                vm.busyLoadingPendingContributionsProfile = false;
            }).$promise;
        }

        function deletePendingContribution(pendingContrib){
            DoublonProfile.deletePendingContribution({id: pendingContrib.id},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingContributionsProfile(true);
                });
        }

        function createProfileFromPendingContribution(pendingContrib, grade){
            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            DoublonProfile.createProfileFromPendingContribution({id: pendingContrib.id, grade:grade}, {},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingContributionsProfile(true);
                    vm.connecting = false;
                });
        }

        function loadMorePendingHomonymsProfile(reset) {
            if (vm.busyLoadingPendingHomonymsProfile) {
                return;
            }
            vm.busyLoadingPendingHomonymsProfile = true;

            if (reset) vm.pagePendingHomonymProfile = 0;

            return DoublonProfile.myPendingHomonyms({
                page: vm.pagePendingHomonymProfile,
                size: vm.pendingHomonymsProfileParPage
            }, function (pendingHomonymsProfile, headers) {

                vm.hasNextPagePendingHomonymsProfile = headers('X-Has-Next-Page') === "true";
                if (reset) {
                    vm.pendingHomonymsProfile = [];
                }
                pendingHomonymsProfile.forEach(function (profile) {
                    loadPicture(profile);
                    vm.pendingHomonymsProfile.push(profile);
                });
                vm.pagePendingHomonymProfile += 1;
                vm.busyLoadingPendingHomonymsProfile = false;
            }).$promise;
        }


        function deletePendingHomonym(pendingContrib){
            DoublonProfile.deletePendingHomonym({id: pendingContrib.id},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingHomonymsProfile(true);
                });
        }

        function createProfileFromPendingHomonym(pendingContrib, grade){

            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            DoublonProfile.createProfileFromPendingHomonym({id: pendingContrib.id, grade:grade}, {},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingHomonymsProfile(true);
                    vm.connecting = false;
                });
        }

        function connectProfileFromPendingHomonym(pendingContrib, grade){
            if (vm.connecting){
                return;
            }
            vm.connecting = true;
            DoublonProfile.connectProfileFromPendingHomonym({id: pendingContrib.id, grade:grade}, {},
                function () {
                    Dashboard.get().then(function (data) {
                        vm.networkCount = data.myNetwork;
                        vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                        vm.aConnecterCount = data.aConnecter;
                        vm.myPendingContributionsCount = data.pendingContributions;
                        vm.myPendingHomonymsCount = data.pendingHomonyms;
                    });
                    vm.loadMorePendingHomonymsProfile(true);
                    vm.connecting = false;
                });
        }

        function loadPicture(profile){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    profile.picture=response;
                }, function (response) {
                });
            }
        }

        function deleteAQualifierProfile(id) {
            if (vm.profile.id !== null) {
                Profile.delete({
                    id: id
                }, onDeleteAQualifierProfileSuccess, onDeleteAQualifierProfileError);
            }
        }

        function onDeleteAQualifierProfileSuccess(result) {

            Dashboard.get().then(function (data) {
                vm.networkCount = data.myNetwork;
                vm.networkCountWithGrade3 = data.myNetworkWithGrade3;
                vm.aConnecterCount = data.aConnecter;
                vm.myPendingContributionsCount = data.pendingContributions;
                vm.myPendingHomonymsCount = data.pendingHomonyms;
            });
            vm.loadMoreContributionsProfile(true);

            $scope.$emit('quilinkApp:profileDelete', null);
        }
        function onDeleteAQualifierProfileError() {
        }

        function memePersonne(contrib, memePersonne) {
            contrib.memePersonne = memePersonne;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope', '$scope', '$state', '$timeout', 'Auth', 'Principal', 'User', 'ProfileService', 'LoginService', 'Search', 'Discussion', 'Alert', 'Picture', 'Oauth2LoginService', '$window'];

    function NavbarController ($rootScope, $scope, $state, $timeout, Auth, Principal, User, ProfileService, LoginService, Search, Discussion, Alert, Picture, Oauth2LoginService, $window) {
        var vm = this;


        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.noResults = false;
        vm.query = '';
        vm.$state = $state;
        vm.isLoginModalOpen = false;
        vm.searchCompaniesCount = 0;
        vm.searchCollectivitiesCount = 0;
        vm.searchProfilesCount = 0;

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.search = search;
        vm.markAlertAsSeen = markAlertAsSeen;
        vm.seenFilter = seenFilter;

        vm.discussions = [];
        vm.alerts = [];
        //Discussion.query(onDiscussionsFetchCompleted);
        //Alert.query(onAlertsFetchCompleted);

        vm.myPicture;
        vm.hasProfile = Principal.hasProfile;
        vm.isAdmin = isAdmin;



        vm.currentAccount = null;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });


        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        $scope.$watch('vm.query', function (query) {
            if (typeof query === 'object') {
                console.log(query);
                if (query.dropdownType === 'profile') {
                    $state.go('profile', { id: query.id })
                } else if (query.dropdownType === 'company') {
                    $state.go('company-detail', { id: query.id })
                } else if (query.dropdownType === 'collectivity') {
                    $state.go('collectivity-detail', { id: query.id })
                }
            }
        });

        Principal.profile().then(function (profile) {
            loadPicture(profile);
        })

        // Prevent inbox pop-up from window scrolling
        $timeout(function () {
            angular.element('#inbox-popup-container').bind('DOMMouseScroll mousewheel', preventScrollPropagation);
            angular.element('#alerts-popup-container').bind('DOMMouseScroll mousewheel', preventScrollPropagation);
        });

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        $rootScope.$on('$stateChangeStart', function() {
            vm.query = '';
        });

        function onAlertsFetchCompleted(alerts) {
            vm.alerts = alerts;
            vm.alerts = vm.alerts.map(buildAlertMessage);
        }

        function buildAlertMessage(alert) {
            switch (alert.type) {
                case 'profile':
                    alert.message = "Le profil de " + alert.profile.firstName + " " +
                        alert.profile.lastName + " a été modifié";
                    if (alert.modification.field === "job") {
                        alert.submessage = "Fonction : " + alert.modification.value;
                    }
                    break;
                case 'organisation':
                    alert.message = "La page de " + alert.organisation.name + " a été modifiée";
                    break;
            }
            return alert;
        }

        function markAlertAsSeen(alert) {
            alert.seen = true;
            Alert.update(alert, function () {
                $state.reload();
            });
        }

        function seenFilter(alert) {
            return alert.seen === false;
        }

        function onDiscussionsFetchCompleted(discussions) {
            var conversations = [];
            // Replace discussion.members by discussion.contact
            Principal.identity().then(function (me) {
                discussions.forEach(function (discussion) {
                    var d = discussion;
                    if (d.admin) {
                        if (me.authorities.indexOf("ROLE_ADMIN") > -1) {
                            d.contact = d.members[0];
                            // Désactivation rgpd
                            /*
                            if (d.contact.pictureContentType){
                                Picture.getProfilePictureByEmail(d.contact.email).then(function (picSrc) {
                                    d.contact.picture = picSrc;
                                });
                            }
                            */
                        } else {
                            d.contact = {
                                id: 0,
                                firstName: "Axenteev",
                                lastName: "",
                                picture: "../content/images/axenteev-icon.svg"
                            }
                        }
                    } else {
                        if (d.members[0].id !== me.id) {
                            d.contact = d.members[0];
                        } else {
                            d.contact = d.members[1];
                        }

                        if (d.contact.pictureContentType){
                            Picture.getProfilePictureByEmail(d.contact.email).then(function (picSrc) {
                                d.contact.picture = picSrc;
                            });
                        }
                    }
                    // Show only open conversations
                    if (!d.closed) {
                        conversations.push(d);
                    }
                });
                if (conversations.length > 5) {
                    conversations = conversations.splice(0, 5);
                }
                vm.discussions = conversations;
            });
        }

        function login() {
            collapseNavbar();
            vm.isLoginModalOpen = true;
            LoginService.open().then(function() {
                vm.isLoginModalOpen = false;
            });
        }

        function logout() {
            collapseNavbar();

            Principal.identity().then(function (me) {
                if (me && me.oauth2) {
                    Oauth2LoginService.logout({}, function(oauth2LogoutResponse) {
                        Auth.logout();
                        $window.location.href = oauth2LogoutResponse.logoutUrl;
                    }, function (err) {
                        Auth.logout();
                        $state.go('home', {}, {reload: true});
                    });
                } else {
                    Auth.logout();
                    $state.go('home', {}, {reload: true});
                }
            });
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function search(q) {
            return Search.query(q).then(reshapeQueryResults);
        }

        function reshapeQueryResults(response) {
            var data = response.data;
            var collectivities = data.collectivities.map(function (el) {
                el.dropdownType = 'collectivity';
                return el;
            });
            var companies = data.companies.map(function (el) {
                el.dropdownType = 'company';
                return el;
            });

            var profiles1 = data.profiles['1'].map(function (el) {

                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles2 = [];
            if ( data.profiles['2']) {
                profiles2 = data.profiles['2'].map(function (el) {
                    el.name = el.firstName + ' ' + el.lastName;
                    el.dropdownType = 'profile';
                    return el;
                });
            }


            var mixedResults = [];
            var maxLen = Math.max(collectivities.length, companies.length, profiles1.length, profiles2.length, 6);
            for (var i = 0; i < maxLen; i++) {
                if (i < collectivities.length) mixedResults.push(collectivities[i]);
                if (i < companies.length) mixedResults.push(companies[i]);
                if (i < profiles1.length) mixedResults.push(profiles1[i]);
                if (i < profiles2.length) mixedResults.push(profiles2[i]);
            }
            return mixedResults.splice(0, 18);
        }

        function preventScrollPropagation(ev) {
            var $this = $(this),
                scrollTop = this.scrollTop,
                scrollHeight = this.scrollHeight,
                height = $this.innerHeight(),
                delta = (ev.type == 'DOMMouseScroll' ?
                ev.originalEvent.detail * -40 :
                    ev.originalEvent.wheelDelta),
                up = delta > 0;

            var prevent = function() {
                ev.stopPropagation();
                ev.preventDefault();
                ev.returnValue = false;
                return false;
            };

            if (!up && -delta > scrollHeight - height - scrollTop) {
                // Scrolling down, but this will take us past the bottom.
                $this.scrollTop(scrollHeight);
                return prevent();
            } else if (up && delta > scrollTop) {
                // Scrolling up, but this will take us past the top.
                $this.scrollTop(0);
                return prevent();
            }
        }

        function loadPicture(profile){
            if (profile && profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    vm.myPicture=response;
                }, function (response) {
                });
            }
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Axenteev | Erreur'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: [],
                    pageTitle: 'Axenteev | Accès non authorisé'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            })
            .state('comingsoon', {
                parent: 'app',
                url: '/comingsoon',
                data: {
                    authorities: [],
                    pageTitle: 'Axenteev | Coming soon'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/comingsoon.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('InboxNewController', InboxNewController);

    InboxNewController.$inject = ['$scope', '$stateParams', '$timeout', '$uibModalInstance', 'entity', 'Principal', 'Message', 'Discussion', 'User', 'Director'];

    function InboxNewController($scope, $stateParams, $timeout, $uibModalInstance, entity, Principal, Message, Discussion, User, Director) {
        var vm = this;
        vm.discussion = entity;
        vm.me = {};
        vm.to = "";
        vm.sale = {}; // Selected salesman
        vm.sales = []; // List of my sales (dg), my fellow sales (salesman) or list of users (admin)
        vm.myDirector = {}; // Only if user is salesman

        vm.clear = clear;
        vm.save = save;

        // Add me by default as a member of the discussion
        Principal.identity().then(function (me) {
            vm.me = me;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        Principal.hasAuthority('ROLE_COMMERCIAL').then(function (isSale) {
            Principal.hasAuthority('ROLE_DG').then(function (isDG) {
                if (isSale) {
                    console.log('sale');
                    User.mySuperior().$promise.then(getMyDirectorCompleted);
                    User.sameSuperior().$promise.then(getMyFellowSalesCompleted);
                } else if (isDG) {
                    console.log('dg');
                    Director.querySales().$promise.then(getMySalesCompleted);
                } else {
                    console.log('admin');
                    User.query(getAllUsersCompleted);
                }
            });
        });

        function getMyDirectorCompleted(myDirector) {
            vm.myDirector = myDirector;
        }

        function getMySalesCompleted(sales) {
            vm.sales = sales;
        }

        function getMyFellowSalesCompleted(sales) {
            var res = [];
            sales.forEach(function (sale) {
                if (sale.id !== vm.me.id) {
                    res.push(sale);
                }
            });
            vm.sales = res;
        }

        function getAllUsersCompleted(users) {
            vm.sales = users;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            console.log('saving');
            switch (vm.to) {
                case 'admin':
                    vm.discussion.admin = true;
                    vm.discussion.members = [
                        vm.me
                    ];
                    break;
                case 'director':
                    vm.discussion.admin = false;
                    vm.discussion.members = [
                        vm.me,
                        vm.myDirector
                    ];
                    break;
                case 'sale':
                    if (vm.sale.id) {
                        if (vm.me.authorities.indexOf("ROLE_ADMIN") > -1) {
                            vm.discussion.admin = true;
                            vm.discussion.members = [
                                vm.sale
                            ];
                        } else {
                            vm.discussion.admin = false;
                            vm.discussion.members = [
                                vm.sale,
                                vm.me
                            ];
                        }
                    } else {
                        vm.isSaving = false;
                        return;
                    }
            }
            console.log(vm.discussion);
            Discussion.save(vm.discussion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:discussionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('InboxCloseController',InboxCloseController);

    InboxCloseController.$inject = ['$uibModalInstance', 'entity', 'Discussion'];

    function InboxCloseController($uibModalInstance, entity, Discussion) {
        var vm = this;

        vm.discussion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Discussion.close({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('inbox', {
                parent: 'app',
                url: '/inbox?discussionId',
                data: {
                    pageTitle: 'Axenteev | Messagerie',
                    authorities: ['ROLE_COMMERCIAL', 'ROLE_DG', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/inbox/inbox.html',
                        controller: 'InboxController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    'discussionId': null
                }
            })
            .state('inbox.new', {
                parent: 'inbox',
                url: '/new',
                data: {
                    authorities: ['ROLE_COMMERCIAL', 'ROLE_DG', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/inbox/inbox-dialog.html',
                        controller: 'InboxNewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    closed: false,
                                    admin: false,
                                    title: null,
                                    members: []
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('inbox', null, { reload: 'inbox' });
                    }, function() {
                        $state.go('inbox');
                    });
                }]
            })
            .state('inbox.close', {
                parent: 'inbox',
                url: '/{id}/close',
                data: {
                    authorities: ['ROLE_DG', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/inbox/inbox-close-dialog.html',
                        controller: 'InboxCloseController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Discussion', function(Discussion) {
                                return Discussion.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('inbox', null, { reload: 'inbox' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('InboxController', InboxController);

    InboxController.$inject = ['$stateParams', '$state', '$sce', 'Message', 'Principal', 'Discussion', 'User', 'Picture'];

    function InboxController($stateParams, $state, $sce, Message, Principal, Discussion, User, Picture) {
        var vm = this;
        vm.trustAsHtml = $sce.trustAsHtml
        vm.discussionId = $stateParams.discussionId ? parseInt($stateParams.discussionId) : null;
        vm.currentDiscussion = {
            id: vm.discussionId
        };
        vm.me = {};
        vm.newMessage = {
            content: ''
        };
        vm.discussions = [];
        vm.closed = false;

        Principal.identity().then(function (me) {
            vm.me = me;
        });
        Discussion.query(onFetchCompleted);
        if (vm.discussionId) {
            Discussion.get({id: vm.discussionId}, onGetDiscussionCompleted);
        }

        vm.sendNewMessage = sendNewMessage;
        vm.scrollToBottom = scrollToBottom;

        function onFetchCompleted(discussions) {
            var conversations = [];

            // Replace discussion.members by discussion.contact
            // Add a discussion.contact.picture field
            discussions.forEach(function (discussion) {
                var d = discussion;
                if (d.admin) {
                    if (vm.me.authorities.indexOf("ROLE_ADMIN") > -1) {
                        d.contact = d.members[0];
                        Picture.getProfilePictureByEmail(d.contact.email).then(function (picSrc) {
                            d.contact.picture = picSrc;
                        });
                    } else {
                        d.contact = {
                            id: 0,
                            firstName: "Axenteev",
                            lastName: "",
                            picture: "../content/images/axenteev-icon.svg"
                        };
                    }
                } else {
                    if (d.members[0].id !== vm.me.id) {
                        d.contact = d.members[0];
                    } else {
                        d.contact = d.members[1];
                    }
                    Picture.getProfilePictureByEmail(d.contact.email).then(function (picSrc) {
                        d.contact.picture = picSrc;
                    });
                }
                conversations.push(d);
            });

            vm.discussions = conversations;
        }

        function onGetDiscussionCompleted(discussion) {
            vm.currentDiscussion = discussion;
            Message.query({ discussionId: vm.currentDiscussion.id }, onGetMessagesCompleted);
        }

        function onGetMessagesCompleted(messages) {
            vm.currentDiscussion.messages = messages;
            vm.currentDiscussion.messages.forEach(function (message) {
                Picture.getProfilePictureByEmail(message.sentBy.email).then(function (picSrc) {
                    message.sentBy.picture = picSrc;
                });
            })
        }

        function sendNewMessage() {
            if (vm.currentDiscussion.id && vm.newMessage.content.length > 0) {
                vm.newMessage.discussion = vm.currentDiscussion;
                vm.newMessage.sentBy = vm.me;
                Message.create(vm.newMessage, onCreateMessageCompleted);
            }
        }

        function onCreateMessageCompleted() {
            $state.reload();
        }

        function scrollToBottom() {
            var wrapper = angular.element(document.querySelector('#message-wrapper'));
            var container = angular.element(document.querySelector('#message-container'));
            container[0].scrollTop = wrapper[0].offsetHeight;
            return true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                pageTitle: 'Axenteev | Accueil',
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        });
       
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', 'Dashboard', 'History', 'AlertService', 'Search', 'Sector', 'CompanyStatus', 'ContactEmail', 'Picture', '$state'];

    function HomeController ($scope, Principal, LoginService, Dashboard, History, AlertService, Search, Sector, CompanyStatus, ContactEmail, Picture, $state) {
        var vm = this;
        vm.hide =false;
        vm.oldValue = "";
        vm.account = null;
        vm.isAuthenticated = null;
        vm.aboutSlideActive = 0;
        vm.conceptSlideActive = 0;
        vm.storiesSlideActive = 0;
        vm.login = LoginService.open;
        vm.news = [];
        vm.newsfeedFocus = '';
        vm.newsPage = 1;
        vm.itemsPerPage = 10;
        vm.hasNextPageNews = true;
        vm.contactEmail = {
            mail: '',
            firstName: '',
            lastName: '',
            company: '',
            position: '',
            subject: '',
            message: ''
        };
        vm.contactMessageError = false;
        vm.contactMessageSent = false;
        vm.filters = {
            eventTypes: {
                contribution: true,
                modification: true,
                add: true
            },
            types: {
                profile: true,
                company: true,
                collectivity: true
            }
        };

        vm.statsWebsite = {
            companies: {
                count: 0,
                rate: 0
            },
            collectivities: {
                count: 0,
                rate: 0
            },
            quilinkers: {
                count: 0,
                rate: 0
            },
            quilinkees : {
                count: 0,
                rate: 0
            }
        };
        vm.statsAccount = {
            position: {
                count: 5,
                rate: 0
            },
            deals: {
                count: 0,
                rate: 0
            },
            contributions: {
                count: 0,
                rate: 0
            },
            network: {
                count: 0,
                rate: 0
            },
            networkWithGrade3: {
                count: 0,
                rate: 0
            }
        };

        vm.newsfeedSearch = newsfeedSearch;
        vm.getNewsfeed = getNewsfeedSearch;
        vm.loadMoreNewsfeed = loadMoreNewsfeed;
        vm.sendContactEmail = sendContactEmail;

        init($scope);


        function init($scope) {


            $scope.homeBusyPromise = Principal.identity()
            .then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            }).then(function(result) {
                if (!Principal.isAuthenticated()){
                    //LoginService.open();
                    //$window.location.href = '/#/login';
                    //$location.path( "/login" );
                    $state.go('login', {}, {reload: true});
                } else {
                     // Get Dashboard
                    return Dashboard.get().then(function (data) {
                        // Dashboard result processing
                        vm.statsWebsite = {
                            companies: { count: data.company, rate: 0 },
                            collectivities: { count: data.collectivity, rate: -1 },
                            quilinkers: { count: data.user, rate: 3 },
                            quilinkees: { count: data.profile, rate: 3 },
                            currentMonth: data.currentMonth
                        };
                        vm.statsAccount = {
                            position: { count: 5, rate: 5 },
                            deals: { count: 0, rate: 3 },
                            contributions: { count: data.contributions, rate: -2 },
                            network: { count: data.myNetwork, rate: 2 },
                            networkWithGrade3: { count: data.myNetworkWithGrade3, rate: 2 },
                            internal: { count: data.internal, rate: 2 },
                            currentMonth: data.currentMonth
                        };
                        computeProgressBarWidth();
                    /*
                    }).then(function(result) {
                        return getNewsfeed();
                    }).then(function(data, headers) {
                        return onNewsfeedSuccess(data, headers, true);
                    }).then(function(result) {
                        getFilters();
                    */
                    }).then(function(result) {
                        vm.hide = false;
                    });
                }

            });

        }

        function sendContactEmail() {
            return ContactEmail.save(vm.contactEmail).$promise
                .then(function () {
                    vm.contactMessageError = false;
                    vm.contactMessageSent = true;
                })
                .catch(function () {
                    vm.contactMessageError = true;
                    vm.contactMessageSent = false;
                })
        }

        function getFilters() {
            Sector.query(storeSectors);
            CompanyStatus.query(storeCompanyStatuses);

            function storeSectors(sectors) {
                vm.sectors = sectors;
            }

            function storeCompanyStatuses(companyStatuses) {
                vm.companyStatuses = companyStatuses;
            }
        }

        /*
        function getAccount() {
            return Principal.identity()
            .then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            }).then(function(result) {
                getDashboard();
            });
        }
        */


        function computeProgressBarWidth() {
            /**
             * Bar width is computed using the formulae :
             *      width = 50% + 50 * value / max
             * where max is the maximum of the values in the left panel (wMax) or the right panel (aMax).
             *
             * The 'position' key has a special width formulae :
             *      width = 50% + 50 * | (20 - value) / 20 |
             * after 20th position -> with = 50%
             */

            // Website (left)
            var wKeys = ['companies', 'collectivities', 'quilinkers', 'quilinkees'];
            var wMax = 0;
            // Compute wMax
            wKeys.forEach(function (key) {
                if (vm.statsWebsite[key].count > wMax) {
                    wMax = vm.statsWebsite[key].count;
                }
            });
            if (wMax === 0) {
                wKeys.forEach(function (key) {
                    vm.statsWebsite[key].width = 50;
                });
            } else {
                wKeys.forEach(function (key) {
                    vm.statsWebsite[key].width = 50 + 50 * vm.statsWebsite[key].count / wMax;
                });
            }

            // Account (right)
            var aKeys = ['position', 'deals', 'contributions', 'network'];
            var aMax = 0;
            aKeys.forEach(function (key) {
                if (vm.statsAccount[key].count > aMax) {
                    aMax = vm.statsAccount[key].count;
                }
            });
            if (aMax === 0) {
                aKeys.forEach(function (key) {
                    vm.statsAccount[key].width = 50;
                });
            } else {
                aKeys.forEach(function (key) {
                    if (key === 'position') {
                        vm.statsAccount[key].width = 50 + 50 * Math.max((20 - vm.statsAccount[key].count) / 20, 0);
                    } else {
                        vm.statsAccount[key].width = 50 + 50 * vm.statsAccount[key].count / aMax;
                    }
                });
            }
        }

        function getNewsfeed() {
            if (!vm.newsfeedFocus.id) {
                return History.newsfeed({
                    sectorId: vm.filters.sectorId,
                    page: vm.newsPage - 1,
                    size: vm.itemsPerPage
                }).$promise;
            } else if (vm.newsfeedFocus.dropdownType === 'collectivity' || vm.newsfeedFocus.dropdownType === 'company') {
                return History.newsfeedOrganisation({
                    id: vm.newsfeedFocus.id,
                    page: vm.newsPage - 1,
                    size: vm.itemsPerPage
                }).$promise;
            } else if (vm.newsfeedFocus.dropdownType === 'profile') {
                return History.newsfeedProfile({
                    id: vm.newsfeedFocus.id,
                    page: vm.newsPage - 1,
                    size: vm.itemsPerPage
                }).$promise;
            }
        }

        function onNewsfeedSuccess(data, headers, reset) {
            var profile, organisation, previousPosition;
            data.forEach(function (event) {
                profile = event.news.profile;
                organisation = event.news.organisation;
                previousPosition = event.news.previousPosition;

                switch (event.newsType) {
                    case 'NEW_ORGANISATION':
                        event.type = 'profile';
                        event.itemId = profile.id;
                        event.name = profile.firstName + ' ' + profile.lastName;


                        event.message = 'a modifié son entreprise :';

                        event.title = profile.currentPosition.title;
                        event.organisation = organisation.name;
                        event.organisationId = organisation.id;
                        event.previousOrganisation = previousPosition && previousPosition.organisation && (previousPosition.organisation.name != organisation.name) ? previousPosition.organisation.name : null;
                        event.previousOrganisationId = previousPosition && previousPosition.organisation ? previousPosition.organisation.id : null;
                        loadProfilePicture(profile, event);
                        event.date = new Date(event.info.revtstmp);
                        break;
                    case 'NEW_TITLE':
                        event.type = 'profile';
                        event.itemId = profile.id;
                        event.name = profile.firstName + ' ' + profile.lastName;

                        event.message = 'a modifié son poste :';

                        event.title = profile.currentPosition.title;
                        event.previousTitle = previousPosition && (previousPosition.title != profile.currentPosition.title) ? previousPosition.title : null;

                        event.organisation = organisation.name;
                        event.organisationId = organisation.id;
                        event.previousOrganisation = previousPosition && previousPosition.organisation && (previousPosition.organisation.name != organisation.name) ? previousPosition.organisation.name : null;
                        event.previousOrganisationId = previousPosition && previousPosition.organisation ? previousPosition.organisation.id : null;

                        loadProfilePicture(profile, event);
                        event.date = new Date(event.info.revtstmp);
                        break;
                    case 'NEW_MEMBER':
                        event.type = organisation.type;
                        event.itemId = organisation.id;
                        event.name = organisation.name;

                        event.subItemId = organisation ? organisation.id : null;
                        event.subName = organisation ? organisation.name : null;


                        event.message = 'a un nouveau collaborateur';
                        event.member = profile.firstName + ' ' + profile.lastName;

                        event.picture = organisation.logoContentType ?
                            'data:' + organisation.logoContentType + ';base64,' + organisation.logo
                            : 'content/images/no-picture-company.png';
                        event.date = new Date(event.info.revtstmp);
                        break;
                    case 'POSITION_CHANGE':
                        event.type = 'profile';
                        event.itemId = profile.id;
                        event.name = profile.firstName + ' ' + profile.lastName;

                        event.message = 'a modifié son profil :';

                        event.title = profile.currentPosition.title;
                        event.organisation = organisation.name;
                        event.organisationId = organisation.id;

                        event.previousOrganisation = previousPosition && previousPosition.organisation && (previousPosition.organisation.name != organisation.name) ? previousPosition.organisation.name : null;
                        event.previousOrganisationId = previousPosition && previousPosition.organisation ? previousPosition.organisation.id : null;

                        event.picture = organisation.logoContentType ?
                            'data:' + organisation.logoContentType + ';base64,' + organisation.logo
                            : 'content/images/no-picture-company.png';
                        event.date = new Date(event.info.revtstmp);
                        break;

                }

            });
            //vm.hasNextPageNews = headers('X-Has-Next-Page') === "true";
            console.log("loadMoreNewsfeed", vm.newsPage, vm.hasNextPageNews);
            vm.news = reset ? data : vm.news.concat(data);
        }


        function getNewsfeedSearch() {
            vm.newsPage = 1;
            console.log("loadMoreNewsfeed", vm.newsPage, vm.hasNextPageNews);
            getNewsfeed().then(function(data, headers) {
                return onNewsfeedSuccess(data, headers, true);
            })

        }
        function loadMoreNewsfeed() {
            vm.newsPage += 1;
            console.log("loadMoreNewsfeed", vm.newsPage, vm.hasNextPageNews);
            getNewsfeed().then(function(data, headers) {
                return onNewsfeedSuccess(data, headers, false);
            })

        }

        function newsfeedSearch(q) {
            if (q == "" && vm.oldValue!="") {
                vm.newsfeedFocus = '';
                vm.oldValue = "";
                getNewsfeedSearch();
            } else if (q!=""){
                 vm.oldValue = q;
                return Search.query(q).then(reshapeQueryResults);
            }
        }

        function reshapeQueryResults(response) {
            var data = response.data;
            var collectivities = data.collectivities.map(function (el) {
                el.dropdownType = 'collectivity';
                return el;
            });
            var companies = data.companies.map(function (el) {
                el.dropdownType = 'company';
                return el;
            });
            var profiles1 = data.profiles['1'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles2 = data.profiles['2'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles3 = data.profiles['3'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            /*
            var res = companies.splice(0, 2)
                .concat(collectivities.splice(0, 2))
                .concat(profiles1.splice(0, 3))
                .concat(profiles2.splice(0, 2))
                .concat(profiles3.splice(0, 2));
            */
             var res = companies
                .concat(collectivities)
                .concat(profiles1)
                .concat(profiles2)
                .concat(profiles3);
            return res;
        }

        function onFetchError(error) {
            AlertService.error(error.data.message);
        }

        function loadProfilePicture(profile, event){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    event.picture = 'data:' + profile.pictureContentType + ';base64,' + response;
                }, function (response) {
                    event.picture =  'content/images/no-picture.png';
                });
            } else {
                event.picture =  'content/images/no-picture.png';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Dashboard', Dashboard);

    Dashboard.$inject = ['$http'];

    function Dashboard($http) {

        var service = {
            get : get
        };

        return service;

        function get() {
            return $http.get('api/dashboard/').then(function (res) {
                if (res && res.data) {
                    return res.data;
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('ContactEmail', ContactEmail);

    ContactEmail.$inject = ['$resource'];

    function ContactEmail($resource) {
        var service = $resource('api/contact_email', {}, {});

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('History', History);

    History.$inject = ['$resource'];

    function History ($resource) {
        var resourceUrl =  'api/history/newsfeed?sectorId';

        return $resource(resourceUrl, {id:'@id'}, {
            'newsfeed': {
                method: 'GET',
                isArray: true
            },
            'newsfeedOrganisation': {
                url: 'api/history/newsfeed/organisation/:id',
                method: 'GET',
                isArray: true
            },
            'newsfeedProfile': {
                url: 'api/history/newsfeed/profile/:id',
                method: 'GET',
                isArray: true
            },
            'resetOrganisation': {
                url: 'api/history/reset/organisation/:id',
                method: 'POST'
            },
            'resetProfile': {
                url: 'api/history/reset/profile/:id',
                method: 'POST'
            },
            'resetUser': {
                url: 'api/history/reset/user/:id',
                method: 'POST'
            },
            'get': {
                url: 'api/history/:resource/:id',
                method: 'GET',
                isArray: true
            },
            'myCredits': {
                url: '/api/history/myCredits',
                method: 'GET'
            },
            'userCredits': {
                url: '/api/history/credits/:email/email',
                method: 'GET'
            },
            'profileAdd': {
                url: '/api/history/profile',
                method: 'GET',
                isArray: true
            },
            'previousProfile': {
                url: '/api/history/profile/previous/:profileId',
                method: 'GET'
            }

            
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Whoswho', Whoswho);

    Whoswho.$inject = ['$resource', '$http'];

    function Whoswho ($resource, $http) {
        var resourceUrl =  'api/whoswho/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/whoswho/list'
            },
            'queryMap': {
                method: 'GET',
                isArray: false,
                url: 'api/whoswho/map'
            },
            'getDepartements': {
                method: 'GET',
                isArray: true,
                url: 'api/whoswho/departements'
            },
            'getUser': {
                method: 'GET',
                url: 'api/whoswho/user/:userId',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('TitleDialogController', TitleDialogController);

    TitleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Title'];

    function TitleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Title) {
        var vm = this;

        vm.title = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.title.id !== null) {
                Title.update(vm.title, onSaveSuccess, onSaveError);
            } else {
                Title.save(vm.title, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:titleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('TitleDetailController', TitleDetailController);

    TitleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Title'];

    function TitleDetailController($scope, $rootScope, $stateParams, previousState, entity, Title) {
        var vm = this;

        vm.title = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:titleUpdate', function(event, result) {
            vm.title = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('TitleDeleteController',TitleDeleteController);

    TitleDeleteController.$inject = ['$uibModalInstance', 'entity', 'Title'];

    function TitleDeleteController($uibModalInstance, entity, Title) {
        var vm = this;

        vm.title = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Title.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('title', {
            parent: 'profile-info-management',
            url: '/title?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Titres professionnels'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/title/titles.html',
                    controller: 'TitleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('title-detail', {
            parent: 'profile-info-management',
            url: '/title/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Titre professionnel'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/title/title-detail.html',
                    controller: 'TitleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Title', function($stateParams, Title) {
                    return Title.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'title',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('title-detail.edit', {
            parent: 'title-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/title/title-dialog.html',
                    controller: 'TitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Title', function(Title) {
                            return Title.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('title.new', {
            parent: 'title',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/title/title-dialog.html',
                    controller: 'TitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('title', null, { reload: 'title' });
                }, function() {
                    $state.go('title');
                });
            }]
        })
        .state('title.edit', {
            parent: 'title',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/title/title-dialog.html',
                    controller: 'TitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Title', function(Title) {
                            return Title.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('title', null, { reload: 'title' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('title.delete', {
            parent: 'title',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/title/title-delete-dialog.html',
                    controller: 'TitleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Title', function(Title) {
                            return Title.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('title', null, { reload: 'title' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Title', Title);

    Title.$inject = ['$resource'];

    function Title ($resource) {
        var resourceUrl =  'api/titles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('TitleController', TitleController);

    TitleController.$inject = ['$scope', '$state', 'Title', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TitleController ($scope, $state, Title, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Title.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.titles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SubscriptionDialogController', SubscriptionDialogController);

    SubscriptionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Subscription', 'User'];

    function SubscriptionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Subscription, User) {
        var vm = this;

        vm.subscription = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.subscription.id !== null) {
                Subscription.update(vm.subscription, onSaveSuccess, onSaveError);
            } else {
                Subscription.save(vm.subscription, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:subscriptionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SubscriptionDetailController', SubscriptionDetailController);

    SubscriptionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Subscription', 'User'];

    function SubscriptionDetailController($scope, $rootScope, $stateParams, previousState, entity, Subscription, User) {
        var vm = this;

        vm.subscription = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:subscriptionUpdate', function(event, result) {
            vm.subscription = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SubscriptionDeleteController',SubscriptionDeleteController);

    SubscriptionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Subscription'];

    function SubscriptionDeleteController($uibModalInstance, entity, Subscription) {
        var vm = this;

        vm.subscription = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Subscription.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('subscription', {
            parent: 'entity',
            url: '/subscription?page&sort&search',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Subscriptions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscription/subscriptions.html',
                    controller: 'SubscriptionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('subscription-detail', {
            parent: 'entity',
            url: '/subscription/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Subscription'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscription/subscription-detail.html',
                    controller: 'SubscriptionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Subscription', function($stateParams, Subscription) {
                    return Subscription.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'subscription',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('subscription-detail.edit', {
            parent: 'subscription-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-dialog.html',
                    controller: 'SubscriptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Subscription', function(Subscription) {
                            return Subscription.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subscription.new', {
            parent: 'subscription',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-dialog.html',
                    controller: 'SubscriptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                active: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: 'subscription' });
                }, function() {
                    $state.go('subscription');
                });
            }]
        })
        .state('subscription.edit', {
            parent: 'subscription',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-dialog.html',
                    controller: 'SubscriptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Subscription', function(Subscription) {
                            return Subscription.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: 'subscription' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subscription.delete', {
            parent: 'subscription',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-delete-dialog.html',
                    controller: 'SubscriptionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Subscription', function(Subscription) {
                            return Subscription.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: 'subscription' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Subscription', Subscription);

    Subscription.$inject = ['$resource'];

    function Subscription ($resource) {
        var resourceUrl =  'api/subscriptions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'remove': { method:'DELETE' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SubscriptionController', SubscriptionController);

    SubscriptionController.$inject = ['$scope', '$state', 'Subscription', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SubscriptionController ($scope, $state, Subscription, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Subscription.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.subscriptions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SectorDialogController', SectorDialogController);

    SectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Sector'];

    function SectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Sector) {
        var vm = this;

        vm.sector = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sector.id !== null) {
                Sector.update(vm.sector, onSaveSuccess, onSaveError);
            } else {
                Sector.save(vm.sector, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:sectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SectorDetailController', SectorDetailController);

    SectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Sector'];

    function SectorDetailController($scope, $rootScope, $stateParams, previousState, entity, Sector) {
        var vm = this;

        vm.sector = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:sectorUpdate', function(event, result) {
            vm.sector = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SectorDeleteController',SectorDeleteController);

    SectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sector'];

    function SectorDeleteController($uibModalInstance, entity, Sector) {
        var vm = this;

        vm.sector = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Sector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector', {
            parent: 'profile-info-management',
            url: '/sector?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Secteurs d\'activité'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/sector/sectors.html',
                    controller: 'SectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('sector-detail', {
            parent: 'profile-info-management',
            url: '/sector/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Secteur d\'activité'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/sector/sector-detail.html',
                    controller: 'SectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Sector', function($stateParams, Sector) {
                    return Sector.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sector',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sector-detail.edit', {
            parent: 'sector-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-dialog.html',
                    controller: 'SectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sector', function(Sector) {
                            return Sector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector.new', {
            parent: 'sector',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-dialog.html',
                    controller: 'SectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: 'sector' });
                }, function() {
                    $state.go('sector');
                });
            }]
        })
        .state('sector.edit', {
            parent: 'sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-dialog.html',
                    controller: 'SectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sector', function(Sector) {
                            return Sector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: 'sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector.delete', {
            parent: 'sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-delete-dialog.html',
                    controller: 'SectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sector', function(Sector) {
                            return Sector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: 'sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Sector', Sector);

    Sector.$inject = ['$resource'];

    function Sector ($resource) {
        var resourceUrl =  'api/sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SectorController', SectorController);

    SectorController.$inject = ['$scope', '$state', 'Sector', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SectorController ($scope, $state, Sector, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Sector.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sectors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('RectifyProfileDialogController', RectifyProfileDialogController);

        RectifyProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Message'];

    function RectifyProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Message) {
        var vm = this;
        vm.profileToRectify = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>textarea').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Message.envoyerMessageRectifyProfile({profileId : vm.profileToRectify.id}, vm.message, onSaveSuccess, onSaveError);

        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
    }

})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('QuickconnectDialogController', QuickconnectDialogController);

    QuickconnectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Quickconnect', 'Principal'];

    function QuickconnectDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Quickconnect, Principal) {
        var vm = this;
        vm.organisation = $stateParams.organisation;
        vm.quickconnect = entity;
        vm.clear = clear;
        vm.save = save;
        vm.me;

        Principal.identity().then(function (me) {
            vm.me = me;
            if (!vm.quickconnect.id){
                vm.quickconnect.myfirstname = vm.me.firstName;
                vm.quickconnect.mylastname = vm.me.lastName;
                vm.quickconnect.quickconnectOrganisation = vm.organisation;
            }
        });
        $timeout(function (){
            angular.element('.form-group:eq(3)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        

        function save () {
            vm.isSaving = true;
            if (vm.quickconnect.id !== null) {
                Quickconnect.update(vm.quickconnect, onSaveSuccess, onSaveError);
            } else {
                Quickconnect.save(vm.quickconnect, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:quickconnectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('QuickconnectDetailController', QuickconnectDetailController);

    QuickconnectDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Quickconnect'];

    function QuickconnectDetailController($scope, $rootScope, $stateParams, previousState, entity, Quickconnect) {
        var vm = this;

        vm.quickconnect = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:quickconnectUpdate', function(event, result) {
            vm.quickconnect = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('QuickconnectDeleteController',QuickconnectDeleteController);

    QuickconnectDeleteController.$inject = ['$uibModalInstance', 'entity', 'Quickconnect'];

    function QuickconnectDeleteController($uibModalInstance, entity, Quickconnect) {
        var vm = this;

        vm.quickconnect = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Quickconnect.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('quickconnect', {
            parent: 'admin',
            url: '/quickconnect?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Quick Connect'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/entities/quickconnect/quickconnects.html',
                    controller: 'QuickconnectController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('quickconnect-detail', {
            parent: 'admin',
            url: '/quickconnect/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Ville'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/entities/quickconnect/quickconnect-detail.html',
                    controller: 'QuickconnectDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Quickconnect', function($stateParams, Quickconnect) {
                    return Quickconnect.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'quickconnect',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('quickconnect-detail.edit', {
            parent: 'quickconnect-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quickconnect/quickconnect-dialog.html',
                    controller: 'QuickconnectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quickconnect', function(Quickconnect) {
                            return Quickconnect.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quickconnect.new', {
            parent: 'quickconnect',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quickconnect/quickconnect-dialog.html',
                    controller: 'QuickconnectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('quickconnect', null, { reload: 'quickconnect' });
                }, function() {
                    $state.go('quickconnect');
                });
            }]
        })
        .state('quickconnect.edit', {
            parent: 'quickconnect',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quickconnect/quickconnect-dialog.html',
                    controller: 'QuickconnectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quickconnect', function(Quickconnect) {
                            return Quickconnect.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quickconnect', null, { reload: 'quickconnect' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quickconnect.delete', {
            parent: 'quickconnect',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quickconnect/quickconnect-delete-dialog.html',
                    controller: 'QuickconnectDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Quickconnect', function(Quickconnect) {
                            return Quickconnect.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quickconnect', null, { reload: 'quickconnect' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Quickconnect', Quickconnect);

    Quickconnect.$inject = ['$resource'];

    function Quickconnect ($resource) {
        var resourceUrl =  'api/quickconnects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'search': {
                method: 'GET',
                url: 'api/quickconnects/search/:query',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('QuickconnectController', QuickconnectController);

    QuickconnectController.$inject = ['$scope', '$state', 'Quickconnect', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function QuickconnectController ($scope, $state, Quickconnect, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Quickconnect.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.quickconnects = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('ProfileCategory', ProfileCategory);

    ProfileCategory.$inject = ['$resource'];

    function ProfileCategory ($resource) {
        var resourceUrl =  'api/profile-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfilePublicPositionDialogController', ProfilePublicPositionDialogController);

    ProfilePublicPositionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'Profile', 'Company', 'Collectivity', 'Principal'];

    function ProfilePublicPositionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, Profile, Company, Collectivity, Principal) {
        var vm = this;

        vm.profile = $stateParams.profile;
        vm.organizationsNoResults = false;
        vm.getOrganizations = getOrganizations;
        vm.clear = clear;
        vm.save = save;
        vm.addCurrentPosition = addCurrentPosition;
        vm.addPastPosition = addPastPosition;

        vm.profilesNoResults = false;
        vm.getProfiles = getProfiles;

        vm.isAdmin = isAdmin;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();

            if (vm.profile.positions){
                vm.currentPositions =  vm.profile.positions.filter(function(val) {
                    return val.active == true;
                });

                vm.pastPositions =  vm.profile.positions.filter(function(val) {
                    return val.active == false;
                });
            } else {
                vm.currentPositions = [];
                vm.pastPositions = [];
            }

        });

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function addCurrentPosition() {
            vm.currentPositions.push({"active":true});
        }

        function addPastPosition() {
            vm.pastPositions.push({"active":false});
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.profile.positions = vm.currentPositions.concat(vm.pastPositions);
            Profile.update(vm.profile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:positionUpdate', result);
            $uibModalInstance.close(result);
            console.log(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getOrganizations(q) {
            return Company.search({ query: q }).$promise.then(function (companies) {
                return Collectivity.search({ query: q }).$promise.then(function (collectivities) {
                    var organizations = companies.concat(collectivities);
                    vm.organizationsNoResults = organizations.length === 0;

                    if (isAdmin()) {
                        organizations.map( function(org) {
                            if (org.equipeCommerciale) {
                                org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                            }
                        });
                    }
                    return organizations;
                });
            });
        }

        function getProfiles(q) {
            return Profile.search({ query: q }).$promise.then(function (profiles) {
                vm.profilesNoResults = profiles.length === 0;
                return profiles;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfilePublicController', ProfilePublicController);

    ProfilePublicController.$inject = ['$scope', '$stateParams', 'entity', 'Principal', 'Connexion', 'Picture', 'Position'];

    function ProfilePublicController($scope, $stateParams, entity, Principal, Connexion, Picture, Position) {
        var vm = this;
        vm.isAdmin = isAdmin;

        vm.hideProfileCard =true;
        vm.profile = entity;

        loadPicture(vm.profile);
        vm.isDG = false;
        Principal.profile().then(function (profile) {
            vm.myProfile = profile;
        });
        vm.connexion = {};
        vm.updateGrade = updateGrade;

        
        vm.fullName = vm.profile.firstName + ' ' + vm.profile.lastName;

        if ($stateParams.position){
            vm.selectedPosition = vm.profile.positions.find(function (p) {
                return p.id === parseInt($stateParams.position);
            });
        } else {
            vm.selectedPosition = vm.profile.currentPosition;
        }

        vm.websiteForOrganisation = websiteForOrganisation;
        vm.websiteGuidePouvoir = websiteGuidePouvoir(vm.profile);
        vm.websiteDataGouv = websiteDataGouv;

        vm.clipTooltip = 'Cliquez pour copier dans le presse papier';
        vm.copied = copied;
        //vm.selectedPosition = vm.profile.currentPosition? vm.profile.currentPosition : {};


        vm.organisations = vm.profile.positions.map(function(position){
            return position.organisation;
        });

        vm.organisation = vm.selectedPosition && vm.selectedPosition.organisation && vm.selectedPosition.organisation.id ?
            vm.selectedPosition.organisation : {};

        Principal.hasAuthority('ROLE_DG').then(function (isDG) {
            vm.isDG = isDG;
        });
        setConnexion();

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function setConnexion() {
            $scope.profileCardBusyPromise = Connexion.search({
                query: vm.profile.lastName
            }, function (connexions) {
                var relevantConnexions = connexions.filter(function (connexion) {
                    return connexion.target.id === vm.profile.id || connexion.creator.id === vm.profile.id
                });
                if (relevantConnexions.length) {
                    vm.connexion = relevantConnexions[0];
                }
                setTimeout(function(){ vm.hideProfileCard = false;}, 0);

            }).$promise;
        }

        function updateGrade(newGrade) {
            if (vm.connexion.id) {
                Connexion.update({
                    id: vm.connexion.id,
                    grade: newGrade,
                    target: vm.connexion.target,
                    creator: vm.connexion.creator
                }, function (connexion) {
                    vm.connexion = connexion;
                });
            } else {
                Connexion.create({
                    grade: newGrade,
                    target: vm.profile,
                    creator: vm.myProfile
                }, function (connexion) {
                    vm.connexion = connexion;
                });
            }
        }

        function loadPicture(profile){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    profile.picture=response;
                }, function (response) {
                    console.log(response);
                });
            }
        }

        function websiteForOrganisation(selectedPosition) {
            var website = selectedPosition ? selectedPosition.organisation.website : null;
            if (website && !website.includes('http')) {
                return 'https://' + website;
            } else {
                return website;
            }
        }
        function websiteGuidePouvoir(profile) {
            if (profile.domain && profile.domain === 'guidep') {
                return  'https://www.leguidedupouvoir.fr/page/personnalite_entite/'+ profile.importId + '/index.htm';
            } else {
                return null;
            }
        }

        function websiteDataGouv(selectedPosition) {
            if (selectedPosition && selectedPosition.organisation.type === 'collectivity') {
                return  'https://www.data.gouv.fr/fr/datasets/repertoire-national-des-elus-1/';
            } else {
                return null
            }
        }

        function copied() {
            vm.clipTooltip = 'Copié !';
            setTimeout(function() {
                vm.clipTooltip = 'Cliquez pour copier dans le presse papier';
            }, 3000);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfilePositionDialogController', ProfilePositionDialogController);

    ProfilePositionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Position', 'Company', 'Collectivity', 'Sector', 'Department', 'Profile'];

    function ProfilePositionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Position, Company, Collectivity, Sector, Department, Profile) {
        var vm = this;

        vm.position = entity;
        vm.type = 'company';
        vm.sectors = Sector.query();
        vm.departments = Department.query();
        vm.profiles = Profile.query();
        vm.loadingOrganizations = false;
        vm.switchType = switchType;
        vm.getOrganizations = getOrganizations;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.position.id !== null) {
                Position.update(vm.position, onSaveSuccess, onSaveError);
            } else {
                Position.save(vm.position, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:positionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function switchType(type) {
            vm.type = type;
        }

        function getOrganizations(q) {
            return Company.query({ name: q }).$promise.then(function (companies) {
                return Collectivity.query({ name: q }).$promise.then(function (collectivities) {
                    return companies.concat(collectivities);
                });
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfilePictureDialogController', ProfilePictureDialogController);

    ProfilePictureDialogController.$inject = ['$scope', '$state', '$uibModalInstance', '$timeout', 'entity', 'DataUtils', 'Principal', 'Auth', 'Position', 'Education', 'Profile'];

    function ProfilePictureDialogController($scope, $state, $uibModalInstance, $timeout, entity, DataUtils, Principal, Auth, Position, Education, Profile) {
        var vm = this;

        vm.profile = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.clear = clear;
        vm.setPicture = setPicture;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.profile.id !== null) {
                Profile.update(vm.profile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:profileUpdate', result);
            // Reset profile but not identity
            Auth.authorize(false, true).then(function () {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            });
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        function setPicture($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.picture = base64Data;
                        profile.pictureContentType = $file.type;
                    });
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileLinkedinDialogController', ProfileLinkedinDialogController);

    ProfileLinkedinDialogController.$inject = ['$scope', '$timeout', 'Linkedin', 'Auth'];

    function ProfileLinkedinDialogController($scope, $timeout, Linkedin, Auth) {
        var vm = this;

        vm.file = null;
        vm.save = save;
        vm.isSuccess = false;
        vm.isError = false;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });


        function save () {
            if (!vm.file){
                onSaveError();
                return;
            }
            vm.isSuccess = false;
            vm.isError = false;
            vm.isSaving = true;
            var fd = new FormData();
            fd.append('file', vm.file);

            Linkedin.importContacts({}, fd).$promise
                .then(onSaveSuccess)
                .catch(onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:profileUpdate', result);
            // Reset profile but not identity
            Auth.authorize(false, true).then(function () {
               // $uibModalInstance.close(result);
                vm.isSaving = false;
                vm.isSuccess = true;
                vm.isError = false;
            });
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.isSuccess = false;
            vm.isError = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileInitController', ProfileInitController);

    ProfileInitController.$inject = ['$stateParams', '$scope', '$state', '$timeout', 'DataUtils', 'Principal', 'Auth', 'Position', 'Education', 'Collectivity', 'Company', 'Profile', 'Account'];

    function ProfileInitController($stateParams, $scope, $state, $timeout, DataUtils, Principal, Auth, Position, Education, Collectivity, Company, Profile, Account) {
        var vm = this;

        vm.authSuccess = authSuccess;
        vm.authenticationError = false;


        vm.key= $stateParams.key

        vm.profileInitForm;
        vm.mode = null;
        vm.profile = {};
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        //vm.educations = Education.query();
        vm.save = save;
        vm.setPicture = setPicture;
        vm.switchTo = switchTo;
        vm.conditions = false;

        vm.organizationsNoResults = false;
        vm.getOrganizations = getOrganizations;

        vm.addCurrentPosition = addCurrentPosition;
        vm.addPastPosition = addPastPosition;

        vm.profilesNoResults = false;
        vm.getProfiles = getProfiles;

        vm.readOnlyInitTitle = false;
        vm.readOnlyInitOrganisation = false;
        vm.init = init;

        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.initError = false;

        if (vm.key && vm.key !== "") {
            Auth.loginWithKey({
                key: vm.key
            },  vm.authSuccess).then(function () {
                vm.authenticationError = false;
                $rootScope.$broadcast('authenticationSuccess');
                init(account.data);
            }).catch(function () {
                vm.authenticationError = true;
            });
        } else {
            Account.getByKey({key:vm.key}, init, onError);
        }

        vm.switchTo('manual')


       function authSuccess(){
            Account.getByKey({key:vm.key}, init, onError);
       }

       function init(account){
            vm.authenticationError = false;
            vm.profile.user = account.data;
            vm.profile.email = vm.profile.user.email;
            vm.profile.lastName = vm.profile.user.lastName;
            vm.profile.firstName = vm.profile.user.firstName;

            angular.element('.form-group:eq(1)>input').focus();

            vm.currentPositions = [];
            vm.pastPositions = [];

            var initTitle = null;
            if (vm.profile.user.initTitle){
                initTitle = vm.profile.user.initTitle;


            } else if (Principal.hasAnyAuthority(['ROLE_COMMERCIAL'])){
                initTitle = 'Commercial';
            } else if (Principal.hasAnyAuthority(['ROLE_CONSULTANT'])){
                initTitle = 'Consultant';
                vm.readOnlyInitTitle = true;
            }

            var initOrganisation = null;
            if (vm.profile.user.initOrganisation){
                initOrganisation = vm.profile.user.initOrganisation;
            }

            var initSuperior = null;
            if (vm.profile.user.initSuperior){
                initSuperior = vm.profile.user.initSuperior;
            }

            //NOTE: Si je suis consultant, mon entreprise est renseignée automatiquement en independant et mon job en Consultant et je ne peux pas changer.
            // En revanche, je peux ajouter un autre job comme pour tous les utilisateurs à cette etape la.
            if (Principal.hasAnyAuthority(['ROLE_CONSULTANT'])) {
                if (initOrganisation){
                    vm.readOnlyInitOrganisation = true;
                }
                if (initTitle){
                    vm.readOnlyInitTitle = true;
                }
                if (initSuperior){
                    vm.readOnlyInitSuperior = true;
                }
            }
            vm.currentPositions.push({"readOnlyInitTitle": vm.readOnlyInitTitle, "readOnlyInitOrganisation": vm.readOnlyInitOrganisation, "readOnlyInitSuperior": vm.readOnlyInitSuperior, "active":true, "organisation":initOrganisation, "title":initTitle, "superior":initSuperior});
        };
        function onError(error) {
            console.log(error.data);
            vm.authenticationError = true;
        }

        function addCurrentPosition() {
            vm.currentPositions.push({"active":true, "readOnlyInitTitle": false, "readOnlyInitOrganisation": false, "readOnlyInitSuperior": false});
        }

        function addPastPosition() {
            vm.pastPositions.push({"active":false});
        }


        vm.setPicture = function ($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.picture = base64Data;
                        profile.pictureContentType = $file.type;
                    });
                });
            }
        };

        function getProfiles(q) {
            return Profile.search({ query: q }).$promise.then(function (profiles) {

                return profiles;
            });
        }

        function getOrganizations(q) {
            return Company.search({ query: q }).$promise.then(function (companies) {
                return Collectivity.search({ query: q }).$promise.then(function (collectivities) {
                    var organizations = companies.concat(collectivities);
                    // vm.organizationsNoResults = organizations.length === 0;
                    // vm.profileInitForm.organisation.$setValidity('exist',  organizations.length !== 0);
                    return organizations;
                });
            });
        }


        function switchTo(value) {
            if (value === 'linkedin' || value === 'manual') {
                vm.mode = value;
            } else {
                vm.mode = null;
            }
        }

        function save () {
            vm.isSaving = true;
            vm.profile.email = vm.profile.user.email;
            vm.profile.positions = vm.currentPositions.concat(vm.pastPositions);

            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
                vm.isSaving = false;
            } else {
                vm.doNotMatch = null;
                vm.profile.password = vm.password;
                Profile.init(vm.profile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:profileUpdate', result);
            vm.isSaving = false;
            vm.error = null;
            vm.success = 'OK';

            Auth.authorize(true, true).then(function () {
                $state.go('home', {}, {reload: true});
            });
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.success = null;
            vm.error = 'ERROR';
        }


        function setPicture($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.picture = base64Data;
                        profile.pictureContentType = $file.type;
                    });
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileEducationDialogController', ProfileEducationDialogController);

    ProfileEducationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Education', 'Establishment', 'Profile'];

    function ProfileEducationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Education, Establishment, Profile) {
        var vm = this;

        vm.education = entity;
        vm.establishments = [];
        vm.loadingEstablishments = false;
        vm.clear = clear;
        vm.save = save;
        vm.getEstablishments = getEstablishments;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function getEstablishments(query) {
            if (!query) return [];

            return Establishment.query({
                name: query
            }).$promise;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.education.id !== null) {
                Education.update(vm.education, onSaveSuccess, onSaveError);
            } else {
                Education.save(vm.education, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:educationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileDialogController', ProfileDialogController);

    ProfileDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$state', '$window', '$stateParams', '$q', 'DataUtils', 'entity', 'Profile', 'Company', 'Collectivity', 'Principal', 'Picture', 'ModerationProfile', 'Whoswho'];

    function ProfileDialogController($timeout, $scope, $rootScope, $state, $window, $stateParams, $q, DataUtils, entity, Profile, Company, Collectivity, Principal, Picture, ModerationProfile, Whoswho) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        vm.organizationsNoResults = false;
        vm.getOrganizations = getOrganizations;

        vm.addCurrentPosition = addCurrentPosition;
        vm.addPastPosition = addPastPosition;

        vm.setActive = setActive;
        vm.setInActive = setInActive;

        vm.profilesNoResults = false;
        vm.getProfiles = getProfiles;

        vm.isAdmin = isAdmin;
        vm.deleteProfile = deleteProfile;

        vm.grade = "";

        vm.editForm;

        vm.currentAccount = null;

        vm.departements = Whoswho.getDepartements();

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        $timeout(function() {
            loadPicture(vm.profile);
            if (vm.profile.grade){
                vm.grade = vm.profile.grade.toString();
            }

            $scope.$parent.vm.selectedContribution = "new-profile";
            angular.element('.form-group:eq(0)>input').focus();
            if (entity.id) {
                $scope.$parent.vm.edit = true;
            }
            if (vm.profile.positions) {
                vm.currentPositions = vm.profile.positions.filter(function(val) {
                    return val.active == true;
                });

                vm.pastPositions = vm.profile.positions.filter(function(val) {
                    return val.active == false;
                });
            } else {
                vm.currentPositions = [];
                vm.pastPositions = [];
                addCurrentPosition();
            }

        });

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function addCurrentPosition() {
            vm.currentPositions.push({ "active": true });
        }

        function addPastPosition() {
            vm.pastPositions.push({ "active": false });
        }


        function setActive(index) {
            var position = vm.pastPositions[index];
            position.active = true;
            vm.pastPositions.splice(index, 1)
            vm.currentPositions.push(position);
        }

        function setInActive(index) {
            var position = vm.currentPositions[index];
            position.active = false;
            vm.currentPositions.splice(index, 1)
            vm.pastPositions.push(position);
        }

        function clear() {
            $scope.$parent.$dismiss();
        }

        function save() {
            vm.isSaving = true;

            vm.profile.positions = vm.currentPositions.concat(vm.pastPositions);

            for (var i = 0; i < vm.profile.positions.length; i++) {
                if (vm.profile.positions[i].superior == "") {
                    vm.profile.positions[i].superior = null;
                }
            }
            // if (isAdmin() || vm.profile.mine || vm.profile.myContribution) {
                if (vm.profile.id !== null) {
                    if (vm.profile.moderationId) {
                        // Update du profile à partir de la modération
                        ModerationProfile.updateAndApprove({ id: vm.profile.moderationId }, vm.profile, onSaveSuccess, onSaveError);
                    } else {
                        Profile.update(vm.profile, onSaveSuccess, onSaveError);
                    }
                } else {
                    if (vm.profile.moderationId) {
                        // Création du profile à partir de la modération
                        ModerationProfile.createAndApprove({ id: vm.profile.moderationId }, vm.profile, onSaveSuccess, onSaveError);
                    } else {
                        Profile.save(vm.profile, onSaveSuccess, onSaveError);
                    }
                }
            /*
            } else {
                // Création d'une modération si non admin/profile non crée par l'utilisateur
                var mProfile = Object.assign({}, vm.profile);
                mProfile['mPositions'] = mProfile.positions;
                mProfile.positions = null;
                mProfile['grade'] = vm.grade;
                if (vm.profile.id !== null) {
                    mProfile['referencedProfile'] = Object.assign({}, vm.profile);
                    mProfile.id = null;
                    ModerationProfile.mupdate(mProfile, onModerationSaveSuccess, onSaveError);
                } else {
                    ModerationProfile.msave(mProfile, onModerationSaveSuccess, onSaveError);
                }
            }
            */
        }

        function deleteProfile() {
            vm.isSaving = true;
            if (vm.profile.id !== null) {
                Profile.delete({
                    id: vm.profile.id
                }, onDeleteSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('quilinkApp:profileUpdate', result);
            $rootScope.$broadcast('quilinkApp:profileUpdate', result);
            vm.isSaving = false;
            $scope.$parent.$close();
        }


        function onModerationSaveSuccess(result) {
            $scope.$emit('quilinkApp:moderationProfileUpdate', result);
            $rootScope.$broadcast('quilinkApp:moderationProfileUpdate', result);
            vm.profile.hasModeration = true;
            vm.isSaving = false;
            $scope.$parent.$close();
        }

        function onDeleteSuccess(result) {
            $scope.$emit('quilinkApp:profileUpdate', null);
            $rootScope.$broadcast('quilinkApp:profileUpdate', null);
            vm.isSaving = false;
            $window.location.href = '/';
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.setPicture = function($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.picture = base64Data;
                        profile.pictureContentType = $file.type;
                    });
                });
            }
        };

        function getProfiles(q) {
            return Profile.search({ query: q }).$promise.then(function(profiles) {
                vm.profilesNoResults = profiles.length === 0;
                return profiles;
            });
        }

        function getOrganizations(q) {
            return Company.search({ query: q }).$promise.then(function(companies) {
                return Collectivity.search({ query: q }).$promise.then(function(collectivities) {
                    var organizations = companies.concat(collectivities);
                    if (isAdmin()) {
                        organizations.map( function(org) {
                            if (org.equipeCommerciale) {
                                org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                            }
                        });
                    }
                    return organizations;
                });
            });
        }


        function loadPicture(profile) {
            if (profile.pictureContentType) {
                Picture.getProfilePicture(profile.id).then(function(response) {
                    profile.picture = response;
                }, function(response) {
                    console.log(response);
                });
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileDetailController', ProfileDetailController);

    ProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Profile', 'User', 'Position', 'Education'];

    function ProfileDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Profile, User, Position, Education) {
        var vm = this;

        vm.profile = entity;
        loadPicture(vm.profile);
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('quilinkApp:profileUpdate', function(event, result) {
            vm.profile = result;
        });
        $scope.$on('$destroy', unsubscribe);
       
    }

    function loadPicture(profile){
        if (profile.pictureContentType){
            Picture.getProfilePicture(profile.id).then(function (response) {
                profile.picture=response;
            }, function (response) {
                console.log(response);
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileDeleteController',ProfileDeleteController);

    ProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'Profile'];

    function ProfileDeleteController($uibModalInstance, entity, Profile) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Profile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileCreditController', ProfileCreditController);

        ProfileCreditController.$inject = ['$scope', '$state', 'entity', 'Principal', 'User', 'Profile', 'Education', 'Position', 'Picture', 'Dashboard', 'History'];

    function ProfileCreditController($scope, $state, entity, Principal, User, Profile, Education, Position, Picture, Dashboard, History) {
        var vm = this;
        vm.profile = entity;
        loadPicture(vm.profile);
        console.log(vm.profile);
        
        vm.creditsLastMonth;
        vm.credits;

        
        init();
        
        function init(){
            getCreditsHistory();
        }

        function getCreditsHistory() {
            History.myCredits({}, function (response) {
                if (response.credits){
                    vm.creditsLastMonth = response.credits[response.credits.length - 1];
                    vm.credits = response;
                    computeCharts(response.credits);
                }
            });
        }


        vm.datasetOverride = [
            {
              label: "Crédits",
              borderWidth: 1,
              type: 'bar'
            }
            
          ];
        function computeCharts(credits){
            vm.labels1 = credits.map(function (obj) {
                return obj.monthStr;
              });
            vm.data1 = [];
            vm.data1.push(credits.map(function (obj) {
                return obj.creditsCount;
              }));
            
          
        }
        
        function loadPicture(profile){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    profile.picture=response;
                }, function (response) {
                });
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profile', {
            parent: 'entity',
            url: '/profile/{id}/{position}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Profil'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/public/profile-public.html',
                    controller: 'ProfilePublicController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', '$rootScope', '$state', 'Profile', '$timeout', 'Principal',
                    function($stateParams, $rootScope, $state, Profile, $timeout, Principal) {
                        if ($stateParams.id) {
                            // Get another user profile except if it's the auth user profile
                            return Profile.get({id: $stateParams.id}).$promise
                            .then(function (profile) {
                                if (profile.mine) {
                                    $state.go('my-profile');
                                }
                                return profile;
                            }).catch(function(error) {
                                $state.go('accessdenied');
                            });
                        } else {
                            // Get the auth user profile
                            var deferred = $q.defer();
                            $timeout(function() {
                                $state.go('my-profile');
                                return deferred.reject();
                            }, 100);
                            return deferred.promise;
                        }
                    }
                ],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('position-edit', {
            parent: 'profile',
            url: '/position/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            params: {
                profile: {
                    value: {}
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/public/profile-public-position.html',
                    controller: 'ProfilePublicPositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('my-profile', {
            parent: 'entity',
            url: '/my-profile',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Mon profil'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile.html',
                    controller: 'ProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['Principal', function(Principal) {
                    // Get the auth user profile
                    console.log('my-profile');
                    return Principal.profile();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('linkedin', {
            parent: 'entity',
            url: '/linkedin/add',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile-linkedin-dialog.html',
                    controller: 'ProfileLinkedinDialogController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('my-position-edit', {
            parent: 'my-profile',
            url: '/position/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-position-dialog.html',
                    controller: 'ProfilePositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('my-position-new', {
            parent: 'my-profile',
            url: '/position/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-position-dialog.html',
                    controller: 'ProfilePositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Principal', function(Principal) {
                            return Principal.profile().then(function (profile) {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    organisation: {
                                        id: null,
                                        name: null
                                    },
                                    profile: profile,
                                    title: null,
                                    id: null
                                };
                            });
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: 'profile' });
                }, function() {
                    $state.go('profile');
                });
            }]
        })
        .state('my-education-edit', {
            parent: 'my-profile',
            url: '/education/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-education-dialog.html',
                    controller: 'ProfileEducationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Education', function(Education) {
                            return Education.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('my-education-new', {
                parent: 'my-profile',
                url: '/education/new',
                data: {
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-education-dialog.html',
                        controller: 'ProfileEducationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Principal', function(Principal) {
                                return Principal.profile().then(function (profile) {
                                    return {
                                        startDate: null,
                                        endDate: null,
                                        degree: null,
                                        establishment: {
                                            id: null,
                                            name: null
                                        },
                                        profile: profile,
                                        id: null
                                    };
                                });
                            }]
                        }
                    }).result.then(function() {
                        $state.go('profile', null, { reload: 'profile' });
                    }, function() {
                        $state.go('profile');
                    });
                }]
            })
        .state('picture-edit', {
            parent: 'my-profile',
            url: '/picture/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-picture-dialog.html',
                    controller: 'ProfilePictureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: ['Principal', function(Principal) {
                            return Principal.profile();
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: 'profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-init', {
            parent: 'app',
            url: '/profile-init/:key',
            data: {
                pageTitle: 'Axenteev | Complétez votre profil',
                //authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile-init.html',
                    controller: 'ProfileInitController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('my-profile.contribution', {
            parent: 'my-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('my-profile',{}, { reload: true });
                }, function() {
                    $state.go('my-profile');
                });
            }]
        })

        .state('my-profile.contribution.edit-profile', {
            parent: 'my-profile.contribution',
            url: '/edit-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                profile: {
                    value: {}
                }
            },
            views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })

        .state('profile-init.my-education-new', {
            parent: 'profile-init',
            url: '/education/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-education-dialog.html',
                    controller: 'ProfileEducationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Principal', function(Principal) {
                            return Principal.profile().then(function (profile) {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    degree: null,
                                    establishment: {
                                        id: null,
                                        name: null
                                    },
                                    profile: profile,
                                    id: null
                                };
                            });
                        }]
                    }
                }).result.then(function() {
                    //$state.go('profile-init', null, { reload:  false });
                }, function() {
                    //$state.go('profile-init');
                });
            }]
        })

        .state('profile.new', {
            parent: 'app',
            url: 'new-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                picture: null,
                                pictureContentType: null,
                                email: null,
                                phoneNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile.contribution', {
            parent: 'profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('profile',{}, { reload: true });
                }, function() {
                    $state.go('profile');
                });
            }]
        })


        .state('profile.contribution.new-profile', {
            parent: 'profile.contribution',
            url: '/new-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        id: null
                    };
                }
            },
            views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })


        .state('profile.contribution.edit-profile', {
            parent: 'profile.contribution',
            url: '/edit-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                profile: {
                    value: {}
                }
            },

            resolve: {
                entity: ['$stateParams', 'Profile', function($stateParams, Profile) {
                    return Profile.get({id : $stateParams.id}).$promise;
                }]
            },

            views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('profile.contribution.rectify-profile', {
            parent: 'profile.contribution',
            url: '/edit-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                profile: {
                    value: {}
                },
                rectify: true
            },

            resolve: {
                entity: ['$stateParams', 'Profile', function($stateParams, Profile) {
                    return Profile.get({id : $stateParams.id}).$promise;
                }]
            },

            views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('profile.contribution.new-company', {
            parent: 'profile.contribution',
            url: '/new-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        logo: null,
                        logoContentType: null,
                        id: null
                    };
                }
            },
            views: {
                'contrib@': {
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm'
              }
            }
        })

         .state('profile.request-external-network', {
            parent: 'profile',
            url: '/request-external-network',
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/organisation-network/external-network-request-dialog.html',
                    controller: 'ExternalNetworkRequestController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile.envoyer-message-commercial', {
            parent: 'profile',
            url: '/envoyer-message-commercial/:commercialId',
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/organisation-network/envoyer-message-commercial-dialog.html',
                    controller: 'EnvoyerMessageCommercialDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }],
                        commercial: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.commercialId}).$promise;
                        }],

                    }
                }).result.then(function() {
                    $state.go('profile', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            params: {
                'commercialId': null
            }
        })
        .state('my-profile-credits', {
            parent: 'entity',
            url: '/my-profile-credits',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Mes crédits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile-credit.html',
                    controller: 'ProfileCreditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['Principal', function(Principal) {
                    // Get the auth user profile
                    console.log('my-profile-credits');
                    return Principal.profile();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })

        .state('profile.message-libre', {
            parent: 'profile',
            url: '/message-libre/{userId}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message-libre/message-libre-dialog.html',
                    controller: 'MessageLibreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Whoswho', function(Whoswho) {
                            return Whoswho.getUser({userId : $stateParams.userId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: false });
                }, function() {
                    $state.go('profile');
                });

            }]
        })
        .state('profile.rectify', {
            parent: 'profile',
            url: '/rectify-profile/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rectify-profile/rectify-profile-dialog.html',
                    controller: 'RectifyProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['$stateParams', 'Profile', function($stateParams, Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: false });
                }, function() {
                    $state.go('profile');
                });

            }]
        })
       ;

        /*
        .state('profile.new-profile', {
            parent: 'profile',
            url: '/new-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                picture: null,
                                pictureContentType: null,
                                email: null,
                                phoneNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        });
        */
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Profile', Profile);

    Profile.$inject = ['$resource'];

    function Profile ($resource) {
        var resourceUrl =  'api/profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'myProfile': {
                method: 'GET',
                url: 'api/profiles/myprofile',
                isArray: false
            },
            'countProfilesForOrganisation': {
                method: 'GET',
                url: 'api/profiles/countProfilesForOrganisation?organisationId=:organisationId',
                isArray: false
            },
            'countAxenteeversForOrganisation': {
                method: 'GET',
                url: 'api/profiles/countAxenteeversForOrganisation?organisationId=:organisationId',
                isArray: false
            },
            'update': { method:'PUT' },
            'init': { method:'POST', url: 'api/profiles/init', },
            'delete': {
                method: 'DELETE',
                url: 'api/profiles/:id',
            },
            'category': {
                method: 'GET',
                isArray: true,
                url: '/api/profiles/organisation/category'
            },
            'search': {
                method: 'GET',
                url: 'api/profiles/search/:query',
                isArray: true
            },
            'getPicture': {
                method: 'GET',
                url: 'api/profiles/:id/picture',
                isArray: false,
                transformResponse: function (data) { return  data.toString() }
            },
            'myContributions': {
                method: 'GET',
                url: 'api/profiles/mycontributions',
                isArray: true
            },
            'aConnecter': {
                method: 'GET',
                url: 'api/profiles/aconnecter',
                isArray: true
            },
            'check': {
                method: 'POST',
                url: 'api/profiles/check',
                isArray: false
            },
            'requestDelete': {
                method: 'POST',
                url: 'api/profiles/requestDelete',
                isArray: false
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['$scope', '$rootScope', '$state', 'entity', 'Principal', 'User', 'Profile', 'Education', 'Position', 'Picture', 'Dashboard'];

    function ProfileController($scope, $rootScope, $state, entity, Principal, User, Profile, Education, Position, Picture, Dashboard) {

        var vm = this;
        vm.profile = entity;
        loadPicture(vm.profile);
        vm.picture;
        vm.currentAccount;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });



        vm.educations = vm.profile.educations ? vm.profile.educations : [];
        vm.currentPosition = vm.profile.currentPosition;
        vm.positions = vm.profile.positions ? vm.profile.positions : [];
        vm.isStatOpen = false;
        vm.statMode = 'rank';
        vm.lineOptions = {
            legend: { display: true },
            elements : { line : { tension : 0 } }
        };
        vm.barOptions = {
            legend: { display: true }
        };
        vm.series = {
            ranks: ['Classement'],
            rates: ['Note'],
            deals: ['Deals'],
            contributions: ['Créations', 'Modifications', 'Alertes'],
            network: ['Rang 1', 'Rang 2', 'Rang 3']
        };
        vm.rankColors = [{
            backgroundColor: "rgb(166,210,253)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "transparent",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        }];
        vm.rateColors = [{
            backgroundColor: "transparent",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "rgb(117,151,184)",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        }];
        vm.dealColors = [{
            backgroundColor: "rgb(166,210,253)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "rgb(117,151,184)",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        }];
        vm.contributionColors = [{
            backgroundColor: "rgb(117, 151, 184)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "transparent",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        },{
            backgroundColor: "rgb(157, 190, 224)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "transparent",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        },{
            backgroundColor: "rgb(166, 210, 253)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "transparent",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        }];

        vm.statsAccount = {
            position: {
                count: 16,
                rate: 3
            },
            deals: {
                count: 5,
                rate: 0
            },
            contributions: {
                count: 16,
                rate: -5
            },
            network: {
                count: 0,
                rate: 0
            },
            networkWithGrade3: {
                count: 0,
                rate: 0
            }
        };

        //computeProgressBarWidth();
        init();

        function init(){
            Dashboard.get().then(function (data) {
                vm.statsAccount.networkWithGrade3.count = data.myNetworkWithGrade3;
                vm.statsAccount.network.count = data.myNetwork;
                vm.statsAccount.aConnecterCount = data.aConnecter;
            })
        }



        function computeProgressBarWidth() {
            var aKeys = ['position', 'deals', 'contributions', 'indices'];
            var aMax = 0;
            aKeys.forEach(function (key) {
                if (vm.statsAccount[key].count > aMax) {
                    aMax = vm.statsAccount[key].count;
                }
            });
            if (aMax === 0) {
                aKeys.forEach(function (key) {
                    vm.statsAccount[key].width = 50;
                });
            } else {
                aKeys.forEach(function (key) {
                    if (key === 'position') {
                        vm.statsAccount[key].width = 50 + 50 * Math.max((20 - vm.statsAccount[key].count) / 20, 0);
                    } else {
                        vm.statsAccount[key].width = 50 + 50 * vm.statsAccount[key].count / aMax;
                    }
                });
            }
        }

        vm.statLabels = ['07/2016', '08/2016', '09/2016', '10/2016', '11/2016', '12/2016',
                    '01/2017', '02/2017','03/2017','04/2017','05/2017','06/2017'];
        vm.stats = {
            ranks: [[32,25,28,22,24,25,18,18,15,10,12,11]],
            rates: [[7,7.12,7.6,7.5,7.8,7.9,8.2,8.6,8.8,8.81,8.88,8.99]],
            deals: [[1,4,3,5,1,4,3,2,4,1,4,3]],
            contributions: [[1,3,3,4,2,1,5,3,4,3,2,1],
                [1,4,5,1,3,3,4,1,2,3,4,3],
                [1,4,3,2,1,2,3,1,0,3,1,2]],
            network: [[1,3,5,5,2,1,4,3,1,0,2,1],
                [1,3,4,4,5,4,5,4,3,2,3,3],
                [3,3,2,1,4,4,3,2,4,1,4,2]]
        }

        function loadPicture(profile){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    profile.picture = response;
                    vm.picture = response;
                }, function (response) {
                    console.log(response);
                });
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('PositionDialogController', PositionDialogController);

    PositionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Position', 'Company', 'Collectivity', 'Sector', 'Department', 'Profile'];

    function PositionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Position, Company, Collectivity, Sector, Department, Profile) {
        var vm = this;

        vm.position = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();
        vm.collectivities = Collectivity.query();
        vm.sectors = Sector.query();
        vm.departments = Department.query();
        vm.profiles = Profile.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.position.id !== null) {
                Position.update(vm.position, onSaveSuccess, onSaveError);
            } else {
                Position.save(vm.position, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:positionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('PositionDetailController', PositionDetailController);

    PositionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Position', 'Company', 'Collectivity', 'Sector', 'Department', 'Profile'];

    function PositionDetailController($scope, $rootScope, $stateParams, previousState, entity, Position, Company, Collectivity, Sector, Department, Profile) {
        var vm = this;

        vm.position = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:positionUpdate', function(event, result) {
            vm.position = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('PositionDeleteController',PositionDeleteController);

    PositionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Position'];

    function PositionDeleteController($uibModalInstance, entity, Position) {
        var vm = this;

        vm.position = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Position.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('position', {
            parent: 'entity',
            url: '/position?page&sort&search',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Positions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/position/positions.html',
                    controller: 'PositionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('position-detail', {
            parent: 'entity',
            url: '/position/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Position'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/position/position-detail.html',
                    controller: 'PositionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Position', function($stateParams, Position) {
                    return Position.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'position',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('position-detail.edit', {
            parent: 'position-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-dialog.html',
                    controller: 'PositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('position.new', {
            parent: 'position',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-dialog.html',
                    controller: 'PositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startDate: null,
                                endDate: null,
                                title: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: 'position' });
                }, function() {
                    $state.go('position');
                });
            }]
        })
        .state('position.edit', {
            parent: 'position',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-dialog.html',
                    controller: 'PositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: 'position' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('position.delete', {
            parent: 'position',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-delete-dialog.html',
                    controller: 'PositionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: 'position' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Position', Position);

    Position.$inject = ['$resource'];

    function Position ($resource) {
        var resourceUrl =  'api/positions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('PositionController', PositionController);

    PositionController.$inject = ['$scope', '$state', 'Position', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PositionController ($scope, $state, Position, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Position.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.positions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationSwitchController',OrganisationSwitchController);

    OrganisationSwitchController.$inject = ['$uibModalInstance', 'entity', 'Organisation', 'Collectivity', 'Company', 'Principal'];

    function OrganisationSwitchController($uibModalInstance, entity, Organisation, Collectivity, Company, Principal) {
        var vm = this;
        vm.collectivitysNoResults = false;
        vm.getCollectivities = getCollectivities;
        vm.getCompanies = getCompanies;
        vm.organisation = entity;
        vm.clear = clear;
        vm.merge = merge;
        vm.collectivityTarget;
        vm.companyTarget;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function merge (id) {
            var targetId = vm.collectivityTarget? vm.collectivityTarget.id : vm.companyTarget? vm.companyTarget.id : null;
            if (!targetId) {
                return;
            }
            Organisation.merge({sourceId: id, targetId: targetId},
                function () {
                    $uibModalInstance.close(true);
                });
        }

        function getCollectivities(q) {
            return Collectivity.search({ query: q }).$promise.then(function (collectivities) {
                vm.collectivitysNoResults = collectivities.length === 0;

                if (isAdmin()) {
                    collectivities.map( function(org) {
                        if (org.equipeCommerciale) {
                            org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                        }
                    });
                }

                return collectivities;
            });
        }

        function getCompanies(q) {
            return Company.search({ query: q }).$promise.then(function (companies) {
                if (isAdmin()) {
                    companies.map( function(org) {
                        if (org.equipeCommerciale) {
                            org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                        }
                    });
                }
                vm.companiesNoResults = companies.length === 0;
                return companies;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationDialogController', OrganisationDialogController);

    OrganisationDialogController.$inject = ['$timeout', '$scope', '$window', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Organisation', 'Sector', 'Principal'];

    function OrganisationDialogController ($timeout, $scope, $window, $stateParams, $uibModalInstance, DataUtils, entity, Organisation, Sector, Principal) {
        var vm = this;

        vm.organisation = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.sectors = Sector.query();

        vm.deleteOrganisation = deleteOrganisation;
        vm.isAdmin = isAdmin;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.organisation.id !== null) {
                Organisation.update(vm.organisation, onSaveSuccess, onSaveError);
            } else {
                Organisation.save(vm.organisation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:organisationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setLogo = function ($file, organisation) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        organisation.logo = base64Data;
                        organisation.logoContentType = $file.type;
                    });
                });
            }
        };

        function deleteOrganisation() {
            vm.isSaving = true;
            if (vm.organisation.id !== null) {
                Organisation.delete({
                    id: vm.organisation.id
                }, onDeleteSuccess, onSaveError);
            }
        }

        function onDeleteSuccess(result) {
            $scope.$emit('quilinkApp:OrganisationUpdate', null);
            $rootScope.$broadcast('quilinkApp:OrganisationUpdate', null);
            vm.isSaving = false;
            $window.location.href = '/';
        }
        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationDetailController', OrganisationDetailController);

    OrganisationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Organisation', 'Sector'];

    function OrganisationDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Organisation, Sector) {
        var vm = this;

        vm.organisation = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('quilinkApp:organisationUpdate', function(event, result) {
            vm.organisation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationDeleteController',OrganisationDeleteController);

    OrganisationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Organisation'];

    function OrganisationDeleteController($uibModalInstance, entity, Organisation) {
        var vm = this;

        vm.organisation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Organisation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('organisation', {
            parent: 'entity',
            url: '/organisation?page&sort&search',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Organisations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/organisation/organisations.html',
                    controller: 'OrganisationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('organisation-detail', {
            parent: 'entity',
            url: '/organisation/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Organisation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/organisation/organisation-detail.html',
                    controller: 'OrganisationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Organisation', function($stateParams, Organisation) {
                    return Organisation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'organisation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('organisation-detail.edit', {
            parent: 'organisation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organisation/organisation-dialog.html',
                    controller: 'OrganisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Organisation', function(Organisation) {
                            return Organisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organisation.new', {
            parent: 'organisation',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organisation/organisation-dialog.html',
                    controller: 'OrganisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                logo: null,
                                logoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: 'organisation' });
                }, function() {
                    $state.go('organisation');
                });
            }]
        })
        .state('organisation.edit', {
            parent: 'organisation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organisation/organisation-dialog.html',
                    controller: 'OrganisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Organisation', function(Organisation) {
                            return Organisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: 'organisation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organisation.delete', {
            parent: 'organisation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organisation/organisation-delete-dialog.html',
                    controller: 'OrganisationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Organisation', function(Organisation) {
                            return Organisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: 'organisation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Organisation', Organisation);

    Organisation.$inject = ['$resource'];

    function Organisation ($resource) {
        var resourceUrl =  'api/organisations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'merge': {   
                method: 'GET',
                url: 'api/organisations/mergeOrganisation/:sourceId/:targetId'},
                
            'myContributions': {
                method: 'GET',
                url: 'api/organisations/mycontributions',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationController', OrganisationController);

    OrganisationController.$inject = ['$scope', '$state', 'DataUtils', 'Organisation', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function OrganisationController ($scope, $state, DataUtils, Organisation, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            Organisation.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.organisations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('MessageLibreDialogController', MessageLibreDialogController);

        MessageLibreDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Message'];

    function MessageLibreDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Message) {
        var vm = this;
        vm.user = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>textarea').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Message.envoyerMessageLibre({userId : vm.user.id}, vm.message, onSaveSuccess, onSaveError);

        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
    }

})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('MessageDialogController', MessageDialogController);

    MessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Message', 'Discussion', 'User'];

    function MessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Message, Discussion, User) {
        var vm = this;

        vm.message = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.discussions = Discussion.query();
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.message.id !== null) {
                Message.update(vm.message, onSaveSuccess, onSaveError);
            } else {
                Message.save(vm.message, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:messageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('MessageDetailController', MessageDetailController);

    MessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Message', 'Discussion', 'User'];

    function MessageDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Message, Discussion, User) {
        var vm = this;

        vm.message = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('quilinkApp:messageUpdate', function(event, result) {
            vm.message = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('MessageDeleteController',MessageDeleteController);

    MessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'Message'];

    function MessageDeleteController($uibModalInstance, entity, Message) {
        var vm = this;

        vm.message = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Message.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('message', {
            parent: 'entity',
            url: '/message',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Messages'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/message/messages.html',
                    controller: 'MessageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('message-detail', {
            parent: 'entity',
            url: '/message/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Message'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/message/message-detail.html',
                    controller: 'MessageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Message', function($stateParams, Message) {
                    return Message.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'message',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('message-detail.edit', {
            parent: 'message-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/message-dialog.html',
                    controller: 'MessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Message', function(Message) {
                            return Message.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('message.new', {
            parent: 'message',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/message-dialog.html',
                    controller: 'MessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('message', null, { reload: 'message' });
                }, function() {
                    $state.go('message');
                });
            }]
        })
        .state('message.edit', {
            parent: 'message',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/message-dialog.html',
                    controller: 'MessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Message', function(Message) {
                            return Message.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('message', null, { reload: 'message' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('message.delete', {
            parent: 'message',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/message-delete-dialog.html',
                    controller: 'MessageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Message', function(Message) {
                            return Message.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('message', null, { reload: 'message' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Message', Message);

    Message.$inject = ['$resource'];


    function Message ($resource) {
        var resourceUrl =  'api/messages/:discussionId';

        return $resource(resourceUrl, {}, {
            'create': {
                method:'POST',
                url:'api/messages/:discussionId'
            },
            'messageRequestExternalNetwork': {
                method: 'POST',
                url: 'api/messageRequestExternalNetwork'
            },
            'envoyerMessageCommercial': {
                method: 'POST',
                url: 'api/envoyerMessageCommercial/:commercialUserId'
            },
            'envoyerMessageLibre': {
                method: 'POST',
                url: 'api/envoyerMessageLibre/:userId'
            },
            'envoyerMessageRectifyProfile': {
                method: 'POST',
                url: 'api/envoyerMessageRectifyProfile/:profileId'
            },
            'query': {
                method:'GET',
                url:'api/messages/:discussionId',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('MessageController', MessageController);

    MessageController.$inject = ['$scope', '$state', 'DataUtils', 'Message'];

    function MessageController ($scope, $state, DataUtils, Message) {
        var vm = this;

        vm.messages = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            Message.query(function(result) {
                vm.messages = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EstablishmentDialogController', EstablishmentDialogController);

    EstablishmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Establishment'];

    function EstablishmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Establishment) {
        var vm = this;

        vm.establishment = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.establishment.id !== null) {
                Establishment.update(vm.establishment, onSaveSuccess, onSaveError);
            } else {
                Establishment.save(vm.establishment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:establishmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EstablishmentDetailController', EstablishmentDetailController);

    EstablishmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Establishment'];

    function EstablishmentDetailController($scope, $rootScope, $stateParams, previousState, entity, Establishment) {
        var vm = this;

        vm.establishment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:establishmentUpdate', function(event, result) {
            vm.establishment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EstablishmentDeleteController',EstablishmentDeleteController);

    EstablishmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Establishment'];

    function EstablishmentDeleteController($uibModalInstance, entity, Establishment) {
        var vm = this;

        vm.establishment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Establishment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('establishment', {
            parent: 'profile-info-management',
            url: '/establishment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Universités, écoles'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/establishment/establishments.html',
                    controller: 'EstablishmentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('establishment-detail', {
            parent: 'profile-info-management',
            url: '/establishment/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Université, école'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/establishment/establishment-detail.html',
                    controller: 'EstablishmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Establishment', function($stateParams, Establishment) {
                    return Establishment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'establishment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('establishment-detail.edit', {
            parent: 'establishment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/establishment/establishment-dialog.html',
                    controller: 'EstablishmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Establishment', function(Establishment) {
                            return Establishment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('establishment.new', {
            parent: 'establishment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/establishment/establishment-dialog.html',
                    controller: 'EstablishmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('establishment', null, { reload: 'establishment' });
                }, function() {
                    $state.go('establishment');
                });
            }]
        })
        .state('establishment.edit', {
            parent: 'establishment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/establishment/establishment-dialog.html',
                    controller: 'EstablishmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Establishment', function(Establishment) {
                            return Establishment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('establishment', null, { reload: 'establishment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('establishment.delete', {
            parent: 'establishment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/establishment/establishment-delete-dialog.html',
                    controller: 'EstablishmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Establishment', function(Establishment) {
                            return Establishment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('establishment', null, { reload: 'establishment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Establishment', Establishment);

    Establishment.$inject = ['$resource'];

    function Establishment ($resource) {
        var resourceUrl =  'api/establishments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EstablishmentController', EstablishmentController);

    EstablishmentController.$inject = ['$scope', '$state', 'Establishment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function EstablishmentController ($scope, $state, Establishment, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Establishment.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.establishments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EducationDialogController', EducationDialogController);

    EducationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Education', 'Establishment', 'Profile'];

    function EducationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Education, Establishment, Profile) {
        var vm = this;

        vm.education = entity;
        vm.clear = clear;
        vm.save = save;
        vm.establishments = Establishment.query();
        vm.profiles = Profile.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.education.id !== null) {
                Education.update(vm.education, onSaveSuccess, onSaveError);
            } else {
                Education.save(vm.education, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:educationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EducationDetailController', EducationDetailController);

    EducationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Education', 'Establishment', 'Profile'];

    function EducationDetailController($scope, $rootScope, $stateParams, previousState, entity, Education, Establishment, Profile) {
        var vm = this;

        vm.education = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:educationUpdate', function(event, result) {
            vm.education = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EducationDeleteController',EducationDeleteController);

    EducationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Education'];

    function EducationDeleteController($uibModalInstance, entity, Education) {
        var vm = this;

        vm.education = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Education.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('education', {
            parent: 'entity',
            url: '/education?page&sort&search',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Educations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/education/educations.html',
                    controller: 'EducationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('education-detail', {
            parent: 'entity',
            url: '/education/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Education'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/education/education-detail.html',
                    controller: 'EducationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Education', function($stateParams, Education) {
                    return Education.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'education',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('education-detail.edit', {
            parent: 'education-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/education/education-dialog.html',
                    controller: 'EducationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Education', function(Education) {
                            return Education.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('education.new', {
            parent: 'education',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/education/education-dialog.html',
                    controller: 'EducationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startDate: null,
                                endDate: null,
                                degree: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('education', null, { reload: 'education' });
                }, function() {
                    $state.go('education');
                });
            }]
        })
        .state('education.edit', {
            parent: 'education',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/education/education-dialog.html',
                    controller: 'EducationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Education', function(Education) {
                            return Education.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('education', null, { reload: 'education' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('education.delete', {
            parent: 'education',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/education/education-delete-dialog.html',
                    controller: 'EducationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Education', function(Education) {
                            return Education.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('education', null, { reload: 'education' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Education', Education);

    Education.$inject = ['$resource'];

    function Education ($resource) {
        var resourceUrl =  'api/educations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EducationController', EducationController);

    EducationController.$inject = ['$scope', '$state', 'Education', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function EducationController ($scope, $state, Education, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Education.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.educations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DivisionDialogController', DivisionDialogController);

    DivisionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Division'];

    function DivisionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Division) {
        var vm = this;

        vm.division = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.division.id !== null) {
                Division.update(vm.division, onSaveSuccess, onSaveError);
            } else {
                Division.save(vm.division, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:divisionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DivisionDetailController', DivisionDetailController);

    DivisionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Division'];

    function DivisionDetailController($scope, $rootScope, $stateParams, previousState, entity, Division) {
        var vm = this;

        vm.division = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:divisionUpdate', function(event, result) {
            vm.division = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DivisionDeleteController',DivisionDeleteController);

    DivisionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Division'];

    function DivisionDeleteController($uibModalInstance, entity, Division) {
        var vm = this;

        vm.division = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Division.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('division', {
            parent: 'admin',
            url: '/division?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Divisions'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/entities/division/divisions.html',
                    controller: 'DivisionController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
            }
        })
        .state('division-detail', {
            parent: 'admin',
            url: '/division/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Division'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/entities/division/division-detail.html',
                    controller: 'DivisionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Division', function($stateParams, Division) {
                    return Division.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'division',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('division-detail.edit', {
            parent: 'division-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('division.new', {
            parent: 'division',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('division');
                });
            }]
        })
        .state('division.edit', {
            parent: 'division',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('division.delete', {
            parent: 'division',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-delete-dialog.html',
                    controller: 'DivisionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Division', Division);

    Division.$inject = ['$resource'];

    function Division ($resource) {
        var resourceUrl =  'api/divisions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'search': {
                method: 'GET',
                url: 'api/divisions/search/:query',
                isArray: true
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DivisionController', DivisionController);

    DivisionController.$inject = ['$scope', '$state', 'Division', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DivisionController ($scope, $state, Division, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Division.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.divisions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DiscussionDialogController', DiscussionDialogController);

    DiscussionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Discussion', 'User'];

    function DiscussionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Discussion, User) {
        var vm = this;

        vm.discussion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.discussion.id !== null) {
                Discussion.update(vm.discussion, onSaveSuccess, onSaveError);
            } else {
                Discussion.save(vm.discussion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:discussionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DiscussionDetailController', DiscussionDetailController);

    DiscussionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Discussion', 'User'];

    function DiscussionDetailController($scope, $rootScope, $stateParams, previousState, entity, Discussion, User) {
        var vm = this;

        vm.discussion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:discussionUpdate', function(event, result) {
            vm.discussion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DiscussionDeleteController',DiscussionDeleteController);

    DiscussionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Discussion'];

    function DiscussionDeleteController($uibModalInstance, entity, Discussion) {
        var vm = this;

        vm.discussion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Discussion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discussion', {
            parent: 'entity',
            url: '/discussion',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Discussions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discussion/discussions.html',
                    controller: 'DiscussionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('discussion-detail', {
            parent: 'entity',
            url: '/discussion/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Discussion'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discussion/discussion-detail.html',
                    controller: 'DiscussionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Discussion', function($stateParams, Discussion) {
                    return Discussion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'discussion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('discussion-detail.edit', {
            parent: 'discussion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discussion/discussion-dialog.html',
                    controller: 'DiscussionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Discussion', function(Discussion) {
                            return Discussion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discussion.new', {
            parent: 'discussion',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discussion/discussion-dialog.html',
                    controller: 'DiscussionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                closed: false,
                                admin: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('discussion', null, { reload: 'discussion' });
                }, function() {
                    $state.go('discussion');
                });
            }]
        })
        .state('discussion.edit', {
            parent: 'discussion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discussion/discussion-dialog.html',
                    controller: 'DiscussionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Discussion', function(Discussion) {
                            return Discussion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('discussion', null, { reload: 'discussion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discussion.delete', {
            parent: 'discussion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discussion/discussion-delete-dialog.html',
                    controller: 'DiscussionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Discussion', function(Discussion) {
                            return Discussion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('discussion', null, { reload: 'discussion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Discussion', Discussion);

    Discussion.$inject = ['$resource'];

    function Discussion ($resource) {
        var resourceUrl =  'api/discussions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'close': {
                method: 'GET',
                url: 'api/discussions/close/:id'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DiscussionController', DiscussionController);

    DiscussionController.$inject = ['$scope', '$state', 'Discussion'];

    function DiscussionController ($scope, $state, Discussion) {
        var vm = this;

        vm.discussions = [];

        loadAll();

        function loadAll() {
            Discussion.query(function(result) {
                vm.discussions = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Director', Director);

    Director.$inject = ['$resource', '$http'];

    function Director ($resource, $http) {
        var service = $resource('api/directors/:id', { email: '@email'}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'querySales': {
                method: 'GET',
                isArray: true,
                url: 'api/directors/mySales'
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DepartmentDialogController', DepartmentDialogController);

    DepartmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Department'];

    function DepartmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Department) {
        var vm = this;

        vm.department = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.department.id !== null) {
                Department.update(vm.department, onSaveSuccess, onSaveError);
            } else {
                Department.save(vm.department, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:departmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DepartmentDetailController', DepartmentDetailController);

    DepartmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Department'];

    function DepartmentDetailController($scope, $rootScope, $stateParams, previousState, entity, Department) {
        var vm = this;

        vm.department = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:departmentUpdate', function(event, result) {
            vm.department = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DepartmentDeleteController',DepartmentDeleteController);

    DepartmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Department'];

    function DepartmentDeleteController($uibModalInstance, entity, Department) {
        var vm = this;

        vm.department = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Department.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('department', {
            parent: 'profile-info-management',
            url: '/department?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Départements'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/department/departments.html',
                    controller: 'DepartmentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('department-detail', {
            parent: 'profile-info-management',
            url: '/department/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Département'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/department/department-detail.html',
                    controller: 'DepartmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Department', function($stateParams, Department) {
                    return Department.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'department',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('department-detail.edit', {
            parent: 'department-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department/department-dialog.html',
                    controller: 'DepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Department', function(Department) {
                            return Department.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('department.new', {
            parent: 'department',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department/department-dialog.html',
                    controller: 'DepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('department', null, { reload: 'department' });
                }, function() {
                    $state.go('department');
                });
            }]
        })
        .state('department.edit', {
            parent: 'department',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department/department-dialog.html',
                    controller: 'DepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Department', function(Department) {
                            return Department.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('department', null, { reload: 'department' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('department.delete', {
            parent: 'department',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department/department-delete-dialog.html',
                    controller: 'DepartmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Department', function(Department) {
                            return Department.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('department', null, { reload: 'department' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Department', Department);

    Department.$inject = ['$resource'];

    function Department ($resource) {
        var resourceUrl =  'api/departments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DepartmentController', DepartmentController);

    DepartmentController.$inject = ['$scope', '$state', 'Department', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DepartmentController ($scope, $state, Department, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Department.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.departments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DeleteProfileRequestDialogController', DeleteProfileRequestDialogController);

    DeleteProfileRequestDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DeleteProfileRequest'];

    function DeleteProfileRequestDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DeleteProfileRequest) {
        var vm = this;

        vm.deleteProfileRequest = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.deleteProfileRequest.id !== null) {
                DeleteProfileRequest.update(vm.deleteProfileRequest, onSaveSuccess, onSaveError);
            } else {
                DeleteProfileRequest.save(vm.deleteProfileRequest, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:deleteProfileRequestUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DeleteProfileRequestDetailController', DeleteProfileRequestDetailController);

    DeleteProfileRequestDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DeleteProfileRequest'];

    function DeleteProfileRequestDetailController($scope, $rootScope, $stateParams, previousState, entity, DeleteProfileRequest) {
        var vm = this;

        vm.deleteProfileRequest = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:deleteProfileRequestUpdate', function(event, result) {
            vm.deleteProfileRequest = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DeleteProfileRequestDeleteController',DeleteProfileRequestDeleteController);

    DeleteProfileRequestDeleteController.$inject = ['$uibModalInstance', 'entity', 'DeleteProfileRequest'];

    function DeleteProfileRequestDeleteController($uibModalInstance, entity, DeleteProfileRequest) {
        var vm = this;

        vm.deleteProfileRequest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DeleteProfileRequest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('delete-profile-request', {
            parent: 'profile-info-management',
            url: '/delete-profile-request?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Demande de suppression de profil'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/delete-profile-request/delete-profile-request.html',
                    controller: 'DeleteProfileRequestController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('delete-profile-request-detail', {
            parent: 'profile-info-management',
            url: '/delete-profile-request/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Demande de suppression de profil'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/delete-profile-request/delete-profile-request-detail.html',
                    controller: 'DeleteProfileRequestDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'DeleteProfileRequest', function($stateParams, DeleteProfileRequest) {
                    return DeleteProfileRequest.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'delete-profile-request',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('delete-profile-request-detail.edit', {
            parent: 'delete-profile-request-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delete-profile-request/delete-profile-request-dialog.html',
                    controller: 'DeleteProfileRequestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DeleteProfileRequest', function(DeleteProfileRequest) {
                            return DeleteProfileRequest.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delete-profile-request.new', {
            parent: 'delete-profile-request',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delete-profile-request/delete-profile-request-dialog.html',
                    controller: 'DeleteProfileRequestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('delete-profile-request', null, { reload: 'delete-profile-request' });
                }, function() {
                    $state.go('delete-profile-request');
                });
            }]
        })
        .state('delete-profile-request.edit', {
            parent: 'delete-profile-request',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delete-profile-request/delete-profile-request-dialog.html',
                    controller: 'DeleteProfileRequestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DeleteProfileRequest', function(DeleteProfileRequest) {
                            return DeleteProfileRequest.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delete-profile-request', null, { reload: 'delete-profile-request' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delete-profile-request.delete', {
            parent: 'delete-profile-request',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delete-profile-request/delete-profile-request-delete-dialog.html',
                    controller: 'DeleteProfileRequestDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DeleteProfileRequest', function(DeleteProfileRequest) {
                            return DeleteProfileRequest.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delete-profile-request', null, { reload: 'delete-profile-request' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('DeleteProfileRequest', DeleteProfileRequest);

    DeleteProfileRequest.$inject = ['$resource'];

    function DeleteProfileRequest ($resource) {
        var resourceUrl =  'api/deleteProfileRequests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DeleteProfileRequestController', DeleteProfileRequestController);

    DeleteProfileRequestController.$inject = ['$scope', '$state', 'DeleteProfileRequest', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DeleteProfileRequestController ($scope, $state, DeleteProfileRequest, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            DeleteProfileRequest.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.deleteProfileRequests = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DegreeDialogController', DegreeDialogController);

    DegreeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Degree'];

    function DegreeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Degree) {
        var vm = this;

        vm.degree = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.degree.id !== null) {
                Degree.update(vm.degree, onSaveSuccess, onSaveError);
            } else {
                Degree.save(vm.degree, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:degreeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DegreeDetailController', DegreeDetailController);

    DegreeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Degree'];

    function DegreeDetailController($scope, $rootScope, $stateParams, previousState, entity, Degree) {
        var vm = this;

        vm.degree = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:degreeUpdate', function(event, result) {
            vm.degree = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DegreeDeleteController',DegreeDeleteController);

    DegreeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Degree'];

    function DegreeDeleteController($uibModalInstance, entity, Degree) {
        var vm = this;

        vm.degree = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Degree.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('degree', {
            parent: 'profile-info-management',
            url: '/degree?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Diplômes'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/degree/degrees.html',
                    controller: 'DegreeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('degree-detail', {
            parent: 'profile-info-management',
            url: '/degree/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Diplôme'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/degree/degree-detail.html',
                    controller: 'DegreeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Degree', function($stateParams, Degree) {
                    return Degree.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'degree',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('degree-detail.edit', {
            parent: 'degree-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/degree/degree-dialog.html',
                    controller: 'DegreeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Degree', function(Degree) {
                            return Degree.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('degree.new', {
            parent: 'degree',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/degree/degree-dialog.html',
                    controller: 'DegreeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('degree', null, { reload: 'degree' });
                }, function() {
                    $state.go('degree');
                });
            }]
        })
        .state('degree.edit', {
            parent: 'degree',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/degree/degree-dialog.html',
                    controller: 'DegreeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Degree', function(Degree) {
                            return Degree.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('degree', null, { reload: 'degree' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('degree.delete', {
            parent: 'degree',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/degree/degree-delete-dialog.html',
                    controller: 'DegreeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Degree', function(Degree) {
                            return Degree.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('degree', null, { reload: 'degree' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Degree', Degree);

    Degree.$inject = ['$resource'];

    function Degree ($resource) {
        var resourceUrl =  'api/degrees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DegreeController', DegreeController);

    DegreeController.$inject = ['$scope', '$state', 'Degree', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DegreeController ($scope, $state, Degree, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Degree.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.degrees = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DealDialogController', DealDialogController);

    DealDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Deal', 'User'];

    function DealDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Deal, User) {
        var vm = this;

        vm.deal = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.deal.id !== null) {
                Deal.update(vm.deal, onSaveSuccess, onSaveError);
            } else {
                Deal.save(vm.deal, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:dealUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DealDetailController', DealDetailController);

    DealDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Deal', 'User'];

    function DealDetailController($scope, $rootScope, $stateParams, previousState, entity, Deal, User) {
        var vm = this;

        vm.deal = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:dealUpdate', function(event, result) {
            vm.deal = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DealDeleteController',DealDeleteController);

    DealDeleteController.$inject = ['$uibModalInstance', 'entity', 'Deal'];

    function DealDeleteController($uibModalInstance, entity, Deal) {
        var vm = this;

        vm.deal = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Deal.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('deal', {
            parent: 'entity',
            url: '/deal?page&sort&search',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Deals'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/deal/deals.html',
                    controller: 'DealController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('deal-detail', {
            parent: 'entity',
            url: '/deal/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Deal'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/deal/deal-detail.html',
                    controller: 'DealDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Deal', function($stateParams, Deal) {
                    return Deal.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'deal',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('deal-detail.edit', {
            parent: 'deal-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/deal/deal-dialog.html',
                    controller: 'DealDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Deal', function(Deal) {
                            return Deal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('deal.new', {
            parent: 'deal',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/deal/deal-dialog.html',
                    controller: 'DealDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                amount: null,
                                commission: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('deal', null, { reload: 'deal' });
                }, function() {
                    $state.go('deal');
                });
            }]
        })
        .state('deal.edit', {
            parent: 'deal',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/deal/deal-dialog.html',
                    controller: 'DealDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Deal', function(Deal) {
                            return Deal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('deal', null, { reload: 'deal' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('deal.delete', {
            parent: 'deal',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/deal/deal-delete-dialog.html',
                    controller: 'DealDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Deal', function(Deal) {
                            return Deal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('deal', null, { reload: 'deal' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Deal', Deal);

    Deal.$inject = ['$resource'];

    function Deal ($resource) {
        var resourceUrl =  'api/deals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DealController', DealController);

    DealController.$inject = ['$scope', '$state', 'Deal', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DealController ($scope, $state, Deal, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Deal.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.deals = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ContributionDialogController', ContributionDialogController);

    ContributionDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', 'Principal'];

    function ContributionDialogController ($timeout, $scope, $state, $stateParams, $uibModalInstance, Principal) {
        var vm = this;
        vm.isAdmin = isAdmin;
        $timeout(function (){
            if ($stateParams.multiple){
                vm.multiple = true;
                vm.selectedContribution = 'new-profile';
                $state.go($state.current.parent + '.' + vm.selectedContribution);
            } else {
                vm.multiple = false;
            }
        });
        console.log($stateParams);
        
        $scope.options = [
          { label: 'Une nouvelle personne', value: 'new-profile' },
          { label: 'Une nouvelle entreprise', value: 'new-company' },
          { label: 'Une nouvelle collectivité', value: 'new-collectivity' }
        ];
       
        vm.change = function() {
            $state.go($state.current.parent + '.' + vm.selectedContribution);
        };


        function clear () {
            $uibModalInstance.close();
        }

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('new-contribution', {
            parent: 'home',
            url: '/new-contribution',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: false});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('home.new-profile', {
            parent: 'home',
            url: '/contribution-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
             resolve: {
                entity: function () {
                    return {
                        name: null,
                        id: null
                    };
                }
            },
             views: {
              'contrib@': { 
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('home.new-company', {
            parent: 'home',
            url: '/contribution-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        logo: null,
                        logoContentType: null,
                        id: null
                    };
                }
            },
            views: {
              'contrib@': { 
                templateUrl: 'app/entities/company/company-dialog.html',
                controller: 'CompanyDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('home.new-collectivity', {
            parent: 'home',
            url: '/contribution-collectivity',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        city: null,
                        collectivitySize: null,
                        id: null
                    };
                }
            },
            views: {
              'contrib@': { 
                templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                controller: 'CollectivityDialogController',
                controllerAs: 'vm'
              }
            }
        })

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ConnexionDialogController', ConnexionDialogController);

    ConnexionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Connexion', 'Profile'];

    function ConnexionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Connexion, Profile) {
        var vm = this;

        vm.connexion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.profiles = Profile.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.connexion.id !== null) {
                Connexion.update(vm.connexion, onSaveSuccess, onSaveError);
            } else {
                Connexion.save(vm.connexion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:connexionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ConnexionDetailController', ConnexionDetailController);

    ConnexionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Connexion', 'Profile'];

    function ConnexionDetailController($scope, $rootScope, $stateParams, previousState, entity, Connexion, Profile) {
        var vm = this;

        vm.connexion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:connexionUpdate', function(event, result) {
            vm.connexion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ConnexionDeleteController',ConnexionDeleteController);

    ConnexionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Connexion'];

    function ConnexionDeleteController($uibModalInstance, entity, Connexion) {
        var vm = this;

        vm.connexion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Connexion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('connexion', {
            parent: 'entity',
            url: '/connexion',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Connexions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/connexion/connexions.html',
                    controller: 'ConnexionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('connexion-detail', {
            parent: 'entity',
            url: '/connexion/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Connexion'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/connexion/connexion-detail.html',
                    controller: 'ConnexionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Connexion', function($stateParams, Connexion) {
                    return Connexion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'connexion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('connexion-detail.edit', {
            parent: 'connexion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/connexion/connexion-dialog.html',
                    controller: 'ConnexionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Connexion', function(Connexion) {
                            return Connexion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('connexion.new', {
            parent: 'connexion',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/connexion/connexion-dialog.html',
                    controller: 'ConnexionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                grade: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('connexion', null, { reload: 'connexion' });
                }, function() {
                    $state.go('connexion');
                });
            }]
        })
        .state('connexion.edit', {
            parent: 'connexion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/connexion/connexion-dialog.html',
                    controller: 'ConnexionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Connexion', function(Connexion) {
                            return Connexion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('connexion', null, { reload: 'connexion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('connexion.delete', {
            parent: 'connexion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/connexion/connexion-delete-dialog.html',
                    controller: 'ConnexionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Connexion', function(Connexion) {
                            return Connexion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('connexion', null, { reload: 'connexion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Connexion', Connexion);

    Connexion.$inject = ['$resource'];

    function Connexion ($resource) {
        var resourceUrl =  'api/connexions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'create': { method: 'POST' },
            'update': { method:'PUT' },
            'internalNetworkCommercial': {
                url: '/api/connexions/internalnetwork/commercial/:profileId?size=50',
                isArray: true,
                method: 'GET'
            },
            'internalNetworkDG': {
                url: '/api/connexions/internalnetwork/dg/:profileId',
                isArray: true,
                method: 'GET'
            },
            'externalNetwork': {
                url: '/api/connexions/externalnetwork/:profileId',
                isArray: true,
                method: 'GET'
            },
            'allInternalNetworkCommercial': {
                url: '/api/connexions/internalnetwork/commercial',
                isArray: true,
                method: 'GET'
            },
            'allInternalNetworkDG': {
                url: '/api/connexions/internalnetwork/dg',
                isArray: true,
                method: 'GET'
            },
            'allInternalNetworkDGInvited': {
                url: '/api/connexions/internalnetwork/dg/invited',
                isArray: true,
                method: 'GET'
            },
            'allInternalNetworkDGArchived': {
                url: '/api/connexions/internalnetwork/dg/archived',
                isArray: true,
                method: 'GET'
            },
            'inverseNetworks': {
                url: '/api/connexions/inverseNetworks/:profileId',
                isArray: true,
                method: 'GET'
            },
            'search': {
                url: '/api/connexions/network/search/:query',
                isArray: true,
                method: 'GET'
            },
            'internalNetworkOfOrganisation': {
                method: 'GET',
                isArray: true,
                url: '/api/connexions/internalnetworkorganisation?organizationId=:organizationId&size=50'
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ConnexionController', ConnexionController);

    ConnexionController.$inject = ['$scope', '$state', 'Connexion'];

    function ConnexionController ($scope, $state, Connexion) {
        var vm = this;

        vm.connexions = [];

        loadAll();

        function loadAll() {
            Connexion.query(function(result) {
                vm.connexions = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyStatusDialogController', CompanyStatusDialogController);

    CompanyStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyStatus'];

    function CompanyStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyStatus) {
        var vm = this;

        vm.companyStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.companyStatus.id !== null) {
                CompanyStatus.update(vm.companyStatus, onSaveSuccess, onSaveError);
            } else {
                CompanyStatus.save(vm.companyStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:companyStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyStatusDetailController', CompanyStatusDetailController);

    CompanyStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CompanyStatus'];

    function CompanyStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, CompanyStatus) {
        var vm = this;

        vm.companyStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:companyStatusUpdate', function(event, result) {
            vm.companyStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyStatusDeleteController',CompanyStatusDeleteController);

    CompanyStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanyStatus'];

    function CompanyStatusDeleteController($uibModalInstance, entity, CompanyStatus) {
        var vm = this;

        vm.companyStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CompanyStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('company-status', {
            parent: 'profile-info-management',
            url: '/company-status?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Statuts entreprises'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/company-status/company-statuses.html',
                    controller: 'CompanyStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('company-status-detail', {
            parent: 'profile-info-management',
            url: '/company-status/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Statut entreprise'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/company-status/company-status-detail.html',
                    controller: 'CompanyStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CompanyStatus', function($stateParams, CompanyStatus) {
                    return CompanyStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'company-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('company-status-detail.edit', {
            parent: 'company-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-status/company-status-dialog.html',
                    controller: 'CompanyStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CompanyStatus', function(CompanyStatus) {
                            return CompanyStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company-status.new', {
            parent: 'company-status',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-status/company-status-dialog.html',
                    controller: 'CompanyStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company-status', null, { reload: 'company-status' });
                }, function() {
                    $state.go('company-status');
                });
            }]
        })
        .state('company-status.edit', {
            parent: 'company-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-status/company-status-dialog.html',
                    controller: 'CompanyStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CompanyStatus', function(CompanyStatus) {
                            return CompanyStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-status', null, { reload: 'company-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company-status.delete', {
            parent: 'company-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-status/company-status-delete-dialog.html',
                    controller: 'CompanyStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CompanyStatus', function(CompanyStatus) {
                            return CompanyStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-status', null, { reload: 'company-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('CompanyStatus', CompanyStatus);

    CompanyStatus.$inject = ['$resource'];

    function CompanyStatus ($resource) {
        var resourceUrl =  'api/company-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyStatusController', CompanyStatusController);

    CompanyStatusController.$inject = ['$scope', '$state', 'CompanyStatus', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CompanyStatusController ($scope, $state, CompanyStatus, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CompanyStatus.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {

    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyDialogController', CompanyDialogController);

    CompanyDialogController.$inject = ['$timeout', '$scope', '$window','$rootScope', '$stateParams', 'DataUtils', 'entity', 'Company', 'CompanyStatus', 'Sector', 'Organisation', 'Principal', 'ModerationOrganisation'];

    function CompanyDialogController ($timeout, $scope, $window, $rootScope, $stateParams, DataUtils, entity, Company, CompanyStatus, Sector, Organisation, Principal, ModerationOrganisation) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.companystatuses = CompanyStatus.query();
        vm.sectors = Sector.query();

        vm.companiesNoResults = false;
        vm.getCompanies = getCompanies;
        vm.isAdmin = isAdmin;
        vm.currentAccount = null;

        vm.deleteOrganisation = deleteOrganisation;
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        $timeout(function (){
            vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
            if (entity.id){
                $scope.$parent.vm.edit = true;
            }

            if (vm.company.selfHolding){
                vm.company.holding = vm.company;
            }

            $scope.$parent.vm.selectedContribution="new-company";
            angular.element('.form-group:eq(0)>input').focus();
        });

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function clear () {
            $scope.$parent.$dismiss();
        }

        function save () {
            vm.isSaving = true;
            // if (isAdmin() || vm.company.myContribution){
                if (vm.company.id !== null) {
                    // UPDATE
                    if (vm.company.holding == ""){
                        vm.company.holding = null;
                    }
                    if (vm.company.holding && (vm.company.holding.id==vm.company.id)){
                        vm.company.holding=null;
                        vm.company.selfHolding=true;
                    } else {
                        vm.company.selfHolding=false;
                    }

                    if (vm.company.moderationId){
                        // Il s'agit d'une modération. Update de la company à partir de la modération
                        ModerationOrganisation.updateAndApprove({id: vm.company.moderationId}, vm.company, onSaveSuccess, onSaveError);
                    } else {
                        // Update direct de la company en base
                        Organisation.update(vm.company, onSaveSuccess, onSaveError);
                    }
                } else {
                    // CREATION
                    if (vm.company.moderationId){
                        // Il s'agit d'une modération. Création de la company à partir de la modération
                        ModerationOrganisation.createAndApprove({id: vm.company.moderationId}, vm.company, onSaveSuccess, onSaveError);
                    } else {
                        // Création direct de la company en base
                        vm.company.type = 'company';
                        Organisation.save(vm.company, onSaveSuccess, onSaveError);
                    }
                }
            /*
            } else {
                // Création d'une modération si non admin
                var mCompany = Object.assign({}, vm.company);
                mCompany.positions = null;
                if (vm.company.id !== null) {
                    mCompany['referencedOrganisation']  = Object.assign({}, vm.company);
                    mCompany.id = null;
                    ModerationOrganisation.mupdate(mCompany, onModerationSaveSuccess, onSaveError);
                } else {
                    mCompany.type = 'company';
                    ModerationOrganisation.msave(mCompany, onModerationSaveSuccess, onSaveError);
                }
            }
            */
        }

        function onModerationSaveSuccess (result) {
            $scope.$emit('quilinkApp:moderationCompanyUpdate', result);
            $rootScope.$broadcast('quilinkApp:moderationCompanyUpdate', result);
            vm.company.hasModeration = true;
            vm.isSaving = false;
            $scope.$parent.$close();
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:companyUpdate', result);
            $rootScope.$broadcast('quilinkApp:companyUpdate', result);
            $scope.$parent.$close();
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setLogo = function ($file, company) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        company.logo = base64Data;
                        company.logoContentType = $file.type;
                    });
                });
            }
        };

        function getCompanies(q) {
            return Company.search({ query: q }).$promise.then(function (companies) {
                vm.organizationsNoResults = companies.length === 0;
                if (isAdmin()) {
                    companies.map( function(org) {
                        if (org.equipeCommerciale) {
                            org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                        }
                    });
                }
                return companies;
            });
        }


        function deleteOrganisation() {
            vm.isSaving = true;
            if (vm.company.id !== null) {
                Organisation.delete({
                    id: vm.company.id
                }, onDeleteSuccess, onSaveError);
            }
        }

        function onDeleteSuccess(result) {
            $scope.$emit('quilinkApp:companyUpdate', null);
            $rootScope.$broadcast('quilinkApp:companyUpdate', null);
            vm.isSaving = false;
            $window.location.href = '/';
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyDetailController', CompanyDetailController);

    CompanyDetailController.$inject = ['entity', 'Profile', 'Principal'];

    function CompanyDetailController (entity, Profile, Principal) {
        var vm = this;
        vm.company = entity;
        vm.isAdmin = isAdmin;
        vm.website = website(vm.company);
        vm.countProfilesForOrganisation = " ";
        vm.countAxenteeversForOrganisation = " ";
        init(); 
        function init() {
  			Profile.countProfilesForOrganisation({
                organisationId: vm.company.id
            }, function (result) {
                vm.countProfilesForOrganisation = result.count;
            });

  			Profile.countAxenteeversForOrganisation({
                organisationId: vm.company.id
            }, function (result) {
                vm.countAxenteeversForOrganisation = result.count;
            });
         }
         
        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function website(company) {
            var website = company.website;
            if (website && !website.includes('http')) {
                return 'https://' + website;
            } else {
                return website;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyDeleteController',CompanyDeleteController);

    CompanyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Organisation'];

    function CompanyDeleteController($uibModalInstance, entity, Organisation) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Organisation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('company', {
            parent: 'profile-info-management',
            url: '/company?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Entreprises'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/company/companies.html',
                    controller: 'CompanyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('company-detail', {
            parent: 'entity',
            url: '/company/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Entreprise'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company/company-detail.html',
                    controller: 'CompanyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Company', function($stateParams, Company) {
                    return Company.get({id : $stateParams.id}).$promise.catch(function(error) {
                        $state.go('accessdenied');
                    });
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'company',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('company-detail.edit', {
            parent: 'company-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company.new', {
            parent: 'company',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                logo: null,
                                logoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: 'company' });
                }, function() {
                    $state.go('company');
                });
            }]
        })



        .state('company.contribution', {
            parent: 'company',
            url:"/company-contribution",
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('company');
                }, function() {
                    $state.go('company');
                });
            }]
        })
        .state('company.contribution.new-company', {
            parent: 'company.contribution',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
           resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        logo: null,
                        logoContentType: null,
                        id: null
                    };
                }
            },
            views: {
                'contrib@': {
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm'
              }
            },
        })

        .state('company.new-company', {
            parent: 'app',
            url: 'new-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                logo: null,
                                logoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        /*
        .state('company.new-company-detail', {
            parent: 'company-detail',
            url: '/new-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                logo: null,
                                logoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        */
        .state('company-detail.contribution', {
            url: '/company-detail-contribution',
            parent: 'company-detail',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('company-detail',{}, { reload: true });
                }, function() {
                    $state.go('company-detail');
                });
            }]
        })

        .state('company-detail.contribution.new-profile', {
            parent: 'company-detail.contribution',
            url: '/new-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
             resolve: {
                entity: function () {
                    return {
                        name: null,
                        id: null
                    };
                }
            },
             views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })

        .state('company-detail.contribution.new-company', {
            parent: 'company-detail.contribution',
            url: '/new-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        logo: null,
                        logoContentType: null,
                        id: null
                    };
                }
            },
            views: {
                'contrib@': {
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm'
              }
            }
        })


        /*
        .state('company.new-company-profile', {
            parent: 'profile',
            url: '/new-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                logo: null,
                                logoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        */

        /*
        .state('company.edit', {
            parent: 'company',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: 'company' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        */


        .state('company.contribution.edit', {
            parent: 'company.contribution',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: ['$stateParams', 'Company', function($stateParams, Company) {
                    return Company.get({id : $stateParams.id}).$promise;
                }],
            },
            views: {
                'contrib@': {
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm'
                }
            }
        })

        .state('company-detail.contribution.edit-company', {
            parent: 'company-detail.contribution',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: ['$stateParams', 'Company', function($stateParams, Company) {
                    return Company.get({id : $stateParams.id}).$promise;
                }],
            },
            views: {
              'contrib@': {
                templateUrl: 'app/entities/company/company-dialog.html',
                controller: 'CompanyDialogController',
                controllerAs: 'vm'
              }
            }
        })

        .state('company.delete', {
            parent: 'company',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-delete-dialog.html',
                    controller: 'CompanyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: 'company' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company.switch', {
            parent: 'company',
            url: '/{id}/switch',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organisation/organisation-switch-dialog.html',
                    controller: 'OrganisationSwitchController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: false});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company-detail.quickconnect-new', {
            parent: 'company-detail',
            url: '/detail/quickconnect/{organisation}',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quickconnect/quickconnect-dialog.html',
                    controller: 'QuickconnectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company-detail', null, { reload: false });
                }, function() {
                    $state.go('company-detail');
                });
            }]
        });
    }


})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Company', Company);

    Company.$inject = ['$resource'];

    function Company ($resource) {
        var resourceUrl =  'api/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'search': {
                method: 'GET',
                url: 'api/companies/search/:query',
                isArray: true
            },
            'queryPaginated': {
                method: 'GET',
                url: 'api/companies/paginated',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CompanyController', CompanyController);

    CompanyController.$inject = ['$scope', '$state', 'DataUtils', 'Company', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$uibModal'];

    function CompanyController ($scope, $state, DataUtils, Company, ParseLinks, AlertService, paginationConstants, pagingParams, $uibModal) {
        var vm = this;

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.companies = [];
        vm.confirmMerge = confirmMerge;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.totalItems = null;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = 200;
        vm.transition = transition;
        vm.links = null;
        vm.loadAll();

        function loadAll () {
            Company.queryPaginated({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }
        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }
        function onSuccess(data, headers) {
           
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.companies = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function confirmMerge (id) {
            $uibModal.open({
                templateUrl: 'app/entities/organisation/organisation-switch-dialog.html',
                controller: 'OrganisationSwitchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Company', function(Company) {
                        return Company.get({id : id}).$promise;
                    }]
                }
            }).result.then(function() {
                vm.companies = vm.companies.filter(function(el) {
                    return el.id !== id;
                })
            }, function() {
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityTypeDialogController', CollectivityTypeDialogController);

    CollectivityTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CollectivityType'];

    function CollectivityTypeDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CollectivityType) {
        var vm = this;

        vm.collectivityType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.collectivityType.id !== null) {
                CollectivityType.update(vm.collectivityType, onSaveSuccess, onSaveError);
            } else {
                CollectivityType.save(vm.collectivityType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('quilinkApp:collectivityTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityTypeDetailController', CollectivityTypeDetailController);

    CollectivityTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CollectivityType'];

    function CollectivityTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, CollectivityType) {
        var vm = this;

        vm.collectivityType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:collectivityTypeUpdate', function(event, result) {
            vm.collectivityType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityTypeDeleteController', CollectivityTypeDeleteController);

    CollectivityTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CollectivityType'];

    function CollectivityTypeDeleteController($uibModalInstance, entity, CollectivityType) {
        var vm = this;

        vm.collectivityType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CollectivityType.delete({ id: id },
                function() {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('collectivity-type', {
                parent: 'profile-info-management',
                url: '/collectivity-type?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Types des collectivités'
                },
                views: {
                    'content@profile-info-management': {
                        templateUrl: 'app/entities/collectivity-type/collectivity-types.html',
                        controller: 'CollectivityTypeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                }
            })
            .state('collectivity-type-detail', {
                parent: 'profile-info-management',
                url: '/collectivity-type/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Taille d\'entreprise'
                },
                views: {
                    'content@profile-info-management': {
                        templateUrl: 'app/entities/collectivity-type/collectivity-type-detail.html',
                        controller: 'CollectivityTypeDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'CollectivityType', function($stateParams, CollectivityType) {
                        return CollectivityType.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'collectivity-type',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('collectivity-type-detail.edit', {
                parent: 'collectivity-type-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/collectivity-type/collectivity-type-dialog.html',
                        controller: 'CollectivityTypeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CollectivityType', function(CollectivityType) {
                                return CollectivityType.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('collectivity-type.new', {
                parent: 'collectivity-type',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/collectivity-type/collectivity-type-dialog.html',
                        controller: 'CollectivityTypeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    name: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('collectivity-type', null, { reload: 'collectivity-type' });
                    }, function() {
                        $state.go('collectivity-type');
                    });
                }]
            })
            .state('collectivity-type.edit', {
                parent: 'collectivity-type',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/collectivity-type/collectivity-type-dialog.html',
                        controller: 'CollectivityTypeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CollectivityType', function(CollectivityType) {
                                return CollectivityType.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('collectivity-type', null, { reload: 'collectivity-type' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('collectivity-type.delete', {
                parent: 'collectivity-type',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/collectivity-type/collectivity-type-delete-dialog.html',
                        controller: 'CollectivityTypeDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CollectivityType', function(CollectivityType) {
                                return CollectivityType.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('collectivity-type', null, { reload: 'collectivity-type' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }

})();
(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('CollectivityType', CollectivityType);

    CollectivityType.$inject = ['$resource'];

    function CollectivityType($resource) {
        var resourceUrl = 'api/collectivity-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityTypeController', CollectivityTypeController);

    CollectivityTypeController.$inject = ['$scope', '$state', 'CollectivityType', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CollectivityTypeController($scope, $state, CollectivityType, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            CollectivityType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.collectivityTypes = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivitySizeDialogController', CollectivitySizeDialogController);

    CollectivitySizeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CollectivitySize'];

    function CollectivitySizeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CollectivitySize) {
        var vm = this;

        vm.collectivitySize = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.collectivitySize.id !== null) {
                CollectivitySize.update(vm.collectivitySize, onSaveSuccess, onSaveError);
            } else {
                CollectivitySize.save(vm.collectivitySize, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:collectivitySizeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivitySizeDetailController', CollectivitySizeDetailController);

    CollectivitySizeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CollectivitySize'];

    function CollectivitySizeDetailController($scope, $rootScope, $stateParams, previousState, entity, CollectivitySize) {
        var vm = this;

        vm.collectivitySize = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:collectivitySizeUpdate', function(event, result) {
            vm.collectivitySize = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivitySizeDeleteController',CollectivitySizeDeleteController);

    CollectivitySizeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CollectivitySize'];

    function CollectivitySizeDeleteController($uibModalInstance, entity, CollectivitySize) {
        var vm = this;

        vm.collectivitySize = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CollectivitySize.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collectivity-size', {
            parent: 'profile-info-management',
            url: '/collectivity-size?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Tailles des entreprises'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/collectivity-size/collectivity-sizes.html',
                    controller: 'CollectivitySizeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('collectivity-size-detail', {
            parent: 'profile-info-management',
            url: '/collectivity-size/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Taille d\'entreprise'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/collectivity-size/collectivity-size-detail.html',
                    controller: 'CollectivitySizeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CollectivitySize', function($stateParams, CollectivitySize) {
                    return CollectivitySize.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'collectivity-size',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('collectivity-size-detail.edit', {
            parent: 'collectivity-size-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collectivity-size/collectivity-size-dialog.html',
                    controller: 'CollectivitySizeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CollectivitySize', function(CollectivitySize) {
                            return CollectivitySize.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collectivity-size.new', {
            parent: 'collectivity-size',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collectivity-size/collectivity-size-dialog.html',
                    controller: 'CollectivitySizeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collectivity-size', null, { reload: 'collectivity-size' });
                }, function() {
                    $state.go('collectivity-size');
                });
            }]
        })
        .state('collectivity-size.edit', {
            parent: 'collectivity-size',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collectivity-size/collectivity-size-dialog.html',
                    controller: 'CollectivitySizeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CollectivitySize', function(CollectivitySize) {
                            return CollectivitySize.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('collectivity-size', null, { reload: 'collectivity-size' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collectivity-size.delete', {
            parent: 'collectivity-size',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collectivity-size/collectivity-size-delete-dialog.html',
                    controller: 'CollectivitySizeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CollectivitySize', function(CollectivitySize) {
                            return CollectivitySize.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('collectivity-size', null, { reload: 'collectivity-size' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('CollectivitySize', CollectivitySize);

    CollectivitySize.$inject = ['$resource'];

    function CollectivitySize ($resource) {
        var resourceUrl =  'api/collectivity-sizes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivitySizeController', CollectivitySizeController);

    CollectivitySizeController.$inject = ['$scope', '$state', 'CollectivitySize', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CollectivitySizeController ($scope, $state, CollectivitySize, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CollectivitySize.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.collectivitySizes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityDialogController', CollectivityDialogController);

    CollectivityDialogController.$inject = ['$timeout', '$scope', '$window', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Organisation', 'City', 'Sector', 'CollectivitySize', 'CollectivityType', 'Principal', 'ModerationOrganisation'];

    function CollectivityDialogController($timeout, $scope, $window, $rootScope, $stateParams, DataUtils, entity, Organisation, City, Sector, CollectivitySize, CollectivityType, Principal, ModerationOrganisation) {
        var vm = this;

        vm.collectivity = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cities = City.query();
        vm.sectors = Sector.query();
        vm.collectivitysizes = CollectivitySize.query();

        vm.collectivityTypes = CollectivityType.query();

        vm.citiesNoResults = false;
        vm.getCities = getCities;

        vm.isAdmin = isAdmin;
        vm.deleteOrganisation = deleteOrganisation;
        $timeout(function() {
            vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
            if (entity.id) {
                $scope.$parent.vm.edit = true;
            }
            $scope.$parent.vm.selectedContribution = "new-collectivity";
            angular.element('.form-group:eq(0)>input').focus();
        });

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function clear() {
            $scope.$parent.$dismiss();
        }

        function save() {
            vm.isSaving = true;
            // if (isAdmin() || vm.collectivity.myContribution){
                if (vm.collectivity.id !== null) {
                    // UPDATE
                    if (vm.collectivity.moderationId) {
                        // Il s'agit d'une modération. Update de la collectivity à partir de la modération
                        ModerationOrganisation.updateAndApprove({ id: vm.collectivity.moderationId }, vm.collectivity, onSaveSuccess, onSaveError);
                    } else {
                        // Update direct de la company en base
                        Organisation.update(vm.collectivity, onSaveSuccess, onSaveError);
                    }
                } else {
                    // CREATION
                    if (vm.collectivity.moderationId) {
                        // Il s'agit d'une modération. Création de la collectivity à partir de la modération
                        ModerationOrganisation.createAndApprove({ id: vm.collectivity.moderationId }, vm.collectivity, onSaveSuccess, onSaveError);
                    } else {
                        // Création direct de la company en base
                        vm.collectivity.type = 'collectivity';
                        Organisation.save(vm.collectivity, onSaveSuccess, onSaveError);
                    }
                }
            /*
            } else {
                // Création d'une modération si non admin
                var mCompany = Object.assign({}, vm.collectivity);
                mCompany.positions = null;
                if (vm.collectivity.id !== null) {
                    mCompany['referencedOrganisation'] = Object.assign({}, vm.collectivity);
                    mCompany.id = null;
                    ModerationOrganisation.mupdate(mCompany, onModerationSaveSuccess, onSaveError);
                } else {
                    mCompany.type = 'collectivity';
                    ModerationOrganisation.msave(mCompany, onModerationSaveSuccess, onSaveError);
                }
            }
            */
        }

        function onModerationSaveSuccess(result) {
            $scope.$emit('quilinkApp:moderationCompanyUpdate', result);
            $rootScope.$broadcast('quilinkApp:moderationCompanyUpdate', result);
            vm.collectivity.hasModeration = true;
            vm.isSaving = false;
            $scope.$parent.$close();
        }

        function onSaveSuccess(result) {
            $scope.$emit('quilinkApp:collectivityUpdate', result);
            $rootScope.$broadcast('quilinkApp:collectivityUpdate', result);
            $scope.$parent.$close();
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.setLogo = function($file, company) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        company.logo = base64Data;
                        company.logoContentType = $file.type;
                    });
                });
            }
        };

        function getCities(q) {
            return City.search({ query: q }).$promise.then(function(cities) {
                vm.citiesNoResults = cities.length === 0;
                return cities;
            });
        }

        function deleteOrganisation() {
            vm.isSaving = true;
            if (vm.collectivity.id !== null) {
                Organisation.delete({
                    id: vm.collectivity.id
                }, onDeleteSuccess, onSaveError);
            }
        }

        function onDeleteSuccess(result) {
            $scope.$emit('quilinkApp:collectivityUpdate', null);
            $rootScope.$broadcast('quilinkApp:collectivityUpdate', null);
            vm.isSaving = false;
            $window.location.href = '/';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityDetailController', CollectivityDetailController);

    CollectivityDetailController.$inject = ['entity', 'Profile', 'Principal'];

    function CollectivityDetailController(entity, Profile, Principal) {
        var vm = this;
        vm.collectivity = entity;
        vm.isAdmin = isAdmin;
        vm.website = website(vm.collectivity);
        vm.countProfilesForOrganisation = " ";
        vm.countAxenteeversForOrganisation = " ";
        init(); 
        function init() {
  			Profile.countProfilesForOrganisation({
                organisationId: vm.collectivity.id
            }, function (result) {
                vm.countProfilesForOrganisation = result.count;
            });

  			Profile.countAxenteeversForOrganisation({
                organisationId: vm.collectivity.id
            }, function (result) {
                vm.countAxenteeversForOrganisation = result.count;
            });
         }
         
        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function website(collectivity) {
            var website = collectivity.website;
            if (website && !website.includes('http')) {
                return 'https://' + website;
            } else {
                return website;
            }
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityDeleteController',CollectivityDeleteController);

    CollectivityDeleteController.$inject = ['$uibModalInstance', 'entity', 'Organisation'];

    function CollectivityDeleteController($uibModalInstance, entity, Organisation) {
        var vm = this;

        vm.collectivity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Organisation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collectivity', {
            parent: 'profile-info-management',
            url: '/collectivity?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Collectivités'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/collectivity/collectivities.html',
                    controller: 'CollectivityController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('collectivity-detail', {
            parent: 'entity',
            url: '/collectivity/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Collectivité'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/collectivity/collectivity-detail.html',
                    controller: 'CollectivityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Collectivity', function($stateParams, Collectivity) {
                    return Collectivity.get({id : $stateParams.id}).$promise.catch(function(error) {
                        $state.go('accessdenied');
                    });
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'collectivity',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('collectivity-detail.edit', {
            parent: 'collectivity-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                    controller: 'CollectivityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Collectivity', function(Collectivity) {
                            return Collectivity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('collectivity.new-collectivity', {
            parent: 'app',
            url: 'new-collectivity',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                    controller: 'CollectivityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                city: null,
                                collectivitySize: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('collectivity.edit', {
            parent: 'collectivity',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                    controller: 'CollectivityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Collectivity', function(Collectivity) {
                            return Collectivity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('collectivity', null, { reload: 'collectivity' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collectivity.delete', {
            parent: 'collectivity',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collectivity/collectivity-delete-dialog.html',
                    controller: 'CollectivityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Collectivity', function(Collectivity) {
                            return Collectivity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('collectivity', null, { reload: 'collectivity' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collectivity-detail.contribution', {
            parent: 'collectivity-detail',
            url: '/collectivity-detail-contribution',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('collectivity-detail',{}, { reload: true });
                }, function() {
                    $state.go('collectivity-detail');
                });
            }]
        })

        .state('collectivity-detail.contribution.new-collectivity', {
            parent: 'collectivity-detail.contribution',
            url: '/new-collectivity',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        city: null,
                        collectivitySize: null,
                        id: null
                    };
                }
            },
            views: {
                'contrib@': {
                    templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                    controller: 'CollectivityDialogController',
                    controllerAs: 'vm'
              }
            }
        })

        .state('collectivity-detail.contribution.edit-collectivity', {
            parent: 'collectivity-detail.contribution',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: ['$stateParams', 'Collectivity', function($stateParams, Collectivity) {
                    return Collectivity.get({id : $stateParams.id}).$promise;
                }],
            },
            views: {
              'contrib@': {
                templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                controller: 'CollectivityDialogController',
                controllerAs: 'vm'
              }
            }
        })




        .state('collectivity-detail.contribution.new-profile', {
            parent: 'collectivity-detail.contribution',
            url: '/new-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
             resolve: {
                entity: function () {
                    return {
                        name: null,
                        id: null
                    };
                }
            },
             views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('collectivity.contribution', {
            parent: 'collectivity',
            url: '/collectivity-contribution',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('collectivity');
                }, function() {
                    $state.go('collectivity');
                });
            }]
        })
        .state('collectivity.contribution.new-collectivity', {
            parent: 'collectivity.contribution',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
           resolve: {
                entity: function () {
                    return {
                        name: null,
                        city: null,
                        collectivitySize: null,
                        id: null
                    };
                }
            },
            views: {
                'contrib@': {
                    templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                    controller: 'CollectivityDialogController',
                    controllerAs: 'vm'
              }
            }
        })
        .state('collectivity.contribution.edit', {
            parent: 'collectivity.contribution',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: ['$stateParams', 'Collectivity', function($stateParams, Collectivity) {
                    return Collectivity.get({id : $stateParams.id}).$promise;
                }],
            },
            views: {
                'contrib@': {
                    templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                    controller: 'CollectivityDialogController',
                    controllerAs: 'vm'
                }
            }
        })

        .state('collectivity-detail.quickconnect-new', {
            parent: 'collectivity-detail',
            url: '/detail/quickconnect/{organisation}',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quickconnect/quickconnect-dialog.html',
                    controller: 'QuickconnectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collectivity-detail', null, { reload: false });
                }, function() {
                    $state.go('collectivity-detail');
                });
            }]
        })
        .state('collectivity.switch', {
            parent: 'collectivity',
            url: '/{id}/switch',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organisation/organisation-switch-dialog.html',
                    controller: 'OrganisationSwitchController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Collectivity', function(Collectivity) {
                            return Collectivity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('collectivity', null, { reload: false});
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Collectivity', Collectivity);

    Collectivity.$inject = ['$resource'];

    function Collectivity ($resource) {
        var resourceUrl =  'api/collectivities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'search': {
                method: 'GET',
                url: 'api/collectivities/search/:query',
                isArray: true
            },
            'queryPaginated': {
                method: 'GET',
                url: 'api/collectivities/paginated',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityController', CollectivityController);

    CollectivityController.$inject = ['$scope', '$state', 'Collectivity', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$uibModal'];

    function CollectivityController ($scope, $state, Collectivity, ParseLinks, AlertService, paginationConstants, pagingParams, $uibModal) {
        var vm = this;

        vm.collectivities = [];

        vm.confirmMerge = confirmMerge;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.totalItems = null;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = 200;
        vm.transition = transition;
        vm.links = null;
        vm.loadAll();

        function loadAll () {
            Collectivity.queryPaginated({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }
        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }
        function onSuccess(data, headers) {
           
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.collectivities = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function confirmMerge (id) {
            $uibModal.open({
                templateUrl: 'app/entities/organisation/organisation-switch-dialog.html',
                controller: 'OrganisationSwitchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Collectivity', function(Collectivity) {
                        return Collectivity.get({id : id}).$promise;
                    }]
                }
            }).result.then(function() {
                vm.collectivities = vm.collectivities.filter(function(el) {
                    return el.id !== id;
                })
            }, function() {
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CityDialogController', CityDialogController);

    CityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'City'];

    function CityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, City) {
        var vm = this;

        vm.city = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.city.id !== null) {
                City.update(vm.city, onSaveSuccess, onSaveError);
            } else {
                City.save(vm.city, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:cityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CityDetailController', CityDetailController);

    CityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'City'];

    function CityDetailController($scope, $rootScope, $stateParams, previousState, entity, City) {
        var vm = this;

        vm.city = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:cityUpdate', function(event, result) {
            vm.city = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CityDeleteController',CityDeleteController);

    CityDeleteController.$inject = ['$uibModalInstance', 'entity', 'City'];

    function CityDeleteController($uibModalInstance, entity, City) {
        var vm = this;

        vm.city = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            City.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('city', {
            parent: 'profile-info-management',
            url: '/city?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Villes'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/city/cities.html',
                    controller: 'CityController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('city-detail', {
            parent: 'profile-info-management',
            url: '/city/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Ville'
            },
            views: {
                'content@profile-info-management': {
                    templateUrl: 'app/entities/city/city-detail.html',
                    controller: 'CityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'City', function($stateParams, City) {
                    return City.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'city',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('city-detail.edit', {
            parent: 'city-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city.new', {
            parent: 'city',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('city');
                });
            }]
        })
        .state('city.edit', {
            parent: 'city',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city.delete', {
            parent: 'city',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-delete-dialog.html',
                    controller: 'CityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('City', City);

    City.$inject = ['$resource'];

    function City ($resource) {
        var resourceUrl =  'api/cities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'search': {
                method: 'GET',
                url: 'api/cities/search/:query',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CityController', CityController);

    CityController.$inject = ['$scope', '$state', 'City', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CityController ($scope, $state, City, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            City.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.cities = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CategoryRankingDialogController', CategoryRankingDialogController);

    CategoryRankingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CategoryRanking', 'ProfileCategory'];

    function CategoryRankingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CategoryRanking, ProfileCategory) {
        var vm = this;

        vm.categoryRanking = entity;
        vm.clear = clear;
        vm.save = save;
        vm.profilecategories = ProfileCategory.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.categoryRanking.id !== null) {
                CategoryRanking.update(vm.categoryRanking, onSaveSuccess, onSaveError);
            } else {
                CategoryRanking.save(vm.categoryRanking, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:categoryRankingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CategoryRankingDetailController', CategoryRankingDetailController);

    CategoryRankingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CategoryRanking', 'ProfileCategory'];

    function CategoryRankingDetailController($scope, $rootScope, $stateParams, previousState, entity, CategoryRanking, ProfileCategory) {
        var vm = this;

        vm.categoryRanking = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:categoryRankingUpdate', function(event, result) {
            vm.categoryRanking = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CategoryRankingDeleteController',CategoryRankingDeleteController);

    CategoryRankingDeleteController.$inject = ['$uibModalInstance', 'entity', 'CategoryRanking'];

    function CategoryRankingDeleteController($uibModalInstance, entity, CategoryRanking) {
        var vm = this;

        vm.categoryRanking = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CategoryRanking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('category-ranking', {
            parent: 'entity',
            url: '/category-ranking',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'CategoryRankings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/category-ranking/category-rankings.html',
                    controller: 'CategoryRankingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('category-ranking-detail', {
            parent: 'entity',
            url: '/category-ranking/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'CategoryRanking'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/category-ranking/category-ranking-detail.html',
                    controller: 'CategoryRankingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CategoryRanking', function($stateParams, CategoryRanking) {
                    return CategoryRanking.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'category-ranking',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('category-ranking-detail.edit', {
            parent: 'category-ranking-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/category-ranking/category-ranking-dialog.html',
                    controller: 'CategoryRankingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CategoryRanking', function(CategoryRanking) {
                            return CategoryRanking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('category-ranking.new', {
            parent: 'category-ranking',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/category-ranking/category-ranking-dialog.html',
                    controller: 'CategoryRankingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                matchingText: null,
                                priority: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('category-ranking', null, { reload: 'category-ranking' });
                }, function() {
                    $state.go('category-ranking');
                });
            }]
        })
        .state('category-ranking.edit', {
            parent: 'category-ranking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/category-ranking/category-ranking-dialog.html',
                    controller: 'CategoryRankingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CategoryRanking', function(CategoryRanking) {
                            return CategoryRanking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('category-ranking', null, { reload: 'category-ranking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('category-ranking.delete', {
            parent: 'category-ranking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/category-ranking/category-ranking-delete-dialog.html',
                    controller: 'CategoryRankingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CategoryRanking', function(CategoryRanking) {
                            return CategoryRanking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('category-ranking', null, { reload: 'category-ranking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('CategoryRanking', CategoryRanking);

    CategoryRanking.$inject = ['$resource'];

    function CategoryRanking ($resource) {
        var resourceUrl =  'api/category-rankings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CategoryRankingController', CategoryRankingController);

    CategoryRankingController.$inject = ['$scope', '$state', 'CategoryRanking'];

    function CategoryRankingController ($scope, $state, CategoryRanking) {
        var vm = this;

        vm.categoryRankings = [];

        loadAll();

        function loadAll() {
            CategoryRanking.query({
                size: 100000,
                sort: ['profileCategory', 'priority']
            }, function(result) {
                vm.categoryRankings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AlertDialogController', AlertDialogController);

    AlertDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Alert', 'Subscription', 'User'];

    function AlertDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Alert, Subscription, User) {
        var vm = this;

        vm.alert = entity;
        vm.clear = clear;
        vm.save = save;
        vm.subscriptions = Subscription.query();
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.alert.id !== null) {
                Alert.update(vm.alert, onSaveSuccess, onSaveError);
            } else {
                Alert.save(vm.alert, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:alertUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AlertDetailController', AlertDetailController);

    AlertDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Alert', 'Subscription', 'User'];

    function AlertDetailController($scope, $rootScope, $stateParams, previousState, entity, Alert, Subscription, User) {
        var vm = this;

        vm.alert = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('quilinkApp:alertUpdate', function(event, result) {
            vm.alert = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AlertDeleteController',AlertDeleteController);

    AlertDeleteController.$inject = ['$uibModalInstance', 'entity', 'Alert'];

    function AlertDeleteController($uibModalInstance, entity, Alert) {
        var vm = this;

        vm.alert = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Alert.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('alert', {
            parent: 'entity',
            url: '/alert?page&sort&search',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Alerts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/alert/alerts.html',
                    controller: 'AlertController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('alert-detail', {
            parent: 'entity',
            url: '/alert/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Alert'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/alert/alert-detail.html',
                    controller: 'AlertDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Alert', function($stateParams, Alert) {
                    return Alert.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'alert',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('alert-detail.edit', {
            parent: 'alert-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alert/alert-dialog.html',
                    controller: 'AlertDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Alert', function(Alert) {
                            return Alert.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alert.new', {
            parent: 'alert',
            url: '/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alert/alert-dialog.html',
                    controller: 'AlertDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                seen: false,
                                aud: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('alert', null, { reload: 'alert' });
                }, function() {
                    $state.go('alert');
                });
            }]
        })
        .state('alert.edit', {
            parent: 'alert',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alert/alert-dialog.html',
                    controller: 'AlertDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Alert', function(Alert) {
                            return Alert.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('alert', null, { reload: 'alert' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alert.delete', {
            parent: 'alert',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alert/alert-delete-dialog.html',
                    controller: 'AlertDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Alert', function(Alert) {
                            return Alert.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('alert', null, { reload: 'alert' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Alert', Alert);

    Alert.$inject = ['$resource'];

    function Alert ($resource) {
        var resourceUrl =  'api/alerts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AlertController', AlertController);

    AlertController.$inject = ['$scope', '$state', 'Alert', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AlertController ($scope, $state, Alert, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Alert.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.alerts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('discover', {
            parent: 'app',
            url: '/discover',
            abstract: true,
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Discover'
            },
            views: {
                'content@': {
                    templateUrl: 'app/discover/discover.html',
                    controller: 'DiscoverController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('mosaic', {
            parent: 'discover',
            url: '/mosaic',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Discover'
            },
            views: {
                'content@discover': {
                    templateUrl: 'app/discover/mosaic.html',
                    controller: 'DiscoverController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('flow', {
            parent: 'discover',
            url: '/flow',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Discover'
            },
            views: {
                'content@discover': {
                    templateUrl: 'app/discover/flow.html',
                    controller: 'DiscoverController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Discover', Discover);

    Discover.$inject = ['$resource'];

    function Discover($resource) {
        var service = $resource('/api/profiles/suggestions', {}, {
            'getList': {
                method: 'GET',
                isArray: true,
                url: '/api/profiles/suggestions?excludes=:excludes'
            }
        });
        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DiscoverController', DiscoverController);

    DiscoverController.$inject = ['$scope', '$timeout', '$rootScope', 'Principal', 'Suggestions', 'Discover', 'Connexion'];

    function DiscoverController($scope, $timeout, $rootScope, Principal, Suggestions, Discover, Connexion) {
        var vm = this;

        vm.suggestions = [];
        vm.suggestionsDone = [];
        vm.profileToConnect = null;
        vm.page = 1;
        vm.itemsPerPage = 1;
        vm.flowIndex = 0;
        vm.connectMosaic = connectMosaic;
        vm.connectFlow = connectFlow;
        vm.cardFlowClass = cardFlowClass;
        vm.pageConnexion = 0;
        vm.hasNextPageConnexion = true;
        vm.connexionsParPage = 21;
        
         vm.loadMoreConnexions = loadMoreConnexions;

        loadMoreConnexions();
        //getBatchSuggestions();

        $rootScope.$on('keypress', function(onEvent, keypressEvent) {
            if (keypressEvent.which === 116) {
                // T
                connectFlow(vm.suggestions[vm.flowIndex], 1);
            } else if (keypressEvent.which === 102) {
                // F
                connectFlow(vm.suggestions[vm.flowIndex], 2);
            } else if (keypressEvent.which === 106) {
                // J
                connectFlow(vm.suggestions[vm.flowIndex], 3);
            } else if (keypressEvent.which === 120) {
                // X
                vm.flowIndex = Math.max(vm.flowIndex - 1, 0);
                $scope.$apply();
            }
        });

        function getBatchSuggestions() {
            Suggestions.get(60).then(function (results) {
                vm.suggestions = results;
            });
        }


        function loadMoreConnexions(reset) {

            var excludesIds = vm.suggestions.map(function (a) {
                return a.id;
            });
            
            if (reset) vm.pageConnexion = 0;
            
            // N010 "Si on peut changer ce nombre de sorte à avoir tjs un seul profil sur la derniere ligne de profil chargée.""
            if (vm.pageConnexion == 0){
                vm.connexionsParPage = 19;
            } else {
                 vm.connexionsParPage = 21;
            }

            Discover.getList({
                excludes : excludesIds,
                page: vm.pageConnexion,
                size: vm.connexionsParPage
            }, function (results) {
                if (reset) {
                    vm.suggestions = [];
                }
                results.forEach(function (suggestion) {
                    vm.suggestions.push(suggestion);
                });
            });
            vm.pageConnexion += 1;
        }

        function connectMosaic(profileId, grade) {
            vm.profileToConnect = profileId;
            var connection = {
                creator: {
                    id: Principal.profile.id
                },
                grade: grade,
                target: {
                    id: profileId
                }
            };
            Connexion.save(connection, onSaveSuccess, angular.noop);

            function onSaveSuccess() {
                vm.suggestions = vm.suggestions.filter(function (profile) {
                    return profile.id !== vm.profileToConnect;
                });
                /*
                if (vm.suggestions.length > 18) {
                    vm.suggestions = vm.suggestions.slice(0, 18);
                } else {
                    //getBatchSuggestions();
                }
                */
            }
        }

        function connectFlow(people, grade) {
            // Update layout
            people.grade = grade;
            var connection = {
                creator: {
                    id: Principal.profile.id
                },
                grade: grade,
                target: {
                    id: people.id
                }
            };
            Connexion.save(connection, onSaveSuccess, angular.noop);

            function onSaveSuccess() {
                var len = vm.suggestions.length;
                vm.flowIndex = Math.min(len - 1, vm.flowIndex + 1);

                // if (vm.flowIndex === len - 2) {
                //     getBatchSuggestions();
                // }
            }
        }

        function cardFlowClass(index, focusIndex) {
            return {
                'flow-left-out' : index < focusIndex - 2,
                'flow-left-left' : index === focusIndex - 2,
                'flow-left' : index === focusIndex - 1,
                'flow-center' : index === focusIndex,
                'flow-right' : index === focusIndex + 1,
                'flow-right-right': index === focusIndex + 2,
                'flow-right-out' : index > focusIndex + 2
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SalesManagementDesactivateController', SalesManagementDesactivateController);

    SalesManagementDesactivateController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function SalesManagementDesactivateController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.clear = clear;
        vm.confirmDesactivate = confirmDesactivate;
        vm.user = entity;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDesactivate (email) {
            User.deactivate({
                    email: email
                },
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SalesManagementActivateController', SalesManagementActivateController);

    SalesManagementActivateController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function SalesManagementActivateController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.clear = clear;
        vm.confirmActivate = confirmActivate;
        vm.user = entity;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmActivate (email) {
            User.activateCommercial({
                    email: email
                },
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sales-management', {
            parent: 'director',
            url: '/sales-management?page&sort',
            data: {
                authorities: ['ROLE_DG'],
                pageTitle: 'Axenteev | Mes commerciaux'
            },
            views: {
                'content@director': {
                    templateUrl: 'app/director/sales-management/sales-management.html',
                    controller: 'SalesManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        })


        .state('sales-management.new', {
            parent: 'sales-management',
            url: '/new',
            data: {
                authorities: ['ROLE_DG']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null, oauth2: false, initTitle: null, initSuperior: null, initOrganisation: null,
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sales-management', null, { reload: true });
                }, function() {
                    $state.go('sales-management');
                });
            }]
        })

        .state('sales-management.activate', {
            parent: 'sales-management',
            url: '/{email}/activate',
            data: {
                authorities: ['ROLE_DG']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/director/sales-management/sales-management-activate-dialog.html',
                    controller: 'SalesManagementActivateController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({email : $stateParams.email});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sales-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sales-management.desactivate', {
            parent: 'sales-management',
            url: '/{email}/desactivate',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DG'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/director/sales-management/sales-management-desactivate-dialog.html',
                    controller: 'SalesManagementDesactivateController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({email : $stateParams.email});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sales-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sales-management-detail', {
            parent: 'admin',
            url: '/user/:email',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DG'],
                pageTitle: 'Axenteev | User detail'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })

        .state('sales-management.edit', {
            parent: 'sales-management',
            url: '/{email}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DG']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({email : $stateParams.email});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sales-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sales-management.delete', {
            parent: 'sales-management',
            url: '/{email}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DG']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({email : $stateParams.email});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sales-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SalesManagementController', SalesManagementController);

    SalesManagementController.$inject = ['Principal', 'User', 'Director', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'EquipeCommerciale', 'History'];

    function SalesManagementController(Principal, User, Director, ParseLinks, AlertService, $state, pagingParams, paginationConstants, EquipeCommerciale, History) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.sales = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.ec;
        vm.sumCreditCollectes;

        vm.loading = false;
        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            EquipeCommerciale.getByEmail({email: account.email}, function(result) {
                vm.ec = result;
            });
        });

        function loadAll () {
            vm.loading = true;
            Director.querySales({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.page = pagingParams.page;
            vm.sales = data;
            vm.sumCreditCollectes = sumCreditCollectes(data);
            vm.loading = false;
        }

        function onError(error) {
            AlertService.error(error.data.message);
            vm.loading = false;
        }

        function clear () {
            vm.user = {
                id: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null, oauth2: false
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function sumCreditCollectes( sales ) {
            var sum = 0;
            sales.forEach(function(sale){
                if (sale.credits) {
                    sum += parseFloat( sale.credits.creditsCount);
                }

            });
            return sum;
          }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('director', {
            parent: 'app',
            url: '/director',
            data: {
                authorities: ['ROLE_DG']
            },
            views: {
                'content@': {
                    templateUrl: 'app/director/director.html'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('dashboard', {
            parent: 'app',
            url: '/dashboard',
            data: {
                authorities: ['ROLE_DG']
            },
            views: {
                'content@': {
                    controller: 'DashboardController',
                    templateUrl: 'app/dashboard/dashboard.html',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('DashboardKibana', DashboardKibana);

    DashboardKibana.$inject = ['$resource'];

    function DashboardKibana ($resource) {
        var service = $resource('api/kibana-proxy/cookies', {}, {
        });
        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .controller('DashboardController', DashboardController);


    DashboardController.$inject = ['Principal', 'EquipeCommerciale', 'DashboardKibana', '$sce', '$http'];

    function DashboardController(Principal, EquipeCommerciale, DashboardKibana, $sce, $http) {
        var vm = this;
        vm.ec;
        vm.iframeUrl;

        Principal.identity().then(function(account) {
            EquipeCommerciale.getByEmail({email: account.email}, function(result) {
                vm.ec = result;

                if (vm.ec.dashboardUrl) {
                    vm.iframeUrl = $sce.trustAsResourceUrl(vm.ec.dashboardUrl);
                }
            });
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('quilinkApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('keypressEvents', [
            '$document',
            '$rootScope',
            function($document, $rootScope) {
                return {
                    restrict: 'A',
                    link: function() {
                        $document.bind('keypress', function(e) {
                            $rootScope.$broadcast('keypress', e);
                            $rootScope.$broadcast('keypress:' + e.which, e);
                        });
                    }
                };
            }
        ]);
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    '{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'sur {{$ctrl.queryCount}}' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('quilinkApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('organisationSquares', organisationSquares);

    function organisationSquares() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/organisation-squares/organisation-squares.html',
            controller: 'OrganisationSquaresController',
            controllerAs: 'vd',
            bindToController: {
                selectedPosition: '=?',
                organisation: '=',
                profile: '='
            },
           
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationSquaresController', OrganisationSquaresController);

    OrganisationSquaresController.$inject = ['$scope', '$timeout', '$state', 'ProfileCategory', 'Profile', 'Principal', 'Connexion', 'Position'];

    function OrganisationSquaresController($scope, $timeout, state, ProfileCategory, Profile, Principal, Connexion, Position) {
        var vm = this;
        vm.state = state;
        vm.selectedPosition = this.selectedPosition;
        vm.organisation = this.organisation;



        vm.profile = this.profile;

        vm.slicedPositions = [];
        vm.slicePositions = slicePositions;


        if (vm.profile) {
            vm.currentPositions = vm.profile.positions.filter(function(val) {
                return val.active == true;
            });

            // Move the selected position to the Front of the list
            if (vm.selectedPosition){
                vm.currentPositions.forEach(function(pos,i){
                    if(pos.id === vm.selectedPosition.id){
                        vm.currentPositions.splice(i, 1);
                        vm.currentPositions.unshift(pos);
                    }
                });
            }
            slicePositions(); 
        }

        function slicePositions() {
            var index = 0;
            if (vm.slicedPositions.length == 0) {
                index = 0;
            } else {
                index = vm.currentPositions.indexOf(vm.slicedPositions[2]) + 1;
            }

            if (index == vm.currentPositions.length) {
                index = 0;
            }

            var end = index + 3;


            vm.slicedPositions = vm.currentPositions.slice(index, end);

            // On complète les blancs si on arrive à la fin
            if (vm.slicedPositions.length == 1 && vm.currentPositions.length > 1) {

                vm.slicedPositions.push(vm.currentPositions[0]);
                vm.slicedPositions.push(vm.currentPositions[1]);
            } else if (vm.slicedPositions.length == 2 && vm.currentPositions.length > 2) {
                vm.slicedPositions.push(vm.currentPositions[0]);
            }
            vm.selectedPosition = vm.slicedPositions[0];
        }

        vm.categories = [];
        vm.switchSquare = switchSquare;
        vm.connect = connect;
        vm.loadPage = loadPage;


        $scope.$watch('vd.organisation', function(newValue, oldValue) {
            if (!newValue || angular.equals(newValue, oldValue)) {
                return;
            }

            if (newValue)
                console.log("I see a data change!");
            init();

        });


        if (vm.organisation) init();

        function init() {

            vm.organisation.employees = {};
            vm.mode = 0;
            vm.hasNextPage = {
                1: false,
                2: false,
                3: false,
                4: false
            };

            vm.totalCount = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };


            vm.page = {
                1: 1,
                2: 1,
                3: 1,
                4: 1
            };


            keepFocus();
            $timeout(goToBottom, 0, false);
            ProfileCategory.query(function(profileCategories) {
                vm.categories = profileCategories.filter(function(profileCategory) {
                    return profileCategory.company === (vm.organisation.type === 'company');
                });
                vm.categories.forEach(function(category) {
                    Profile.category({
                        categoryId: category.id,
                        organisationId: vm.organisation.id
                    }, function(profiles, headers) {
                        if (!vm.organisation.employees) {
                            vm.organisation.employees = {};
                        }
                        vm.hasNextPage[category.order] = headers('X-Has-Next-Page') === "true";
                        vm.totalCount[category.order] = headers('X-Total-Count');
                        vm.organisation.employees[category.order] = profiles;
                    });
                });
            });
        }

        function switchSquare(newActiveSquare) {
            vm.mode = newActiveSquare;
        }

        function keepFocus() {
            $('.focus-out').blur(function() {
                vm.focus = false;
                $timeout(function() {
                    if (!vm.focus) {
                        vm.mode = '';
                        $scope.$apply();
                    } else {
                        vm.focus = false;
                    }
                }, 200);
            });

            $('.inner-container').click(function(evt) {
                console.log('keep focus');
                vm.focus = true;
            });
        }

        function goToBottom() {
            var a = angular.element("#inner-bottom-left");
            var b = angular.element("#inner-bottom-right");
            a.prop({ scrollTop: a.prop("scrollHeight") });
            b.prop({ scrollTop: b.prop("scrollHeight") });
        }


        function connect(profile, newGrade) {
            if (profile.connectionId) {
                updateGrade(profile, newGrade);
            } else {
                insertGrade(profile, newGrade);
            }
        }

        function insertGrade(profile, newGrade) {
            var connection = {
                creator: {
                    id: vm.profileId
                },
                grade: newGrade,
                target: {
                    id: profile.id
                }
            };
            Connexion.save(connection, function(res) {
                profile.grade = res.grade;
                profile.connectionId = res.id;
            }, angular.noop);
        }

        function updateGrade(profile, newGrade) {
            var connection = {
                id: profile.connectionId,
                creator: {
                    id: vm.profileId
                },
                grade: newGrade,
                target: {
                    id: profile.id
                }
            };
            Connexion.update(connection, function(res) {
                profile.grade = newGrade;
            });
        }

        function loadPage(page, categoryOrder) {
            vm.page[categoryOrder] = page;
            var category = vm.categories.filter(function(category) {
                return category.order === categoryOrder;
            })[0];
            Profile.category({
                page: vm.page[categoryOrder] - 1,
                categoryId: category.id,
                organisationId: vm.organisation.id
            }, function(profiles, headers) {
                vm.hasNextPage[category.order] = headers('X-Has-Next-Page') === "true";
                vm.totalCount[category.order] = headers('X-Total-Count');
                vm.organisation.employees[category.order] = vm.organisation.employees[category.order].concat(profiles);
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('organisationNetwork', organisationNetwork);

    function organisationNetwork() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/organisation-network/organisation-network.html',
            controller: 'OrganisationNetworkController',
            controllerAs: 'vd',
            scope: {
            },

            bindToController: {
                organisation: '=',
                profile: '='
            },

        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationNetworkController', OrganisationNetworkController);

    OrganisationNetworkController.$inject = ['$scope', 'Connexion', 'Principal', 'Network', 'Message', 'Profile'];

    function OrganisationNetworkController($scope, Connexion, Principal, Network, Message, Profile) {
        var vm = this;

        // Profiles de l'internal network, ie tous les commerciaux ou dg (faisant partie de l'organisation/meme dg de l'utilisateur) en relation avec la personne consultée.
        vm.connections = [];
        vm.people = null;

        vm.myNetworkOrganisationConnections = [];
        // Les employés de l'entreprise
        vm.myNetworkOrganisationPeople = [];

        vm.networkOrganisationConnuParConsultantPeople = null;

        vm.organisation = this.organisation;
        vm.profile = this.profile;

        // Profiles de l'external network, ie tous les consultants Axeenteev en relation avec la personne consultée
        vm.externalPeople = [];
        vm.externalConnections = [];
        // Grade du consultant le plus proche de la personne consultée
        vm.minGrade;

        vm.isAdmin;
        vm.isConsultant;
        vm.messageAdminsExternalNetwork = messageAdminsExternalNetwork;

        if (vm.organisation) init();

        function init() {
            Principal.profile().then(function(myProfile) {
                var isDgOrAdmin = Principal.hasAnyAuthority(['ROLE_DG', 'ROLE_ADMIN']);
                var isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
                vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
                var isConsultant = Principal.hasAnyAuthority(['ROLE_CONSULTANT']);
                vm.isConsultant = Principal.hasAnyAuthority(['ROLE_CONSULTANT']);

                var isCommercial = Principal.hasAnyAuthority(['ROLE_COMMERCIAL']);
                vm.isCommercial = Principal.hasAnyAuthority(['ROLE_COMMERCIAL']);


                var isDg = Principal.hasAnyAuthority(['ROLE_DG']);
                vm.isDg = Principal.hasAnyAuthority(['ROLE_DG']);

                if (vm.profile) {
                    if (isAdmin) {
                        Connexion.externalNetwork({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = externalNetwork(connections);
                            vm.externalPeople = network.people;
                            vm.externalConnections = network.connections;
                            vm.minGrade = network.minGrade;
                        });
                        Connexion.inverseNetworks({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = internalNetworkDG(connections);
                            vm.people = network.people;
                            vm.connections = network.connections;
                        });
                    } else if (isDg) {
                        Connexion.internalNetworkDG({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = internalNetworkDG(connections);
                            vm.people = network.people;
                            vm.connections = network.connections;
                        });

                        Connexion.externalNetwork({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = externalNetwork(connections);
                            vm.externalPeople = network.people;
                            vm.externalConnections = network.connections;
                            vm.minGrade = network.minGrade;
                        });
                    } else {
                        if (isCommercial) {
                            // Commercial
                            Connexion.internalNetworkCommercial({
                                profileId: vm.profile.id
                            }, function(connections) {
                                var network = internalNetworkCommercial(connections);
                                vm.people = network.people;
                                vm.connections = network.connections;
                            });
                        }
                        Connexion.externalNetwork({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = externalNetwork(connections);
                            vm.externalPeople = network.people;
                            vm.externalConnections = network.connections;
                            vm.minGrade = network.minGrade;
                        });
                    }
                } else {
                    if (isDg || isCommercial) {
                        Connexion.internalNetworkOfOrganisation({
                            organisationId: vm.organisation.id
                        }, function(connections) {
                            var network = internalNetworkOrganisation(connections);
                            vm.people = network.people;
                            vm.connections = network.connections;
                        });
                    }

                    Network.getList({
                        organisationId: vm.organisation.id
                    }, function(connections) {
                        var network = organisationNetwork(connections, myProfile.id);
                        // Les employés de l'entreprise
                        vm.myNetworkOrganisationPeople = network.people;
                        vm.myNetworkOrganisationConnections = network.connections;
                    });

                    if (isAdmin) {
                        Network.getListConnuParConsultant({
                            organisationId: vm.organisation.id
                        }, function(connections) {
                            var network = organisationNetwork(connections, myProfile.id);
                            // Les employés de l'entreprise
                            vm.networkOrganisationConnuParConsultantPeople = network.people;
                        });
                    }
                }
            });
        }

        function organisationNetwork(connections, myProfileId) {
            var res = {
                connections: [],
                people: []
            };
            connections.forEach(function(connection) {
                var person;
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }

                person.grade = connection.grade;
                person.connectionId = connection.id;
                res.connections.push(connection);


                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                });

                if (!res.people.some(function(e) { return e.id === person.id })) {
                    res.people.push(person);
                }

            });
            return res;
        }

        function internalNetworkDG(connections) {
            var res = {
                connections: [],
                people: []
            };
            connections.forEach(function(connection) {
                var person;

                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */

                person = connection.creator;
                person.grade = connection.grade;
                person.connectionId = connection.id;
                if (!res.connections.some(function(e) { return e.id === connection.id })) {
                    res.connections.push(connection);
                }

                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                });

                if (!res.people.some(function(e) { return e.id === person.id })) {
                    res.people.push(person);
                }
            });
            return res;
        }



        function internalNetworkOrganisation(connections) {
            var res = {
                connections: [],
                people: []
            };
            connections.forEach(function(connection) {
                var person;
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */
                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */

                person = connection.target;
                person.grade = connection.grade;
                person.connectionId = connection.id;
                if (!res.connections.some(function(e) { return e.id === connection.id })) {
                    res.connections.push(connection);
                }

                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.currentPosition) {
                    if (!person.positions) {
                        console.warn("positions is nul for profile");
                        console.log(person);
                    }
                    person.positions && person.positions.forEach(function(p) {
                        if (p.organisation && p.organisation.id === vm.organisation.id){
                            person.currentPosition = p;
                        }
                    });

                    person.positions && !person.currentPosition && person.positions.forEach(function(p) {
                        if (p.active){
                            person.currentPosition = p;
                        }
                    });

                }


                if (!res.people.some(function(e) { return e.id === person.id })) {
                    res.people.push(person);
                }
            });
            return res;
        }


        function internalNetworkCommercial(connections) {
            var res = {
                connections: [],
                people: []
            };

            connections.forEach(function(connection) {
                var person;

                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */

                person = connection.creator;
                person.grade = connection.grade;
                person.connectionId = connection.id;
                if (!res.connections.some(function(e) { return e.id === connection.id })) {
                    res.connections.push(connection);
                }

                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                    person.positions && !person.currentPosition && person.positions.forEach(function(p) {
                        if (p.active){
                            person.currentPosition = p;
                        }
                    });
                });

                if (!res.people.some(function(e) { return e.id === person.id })) {
                    res.people.push(person);
                }
            });
            return res;
        }

        function internalNetworkAdmin(connections) {
            var res = {
                connections: [],
                people: []
            };
            connections.forEach(function(connection) {
                var person;

                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */

                person = connection.creator;
                person.grade = connection.grade;
                person.connectionId = connection.id;
                res.connections.push(connection);


                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                });

                res.people.push(person);
            });
            return res;
        }

        function externalNetwork(connections) {
            var res = {
                connections: [],
                people: [],
                // "Axenteev connait en $minGrade cette personne"
                minGrade: 3
            };

            connections.forEach(function(connection) {
                var person;

                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */
                if (connection.creator)
                    person = connection.creator;
                person.grade = connection.grade;
                if (connection.grade < res.minGrade) {
                    res.minGrade = connection.grade;
                }
                person.connectionId = connection.id;
                res.connections.push(connection);


                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                });

                res.people.push(person);
            });
            return res;
        }

        function messageAdminsExternalNetwork(profile) {
            console.log(profile.id);

            Message.messageRequestExternalNetwork(profile, function(result) {
                console.log(result);
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ExternalNetworkRequestController', ExternalNetworkRequestController);

    ExternalNetworkRequestController.$inject = ['$uibModalInstance', 'entity', 'Message'];

    function ExternalNetworkRequestController($uibModalInstance, entity, Message) {
       
        var vm = this;
        vm.profile = entity;

        vm.clear = clear;
        vm.confirmSend = confirmSend;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        function confirmSend (profile) {
            console.log(profile.id);
            Message.messageRequestExternalNetwork(profile, function (result) {
                console.log(result);
            });
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EnvoyerMessageCommercialDialogController', EnvoyerMessageCommercialDialogController);

        EnvoyerMessageCommercialDialogController.$inject = ['$uibModalInstance', 'entity', 'commercial', 'Message', 'Principal'];

    function EnvoyerMessageCommercialDialogController($uibModalInstance, entity, commercial, Message, Principal) {

        var vm = this;
        vm.profile = entity;
        vm.commercial = commercial;
        vm.clear = clear;
        vm.confirmSend = confirmSend;

        vm.currentAccount = null;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmSend (profile) {
            console.log(profile.id);
            Message.envoyerMessageCommercial({commercialUserId : vm.commercial.id}, profile, function (result) {
                console.log(result);
            });
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('login', {
            parent: 'app',
            url: '/login?error',
            data: {
                pageTitle: 'Axenteev | Login',
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                windowClass: 'login-modal-window'
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

    function LoginController ($rootScope, $state, $timeout, Auth) {
        var vm = this;



        if ($state.params.error) {
            vm.authenticationError = true;
            vm.authenticationErrorMessage = "Connexion impossible ou vous n'ête pas autorisé à accéder à l'application."
        } else {
            vm.authenticationError = false;
            vm.authenticationErrorMessage = null;
        }
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.oktaLogin = oktaLogin;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset' || $state.current.name === 'check') {
                    $state.go('home', {}, {reload:true});
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                } else {
                    $state.go('home', {}, {reload:true});
                }

            }).catch(function (e) {
                if (e.data && e.data.description) {
                    vm.authenticationErrorMessage = e.data.description;
                }
                vm.authenticationError = true;
            });
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }


        function oktaLogin () {
            event.preventDefault();
            // Oauth2LoginService.login();
            location.href =  "/oauth2/authorization/oidc";
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .constant('paginationConstants', {
            'itemsPerPage': 40
        });
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('quilinkApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('quilinkApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.endsWith('app-error') || header.endsWith('app-params')
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('quilinkApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('suggestionAddon', ['Suggestions', 'Principal', 'Connexion', suggestionAddon]);

    function suggestionAddon(Suggestions, Principal, Connexion) {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/addon/suggestion/suggestion-addon.html',
            controller: 'SuggestionAddonController',
            controllerAs: 'vd'
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SuggestionAddonController', SuggestionAddonController);

    SuggestionAddonController.$inject = ['$scope', '$rootScope', 'Principal', 'Suggestions', 'Connexion'];

    function SuggestionAddonController($scope, $rootScope, Principal, Suggestions, Connexion) {
        var vm = this;

        vm.displayedPeople = [];
        vm.suggestions = [];
        vm.profileToConnect = null;
        vm.connect = connect;

        $scope.suggestionBusyPromise = Suggestions.get(60).then(function (results) {
            vm.suggestions = results;
            vm.displayedPeople = results.slice(0, 3);
        });

        function connect(profileId, grade) {
            vm.profileToConnect = profileId;
            var connection = {
                creator: {
                    id: Principal.profile.id
                },
                grade: grade,
                target: {
                    id: profileId
                }
            };
            Connexion.save(connection, onSaveSuccess, angular.noop);

        }

        function onSaveSuccess() {
            vm.suggestions = vm.suggestions.filter(function (profile) {
                return profile.id !== vm.profileToConnect;
            });
            vm.displayedPeople = vm.suggestions.slice(0, 3);

            // firing an event upwards
            $rootScope.$broadcast('quilinkApp:connexionUpdate', null);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('selectDivisionAddon', selectDivisionAddon);

    function selectDivisionAddon() {
        var directive = {
            restrict: 'EA',
            controller: 'SelectDivisionAddonController',
            controllerAs: 'vb',
            templateUrl: 'app/components/addon/select-division/select-division-addon.html'
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SelectDivisionAddonController', SelectDivisionAddonController);

        SelectDivisionAddonController.$inject = ['$state', 'EquipeCommerciale', 'Principal', 'User', '$window', 'AlertService'];

    function SelectDivisionAddonController($state, EquipeCommerciale, Principal, User, $window, AlertService) {
        var vm = this;
        vm.ecs;
        vm.selectedEc;
        vm.selectEc = selectEc;


        vm.currentAccount = null;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        if (Principal.hasAnyAuthority(['ROLE_DIVISION_ADMIN'])) {
            init();
        }

        function init(){
            loadEcs();
        }


        function loadEcs () {
            EquipeCommerciale.myEquipesCommerciales({
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.ecs = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function selectEc() {
            User.updateMyEquipeCommerciale({ id: vm.currentAccount.ec.id }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $window.location.reload();
        }


        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();


(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('rankAddon', rankAddon);

    function rankAddon() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/addon/rank/rank-addon.html',
            controller: 'RankAddonController',
            controllerAs: 'vb',
            link: link
        };
        return directive;

        function link(scope, element, attrs) {
            scope.score = 5;
            scope.progress = 0;

            var bottom = scope.score * 8.5;
            var left = 27 * bottom / 60;
            var width = 100 - 30 * bottom / 60;
            angular.element('.dashed-line').animate({
                bottom: bottom + '%',
                left: left + 'px',
                width: width + '%'
            }, 2000);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('RankAddonController', RankAddonController);

        RankAddonController.$inject = ['$state', 'History'];

    function RankAddonController($state, History) {
        var vm = this;
        vm.credits;
        init();
        function init(){
            loadCreditsHistory();
        }

        function loadCreditsHistory() {
            History.myCredits({}, function (response) {
                if (response.credits){
                    vm.creditsLastMonth = response.credits[response.credits.length - 1];
                    vm.credits = response;
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('discoverAddon', discoverAddon);

    function discoverAddon() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/addon/discover/discover-addon.html'
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('creditsAddon', creditsAddon);

    function creditsAddon() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/addon/credits/credits-addon.html',
            controller: 'CreditsAddonController',
            controllerAs: 'vc'
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CreditsAddonController', CreditsAddonController);

        CreditsAddonController.$inject = ['$scope', '$state', 'History'];

    function CreditsAddonController($scope, $state, History) {
        var vm = this;
        vm.credits;
        init();
        function init(){
            loadCreditsHistory();
            
            // listen for the event in the relevant $scope
            $scope.$on('quilinkApp:connexionUpdate', function (event, data) {
                loadCreditsHistory();
            });

            $scope.$on('quilinkApp:profileUpdate', function (event, data) {
                loadCreditsHistory();
            });

            $scope.$on('quilinkApp:positionUpdate', function (event, data) {
                loadCreditsHistory();
            });

            $scope.$on('quilinkApp:companyUpdate', function (event, data) {
                loadCreditsHistory();
            });

            $scope.$on('quilinkApp:collectivityUpdate', function (event, data) {
                loadCreditsHistory();
            });
        }
        
        function loadCreditsHistory() {
            History.myCredits({}, function (response) {
                vm.credits = response;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('copyrightAddon', copyrightAddon);

    function copyrightAddon() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/addon/copyright/copyright-addon.html'
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('contributionLoopAddon', contributionLoopAddon);

    function contributionLoopAddon() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/addon/contribution-loop/contribution-loop-addon.html'
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ContributionLoopAddonController', ContributionLoopAddonController);

    ContributionLoopAddonController.$inject = ['$state', 'CompanyStatus', 'CollectivitySize', 'City', 'Sector'];

    function ContributionLoopAddonController($state, CompanyStatus, CollectivitySize, City, Sector) {
        var vm = this;

        vm.isContributionsOpen = false;
        vm.isSuperLoopOpen = false;

        vm.collectivitySizes = [];
        vm.cities = [];
        vm.sectors = [];
        vm.companyStatuses = [];
        vm.superLoopForm = {
            isCompany: true // Company or collectivity
        };
        vm.search = search;

        CollectivitySize.query(storeCollectivitySizes);
        City.query(storeCities);
        Sector.query(storeSectors);
        CompanyStatus.query(storeCompanyStatuses);

        vm.switchToCompany = switchToCompany;
        vm.switchToCollectivity = switchToCollectivity;

        function search() {
            $state.go('super-loop', vm.superLoopForm);
        }

        function switchToCompany() {
            vm.superLoopForm.isCompany = true;
        }

        function switchToCollectivity() {
            vm.superLoopForm.isCompany = false;
        }

        function storeCities(cities) {
            vm.cities = cities;
        }

        function storeSectors(sectors) {
            vm.sectors = sectors;
        }

        function storeCollectivitySizes(collectivitySizes) {
            vm.collectivitySizes = collectivitySizes;
        }

        function storeCompanyStatuses(companyStatuses) {
            vm.companyStatuses = companyStatuses;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.endsWith('app-alert') || header.endsWith('app-params')
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('quilinkApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true, true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }
                if (toState.name === 'login') {
                    Auth.logout();
                } else {
                    if (Principal.isIdentityResolved()) {
                        Auth.authorize();
                    }
                }


            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'Axenteev' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('quilinkApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AlertsNewController', AlertsNewController);

    AlertsNewController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'Subscription'];

    function AlertsNewController($stateParams, $uibModalInstance, entity, Subscription) {
        var vm = this;
        vm.subscription = entity;
        vm.name = $stateParams.name;

        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            console.log('saving');
            Subscription.save(vm.subscription, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('alerts', {
                parent: 'app',
                url: '/alerts',
                data: {
                    pageTitle: 'Axenteev | Alertes',
                    authorities: ['ROLE_COMMERCIAL', 'ROLE_DG', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/alerts/alerts.html',
                        controller: 'AlertsController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('alerts.new', {
                parent: 'alerts',
                url: '/new?type&id&name',
                data: {
                    authorities: ['ROLE_COMMERCIAL', 'ROLE_DG', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/alerts/alerts-dialog.html',
                        controller: 'AlertsNewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                var entity = {
                                    "active": true
                                };
                                if ($stateParams.type === "company" || $stateParams.type === "collectivity") {
                                    entity.type = "organisation";
                                    entity["organisation"] = {
                                        id: $stateParams.id,
                                        type: $stateParams.type
                                    };
                                } else {
                                    // Profile
                                    entity.type = $stateParams.type;
                                    entity[$stateParams.type] = {
                                        id: $stateParams.id
                                    };
                                }
                                return entity;
                            }
                        }
                    }).result.then(function() {
                        $state.go('alerts', null, { reload: 'alerts' });
                    }, function() {
                        $state.go('alerts');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AlertsController', AlertsController);

    AlertsController.$inject = ['$state', 'Alert', 'Subscription', 'Search', 'Principal', 'User'];

    function AlertsController($state, Alert, Subscription, Search, Principal, User) {
        var vm = this;

        vm.alerts = [];
        vm.subscriptions = [];
        vm.query = '';
        vm.noResults = false;
        vm.alertMgmtIsOpen = false;
        vm.emailFrequency = 'weekly';
        vm.me = {};

        vm.search = search;
        vm.markAlertAsSeen = markAlertAsSeen;
        vm.seenFilter = seenFilter;
        vm.removeSubscription = removeSubscription;
        vm.toggleAlertMgmt = toggleAlertMgmt;
        vm.updatePreferences = updatePreferences;

        Alert.query(onAlertFetchCompleted);
        Subscription.query(onSubscriptionFetchCompleted);
        Principal.identity().then(onIdentityRetrieved);

        function onAlertFetchCompleted(alerts) {
            vm.alerts = alerts;
            
            vm.alerts = vm.alerts.map(buildAlertMessage);
        }

        function onSubscriptionFetchCompleted(subscriptions) {
            vm.subscriptions = subscriptions;
        }

        function onIdentityRetrieved(me) {
            vm.me = me;
        }

        function removeSubscription(subscriptionId) {
            Subscription.remove({id: subscriptionId}, function () {
                $state.reload();
            });
        }

        function markAlertAsSeen(alert) {
            alert.seen = true;
            Alert.update(alert, function () {
                $state.reload();
            });
        }

        function seenFilter(alert) {
            return alert.seen === false;
        }

        function search(q) {
            return Search.query(q).then(reshapeQueryResults);
        }

        function toggleAlertMgmt() {
            vm.alertMgmtIsOpen = !vm.alertMgmtIsOpen;
        }

        function updatePreferences() {
            User.update(vm.me, function () {
                $state.reload();
            });
        }

        function buildAlertMessage(alert) {
            switch (alert.type) {
                case 'profile':
                    alert.message = "Le profil de " + alert.profile.firstName + " " +
                        alert.profile.lastName + " a été modifié";
                    if (alert.modification.field === "job") {
                        alert.submessage = "Fonction : " + alert.modification.value;
                    }
                    break;
                case 'organisation':
                    alert.message = "La page de " + alert.organisation.name + " a été modifiée";
                    break;
            }
            return alert;
        }

        function reshapeQueryResults(response) {
            var data = response.data;
            var collectivities = data.collectivities.map(function (el) {
                el.dropdownType = 'company';
                return el;
            });
            var companies = data.companies.map(function (el) {
                el.dropdownType = 'company';
                return el;
            });
            var profiles1 = data.profiles['1'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles2 = data.profiles['2'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles3 = data.profiles['3'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            collectivities = collectivities.filter(organisationNotInSubscription);
            companies = companies.filter(organisationNotInSubscription);
            profiles1 = profiles1.filter(profileNotInSubscription);
            profiles2 = profiles2.filter(profileNotInSubscription);
            profiles3 = profiles3.filter(profileNotInSubscription);
            var res = companies.splice(0, 2)
                .concat(collectivities.splice(0, 2))
                .concat(profiles1.splice(0, 3))
                .concat(profiles2.splice(0, 2))
                .concat(profiles3.splice(0, 2));

            function profileNotInSubscription(obj) {
                var res = true;
                vm.subscriptions.forEach(function (subscription) {
                    if (subscription.type === "profile") {
                        if (subscription.profile.id === obj.id) {
                            res = false;
                        }
                    }
                });
                return res;
            }

            function organisationNotInSubscription(obj) {
                var res = true;
                vm.subscriptions.forEach(function (subscription) {
                    if (subscription.type === "organisation") {
                        if (subscription.organisation.id === obj.id) {
                            res = false;
                        }
                    }
                });
                return res;
            }

            return res;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('UserManagementResetController', UserManagementResetController);

    UserManagementResetController.$inject = ['$uibModalInstance', 'profilesPromise', 'History'];

    function UserManagementResetController ($uibModalInstance, profilesPromise, History) {
        var vm = this;
        profilesPromise.$promise.then(function (profiles) {
            vm.profileId = profiles.length ? profiles[0].id : null;
        });

        vm.clear = clear;
        vm.confirmReset = confirmReset;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReset(id) {
            History.resetProfile({ id: id },
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'Company', 'Collectivity', 'Profile', 'EquipeCommerciale', 'Principal', 'Division'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, Company, Collectivity, Profile, EquipeCommerciale, Principal, Division) {
        var vm = this;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN'])) {
            vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT', 'ROLE_DIVISION_ADMIN'];
        } else if (Principal.hasAnyAuthority(['ROLE_DG'])) {
            vm.authorities = ['ROLE_DG', 'ROLE_COMMERCIAL'];
        }



        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        if (Principal.hasAnyAuthority(['ROLE_ADMIN'])) {
            Division.query().$promise.then(function(divisions) {
                vm.divisions = divisions;
            });
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;

            // En création on initiliser la valeur oauth2 avec la valeur par défaut de l'équipe commerciale
            if (vm.user && !vm.user.id ) {
                if (account.ec && account.ec.oauth2) {
                    vm.user.oauth2 = true;
                } else {
                    vm.user.oauth2 = false;
                }
            }
        });

        vm.initOrganisationsNoResults = false;
        vm.getOrganizations = getOrganizations;

        vm.initProfilesNoResults = false;
        vm.getProfiles = getProfiles;

        vm.ecsNoResults = false;
        vm.getEcs = getEcs;
        vm.ecChanged = ecChanged;


        vm.divisionNoResults = false;

        vm.isAdmin = isAdmin;
        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function getOrganizations(q) {
            return Company.search({ query: q }).$promise.then(function(companies) {
                return Collectivity.search({ query: q }).$promise.then(function(collectivities) {
                    var organizations = companies.concat(collectivities);
                    if (isAdmin()) {
                        organizations.map( function(org) {
                            if (org.equipeCommerciale) {
                                org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                            }
                        });
                    }

                    vm.initOrganisationsNoResults = organizations.length === 0;
                    vm.editForm.initOrganisation.$setValidity('exist',  organizations.length !== 0);
                    return organizations;
                });
            });
        }


        function getProfiles(q) {
            return Profile.search({ query: q }).$promise.then(function(profiles) {
                vm.initProfilesNoResults = profiles.length === 0;
                vm.editForm.initSuperior.$setValidity('exist',  profiles.length !== 0);
                return profiles;
            });
        }

        function getEcs(q) {
            return EquipeCommerciale.search({ query: q }).$promise.then(function(ecs) {
                vm.ecsNoResults = ecs.length === 0;
                vm.editForm.ec.$setValidity('exist',  ecs.length !== 0);
                return ecs;
            });
        }

        function ecChanged(item) {
            if (item && item.oauth2) {
                vm.user.oauth2 = true;
            } else {
                vm.user.oauth2 = false;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.email);

        function load (email) {
            User.get({email: email}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (email) {
            User.delete({email: email},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Users'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:email',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DG'],
                pageTitle: 'Axenteev | User detail'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null, initTitle: null, initSuperior: null, initOrganisation: null, oauth2: false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{email}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DG']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({email : $stateParams.email});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.reset', {
            parent: 'user-management',
            url: '/{email}/reset',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-reset-dialog.html',
                    controller: 'UserManagementResetController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        profilesPromise: ['Profile', function (Profile) {
                            return Profile.query({email : $stateParams.email});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{email}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({email : $stateParams.email});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT', 'ROLE_DIVISION_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security

            var hiddenUsersSize = 0;
             /*
            for (var i in data) {
                if (data[i]['email'] === 'anonymous@localhost') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            */
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null, oauth2: false
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('profile-info-management', {
            parent: 'admin',
            url: '/profile-info-management',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/profile-info-management/profile-info-management.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ModerationProfileDeleteController', ModerationProfileDeleteController);

    ModerationProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModerationProfile'];

    function ModerationProfileDeleteController ($uibModalInstance, entity, ModerationProfile) {
        var vm = this;

        vm.moderationProfile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ModerationProfile.reject({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('moderation-profile', {
            parent: 'admin',
            url: '/moderation-profile?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Modérations profiles'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/moderation-profile/moderation-profile.html',
                    controller: 'ModerationProfileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        
        })

        
        .state('moderation-profile.contribution', {
            parent: 'moderation-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                  
                }).result.then(function() {
                    $state.go('moderation-profile',{}, { reload: true });
                }, function() {
                    $state.go('moderation-profile');
                });
            }]
        })


        
        .state('moderation-profile.edit', {
            parent: 'moderation-profile.contribution',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            params: {
                profile: {
                    value: {}
                }
            },
            resolve: {
                entity: ['$stateParams', 'ModerationProfile', function($stateParams, ModerationProfile) {
                    return ModerationProfile.get({id : $stateParams.id}).$promise.then(function (moderationProfile) {
                        var  profileToUpdate = moderationProfile;
                        profileToUpdate.moderationId = moderationProfile.id;
                        if (moderationProfile.referencedProfile){
                            profileToUpdate.id = moderationProfile.referencedProfile.id;
                            profileToUpdate.importId = moderationProfile.referencedProfile.importId;
                        } else {
                            profileToUpdate.id = null;
                        }
                        profileToUpdate['positions'] = moderationProfile.mPositions;

                        for (var index in  profileToUpdate['positions']) {
                            var positionToUpdate = profileToUpdate['positions'][index];
                            if (positionToUpdate.referencedPositionId){
                                positionToUpdate.id = positionToUpdate.referencedPositionId;
                            } else {
                                positionToUpdate.id = null;
                            }
                         }
                       
                        delete profileToUpdate.mPositions;
                        delete profileToUpdate.referencedProfile;
                        profileToUpdate.hasModeration = true;
                        return profileToUpdate;
                    });

                }]
            },
            views: {
                'contrib@': { 
                  templateUrl: 'app/entities/profile/profile-dialog.html',
                  controller: 'ProfileDialogController',
                  controllerAs: 'vm'
                }
              }
  
        })
        .state('moderation-profile.delete', {
            parent: 'moderation-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/moderation-profile/moderation-profile-delete-dialog.html',
                    controller: 'ModerationProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModerationProfile', function(ModerationProfile) {
                            return ModerationProfile.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('moderation-profile', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('ModerationProfile', ModerationProfile);

        ModerationProfile.$inject = ['$resource'];

    function ModerationProfile ($resource) {
        var service = $resource('api/moderation/profile/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: 'api/moderation/profile/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'mupdate': { 
                method:'POST',
                url: '/api/moderation/profile/update'
            },
            'msave': { 
                method:'POST',
                url: '/api/moderation/profile/add'
            },
            
            'reject':{
                method:'DELETE',
                url: 'api/moderation/profile/:id/reject'
            },
            'createAndApprove': { 
                method:'POST',
                url: '/api/moderation/profile/:id/createAndApprove'
            },
            'updateAndApprove': { 
                method:'PUT',
                url: '/api/moderation/profile/:id/updateAndApprove'
            },
            'directCreateAndApprove': { 
                method:'POST',
                url: '/api/moderation/profile/directCreateAndApprove'
            },
            'directUpdateAndApprove': { 
                method:'PUT',
                url: '/api/moderation/profile/directUpdateAndApprove'
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ModerationProfileController', ModerationProfileController);

    ModerationProfileController.$inject = ['Principal', 'ModerationProfile', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function ModerationProfileController(Principal, ModerationProfile, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

       
        vm.currentAccount = null;
        vm.loadAll = loadAll;
        vm.moderationProfiles = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.directApprove = directApprove;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            ModerationProfile.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.moderationProfiles = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function directApprove (moderationProfile) {
            if (moderationProfile.moderationType == "CREATE") {
                vm.isSaving = true;
                ModerationProfile.directCreateAndApprove(moderationProfile, onSaveSuccess, onSaveError);
            } else if (moderationProfile.moderationType == "UPDATE") {
                vm.isSaving = true;
                ModerationProfile.directUpdateAndApprove(moderationProfile, onSaveSuccess, onSaveError);
            } else {
                console.log("Wrong moderation type. Must be CREATE or UPDATE")
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            vm.loadAll();
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ModerationCompanyDeleteController', ModerationCompanyDeleteController);

    ModerationCompanyDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModerationOrganisation'];

    function ModerationCompanyDeleteController ($uibModalInstance, entity, ModerationOrganisation) {
        var vm = this;

        vm.moderationCompany = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ModerationOrganisation.reject({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('moderation-company', {
            parent: 'admin',
            url: '/moderation-company?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Modération company'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/moderation-company/moderation-company.html',
                    controller: 'ModerationCompanyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        
        })

        
        .state('moderation-company.contribution', {
            parent: 'moderation-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                  
                }).result.then(function() {
                    $state.go('moderation-company',{}, { reload: true });
                }, function() {
                    $state.go('moderation-company');
                });
            }]
        })


        
        .state('moderation-company.edit', {
            parent: 'moderation-company.contribution',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            params: {
                company: {
                    value: {}
                }
            },
            resolve: {
                entity: ['$stateParams', 'ModerationOrganisation', function($stateParams, ModerationOrganisation) {
                    return ModerationOrganisation.get({id : $stateParams.id}).$promise.then(function (moderationCompany) {
                        var  companyToUpdate = moderationCompany;
                        companyToUpdate.moderationId = moderationCompany.id;
                        if (moderationCompany.referencedOrganisation){
                            companyToUpdate.id = moderationCompany.referencedOrganisation.id;
                            companyToUpdate.importId = moderationCompany.referencedOrganisation.importId;
                        } else {
                            companyToUpdate.id = null;
                        }
                        companyToUpdate['positions'] = moderationCompany.mPositions;

                        delete companyToUpdate.mPositions;
                        delete companyToUpdate.referencedOrganisation;
                        companyToUpdate.hasModeration = true;
                        return companyToUpdate;
                    });

                }]
            },
            views: {
                'contrib@': { 
                  templateUrl: 'app/entities/company/company-dialog.html',
                  controller: 'CompanyDialogController',
                  controllerAs: 'vm'
                }
              }
  
        })
        .state('moderation-company.delete', {
            parent: 'moderation-company',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/moderation-company/moderation-company-delete-dialog.html',
                    controller: 'ModerationCompanyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModerationOrganisation', function(ModerationOrganisation) {
                            return ModerationOrganisation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('moderation-company', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ModerationCompanyController', ModerationCompanyController);

    ModerationCompanyController.$inject = ['Principal', 'ModerationOrganisation', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function ModerationCompanyController(Principal, ModerationOrganisation, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

       
        vm.currentAccount = null;
        vm.loadAll = loadAll;
        vm.moderationCompanies = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.directApprove = directApprove;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            ModerationOrganisation.queryCompany({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.moderationCompanies = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function directApprove (moderationCompany) {
            if (moderationCompany.moderationType == "CREATE") {
                vm.isSaving = true;
                ModerationOrganisation.directCreateAndApprove(moderationCompany, onSaveSuccess, onSaveError);
            } else if (moderationCompany.moderationType == "UPDATE") {
                vm.isSaving = true;
                ModerationOrganisation.directUpdateAndApprove(moderationCompany, onSaveSuccess, onSaveError);
            } else {
                console.log("Wrong moderation type. Must be CREATE or UPDATE")
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            vm.loadAll();
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ModerationCollectivityDeleteController', ModerationCollectivityDeleteController);

    ModerationCollectivityDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModerationOrganisation'];

    function ModerationCollectivityDeleteController ($uibModalInstance, entity, ModerationOrganisation) {
        var vm = this;

        vm.moderationCollectivity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ModerationOrganisation.reject({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('moderation-collectivity', {
            parent: 'admin',
            url: '/moderation-collectivity?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Modération collectivity'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/moderation-collectivity/moderation-collectivity.html',
                    controller: 'ModerationCollectivityController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        
        })

        
        .state('moderation-collectivity.contribution', {
            parent: 'moderation-collectivity',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                  
                }).result.then(function() {
                    $state.go('moderation-collectivity',{}, { reload: true });
                }, function() {
                    $state.go('moderation-collectivity');
                });
            }]
        })


        
        .state('moderation-collectivity.edit', {
            parent: 'moderation-collectivity.contribution',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            params: {
                collectivity: {
                    value: {}
                }
            },
            resolve: {
                entity: ['$stateParams', 'ModerationOrganisation', function($stateParams, ModerationOrganisation) {
                    return ModerationOrganisation.get({id : $stateParams.id}).$promise.then(function (moderationCollectivity) {
                        var  collectivityToUpdate = moderationCollectivity;
                        collectivityToUpdate.moderationId = moderationCollectivity.id;
                        if (moderationCollectivity.referencedOrganisation){
                            collectivityToUpdate.id = moderationCollectivity.referencedOrganisation.id;
                            collectivityToUpdate.importId = moderationCollectivity.referencedOrganisation.importId;
                        } else {
                            collectivityToUpdate.id = null;
                        }
                        collectivityToUpdate['positions'] = moderationCollectivity.mPositions;

                        delete collectivityToUpdate.mPositions;
                        delete collectivityToUpdate.referencedOrganisation;
                        collectivityToUpdate.hasModeration = true;
                        return collectivityToUpdate;
                    });

                }]
            },
            views: {
                'contrib@': { 
                  templateUrl: 'app/entities/collectivity/collectivity-dialog.html',
                  controller: 'CollectivityDialogController',
                  controllerAs: 'vm'
                }
              }
  
        })
        .state('moderation-collectivity.delete', {
            parent: 'moderation-collectivity',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/moderation-collectivity/moderation-collectivity-delete-dialog.html',
                    controller: 'ModerationCollectivityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModerationOrganisation', function(ModerationOrganisation) {
                            return ModerationOrganisation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('moderation-collectivity', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ModerationCollectivityController', ModerationCollectivityController);

    ModerationCollectivityController.$inject = ['Principal', 'ModerationOrganisation', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function ModerationCollectivityController(Principal, ModerationOrganisation, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

       
        vm.currentAccount = null;
        vm.loadAll = loadAll;
        vm.moderationCompanies = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.directApprove = directApprove;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            ModerationOrganisation.queryCollectivity({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.moderationCompanies = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function directApprove (moderationCollectivity) {
            if (moderationCollectivity.moderationType == "CREATE") {
                vm.isSaving = true;
                ModerationOrganisation.directCreateAndApprove(moderationCollectivity, onSaveSuccess, onSaveError);
            } else if (moderationCollectivity.moderationType == "UPDATE") {
                vm.isSaving = true;
                ModerationOrganisation.directUpdateAndApprove(moderationCollectivity, onSaveSuccess, onSaveError);
            } else {
                console.log("Wrong moderation type. Must be CREATE or UPDATE")
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            vm.loadAll();
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Application Metrics'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhimetrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/threaddump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Logs'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Health Checks'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('quilinkApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('EquipeCommerciale', EquipeCommerciale);

        EquipeCommerciale.$inject = ['$resource'];

    function EquipeCommerciale ($resource) {
        var service = $resource('api/equipeCommerciales/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: 'api/equipeCommerciales/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByEmail': {
                method: 'GET',
                url: 'api/equipeCommerciales/:email/email',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{
                method:'DELETE',
                url: 'api/equipeCommerciales/:id'
            },
            'search': {
                method: 'GET',
                url: 'api/equipeCommerciales/search/:query',
                isArray: true
            },
            'myEquipesCommerciales': {
                method: 'GET',
                url: 'api/equipeCommerciales/myEquipesCommerciales',
                isArray: true
            },
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EquipeCommercialeManagementDialogController',EquipeCommercialeManagementDialogController);

    EquipeCommercialeManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'EquipeCommerciale', 'User', 'Division', 'Collectivity'];

    function EquipeCommercialeManagementDialogController ($stateParams, $uibModalInstance, entity, EquipeCommerciale, User, Division) {
        var vm = this;

        vm.editForm;
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.ec = entity;
        vm.getDgs = getDgs;

        vm.divisionsNoResults = false;
        vm.getDivisions = getDivisions;


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        function getDgs(q, dgNum) {
            return User.search({ query: q }).$promise.then(function (dgs) {
                var noResultName = 'dgsNoResults' + dgNum;
                vm[noResultName] = dgs.length === 0;
                return dgs;
            });
        }


        function save () {
            vm.isSaving = true;
            if (vm.ec.dgs) {
                vm.ec.dgs = vm.ec.dgs.filter(function(u) {
                    return u !== null;
                });
            }
            if (vm.ec.commerciaux) {
                vm.ec.commerciaux = vm.ec.commerciaux.filter(function(u) {
                    return u !== null;
                });
            }

            if (vm.ec && vm.ec.id) {
                EquipeCommerciale.update(vm.ec, onSaveSuccess, onSaveError);
            } else {
                EquipeCommerciale.save(vm.ec, onSaveSuccess, onSaveError);
            }
        }

        function getDivisions(q) {
            return Division.search({ query: q }).$promise.then(function(divisions) {
                vm.divisionsNoResults = divisions.length === 0;
                vm.editForm.division.$setValidity('exist',  divisions.length !== 0);
                return divisions;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EquipeCommercialeDeleteController', EquipeCommercialeDeleteController);

    EquipeCommercialeDeleteController.$inject = ['$uibModalInstance', 'entity', 'EquipeCommerciale'];

    function EquipeCommercialeDeleteController ($uibModalInstance, entity, EquipeCommerciale) {
        var vm = this;

        vm.ec = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EquipeCommerciale.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ec-management', {
            parent: 'admin',
            url: '/ec-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Equipes commerciales'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/ec-management/ec-management.html',
                    controller: 'EquipeCommercialeManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })



        .state('ec-management.new', {
            parent: 'ec-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/ec-management/ec-management-dialog.html',
                    controller: 'EquipeCommercialeManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, name: null, user: null, maxUsers: 0, creditValue: 0,
                                creditsSpent: 0, credits: 0, organisation: null, dgs: new Array(5), oauth2: false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ec-management', null, { reload: true });
                }, function() {
                    $state.go('ec-management');
                });
            }]
        })
        .state('ec-management.edit', {
            parent: 'ec-management',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/ec-management/ec-management-dialog.html',
                    controller: 'EquipeCommercialeManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EquipeCommerciale', function(EquipeCommerciale) {
                            var ec = EquipeCommerciale.get({id : $stateParams.id});
                            var dgs = new Array(5);
                            if (ec.dgs && ec.dgs[0]){
                                dgs[0] = ec.dgs[0];
                            }
                            if (ec.dgs && ec.dgs[1]){
                                dgs[1] = ec.dgs[1];
                            }
                            if (ec.dgs && ec.dgs[2]){
                                dgs[2] = ec.dgs[2];
                            }
                            if (ec.dgs && ec.dgs[3]){
                                dgs[3] = ec.dgs[3];
                            }
                            if (ec.dgs && ec.dgs[4]){
                                dgs[4] = ec.dgs[4];
                            }
                            ec.dgs = ec;
                            return ec;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ec-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ec-management.delete', {
            parent: 'ec-management',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/ec-management/ec-management-delete-dialog.html',
                    controller: 'EquipeCommercialeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EquipeCommerciale', function(EquipeCommerciale) {
                            return EquipeCommerciale.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('ec-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EquipeCommercialeManagementController', EquipeCommercialeManagementController);

    EquipeCommercialeManagementController.$inject = ['Principal', 'EquipeCommerciale', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function EquipeCommercialeManagementController(Principal, EquipeCommerciale, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;


        vm.currentAccount = null;
        vm.loadAll = loadAll;
        vm.equipeCommerciales = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            EquipeCommerciale.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {

            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.equipeCommerciales = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null, oauth2: false
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonProfileManagementMergeController', DoublonProfileManagementMergeController);

    DoublonProfileManagementMergeController.$inject = ['$uibModalInstance', 'entity', 'DoublonProfile'];

    function DoublonProfileManagementMergeController ($uibModalInstance, entity, DoublonProfile) {
        var vm = this;

        vm.doublon = entity;
        vm.clear = clear;
        vm.confirmMerge = confirmMerge;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmMerge (nom, prenom) {
            DoublonProfile.merge(entity,
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonProfileManagementDeleteController', DoublonProfileManagementDeleteController);

    DoublonProfileManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'DoublonProfile'];

    function DoublonProfileManagementDeleteController ($uibModalInstance, entity, DoublonProfile) {
        var vm = this;

        vm.doublon = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (userId, nom, prenom) {
            DoublonProfile.deleteByNomPrenom({userId: userId, nom: nom, prenom : prenom},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonProfileManagementCreateController', DoublonProfileManagementCreateController);

    DoublonProfileManagementCreateController.$inject = ['$uibModalInstance', 'entity', 'DoublonProfile'];

    function DoublonProfileManagementCreateController ($uibModalInstance, entity, DoublonProfile) {
        var vm = this;

        vm.doublon = entity;
        vm.clear = clear;
        vm.confirmCreate = confirmCreate;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCreate () {
            DoublonProfile.create(entity,
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('doublon-profile-management', {
            parent: 'admin',
            url: '/doublon-profile-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Doublons'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/doublon-profile-management/doublon-profile-management.html',
                    controller: 'DoublonProfileManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })

        .state('doublon-profile-management.delete', {
            parent: 'doublon-profile-management',
            url: '/{userId}/{nom}/{prenom}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/doublon-profile-management/doublon-profile-management-delete-dialog.html',
                    controller: 'DoublonProfileManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DoublonProfile', function(DoublonProfile) {
                            return DoublonProfile.getByNomPrenom({ userId: $stateParams.userId, nom: $stateParams.nom, prenom: $stateParams.prenom });
                        }]
                    }
                }).result.then(function() {
                    $state.go('doublon-profile-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('doublon-profile-management.create', {
            parent: 'doublon-profile-management',
            url: '/{userId}/{nom}/{prenom}/create',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/doublon-profile-management/doublon-profile-management-create-dialog.html',
                    controller: 'DoublonProfileManagementCreateController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DoublonProfile', function (DoublonProfile) {
                            return DoublonProfile.getByNomPrenom({ userId: $stateParams.userId, nom: $stateParams.nom, prenom: $stateParams.prenom });
                        }]
                    }
                }).result.then(function () {
                    $state.go('doublon-profile-management', null, { reload: true });
                }, function () {
                    $state.go('^');
                });
            }]
        })
        .state('doublon-profile-management.merge', {
            parent: 'doublon-profile-management',
            url: '/{userId}/{nom}/{prenom}/merge',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/doublon-profile-management/doublon-profile-management-merge-dialog.html',
                    controller: 'DoublonProfileManagementMergeController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DoublonProfile', function (DoublonProfile) {
                            return DoublonProfile.getByNomPrenom({ userId: $stateParams.userId, nom: $stateParams.nom, prenom: $stateParams.prenom });
                        }]
                    }
                }).result.then(function () {
                    $state.go('doublon-profile-management', null, { reload: true });
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonProfileManagementController', DoublonProfileManagementController);

    DoublonProfileManagementController.$inject = ['Principal', 'DoublonProfile','ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function DoublonProfileManagementController(Principal, DoublonProfile, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.doublons = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = 10;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            DoublonProfile.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            DoublonProfile.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage, 
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['email'] === 'anonymous@localhost') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.doublons = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('DoublonProfile', DoublonProfile);

    DoublonProfile.$inject = ['$resource'];

    function DoublonProfile ($resource) {
        var service = $resource('api/doublon/profile', {}, {
            'query': {method: 'GET', isArray: true},
            'getByNomPrenom': {
                method: 'GET',
                url: 'api/doublon/profile/nomprenom/:userId/:nom/:prenom',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },

            'create':{
                method:'POST',
                url: 'api/doublon/profile',
            },
            'merge':{
                method:'PUT',
                url: 'api/doublon/profile',
            },
            'deleteByNomPrenom':{
                method:'DELETE',
                url: 'api/doublon/profile/nomprenom/:userId/:nom/:prenom',
            },
            'myPendingContributions':{
                method: 'GET',
                url: 'api/doublon/profile/mypendingcontributions',
                isArray: true
            },
            'myPendingHomonyms':{
                method: 'GET',
                url: 'api/doublon/profile/mypendinghomonyms',
                isArray: true
            },

            /* Validation User */
            'deletePendingContribution':{
                method:'DELETE',
                url: 'api/doublon/profile/id/:id',
            },
            'createProfileFromPendingContribution':{
                method:'POST',
                url: 'api/doublon/profile/id/:id/grade/:grade',
            },
            'deletePendingHomonym':{
                method:'DELETE',
                url: 'api/doublon/profile/id/:id',
            },
            'createProfileFromPendingHomonym':{
                method:'POST',
                url: 'api/doublon/homonyme/profile/id/:id/grade/:grade',
            },
            'connectProfileFromPendingHomonym':{
                method:'POST',
                url: 'api/doublon/profile/connect/id/:id/grade/:grade',
            }
        });

        return service;
    }



})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonCompanyManagementMergeController', DoublonCompanyManagementMergeController);

        DoublonCompanyManagementMergeController.$inject = ['$uibModalInstance', 'entity', 'DoublonCompany'];

    function DoublonCompanyManagementMergeController ($uibModalInstance, entity, DoublonCompany) {
        var vm = this;

        vm.doublon = entity;
        vm.clear = clear;
        vm.confirmMerge = confirmMerge;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmMerge (name) {
            DoublonCompany.merge({name: name},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonCompanyManagementDeleteController', DoublonCompanyManagementDeleteController);

    DoublonCompanyManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'DoublonCompany'];

    function DoublonCompanyManagementDeleteController ($uibModalInstance, entity, DoublonCompany) {
        var vm = this;

        vm.doublon = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (name) {
            DoublonCompany.delete({name: name},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonCompanyManagementCreateController', DoublonCompanyManagementCreateController);

        DoublonCompanyManagementCreateController.$inject = ['$uibModalInstance', 'entity', 'DoublonCompany'];

    function DoublonCompanyManagementCreateController ($uibModalInstance, entity, DoublonCompany) {
        var vm = this;

        vm.doublon = entity;
        vm.clear = clear;
        vm.confirmCreate = confirmCreate;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCreate (name) {
            DoublonCompany.create({name: name},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('doublon-company-management', {
                parent: 'admin',
                url: '/doublon-company-management?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Axenteev | Doublons'
                },
                views: {
                    'content@admin': {
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-management.html',
                        controller: 'DoublonCompanyManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }]
                }
            })

            .state('doublon-company-management.delete', {
                parent: 'doublon-company-management',
                url: '/{name}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-management-delete-dialog.html',
                        controller: 'DoublonCompanyManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DoublonCompany', function (DoublonCompany) {
                                return DoublonCompany.get({ name: $stateParams.name });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('doublon-company-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('doublon-company-management.create', {
                parent: 'doublon-company-management',
                url: '/{name}/create',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-management-create-dialog.html',
                        controller: 'DoublonCompanyManagementCreateController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DoublonCompany', function (DoublonCompany) {
                                return DoublonCompany.get({ name: $stateParams.name });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('doublon-company-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('doublon-company-management.merge', {
                parent: 'doublon-company-management',
                url: '/{name}/merge',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-management-merge-dialog.html',
                        controller: 'DoublonCompanyManagementMergeController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DoublonCompany', function (DoublonCompany) {
                                return DoublonCompany.get({ name: $stateParams.name });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('doublon-company-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('doublon-company-management.merge.db', {
                parent: 'doublon-company-management',
                url: '/{id}/mergeCompanyDB',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-db-management-merge-dialog.html',
                        controller: 'DoublonCompanyDBManagementMergeController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DoublonCompanyDB', function (DoublonCompanyDB) {
                                return DoublonCompanyDB.get({ id: $stateParams.id });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('doublon-company-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonCompanyManagementController', DoublonCompanyManagementController);

    DoublonCompanyManagementController.$inject = ['Principal', 'DoublonCompany','ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function DoublonCompanyManagementController(Principal, DoublonCompany,ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.doublons = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = 100;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            DoublonCompany.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            DoublonCompany.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['email'] === 'anonymous@localhost') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.doublons = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DoublonCompanyDBManagementMergeController', DoublonCompanyDBManagementMergeController);

        DoublonCompanyDBManagementMergeController.$inject = ['$uibModalInstance', 'entity', 'DoublonCompanyDB'];

    function DoublonCompanyDBManagementMergeController ($uibModalInstance, entity, DoublonCompanyDB) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.confirmMerge = confirmMerge;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmMerge (id) {
            DoublonCompanyDB.mergeCompanyDB({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('DoublonCompanyDB', DoublonCompanyDB);

        DoublonCompanyDB.$inject = ['$resource'];

    function DoublonCompanyDB ($resource) {
        var service = $resource('api/doublon/company-db', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: 'api/doublon/company-db/:id',
                isArray: false,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'mergeCompanyDB':{
                method:'PUT',
                url: 'api/doublon/company-db',
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('DoublonCompany', DoublonCompany);

    DoublonCompany.$inject = ['$resource'];

    function DoublonCompany ($resource) {
        var service = $resource('api/doublon/company', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: 'api/doublon/profile/companyName/:name',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'create':{
                method:'POST',
                url: 'api/doublon/company/name/:name',
            },
            'merge':{
                method:'PUT',
                url: 'api/doublon/company/name/:name',
            },
            'mergeCompanyDB':{
                method:'PUT',
                url: 'api/doublon/company/id/:id',
            },
            'delete':{
                method:'DELETE',
                url: 'api/doublon/company/name/:name',
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | API docs'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('db-profile-management', {
            parent: 'admin',
            url: '/db-profile-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Historique DB Profiles'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/db-profile-management/db-profile-management.html',
                    controller: 'DBProfileManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        
        })
        
    }
})();
(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DBProfileManagementController', DBProfileManagementController);

    DBProfileManagementController.$inject = ['Principal', 'History', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'ObjectDiff'];

    function DBProfileManagementController(Principal, History, AlertService, $state, pagingParams, paginationConstants, ObjectDiff) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.profiles = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();


        function loadAll () {
            History.profileAdd({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {

            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.profiles = data;
            vm.profiles = vm.profiles.map(function (profile) {

                if (isNaN(profile.importId)) {
                    profile.importSource = profile.importId;
                } else {

                    profile.importSource =  profile.domain;
                }
                if (profile.revisionType == 'MOD'){
                    History.previousProfile({profileId : profile.id}, function(previousProfile){
                        if (previousProfile){

                            previousProfile.lastModifiedDate = null;
                            delete previousProfile.$promise;
                            delete previousProfile.$resolved;
                            // you can directly diff your objects js now or parse a Json to object and diff
                            var diff = ObjectDiff.diff(previousProfile, profile);

                            delete diff.value.revisionDate;

                            delete diff.value.lastModifiedDate;
                            delete diff.value.lastModifiedBy;
                            delete diff.value.revisionType;
                            delete diff.value.revisionId;
                            delete diff.value.importSource;
                            delete diff.value.originalImport;
                            var diffValue = ObjectDiff.toJsonDiffView(diff);


                            profile.diffValue = diffValue;
                        }
                    });
                }

                return profile;
            });

        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Configuration'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Audits'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            parent: 'app',
            url: '/admin',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/admin.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Paramètres'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                pageTitle: 'Axenteev'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;
            vm.errorMessage = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                vm.error = 'ERROR';
                if (response.status === 400 && response.data) {
                    vm.errorMessage = response.data;
                } else {
                    vm.errorMessage = "Une erreur est survenue.";
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                pageTitle: 'Axenteev'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', '$state'];

    function ResetFinishController ($stateParams, $timeout, Auth, $state) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.logout = logout;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function logout() {
            Auth.logout();
            $state.go('home', {}, {reload: true});
        }


    }
    
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Force du mot de passe :</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Mot de passe'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('check', {
            parent: 'app',
            url: '/check',
            data: {
                pageTitle: 'Vérifier ma présence dans la base Axenteev'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/check/check.html',
                    controller: 'CheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CheckController', CheckController);

    CheckController.$inject = ['$timeout', 'Profile'];

    function CheckController ($timeout, Profile) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.check = check;
        vm.requestDelete = requestDelete;
        vm.lastName = '';
        vm.firstName = '';
        vm.email = '';
        vm.found = false;
        vm.notFound = false;
        vm.deleteRequested = false;

        $timeout(function (){angular.element('#lastName').focus();});

        function check () {
            vm.error = null;
            vm.errorEmailNotExists = null;
            vm.errorMessage = null;
            vm.deleteRequested = false;
            Profile.check({lastName: vm.lastName, firstName: vm.firstName, email: vm.email}, onSuccess, onError);
        }

        function requestDelete () {
            Profile.requestDelete({lastName: vm.lastName, firstName: vm.firstName, email: vm.email}, onDeleteRequestSuccess, onError);
        }


        function onSuccess(data, headers) {
            vm.notFound = data.found === 'false';
            vm.found = data.found === 'true';
            vm.errorMessage = null;
            vm.deleteRequested = false;
        }

        function onDeleteRequestSuccess(data, headers) {
            vm.deleteRequested = true;
            vm.errorMessage = null;
        }

        function onError(response) {
            if (response.status === 404) {
                vm.notFound = true;
                vm.found = false;
                vm.errorMessage = null;
                vm.deleteRequested = false;
            } else if (response.status === 429) {
                vm.notFound = false;
                vm.found = false;
                vm.deleteRequested = false;
                vm.errorMessage = "Trop de tentatives. Merci de réessayer ultérieurement.";
            } else if (response.status === 400) {
                vm.notFound = false;
                vm.found = false;
                vm.deleteRequested = false;
                vm.errorMessage = "Merci de vérifier les champs de saisie.";
            } else if (response.status === 409) {
                vm.notFound = false;
                vm.found = true;
                vm.deleteRequested = false;
                vm.errorMessage = "Demande de suppression impossible. Une suppression a déja été demandée. Nous vous invitons à contacter contact@axenteev.com pour plus de renseignements.";
            } else {
                vm.notFound = false;
                vm.found = false;
                vm.deleteRequested = false;
                vm.errorMessage = "Une erreur est survenue.";
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('quilinkApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/alerts/alerts-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation</h4></div><div class="modal-body"><p>Voulez-vous souscrire aux alertes pour {{ vm.name }} ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Valider</span></button></div></form>');
$templateCache.put('app/alerts/alerts.html','<div class="super-loop-wrapper"><div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body alerts-page col-xs-12"><div class="row"><div class="col-xs-12"><div class="well alerts-creation"><div class="well-header"><h4>Alertes</h4></div><div class="well-body"><div class="input-group"><input type="text" placeholder="Cr\xE9er une alerte pour..." class="form-control" uib-typeahead="result as result.name for result in vm.search($viewValue)" ng-model="vm.query" typeahead-popup-template-url="app/alerts/typeahead/search-popup.html" typeahead-template-url="app/alerts/typeahead/search-company.html" typeahead-no-results="vm.noResults"> <span class="input-group-btn"><button type="submit" class="btn btn-default"><i class="fas fa-search"></i></button></span></div><span ng-click="vm.toggleAlertMgmt()" class="manage-alerts-link">G\xE9rer mes alertes</span></div><div class="well-subbody" ng-show="vm.alertMgmtIsOpen"><label for="email-frequency">Fr\xE9quence de notifications par email :</label><select id="email-frequency" ng-model="vm.me.emailFrequency"><option value="daily" label="Journali\xE8re"></option><option value="weekly" label="Hebdomadaire"></option><option value="bi_monthly" label="Bi-mensuelle"></option><option value="monthly" label="Mensuelle"></option><option value="never" label="Jamais"></option></select><br><label for="my-profile-subscription">Notifications concernant mon profil</label><select id="my-profile-subscription" ng-model="vm.me.subscribeMyProfile" ng-options="o.v as o.n for o in [{ n: \'Desactive\', v: false }, { n: \'Active\', v: true }]"></select><br><label for="my-connections-subscription">Notifications concernant mes connexions</label><select id="my-connections-subscription" ng-model="vm.me.subscribeMyConnexions" ng-options="o.v as o.n for o in [{ n: \'Desactive\', v: false }, { n: \'Active\', v: true }]"></select><button type="submit" ng-click="vm.updatePreferences()" class="btn btn-primary">Valider</button></div></div></div></div><div class="row"><div class="col-xs-7"><div class="well alerts-container"><div class="list-header"><p>Mes Alertes</p></div><div class="list-container"><div class="list-alerts-wrapper"><div ng-repeat="alert in vm.alerts | filter:{ seen: false } | orderBy:\'-createdAt\' : false"><div ng-switch="alert.type"><div ng-switch-when="profile" class="alert-item"><p class="alert-message">{{ alert.message }}</p><p class="alert-submessage">{{ alert.submessage }}</p><a ui-sref="profile({ id: alert.profile.id, position: \'\' })" class="go-to-page-btn"><i class="fas fa-arrow-circle-right"></i> </a><img src="content/images/delete.svg" width="20" class="delete-btn" ng-click="vm.markAlertAsSeen(alert)"></div></div></div><p class="no-alerts" ng-show="vm.alerts.filter(vm.seenFilter).length === 0">Vous \xEAtes \xE0 jour !</p></div></div></div></div><div class="col-xs-5"><div class="well alerts-container"><div class="list-header"><p>Mes Alertes personnalis\xE9es</p></div><div class="list-container"><div class="list-subscriptions-wrapper"><div ng-repeat="subscription in vm.subscriptions | orderBy:\'-createdAt\' : false"><div ng-switch="subscription.type"><div ng-switch-when="profile" class="list-subscription" ng-class-odd="\'grey-bg\'"><div class="img" ng-hide="subscription.profile.picture" style="background-image: url(\'../../content/images/no-picture.png\')"></div><div class="img" ng-show="subscription.profile.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + subscription.profile.pictureContentType + \';base64,\' + subscription.profile.picture + \'\\\')\' }"></div><div class="list-message-informations"><p class="list-message-contact">{{ subscription.profile.firstName + \' \' + subscription.profile.lastName }}</p><img class="delete-btn" ng-click="vm.removeSubscription(subscription.id)" src="content/images/delete.svg" width="18"></div></div><div ng-switch-when="organisation" class="list-subscription" ng-class-odd="\'grey-bg\'"><div class="img" ng-hide="subscription.organisation.logo" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="img" ng-show="subscription.organisation.logo" ng-style="{\'background-image\': \'url(\\\'data:\' + subscription.organisation.logoContentType + \';base64,\' + subscription.organisation.logo + \'\\\')\' }"></div><div class="list-message-informations"><p class="list-message-contact">{{ subscription.organisation.name }}</p><img class="delete-btn" ng-click="vm.removeSubscription(subscription.id)" src="content/images/delete.svg" width="18"></div></div></div></div><p class="no-message" ng-show="vm.subscriptions.length === 0">Aucune alerte personnalis\xE9e.</p></div></div></div></div></div></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><suggestion-addon></suggestion-addon><discover-addon></discover-addon><rank-addon></rank-addon><credits-addon></credits-addon><copyright-addon></copyright-addon></div></div></div></div></div>');
$templateCache.put('app/admin/admin.html','<div class="padding15" style="padding-left: 40px;padding-right: 30px"><div class="row"><div class="col-xs-12 col-md-2"><nav><div class="list-group"><a class="list-group-item" ui-sref-active="active" ui-sref="user-management"><span class="fa fa-users fa-fw" name="user"></span> Utilisateurs </a><a class="list-group-item" ui-sref-active="active" ui-sref="division" style="padding-right: 13px"><span class="fa fa-users fa-fw" name="user"></span> Divisions </a><a class="list-group-item" ui-sref-active="active" ui-sref="ec-management" style="padding-right: 13px"><span class="fa fa-users fa-fw" name="user"></span> Equipes commerciales </a><a class="list-group-item" ui-sref-active="active" ui-sref="doublon-company-management"><span class="fa fa-clone fa-fw" name="clone"></span> Linkedin entreprises </a><a class="list-group-item" ui-sref-active="active" ui-sref="doublon-profile-management"><span class="fa fa-clone fa-fw" name="clone"></span> Linkedin profiles </a><a class="list-group-item" ui-sref-active="active" ui-sref="moderation-profile" style="padding-right: 13px"><span class="fa fa-thumbs-up fa-fw" name="user"></span> Mod\xE9ration profiles </a><a class="list-group-item" ui-sref-active="active" ui-sref="moderation-company" style="padding-right: 13px"><span class="fa fa-thumbs-up fa-fw" name="user"></span> Mod\xE9ration company </a><a class="list-group-item" ui-sref-active="active" ui-sref="moderation-collectivity" style="padding-right: 13px"><span class="fa fa-thumbs-up fa-fw" name="user"></span> Mod\xE9ration collectivi. </a><a class="list-group-item" ui-sref-active="active" ui-sref="db-profile-management" style="padding-right: 13px"><span class="fa fa-users fa-fw" name="user"></span> DB Profiles </a><a class="list-group-item" ui-sref-active="active" ui-sref="profile-info-management"><span class="fa fa-clipboard-user fa-fw" name="clipboard-user"></span> R\xE9f\xE9rentiels </a><a class="list-group-item" ui-sref-active="active" ui-sref="audits"><span class="fa fa-eye fa-fw" name="eye"></span> Audits </a><a class="list-group-item" ui-sref-active="active" ui-sref="jhi-configuration"><span class="fa fa-cogs fa-fw" name="cogs"></span> Configuration </a><a class="list-group-item" ui-sref-active="active" ui-sref="docs"><span class="fa fa-book fa-fw" name="book"></span> Docs </a><a class="list-group-item" ui-sref-active="active" ui-sref="jhi-health"><span class="fa fa-heartbeat fa-fw" name="heartbeat"></span> Health </a><a class="list-group-item" ui-sref-active="active" ui-sref="logs"><span class="fa fa-file-alt fa-fw" name="file-alt"></span> Logs </a><a class="list-group-item" ui-sref-active="active" ui-sref="jhi-metrics"><span class="fa fa-chart-area fa-fw" name="chart-area"></span> Metrics </a><a class="list-group-item" ui-sref-active="active" ui-sref="quickconnect"><span class="fas fa-building fa-fw" name="building"></span> Quick Connect</a></div></nav></div><div class="col-xs-12 col-md-10" ui-view="content"><!-- Angular views --></div></div></div>');
$templateCache.put('app/director/director.html','<div class="container padding15"><div class="row"><div class="col-xs-12 col-md-2" style="padding-right: 0"><div has-any-authority="ROLE_DIVISION_ADMIN"><select-division-addon></select-division-addon><br></div></div><div class="col-xs-12 col-md-10" ui-view="content"><!-- Angular views --></div></div></div>');
$templateCache.put('app/dashboard/dashboard.html','<div class="container padding15" style="width: 100% !important"><div class="row" style="margin: 0"><iframe ng-src="{{vm.iframeUrl}}" height="3700" width="100%" style="border: 0"></iframe></div></div>');
$templateCache.put('app/discover/discover.html','<div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body-discover col-xs-12"><div class="discover-buttons btn-group"><a ui-sref="flow" ui-sref-active="active" class="btn btn-default discover-button discover-flow-button">Mode Discover </a><a ui-sref="mosaic" ui-sref-active="active" class="btn btn-default discover-button discover-mosaic-button">Mode Mosa\xEFque</a></div><div ui-view="content"></div></div><div class="right-addon-container-discover hidden-xs hidden-sm"><div class="right-addon-fixed"><div class="discover-filter-panel panel"><div class="panel-heading">Filtres</div><div class="panel-body"><div class="filter-section"><label for="department-filter">D\xE9partement :</label><select class="filter-select" id="department-filter"><option>-</option><option>Direction G\xE9n\xE9rale</option><option>Marketing</option><option>Produit</option><option>IT</option><option>Sales</option></select></div><div class="filter-section"><label for="sector-filter">Secteur d\'activit\xE9s :</label><select class="filter-select" id="sector-filter"><option>-</option><option>\xC9nergie</option><option>Environement</option><option>Finance</option><option>Luxe</option></select></div><button class="btn btn-primary">Appliquer</button></div></div><copyright-addon></copyright-addon></div></div></div></div>');
$templateCache.put('app/discover/flow.html','<div class="suggestion-card-flow-container"><div class="col-xs-2 col-md-4 suggestion-card-flow suggestion-card-container" ng-repeat="people in vm.suggestions track by $index" ng-class="vm.cardFlowClass($index, vm.flowIndex)"><div class="suggestion-card well"><div class="upper-container"><div class="square-picture" ng-show="people.pictureContentType" style="background-image: url(\'data: {{ people.pictureContentType }};base64,{{ people.picture }}\')"></div><div class="square-picture" ng-hide="people.pictureContentType" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="levels-container"><span class="level-image level-1" ng-click="vm.connectFlow(people, 1)" ng-class="people.grade === 1 ? \'clicked\' : \'\'"></span><br><span class="level-image level-2" ng-click="vm.connectFlow(people, 2)" ng-class="people.grade === 2 ? \'clicked\' : \'\'"></span><br><span class="level-image level-3" ng-click="vm.connectFlow(people, 3)" ng-class="people.grade === 3 ? \'clicked\' : \'\'"></span></div></div><div class="details-container"><h3><a ui-sref="profile({ id: people.id, position: \'\' })">{{ people.firstName + \' \' + people.lastName | characters:18 }}</a></h3><p ng-show="people.currentPosition.organisation.name"><img src="content/images/companies-transparent.png" width="25"> {{ people.currentPosition.organisation.name | characters:21 }}</p><p ng-hide="people.currentPosition.organisation.name"><img src="content/images/companies-transparent.png" width="25"> <i>Entreprise inconnue</i></p><p ng-show="people.currentPosition.title"><img src="content/images/job-transparent.png" width="25"> {{ people.currentPosition.title | characters:21 }}</p><p ng-hide="people.currentPosition.title"><img src="content/images/job-transparent.png" width="25"> <i>Poste inconnu</i></p></div></div></div><div class="suggestions-card-flow-indications"><p class="text-center"><span class="suggestions-card-flow-indication">T : Indice 1,</span> <span class="suggestions-card-flow-indication">F : Indice 2,</span> <span class="suggestions-card-flow-indication">J : Indice 3,</span> X : Retour</p></div></div>');
$templateCache.put('app/discover/mosaic.html','<div style="display:table" infinite-scroll="vm.loadMoreConnexions()" infinite-scroll-disabled="!vm.hasNextPageConnexion"><div class="col-xs-2 col-md-4 suggestion-card-container" ng-repeat="people in vm.suggestions"><div class="suggestion-card well"><div class="upper-container"><div class="square-picture" ng-show="people.pictureContentType" style="background-image: url(\'data: {{ people.pictureContentType }};base64,{{ people.picture }}\')"></div><div class="square-picture" ng-hide="people.pictureContentType" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="levels-container"><span class="level-image level-1" ng-click="vm.connectMosaic(people.id, 1)" ng-class="people.grade === 1 ? \'clicked\' : \'\'"></span><br><span class="level-image level-2" ng-click="vm.connectMosaic(people.id, 2)" ng-class="people.grade === 2 ? \'clicked\' : \'\'"></span><br><span class="level-image level-3" ng-click="vm.connectMosaic(people.id, 3)" ng-class="people.grade === 3 ? \'clicked\' : \'\'"></span></div></div><div class="details-container"><h3><a ui-sref="profile({ id: people.id, position: \'\' })">{{ people.firstName + \' \' + people.lastName | characters:18 }}</a></h3><p ng-show="people.currentPosition.organisation.name"><img src="content/images/companies-transparent.png" width="25"> {{ people.currentPosition.organisation.name | characters:20 }}</p><p ng-hide="people.currentPosition.organisation.name"><img src="content/images/companies-transparent.png" width="25"> <i>Entreprise inconnue</i></p><p ng-show="people.currentPosition.title"><img src="content/images/job-transparent.png" width="25"> {{ people.currentPosition.title | characters:20 }}</p><p ng-hide="people.currentPosition.title"><img src="content/images/job-transparent.png" width="25"> <i>Poste inconnu</i></p></div></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak ng-switch="vm.isAuthenticated()"><div class="home-page-wrapper" ng-switch-when="false"><!--\n        <ng-include src="\'app/home/presentation.html\'"></ng-include>\n        --></div><div class="index-page-wrapper" ng-switch-when="true"><div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body col-xs-12"><div cg-busy="{promise:homeBusyPromise,wrapperClass:\'\', templateUrl: \'cgbusy-big.html\',}" style="position:relative;width: 100%;height: 100%"></div><div ng-hide="vm.hide"><a ui-sref="quilist"><div id="quilist-header" class="well"><p class="no-margin">La Database <span class="quilist-arrow"><img src="content/images/arrow-right.png"></span></p></div></a><div class="row"><div id="left-panel-stats" class="col-xs-12 col-md-6"><div class="panel panel-default panel-stats"><div class="panel-heading">Le Site</div><table class="table table-striped"><tr><td>Entreprises</td><td class="progression"><span class="darker progression-bar" ng-style="{\'width\': vm.statsWebsite.companies.width + \'%\'}">{{ vm.statsWebsite.companies.count }}</span></td><td class="td-arrow"><img src="content/images/arrow-up.png" class="stat-arrow" width="25" ng-if="vm.statsWebsite.companies.rate > 0"> <img src="content/images/arrow-constant.png" class="stat-arrow" width="25" ng-if="vm.statsWebsite.companies.rate == 0"> <img src="content/images/arrow-down.png" class="stat-arrow" width="25" ng-if="vm.statsWebsite.companies.rate < 0"></td><td class="rate"><span ng-if="vm.statsWebsite.companies.rate > 0">+ </span>{{ vm.statsWebsite.companies.rate }} % ({{ vm.statsAccount.currentMonth}})</td></tr><tr><td>Collectivit\xE9s</td><td class="progression"><span class="dark progression-bar" ng-style="{\'width\': vm.statsWebsite.collectivities.width + \'%\'}">{{ vm.statsWebsite.collectivities.count }}</span></td><td class="td-arrow"><img src="content/images/arrow-up.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.collectivities.rate > 0"> <img src="content/images/arrow-constant.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.collectivities.rate == 0"> <img src="content/images/arrow-down.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.collectivities.rate < 0"></td><td class="rate"><span ng-if="vm.statsWebsite.collectivities.rate > 0">+ </span>{{ vm.statsWebsite.collectivities.rate }} % ({{ vm.statsAccount.currentMonth}})</td></tr><tr><td>Axenteever en France</td><td class="progression"><span class="regular progression-bar" ng-style="{\'width\': vm.statsWebsite.quilinkers.width + \'%\'}">{{ vm.statsWebsite.quilinkers.count }}</span></td><td class="td-arrow"><img src="content/images/arrow-up.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.quilinkers.rate > 0"> <img src="content/images/arrow-constant.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.quilinkers.rate == 0"> <img src="content/images/arrow-down.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.quilinkers.rate < 0"></td><td class="rate"><span ng-if="vm.statsWebsite.quilinkers.rate > 0">+ </span>{{ vm.statsWebsite.quilinkers.rate }} % ({{ vm.statsAccount.currentMonth}})</td></tr><tr><td>Contacts potentiels</td><td class="progression"><span class="light progression-bar" ng-style="{\'width\': vm.statsWebsite.quilinkees.width + \'%\'}">{{ vm.statsWebsite.quilinkees.count }}</span></td><td class="td-arrow"><img src="content/images/arrow-up.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.quilinkees.rate > 0"> <img src="content/images/arrow-constant.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.quilinkees.rate == 0"> <img src="content/images/arrow-down.png" class="stat-arrow" width="30" ng-if="vm.statsWebsite.quilinkees.rate < 0"></td><td class="rate"><span ng-if="vm.statsWebsite.quilinkees.rate > 0">+ </span>{{ vm.statsWebsite.quilinkees.rate }} % ({{ vm.statsAccount.currentMonth}})</td></tr></table></div></div><div id="right-panel-stats" class="col-xs-12 col-md-6"><div class="panel panel-default panel-stats"><div class="panel-heading">Mon Compte</div><table class="table table-striped"><!--\n                                    <tr>\n                                        <td>\n                                            Mon Classement\n                                        </td>\n                                        <td class="progression">\n                                            <span class="darker progression-bar"\n                                                  ng-style="{\'width\': vm.statsAccount.position.width + \'%\'}">\n                                                {{ vm.statsAccount.position.count }}\n                                                <sup ng-if="vm.statsAccount.position.count > 1">\n                                                    e\n                                                </sup>\n                                                <sup ng-if="vm.statsAccount.position.count === 1">\n                                                    er\n                                                </sup>\n                                            </span>\n                                        </td>\n                                        <td class="td-arrow">\n                                            <img src="content/images/arrow-up.png" class="stat-arrow"\n                                                 width="30" ng-if="vm.statsAccount.position.rate > 0">\n                                            <img src="content/images/arrow-constant.png" class="stat-arrow"\n                                                 width="30" ng-if="vm.statsAccount.position.rate == 0">\n                                            <img src="content/images/arrow-down.png" class="stat-arrow"\n                                                 width="30" ng-if="vm.statsAccount.position.rate < 0">\n                                        </td>\n                                        <td class="rate">\n                                            <span ng-if="vm.statsAccount.position.rate > 0">\n                                                +\n                                            </span>\n                                            {{ vm.statsAccount.position.rate }} % ({{ vm.statsAccount.currentMonth}})\n                                        </td>\n                                    </tr>\n                                    --><tr><td>Mon internal network</td><td class="progression"><span class="dark progression-bar" ng-style="{\'width\': vm.statsAccount.internal.width + \'%\'}">{{ vm.statsAccount.internal.count }}</span></td><td class="td-arrow"><img src="content/images/arrow-up.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.deals.rate > 0"> <img src="content/images/arrow-constant.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.deals.rate == 0"> <img src="content/images/arrow-down.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.deals.rate < 0"></td><td class="rate"><span ng-if="vm.statsAccount.deals.rate > 0">+ </span>{{ vm.statsAccount.deals.rate }} % ({{ vm.statsAccount.currentMonth}})</td></tr><tr><td>Faire une contribution</td><td class="progression"><span class="regular progression-bar" ng-style="{\'width\': vm.statsAccount.contributions.width + \'%\'}">{{ vm.statsAccount.contributions.count }}</span></td><td class="td-arrow"><img src="content/images/arrow-up.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.contributions.rate > 0"> <img src="content/images/arrow-constant.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.contributions.rate == 0"> <img src="content/images/arrow-down.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.contributions.rate < 0"></td><td class="rate"><span ng-if="vm.statsAccount.contributions.rate > 0">+ </span>{{ vm.statsAccount.contributions.rate }} % ({{ vm.statsAccount.currentMonth}})</td></tr><tr><td>Mon R\xE9seau</td><td class="progression"><span class="light progression-bar" ng-style="{\'width\': vm.statsAccount.networkWithGrade3.width + \'%\'}">{{ vm.statsAccount.network.count }} / {{ vm.statsAccount.networkWithGrade3.count }}</span></td><td class="td-arrow"><img src="content/images/arrow-up.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.network.rate > 0"> <img src="content/images/arrow-constant.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.network.rate == 0"> <img src="content/images/arrow-down.png" class="stat-arrow" width="30" ng-if="vm.statsAccount.network.rate < 0"></td><td class="rate"><span ng-if="vm.statsAccount.network.rate > 0">+ </span>{{ vm.statsAccount.network.rate }} % ({{ vm.statsAccount.currentMonth}})</td></tr><tr></tr></table></div></div></div><!--\n                    <ng-include src="\'app/home/news.html\'"></ng-include>\n                    --></div></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><suggestion-addon></suggestion-addon><discover-addon></discover-addon><rank-addon></rank-addon><credits-addon></credits-addon><copyright-addon></copyright-addon></div></div></div></div></div></div>');
$templateCache.put('app/home/news.html','<div id="news"><a href="#/#news" id="news-link" du-smooth-scroll du-scrollspy><div class="news-home-header well"><p class="news-title">News</p></div></a><a href="#/#top" id="home-link" du-smooth-scroll du-scrollspy><div class="news-home-header well"><p class="home-title">Home</p></div></a><div class="well news-header-well"><h4>Quelles informations recherchez-vous ? <span class="not-important">(Exemples : Renault, CAC 40, Finance, Modifications...)</span></h4><div class="input-group"><input type="text" ng-model="vm.newsfeedFocus" autocomplete="off" uib-typeahead="organization as organization.name for organization in vm.newsfeedSearch($viewValue)" typeahead-no-results="vm.searchNoResults" typeahead-on-select="vm.getNewsfeed(true)" typeahead-min-length="0" class="form-control typeahead-input"> <span class="input-group-btn"><button type="submit" class="btn btn-default"><i class="fas fa-search"></i></button></span></div><!-- D\xE9sactiv\xE9 jusqua impl\xE9mentation\n        <div class="filter-container row">\n\n            <div class="col-sm-3 filter-section">\n                <p class="filter-title">Cat\xE9gorie :</p>\n                <div class="checkbox-container">\n                    <div class="checkbox-item">\n                        <label for="checkbox-contribution">Contribution</label>\n                        <input id="checkbox-contribution" type="checkbox" ng-model="vm.filters.eventTypes.contribution">\n                    </div>\n                    <div class="checkbox-item">\n                        <label for="checkbox-modification">Modification</label>\n                        <input id="checkbox-modification" type="checkbox" ng-model="vm.filters.eventTypes.modification">\n                    </div>\n                    <div class="checkbox-item">\n                        <label for="checkbox-add">Ajout</label>\n                        <input id="checkbox-add" type="checkbox" ng-model="vm.filters.eventTypes.add">\n                    </div>\n                </div>\n            </div>\n            <div class="col-sm-3 filter-section">\n                <p class="filter-title">Type :</p>\n                <div class="checkbox-container">\n                    <div class="checkbox-item">\n                        <label for="checkbox-people">Personnes</label>\n                        <input id="checkbox-people" type="checkbox" ng-model="vm.filters.types.profile">\n                    </div>\n                    <div class="checkbox-item">\n                        <label for="checkbox-company">Entreprises</label>\n                        <input id="checkbox-company" type="checkbox" ng-model="vm.filters.types.company">\n                    </div>\n                    <div class="checkbox-item">\n                        <label for="checkbox-collectivity">Administrations</label>\n                        <input id="checkbox-collectivity" type="checkbox" ng-model="vm.filters.types.collectivity">\n                    </div>\n                </div>\n\n            </div>\n            <div class="col-sm-3 filter-section">\n                <p class="filter-title">Taille :</p>\n                <div class="checkbox-container">\n                    <select name="company-status" id="company-status-select" class="form-control"\n                            ng-model="vm.filters.companyStatusId">\n                        <option ng-repeat="option in vm.companyStatuses" value="{{option.id}}">{{option.name}}</option>\n                    </select>\n                </div>\n            </div>\n            <div class="col-sm-3 filter-section">\n                <p class="filter-title">Secteur :</p>\n                <div class="checkbox-container">\n                    <select name="sector" id="sector-select" class="form-control"\n                            ng-model="vm.filters.sectorId">\n                        <option ng-repeat="option in vm.sectors" value="{{option.id}}">{{option.name}}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n        <div class="apply-filters">\n            <a href ng-click="vm.getNewsfeed(true)">Appliquer</a>\n        </div>\n        --></div><div class="newsfeed"><p class="nothing-to-show" ng-hide="vm.news.length">Aucune contribution \xE0 afficher</p><div class="news-infinite-scoll" infinite-scroll-immediate-check="true" infinite-scroll="vm.loadMoreNewsfeed()" infinite-scroll-disabled="!vm.hasNextPageNews"><div class="news-container" ng-repeat="event in vm.news"><div class="picture-container"><img ng-src="{{ event.picture }}"></div><div class="content-container well"><i class="fa fa-bell"></i><p class="news-event"><a ng-show="event.type === \'profile\'" ui-sref="profile({id: event.itemId, position: \'\' })">{{ event.name }}</a> <a ng-show="event.type === \'company\'" ui-sref="company-detail({id: event.itemId})">{{ event.name }}</a> <a ng-show="event.type === \'collectivity\'" ui-sref="collectivity-detail({id: event.itemId})">{{ event.name }}</a> {{ event.message }}</p><p class="news-content" ng-show="event.type === \'profile\'"><span ng-show="event.title"><i class="fal fa-briefcase"></i> {{ event.title }}</span> <span ng-show="event.previousTitle"><i>(Auparavant {{ event.previousTitle }})</i></span> <span ng-show="event.title"><br></span><i class="fal fa-building"></i> <a ui-sref="company-detail({id: event.organisationId})">{{ event.organisation }}</a> <span ng-show="event.previousOrganisation"><i>(Auparavant <a ui-sref="company-detail({id: event.previousOrganisationId})">{{ event.previousOrganisation }}</a>)</i></span></p><p class="news-content" ng-show="event.type === \'company\'">{{ event.member }}</p><p class="news-content" ng-show="event.type === \'collectivity\'">{{ event.member }}</p><p class="news-date float-right"><span am-time-ago="event.date"></span></p></div></div></div></div></div>');
$templateCache.put('app/home/presentation.html','<!-- Section 1 : Head --><div id="home-section-1" class="bg1 screen-height"><img src="content/images/axenteev-white.svg" alt="Axenteev logo" id="home-logo"><h2 id="home-punchline">Connecting Business</h2><p><a href="/#/#about" du-smooth-scroll><img class="down-icon" src="content/images/arrow-home.png"></a></p></div><!-- End section 1 : --><!-- Section 2 : About --><div id="about"><div uib-carousel interval="7000" active="vm.aboutSlideActive"><div uib-slide index="0"><div id="about1" class="row screen-height"><div class="col-xs-12 col-md-offset-1 col-md-5"><img class="about-stats" src="content/images/graph.svg"></div><div class="col-xs-12 col-md-5"><div class="about-text"><h1>Avec Axenteev,</h1><h2>Boostez votre r\xE9seau\xA0!</h2><h3>et transformez la rencontre digitale en contrat commercial.</h3><div class="content"><h4>1er Business Network rassemblant tous les d\xE9cideurs priv\xE9s et publics nationaux</h4><ul><li>Une base de donn\xE9es mise \xE0 jour en temps r\xE9el,</li><li>Un listing entreprises et collectivit\xE9s,</li><li>Un site pour mieux cartographier vos interlocuteurs.</li></ul><h4>La garantie d\u2019une mise en relation facilit\xE9e</h4><ul><li>Une identification simplifi\xE9e de votre r\xE9seau interne compl\xE9t\xE9e par des experts \xE0 vos c\xF4t\xE9s,</li><li>Une passerelle digitale unique pour rencontrer les d\xE9cideurs cl\xE9s de vos clients et prospects.</li></ul></div></div></div></div></div><div uib-slide index="1"><div id="about2" class="row screen-height"><div class="col-xs-12 col-md-offset-1 col-md-5"><img class="about-stats" src="content/images/about2.png"></div><div class="col-xs-12 col-md-5"><div class="about-text synergy"><h1>Synergie & Efficience renforc\xE9es</h1><h2>avec l\u2019 \xAB\xA0internal Network\xA0\xBB et nos experts.</h2><div class="content"><h4>Un nouvel outil commercial pour les entreprises en mode digital</h4><ul><li>Mise en commun des contacts des commerciaux de l\u2019entreprise pour \xE9tablir une cartographie du r\xE9seau interne et cr\xE9er une synergie relationnelle,</li><li>Chaque salari\xE9 participe ainsi au d\xE9veloppement commercial et en est r\xE9compens\xE9,</li><li>Un r\xE9seau interne accessible uniquement en acc\xE8s priv\xE9 par la direction commerciale.</li></ul><h4>Des experts Axenteev \xE0 vos c\xF4t\xE9s au service de votre business d\xE9veloppement</h4><ul><li>Des professionnels s\xE9lectionn\xE9s et not\xE9s pour d\xE9velopper votre r\xE9seau et augmenter votre taux de r\xE9ussite commerciale,</li><li>Un accompagnement personnalis\xE9 en amont des appels d\u2019offre jusqu\u2019\xE0 la signature des contrats.</li></ul></div></div></div></div></div></div><div id="about3" class="screen-height"><div class="shadow-container"><div class="shadow"></div><h1>Axenteev ou le \xAB\xA0networking\xA0\xBB intelligent</h1><div class="row first-row"><div class="col-md-6 step"><img src="content/images/about-step1.png"><div class="step-text"><h2>Cr\xE9ez la cartographie relationnelle de votre Entreprise</h2><p>Axenteev vous permet de mod\xE9liser votre \xAB\xA0Internal Network\xA0\xBB rapidement et simplement gr\xE2ce \xE0 un algorithme puissant de recherches et de suggestions.</p></div></div><div class="col-md-6 step"><img src="content/images/about-step2.png"><div class="step-text"><h2>Identifiez vos interlocuteurs cl\xE9s</h2><p>Selon les crit\xE8res que vous avez renseign\xE9s, Axenteev trouve les interlocuteurs \xE0 approcher gr\xE2ce \xE0 sa base de donn\xE9es et un moteur de recherche performant.</p></div></div></div><div class="row"><div class="col-md-6 step"><img src="content/images/about-step3.png"><div class="step-text"><h2>Trouvez des relais</h2><p>Axenteev fait ressortir vos relais internes pour approcher les d\xE9cideurs. Cela vous permet de mettre \xE0 profit les relations de vos collaborateurs pour entrer en contact avec vos clients et prospects.</p></div></div><div class="col-md-6 step"><img src="content/images/about-step4.png"><div class="step-text"><h2>Rencontrez les d\xE9cideurs de votre domaine d\u2019activit\xE9</h2><p>Si vous n\u2019avez pas de relais interne, Axenteev vous permet gr\xE2ce \xE0 nos experts de rencontrer les d\xE9cideurs via un acc\xE8s privil\xE9gi\xE9 et exclusif. Un gain de temps et des d\xE9marches commerciales optimis\xE9es.</p></div></div></div></div></div></div><!-- End Section 2 --><!-- Section 3 : Concept --><div id="concept"><div uib-carousel interval="7000" active="vm.conceptSlideActive"><div uib-slide index="0"><div id="concept-slide1" class="row screen-height"><div class="col-xs-12 col-md-7 column"><img ng-src="content/images/mock1.png"></div><div class="col-xs-offset-1 col-xs-10 col-md-offset-0 col-md-5 column"><h1>Devenez un Axenteever</h1><h2>et gagnez des r\xE9compenses\xA0!</h2><p>Profitez de ce nouvel <b>outil de networking interne et externe</b> gr\xE2ce \xE0 une interface intuitive et dynamique.</p><p><b>Renseignez et hi\xE9rarchisez rapidement et simplement votre r\xE9seau</b> dans notre base de donn\xE9es.</p><p>Chaque contribution vous permet de <b>capitaliser des points et transformez les en r\xE9compenses</b> \xE0 chacune de vos contributions (ch\xE8ques cadeaux, voyages, etc)</p></div></div></div><div uib-slide index="1"><div id="concept-slide2" class="row screen-height"><div class="col-xs-12 col-md-7 column"><img ng-src="content/images/mock2.png"></div><div class="col-xs-offset-1 col-xs-10 col-md-offset-0 col-md-5 column"><h1>Restez inform\xE9s ...<br>... et personnalisez votre veille</h1><p><b>Axenteev vous permet d\u2019acc\xE9der simplement \xE0 toutes les derni\xE8res actualit\xE9s de vos clients et prospects.</b></p><p>Un service sur mesure et exclusif pour chaque utilisateur gr\xE2ce \xE0 une veille quotidienne personnalis\xE9e et efficace</p></div></div></div><div uib-slide index="2"><div id="concept-slide3" class="row screen-height"><div class="col-xs-offset-1 col-xs-10 col-md-offset-1 col-md-5 column"><img ng-src="content/images/mock3.png"></div><div class="col-xs-offset-1 col-xs-10 col-md-offset-0 col-md-5 column"><h1>Un service qui vous accompagne partout !</h1><p><b>Renseignez rapidement et hi\xE9rarchisez simplement votre r\xE9seau</b> sur notre application mobile.</p><p>Une application intuitive, qui <b>vous fait gagner du temps.</b> Avec l\u2019application extension, renseignez les personnes que vous connaissez en un click/geste.</p><p><b>20 minutes de train, c\u2019est 800 swipes.</b></p></div></div></div></div></div><!-- End section 3 --><!-- Section 4 : Stories --><div id="stories" class="bg2"><div uib-carousel interval="6000" active="vm.storiesSlideActive"><div uib-slide index="0"><div class="row screen-height"><div class="column col-xs-12 col-md-5 col-md-push-5 col-md-offset-2"><img ng-src="content/images/cyril.png" class="author-picture"></div><div class="column col-xs-12 col-md-5 col-md-pull-5"><h1 class="quote">\u201CGagner du temps en identifiant imm\xE9diatement les d\xE9cideurs chez les prospects et pouvoir les contacter en un click grace \xE0 l\'application est un avantage cl\xE9 pour ma direction commerciale"</h1><p class="author">Cyril, secteur public, Paris</p></div></div></div><div uib-slide index="1"><div class="row screen-height"><div class="column col-xs-12 col-md-5 col-md-push-5 col-md-offset-2"><img ng-src="content/images/laurent.png" class="author-picture"></div><div class="column col-xs-12 col-md-5 col-md-pull-5"><h1 class="quote">\u201CGr\xE2ce \xE0 cette application, cartographier et connecter en amont les d\xE9cideurs cl\xE9s chez nos prospects a fait grimper notre taux de r\xE9ussite !"</h1><p class="author">Laurent, Co-fondateur, Paris</p></div></div></div><div uib-slide index="2"><div class="row screen-height"><div class="column col-xs-12 col-md-5 col-md-push-5 col-md-offset-2"><img ng-src="content/images/arnaud.png" class="author-picture"></div><div class="column col-xs-12 col-md-5 col-md-pull-5"><h1 class="quote">\u201CAxenteev a boulevers\xE9 et dynamit\xE9 notre approche commerciale. Nous ne pouvons plus nous en passer !\u201C</h1><p class="author">Arnaud, Directeur commercial, Paris</p></div></div></div><div uib-slide index="3"><div class="row screen-height"><div class="column col-xs-12 col-md-5 col-md-push-5 col-md-offset-2"><img ng-src="content/images/gilles.png" class="author-picture"></div><div class="column col-xs-12 col-md-5 col-md-pull-5"><h1 class="quote">\u201CNous avions toujours de vraies difficult\xE9s \xE0 identifier les d\xE9cideurs chez nos clients grands comptes. Gr\xE2ce \xE0 Axenteev, nous gagnons du temps et rencontrons plus facilement les bons contacts !\u201C</h1><p class="author">Gilles, Pr\xE9sident, Paris</p></div></div></div></div></div><!-- End section 4 --><!-- Section 5 : Contact --><div id="contact"><div class="container-fluid"><div class="contact-head"><h1><i>Contact</i></h1></div><div class="contact-body"><div class="row"><div class="col-xs-12 col-md-6 form-container"><div class="alert alert-success" ng-show="vm.contactMessageSent"><strong>Message envoy\xE9 !</strong></div><div class="alert alert-danger" ng-show="vm.contactMessageError"><strong>Probl\xE8me d\'envoi du message !</strong> Merci d\'envoyer un message \xE0 contact@axenteev.com.</div><form class="contact-form form" role="form" ng-submit="vm.sendContactEmail()"><div class="row"><div class="col-sm-6"><div class="form-group"><input type="text" class="form-control" id="contact-surname" placeholder="Nom" ng-model="vm.contactEmail.lastName"></div></div><div class="col-sm-6"><div class="form-group"><input type="text" class="form-control" id="contact-firstname" placeholder="Pr\xE9nom" ng-model="vm.contactEmail.firstName"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><input type="text" class="form-control" id="contact-company" placeholder="Entreprise" ng-model="vm.contactEmail.company"></div></div><div class="col-sm-6"><div class="form-group"><input type="text" class="form-control" id="contact-position" placeholder="Poste" ng-model="vm.contactEmail.position"></div></div></div><div class="form-group no-margin"><input type="text" class="form-control" id="email" placeholder="Votre email" ng-model="vm.contactEmail.mail"></div><div class="form-group no-margin"><input type="text" class="form-control" id="subject" placeholder="Objet" ng-model="vm.contactEmail.subject"></div><div class="form-group"><textarea class="form-control" id="contact-message" placeholder="Votre message" ng-model="vm.contactEmail.message"></textarea></div><button type="submit" class="btn btn-primary float-right">Envoyer</button></form></div><div class="col-xs-12 col-md-6 circles-container"><div class="container-fluid"><div class="row"><div class="col-xs-offset-2 col-xs-3 text-center"><a href="mailto:contact@axenteev.com"><span class="contact-circles"><i class="fas fa-enveloppe fa-fw"></i></span></a></div><div class="col-xs-3 text-center"><a href="https://www.linkedin.com/company/axenteev/"><span class="contact-circles"><i class="fas fa-linkedin fa-fw"></i></span></a></div><div class="col-xs-3 text-center"><a href="http://www.twitter.com"><span class="contact-circles"><i class="fas fa-twitter fa-fw"></i></span></a></div></div></div></div></div></div></div></div><!-- End section 5 -->');
$templateCache.put('app/inbox/inbox-close-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.discussion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir cloturer cette discussion ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Cloturer</span></button></div></form>');
$templateCache.put('app/inbox/inbox-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Nouveau message</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_to">\xC0</label><select class="form-control" name="to" id="field_to" ng-model="vm.to" required><option value="sale" has-authority="ROLE_COMMERCIAL">Autre commercial</option><option value="sale" has-authority="ROLE_DG">Commercial</option><option value="sale" has-authority="ROLE_ADMIN">Utilisateur</option><option value="director" has-authority="ROLE_COMMERCIAL">Mon directeur</option><option value="admin" has-authority="ROLE_COMMERCIAL">Axenteev</option><option value="admin" has-authority="ROLE_DG">Axenteev</option></select><div ng-show="editForm.to.$invalid"><p class="help-block" ng-show="editForm.to.$error.required">Ce champ est requis.</p></div><br ng-show="vm.to === \'sale\'"><select class="form-control" name="to2" id="field_to_sale" ng-show="vm.to === \'sale\'" ng-model="vm.sale" ng-options="sale as sale.firstName + \' \' + sale.lastName for sale in vm.sales" required></select></div><div class="form-group"><label class="control-label" for="field_title">Objet</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.discussion.title" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div><div class="form-group"><label class="control-label" for="field_message">Message</label><textarea class="form-control" name="message" id="field_message" ng-model="vm.discussion.message.content" placeholder="Votre message..." required>\n            </textarea><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Valider</span></button></div></form>');
$templateCache.put('app/inbox/inbox.html','<div class="super-loop-wrapper"><div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body col-xs-12"><div class="well inbox-container"><div class="list-container"><div class="list-wrapper"><div class="list-header"><button class="btn btn-primary" ui-sref="inbox.new"><span class="btn-message-container"><span class="fa fa-envelope"></span> </span><span class="btn-text-container">Nouveau<br>Message</span></button></div><div class="list-search"><input type="text" placeholder="Rechercher..."></div><div class="list-messages-wrapper"><select ng-model="vm.closed" ng-options="o.v as o.n for o in [{ n: \'Discussions clotur\xE9es\', v: true }, { n: \'Discussions en cours\', v: false }]" has-authority="ROLE_DG"></select><select ng-model="vm.closed" ng-options="o.v as o.n for o in [{ n: \'Discussions clotur\xE9es\', v: true }, { n: \'Discussions en cours\', v: false }]" has-authority="ROLE_ADMIN"></select><div class="list-messages"><div ng-repeat="discussion in vm.discussions  | filter:{closed: vm.closed} | orderBy:\'-createdAt\' : false"><a ui-sref="inbox({discussionId: discussion.id})" ui-sref-active="active"><div class="list-message"><div class="img" ng-hide="discussion.contact.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="img" ng-show="discussion.contact.picture" ng-style="{\'background-image\': \'url(\\\'data:png;base64,\' + discussion.contact.picture }"></div><div class="list-message-informations"><p class="list-message-contact">{{ discussion.contact.firstName + \' \' + discussion.contact.lastName }}</p><p class="list-message-name">{{ discussion.title | characters:18:true }}</p></div></div></a></div><p class="no-message" ng-show="vm.discussions.length === 0">Aucune conversation \xE0 afficher.</p></div></div></div></div><div class="discussion-container"><div class="discussion-container-top" id="message-container" ng-show="vm.currentDiscussion.messages && vm.scrollToBottom()"><div id="message-wrapper"><div class="message" ng-repeat="message in vm.currentDiscussion.messages | orderBy:\'-createdAt\' : true"><div class="message-header"><div class="contact-picture" ng-hide="message.sentBy.picture" style="background-image: url(\'../../content/images/no-picture.png\')"></div><div class="contact-picture" ng-show="message.sentBy.picture" ng-style="{\'background-image\': \'url(\\\'\' + message.sentBy.picture + \'\\\')\' }"></div><h3 class="contact-name">{{ message.sentBy.firstName + \' \' + message.sentBy.lastName }}</h3></div><div class="message-body" ng-bind-html="vm.trustAsHtml(message.content)"></div></div></div></div><div class="discussion-container-top" ng-hide="vm.currentDiscussion.id"><p class="discussion-help">S\xE9lectionnez une discussion dans la liste ci-contre.</p></div><div class="discussion-container-top" ng-show="vm.currentDiscussion.id &&\n                                                                       !vm.currentDiscussion.messages.length"><p class="discussion-help">Pas de messages \xE0 afficher.</p></div><div class="discussion-input-container"><textarea ng-model="vm.newMessage.content" placeholder="R\xE9pondre..."></textarea><div class="submit-container"><button ng-click="vm.sendNewMessage()" class="btn btn-primary">Envoyer</button></div></div></div></div></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><suggestion-addon></suggestion-addon><discover-addon></discover-addon><rank-addon></rank-addon><credits-addon></credits-addon><copyright-addon></copyright-addon></div></div></div></div></div>');
$templateCache.put('app/network/network.html','<div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body col-xs-12"><div style="margin-left: 15px; margin-right: 15px"><div ng-hide="vm.hide"><div class="network-tabs row"><a ui-sref="my-connections" ui-sref-active="active"><div class="network-tab col-xs-4"><h3>Mon r\xE9seau</h3><p class="count">{{ vm.networkCount }} / {{ vm.networkCountWithGrade3 }}</p></div></a><a ui-sref="contributions-menu" ui-sref-active="active"><div class="network-tab col-xs-3"><h3>\xC0 qualifier</h3><p class="count">{{ vm.aConnecterCount}}</p></div></a><a ui-sref="contributions-pending-profile" ui-sref-active="active"><div class="network-tab col-xs-3"><h3>\xC0 valider</h3><p class="count">{{ vm.myPendingContributionsCount}}</p></div></a><a ui-sref="homonyms-pending-profile" ui-sref-active="active"><div class="network-tab col-xs-2"><h3>Homonymes</h3><p class="count">{{ vm.myPendingHomonymsCount}}</p></div></a><!--\n                        <a ui-sref="internal-network" has-any-authority="ROLE_ADMIN, ROLE_DG" ui-sref-active="active">\n                            <div class="network-tab col-xs-3">\n                                <h3>\n                                    Mon Internal\n                                </h3>\n                                <p class="count">\n                                    {{ vm.invitedSales.length +\n                                    vm.registeredSales.length +\n                                    vm.archivedSales.length }}\n                                </p>\n                            </div>\n                        </a>\n                        --></div></div><div ui-view="content"><!-- Angular views --></div></div></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><suggestion-addon></suggestion-addon><discover-addon></discover-addon><rank-addon></rank-addon><credits-addon></credits-addon><copyright-addon></copyright-addon></div></div></div></div>');
$templateCache.put('app/quilist/quilist.html','<div class="quilist-wrapper"><div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body col-xs-12"><div class="row"><div class="text-center" id="companies-section" ng-class="vm.companiesActive ? \'active\': \'\'" ng-click="vm.choose(\'companies\')"><div class="header-container"><span style="display: inline-block;font-size: 2.5em;border: 2px solid #fff;border-radius: 50%;width: 50px;height: 50px;padding-top: 3px"><i class="fal fa-building fa-stack-1x" style="color:white"></i></span><h3 class="white">Entreprises</h3></div><div class="item-list-container row"><div class="search-top input-group"><input type="text" ng-model="vm.searchTextCompanies" ng-change="vm.searchCompanies()" class="form-control" ng-model-options="{ debounce: 300 }" placeholder="Ex : AXA, Bouygues..."></div><div class="item-list" id="company-container"><div class="item-wrapper" infinite-scroll="vm.loadMoreCompanies()" infinite-scroll-parent infinite-scroll-disabled="!vm.hasNextPageCompanies"><div class="item" ng-repeat="company in vm.companies track by company.id"><div class="item item-divider" ng-if="vm.firstLetter(company.name) != vm.firstLetter(vm.companies[$index-1].name)">{{ vm.firstLetter(company.name) }}</div><i ng-if="company.importId === \'linked\'" class="fab fa-fw fa-linkedin" title="Source : Base cliente Linkedin" style="margin-right: 4px"></i> <i ng-if="company.importId && company.importId !== \'linked\'" class="fal fa-fw fa-file-check" title="Source : The Official Board" style="margin-right: 4px"></i> <a ui-sref="company-detail({id: company.id})">{{ company.name }}</a></div><div ng-hide="vm.companies.length" class="no-items"><div><p class="text-center"><i>Il n\'y a rien aucune entreprise correspondante</i></p></div></div></div></div></div></div><div class="text-center" id="collectivities-section" ng-class="vm.collectivitiesActive ? \'active\': \'\'" ng-click="vm.choose(\'collectivities\')"><div class="header-container"><span style="display: inline-block;font-size: 2.5em;border: 2px solid #fff;border-radius: 50%;width: 50px;height: 50px;padding-top: 3px"><i class="fal fa-university fa-stack-1x" style="color:white"></i></span><h3 class="white">Collectivit\xE9s</h3></div><div class="item-list-container row"><div class="search-top input-group"><input type="text" class="form-control" ng-model="vm.searchTextCollectivities" ng-change="vm.searchCollectivities()" ng-model-options="{ debounce: 300 }" id="collectivities-search" placeholder="Ex : Paris, Lyon..."></div><div class="item-list" id="collectivity-container"><div class="item-wrapper" infinite-scroll="vm.loadMoreCollectivities()" infinite-scroll-parent infinite-scroll-disabled="!vm.hasNextPageCollectivities"><div class="item" ng-repeat="collectivity in vm.collectivities track by collectivity.id"><div class="item-divider" ng-if="vm.firstLetter(collectivity.name) != vm.firstLetter(vm.collectivities[$index-1].name)">{{ vm.firstLetter(collectivity.name) }}</div><i ng-if="collectivity.importId === \'linked\'" class="fab fa-fw fa-linkedin" title="Source : Base cliente Linkedin" style="margin-right: 4px"></i> <i ng-if="collectivity.importId === \'guidep\'" class="fal fa-fw fa-file-user" title="Source : Guide du pouvoir" style="margin-right: 4px"></i> <i ng-if="collectivity.importId === \'datago\'" class="fal fa-book-open" title="Source : data.gouf.fr" style="margin-right: 4px"></i> <i ng-if="collectivity.importId && collectivity.importId !== \'linked\' && collectivity.importId !== \'guidep\' && collectivity.importId !== \'datago\'" class="fal fa-fw fa-scroll-old" title="Source : Legacy" style="margin-right: 4px"></i> <a ui-sref="collectivity-detail({id: collectivity.id})">{{ collectivity.name }}</a></div><div ng-hide="vm.collectivities.length" class="no-items"><p class="text-center"><i>Il n\'y a aucune collectivit\xE9 correspondante</i></p></div></div></div></div></div></div></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><suggestion-addon></suggestion-addon><discover-addon></discover-addon><rank-addon></rank-addon><credits-addon></credits-addon><copyright-addon></copyright-addon></div></div></div></div></div>');
$templateCache.put('app/super-loop/super-loop.html','<div class="super-loop-wrapper"><div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body col-xs-12"><div class="well super-loop-header-well"><div class="super-loop-header-top"><h4>SuperLoop</h4><div class="input-group"><input type="text" ng-model="vm.keyword" ng-change="vm.search(true)" placeholder="Recherche par Mots-cl\xE9s" class="form-control"> <span class="input-group-btn"><button type="submit" class="btn btn-default" ng-click="vm.search(true)"><i class="fas fa-search"></i></button></span></div></div><div class="filter-container row"><div class="col-xs-12 filter-section"><label>Affiner</label><button ng-click="vm.mode = null; vm.search();" ng-class="vm.mode === null ? \'active\' : \'\'" class="btn btn-primary super-loop-filter-btn">Meilleurs r\xE9sultats</button> <button ng-click="vm.mode = \'company\'; vm.search();" ng-class="vm.mode === \'company\' ? \'active\' : \'\'" class="btn btn-primary super-loop-filter-btn">Entreprises</button> <button ng-click="vm.mode = \'collectivity\'; vm.search();" ng-class="vm.mode === \'collectivity\' ? \'active\' : \'\'" class="btn btn-primary super-loop-filter-btn">Collectivit\xE9s</button> <button ng-click="vm.mode = \'profile\'; vm.results = []; vm.search();" ng-class="vm.mode === \'profile\' ? \'active\' : \'\'" class="btn btn-primary super-loop-filter-btn">Profils</button></div><div class="col-xs-6 filter-section filter-section-left" ng-show="vm.mode === \'company\'"><div><label>Type entreprise :</label><select name="company-status" class="form-control" ng-model="vm.companyStatus" ng-change="vm.search()"><option value="">-</option><option ng-repeat="option in vm.companyStatuses" value="{{option.id}}">{{option.name}}</option></select></div></div><div class="col-xs-6 filter-section filter-section-right" ng-show="vm.mode === \'company\'"><div><label>Secteur entreprise :</label><select name="company-status" class="form-control" ng-model="vm.sector" ng-change="vm.search()"><option value="">-</option><option ng-repeat="option in vm.sectors" value="{{option.id}}">{{option.name}}</option></select></div></div><div class="col-xs-6 filter-section filter-section-left" ng-show="vm.mode === \'collectivity\'"><div><label>Taille collectivit\xE9 :</label><select name="company-status" class="form-control" ng-model="vm.collectivitySize" ng-change="vm.search()"><option value="">-</option><option ng-repeat="option in vm.collectivitySizes" value="{{option.id}}">{{option.name}}</option></select></div></div><div class="col-xs-12 text-center filter-section-apply"><a href ng-click="vm.search()">Appliquer</a></div></div></div><p ng-show="vm.results">R\xE9sultats de votre recherche</p><div class="super-loop-usage" ng-show="vm.results === null"><strong>Bien utiliser la Super Loop :</strong><br><br><p>Super Loop est un outil puissant qui vous permet de rechercher rapidement notre base de donn\xE9es. Pour une recherche efficace :</p><ul><li><strong>Utiliser des mots cl\xE9s :</strong> Commercial, Suez, BTP, France...</li><li><strong>Affiner votre recherche :</strong> Recherche limit\xE9e \xE0 30 noms pour + d\'efficacit\xE9, soyez pr\xE9cis</li><li><strong>Utiliser les filtres existants :</strong> Pour structurer votre recherche</li></ul></div><p class="search-no-results text-center" ng-show="vm.mode === null && vm.results.length === 0">Aucun r\xE9sultat ne correspond \xE0 vos crit\xE8res...</p><p class="search-no-results text-center" ng-show="vm.mode === \'company\' && vm.results.length === 0">Aucune entreprise ne correspond \xE0 vos crit\xE8res...</p><p class="search-no-results text-center" ng-show="vm.mode === \'collectivity\' && vm.results.length === 0">Aucune collectivit\xE9 ne correspond \xE0 vos crit\xE8res...</p><p class="search-no-results text-center" ng-show="vm.mode === \'profile\' && vm.results.length === 0">Aucun profil ne correspond \xE0 vos crit\xE8res...</p><div class="search-container" ng-show="vm.results.length"><div ng-repeat="result in vm.results track by $index"><a class="organization-link" ui-sref="company-detail({id: result.id})" ng-show="result.searchType === \'company\'"><div class="well"><div class="square-picture" ng-hide="result.logoContentType" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="square-picture" ng-show="result.logoContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + result.logoContentType + \';base64,\' + result.logo }"></div><div class="text-container"><span class="name">{{ result.name }}</span><br><span class="subtitle">{{ result.sector.name }}</span></div></div></a><a class="organization-link" ui-sref="collectivity-detail({id: result.id})" ng-show="result.searchType === \'collectivity\'"><div class="well"><div class="square-picture" ng-hide="result.logoContentType" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="square-picture" ng-show="result.logoContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + result.logoContentType + \';base64,\' + result.logo }"></div><div class="text-container"><span class="name">{{ result.name }}</span><br><span class="subtitle">{{ result.sector.name }}</span></div></div></a><a class="organization-link" ui-sref="profile({id: result.id, position: \'\' })" ng-show="result.searchType === \'profile\'"><div class="well"><div class="square-picture" ng-hide="result.logoContentType" style="background-image: url(\'../../content/images/no-picture.png\')"></div><div class="square-picture" ng-show="result.logoContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + result.logoContentType + \';base64,\' + result.logo }"></div><div class="text-container"><span class="name">{{ result.firstName }} {{ result.lastName }}</span><br><span class="subtitle">{{ result.currentPosition.organisation.name }}</span></div></div></a></div></div></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><suggestion-addon></suggestion-addon><discover-addon></discover-addon><rank-addon></rank-addon><credits-addon></credits-addon><copyright-addon></copyright-addon></div></div></div></div></div>');
$templateCache.put('app/whoswho/whoswho.html','<div class="container padding15" style="width: 100% !important"><div class="row" style="margin: 0"><div class="col-xs-12 col-md-12" ui-view="content"><!-- Angular views --></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Votre compte a \xE9t\xE9 activ\xE9.</strong> Vous pouvez d\xE9sormais vous <a class="alert-link" href="" ng-click="vm.login()">connecter</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Votre compte n\'a pas pu \xEAtre activ\xE9.</strong></div></div></div></div>');
$templateCache.put('app/account/check/check.html','<div class="row" style="padding:40px"><div class="col-md-8 col-md-offset-2"><h1>V\xE9rifier ma pr\xE9sence sur Axenteev</h1><div class="alert alert-danger" ng-show="vm.errorMessage">{{vm.errorMessage}}</div><div class="alert alert-success" ng-show="vm.found"><p>Ce nom/pr\xE9nom est pr\xE9sent dans la base Axenteev.</p><p>Pour ne plus faire parti d\u2019Axenteev.com, nous vous invitons \xE0 nous en faire la demande en cliquant sur le bouton "Demander la suppression"</p></div><div class="alert alert-warning" ng-show="vm.notFound"><p>Ce nom/pr\xE9nom n\'est pas pr\xE9sent dans la base Axenteev.</p></div><div class="alert alert-success" ng-show="vm.deleteRequested"><p>Votre demande de suppression a bien \xE9t\xE9 prise en compte.</p></div><form name="form" role="form" novalidate ng-submit="vm.check()" show-validation><div class="form-group"><label class="control-label" for="firstName">Pr\xE9nom</label><input type="firstName" class="form-control" id="firstName" name="firstName" placeholder="Votre pr\xE9nom" ng-model="vm.firstName" ng-minlength="2" ng-maxlength="100" required><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Votre pr\xE9nom est requis.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Nom</label><input type="lastName" class="form-control" id="lastName" name="lastName" placeholder="Votre nom" ng-model="vm.lastName" ng-minlength="2" ng-maxlength="100" required><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Votre nom est requis.</p></div></div><div class="form-group" ng-if="vm.found"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Votre email" ng-model="vm.email" ng-minlength="2" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Votre email est requis.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">V\xE9rifier</button> <button type="button" ng-disabled="form.$invalid || vm.deleteRequested" ng-show="vm.found" class="btn btn-danger" ng-click="vm.requestDelete()">Demander la suppression</button></form></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Mot de passe pour <b>{{vm.account.firstName}} {{vm.account.lastName}}</b></h2><div class="alert alert-success" ng-show="vm.success"><strong>Votre mot de passe a \xE9t\xE9 modifi\xE9 !</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>Une erreur s\'est produite !</strong> Le mot de passe n\'a pas pu \xEAtre modifi\xE9.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">Le mot de passe et sa confirmation ne concordent pas !</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">Nouveau mot de passe</label><input type="password" class="form-control" id="password" name="password" placeholder="Nouveau mot de passe" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Un mot de passe est requis.</p><p class="help-block" ng-show="form.password.$error.minlength">Le mot de passe doit contenir au moins 4 caract\xE8res.</p><p class="help-block" ng-show="form.password.$error.maxlength">Le mot de passe ne peut exc\xE9der 50 caract\xE8res.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">Confirmation du nouveau mot de passe</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirmation du nouveau mot de passe" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">La confirmation du mot de passe est requise.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">La confirmation du mot de passe doit contenir au moins 4 caract\xE8res.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">La confirmation du mot de passe ne peut exc\xE9der 50 caract\xE8res.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Valider</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.email}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/alerts/typeahead/search-collectivity.html','<a class="match-link" ui-sref="alerts.new({id: match.model.id, type:\'collectivity\', name: match.label})"><div class="square-picture" ng-hide="match.model.pictureContentType" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="square-picture" ng-show="match.model.pictureContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + match.model.logoContentType + \';base64,\' + match.model.logo }"></div><div class="text-container"><span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span><br><span class="subtitle">{{ match.model.sector }}</span></div></a>');
$templateCache.put('app/alerts/typeahead/search-company.html','<a class="match-link" ui-sref="alerts.new({id: match.model.id, type:\'company\', name: match.label})"><div class="square-picture" ng-hide="match.model.logoContentType" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="square-picture" ng-show="match.model.logoContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + match.model.logoContentType + \';base64,\' + match.model.logo }"></div><div class="text-container"><span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span><br><span class="subtitle">{{ match.model.sector.name }}</span></div></a>');
$templateCache.put('app/alerts/typeahead/search-people.html','<a class="match-link" ui-sref="alerts.new({id: match.model.id, type:\'profile\', name: match.label})"><div class="square-picture" ng-hide="match.model.pictureContentType" style="background-image: url(\'../../content/images/no-picture.png\')"></div><div class="square-picture" ng-show="match.model.pictureContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + match.model.pictureContentType + \';base64,\' + match.model.picture }"></div><div class="text-container"><span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span><br><span class="subtitle">{{ match.model.title }}</span></div></a>');
$templateCache.put('app/alerts/typeahead/search-popup.html','<div class="typeahead-wrapper well" style="display: block" ng-show="isOpen() && !moveInProgress" aria-hidden="{{!isOpen()}}"><div class="category-wrapper" ng-show="(matches|filter:\'profile\').length > 0"><div class="category-label">Personnes</div><ul class="dropdown-menu" role="listbox"><li class="uib-typeahead-match" ng-repeat="match in matches | filter:\'profile\' track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option"><div uib-typeahead-match index="$index" match="match" query="query" template-url="\'app/alerts/typeahead/search-people.html\'"></div></li></ul></div><div class="category-wrapper" ng-show="(matches|filter:\'company\').length > 0"><div class="category-label">Entreprises</div><ul class="dropdown-menu" role="listbox"><li class="uib-typeahead-match" ng-repeat="match in matches | filter:\'company\' track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" role="option"><div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div></li></ul></div><div class="category-wrapper" ng-show="(matches|filter:\'collectivity\').length > 0"><div class="category-label">Collectivit\xE9s</div><ul class="dropdown-menu" role="listbox"><li class="uib-typeahead-match" ng-repeat="match in matches | filter:\'collectivity\' track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option"><div uib-typeahead-match index="$index" match="match" query="query" template-url="\'app/alerts/typeahead/search-collectivity.html\'"></div></li></ul></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filtrer (par pr\xE9fixe)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Pr\xE9fixe</span></th><th class="col-sm-8">Propri\xE9t\xE9</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Propri\xE9t\xE9</th><th class="col-sm-8">Valeur</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filtrer par date</h4><p class="input-group"><span class="input-group-addon">De</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">\xE0</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>Utilisateur</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>\xC9tat</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Donn\xE9es suppl\xE9mentaires</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.mode">{{audit.data.mode}}</span> <span ng-show="audit.data.remoteAddress"><span>Adresse externe</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/db-profile-management/db-profile-management.html','<style>.barre {\n    text-decoration: line-through red !important;\n}\n.add{\n    color:black;\n}\n.del {\n    color:red;\n}\n.mod {\n    color:green;\n}\n.mod a {\n    color: green;\n}</style><div><h2>Historique DB Profiles (Sur 1 mois)</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span>Pr\xE9nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="importId"><span>Source</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Cr\xE9e/Modifi\xE9 par</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="revisionDate"><span>Cr\xE9e/Modifi\xE9</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="revisionType"><span>Action</span> <span class="glyphicon glyphicon-sort"></span></th><th>Diff</th></tr></thead><tbody><tr ng-repeat="profile in vm.profiles track by profile.id" ng-class="profile.revisionType == \'ADD\' ? \'add\' : profile.revisionType == \'DEL\' ? \'del\' : \'mod\'"><td style="white-space: nowrap" ng-class="profile.revisionType == \'DEL\' ? \'barre\' : \'\'"><b><a ng-if="profile.revisionType != \'DEL\'" ui-sref="profile({id: profile.id, position: \'\' })">{{profile.id}}</a> <span ng-if="profile.revisionType == \'DEL\'">{{profile.id}}</span> </b><span ng-if="profile.revisionType == \'MOD\'">* </span><span ng-if="profile.revisionType == \'ADD\'">+</span></td><td ng-class="profile.revisionType == \'DEL\' ? \'barre\' : \'\'">{{profile.lastName}}</td><td ng-class="profile.revisionType == \'DEL\' ? \'barre\' : \'\'">{{profile.firstName}}</td><td>{{profile.importSource }}</td><td>{{profile.lastModifiedBy}}</td><td>{{profile.revisionDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{profile.revisionType}}</td><td><pre ng-if="profile.diffValue" ng-bind-html="profile.diffValue"></pre></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/doublon-profile-management/doublon-profile-management-create-dialog.html','<form name="createForm" ng-submit="vm.confirmCreate()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de cr\xE9ation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir cr\xE9er ce profile : <b>{{vm.doublon.lastNameFirstName}}</b> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Cr\xE9er</span></button></div></form>');
$templateCache.put('app/admin/doublon-profile-management/doublon-profile-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.doublon.creatorId, vm.doublon.lastName, vm.doublon.firstName)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce doublon <b>{{vm.doublon.lastNameFirstName}}</b> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/admin/doublon-profile-management/doublon-profile-management-merge-dialog.html','<form name="mergeForm" ng-submit="vm.confirmMerge()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de merge</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir merger ce match profile <b>{{vm.doublon.lastNameFirstName}}</b> avec <b>{{vm.doublon.similarProfile.lastName}} {{vm.doublon.similarProfile.firstName}}</b> ?<br>Un job et possiblement son organisation seront cr\xE9es. Je job sera ajout\xE9 au profil en base (multi affichage)</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Merger</span></button></div></form>');
$templateCache.put('app/admin/doublon-profile-management/doublon-profile-management.html','<style>td, th {\n        padding: 0;\n        vertical-align: middle !important;\n    }\n    :focus {\n        outline: none;\n    }\n    .btn:focus, .btn.focus, .btn:active:focus, .btn:active.focus, .btn.active:focus, .btn.active.focus {\n        outline: none;\n    }</style><div><h2>Profils Linkedins en attente d\'importation</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="table table-striped"><thead><tr callback="vm.transition()"><th><span>ID</span></th><th><span>Email</span></th><th><span>Nom</span></th><th><span>Pr\xE9nom</span></th><th><span>Score</span></th><th><span>Organisation</span></th><th><span>Job</span></th><th><span>Indice</span></th><th><span>Source</span></th><th></th></tr></thead><tbody ng-repeat="doublon in vm.doublons track by doublon.profile.id"><tr ng-click="isClose=!isClose" style="color:black"><td><b>{{doublon.profile.id}}</b></td><td style="word-break: break-word"><b>{{doublon.profile.email}}</b></td><td><b>{{doublon.profile.lastName}}</b></td><td><b>{{doublon.profile.firstName}}</b></td><td></td><td><b>{{doublon.profile.currentPosition.organisation.name}}</b></td><td><b>{{doublon.profile.currentPosition.title}}</b></td><td><b>{{doublon.size}}</b></td><td></td><td class="text-right"></td></tr><tr ng-repeat="profileMatch in doublon.profileMatchs track by $index" ng-if="!isClose"><td>{{profileMatch.id}}</td><td style="word-break: break-word">{{profileMatch.email}}</td><td>{{profileMatch.lastName}}</td><td>{{profileMatch.firstName}}</td><td>{{profileMatch.score}} %</td><td>{{profileMatch.company}}</td><td>{{profileMatch.position}}</td><td>{{profileMatch.creatorEmail}}</td><td><i title="LinkedIn" class="fab fa-linkedin fa-2x" style="color:#127BB4"></i></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="doublon-profile-management.create({userId:profileMatch.creatorId, nom:profileMatch.lastName, prenom:profileMatch.firstName})" class="btn btn-primary btn-sm" title="Cr\xE9er le profile en base"><i class="fas fa-plus"></i> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="doublon-profile-management.merge({userId:profileMatch.creatorId, nom:profileMatch.lastName, prenom:profileMatch.firstName})" class="btn btn-info btn-sm" title="Fusionner le match avec le profile en base"><i class="fas fa-code-merge"></i> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="doublon-profile-management.delete({userId:profileMatch.creatorId, nom:profileMatch.lastName, prenom:profileMatch.firstName})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.id==profileMatch.email" title="Supprimer le match"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/doublon-company-management/doublon-company-db-management-merge-dialog.html','<form name="mergeForm" ng-submit="vm.confirmMerge(vm.company.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de merge</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir merger tous les matchs avec cette organisation <b>{{vm.company.name}}</b> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Merger</span></button></div></form>');
$templateCache.put('app/admin/doublon-company-management/doublon-company-management-create-dialog.html','<form name="createForm" ng-submit="vm.confirmCreate(vm.doublon[0].company)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de cr\xE9ation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir cr\xE9er cette organisation : <b>{{vm.doublon[0].company}}</b> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Cr\xE9er</span></button></div></form>');
$templateCache.put('app/admin/doublon-company-management/doublon-company-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.doublon[0].company)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce match organisation : <b>{{vm.doublon[0].company}}</b> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/admin/doublon-company-management/doublon-company-management-merge-dialog.html','<form name="mergeForm" ng-submit="vm.confirmMerge(vm.doublon[0].company)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de merge</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir merger tous les matchs avec cette organisation <b>{{vm.doublon[0].company}}</b> ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Merger</span></button></div></form>');
$templateCache.put('app/admin/doublon-company-management/doublon-company-management.html','<style>td, th {\n        padding: 0;\n        vertical-align: middle !important;\n    }\n    :focus {\n        outline: none;\n    }\n    .btn:focus, .btn.focus, .btn:active:focus, .btn:active.focus, .btn.active:focus, .btn.active.focus {\n        outline: none;\n    }</style><div><h2>Organisations Linkedin en attente d\'importation</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>ID</span></th><th><span>Holding</span></th><th><span>Organisation</span></th><th><span>Score</span></th><th><span>Personnes</span></th><th><span>Cr\xE9ateur</span></th><th><span>Source</span></th><th></th></tr></thead><tbody ng-repeat="doublon in vm.doublons track by doublon.organisation.id"><tr ng-click="isClose=!isClose" style="color:black"><td><b>{{doublon.organisation.id}}</b></td><td><b>{{doublon.organisation.holding ? doublon.organisation.holding.name : ""}}</b></td><td><b>{{doublon.organisation.name}}</b></td><td><b></b></td><td><b>{{doublon.size}}</b></td><td></td><td><b>{{doublon.source}}</b></td><td class="text-right"><button type="submit" ui-sref="doublon-company-management.merge.db({id:doublon.organisation.id})" class="btn btn-info btn-sm" title="Fusionner tous les matchs avec cette organisation en base" ng-click="$event.stopPropagation()"><i class="fas fa-code-merge"></i> <span class="hidden-xs hidden-sm"></span></button></td></tr><tr ng-repeat="organisationMatch in doublon.organisationMatchs track by organisationMatch.name" ng-if="!isClose"><td>{{organisationMatch.id}}</td><td></td><td>{{organisationMatch.name}}</td><td>{{organisationMatch.linkedinMatchs[0].score}} %</td><td>{{organisationMatch.linkedinMatchs.length}}</td><td>{{organisationMatch.linkedinMatchs[0].creatorEmail}}</td><td><i title="LinkedIn" class="fab fa-linkedin fa-2x" style="color:#127BB4"></i></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="doublon-company-management.create({name:organisationMatch.name})" class="btn btn-primary btn-sm" title="Cr\xE9er l\'organisation en base"><i class="fas fa-plus"></i> <span class="hidden-xs hidden-sm"></span></button><!--\n                            <button type="submit" ui-sref="doublon-company-management.merge({name:organisationMatch.name})"\n                                class="btn btn-info btn-sm" title="Fusionner tous les matchs en base avec cette organisation">\n                                <i class="fas fa-code-merge"></i>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            --> <button type="submit" ui-sref="doublon-company-management.delete({name:organisationMatch.name})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.id==organisationMatch.name" title="Supprimer le match"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/ec-management/ec-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ec.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette \xE9quipe commerciale ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/admin/ec-management/ec-management-dialog.html','<form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Cr\xE9er ou modifier une \xE9quipe commerciale</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.ec.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Nom de l\'\xE9quipe <span class="required">*</span></label><input type="text" class="form-control" name="name" ng-model="vm.ec.name" ng-maxlength="50" required><div ng-show="vm.editForm.name.$invalid"><p class="help-block" ng-show="vm.editForm.name.$error.required">Ce champ est requis.</p><p class="help-block" ng-show="vm.editForm.name.$error.maxlength">Ce champ ne doit pas d\xE9passer 50 caract\xE8res.</p></div></div><div class="form-group"><label class="control-label" for="field_dg_1">DG 1</label><input id="field_dg_1" name="dg1" type="text" ng-model="vm.ec.dgs[0]" autocomplete="off" uib-typeahead="dg as dg.firstName + \' \' + dg.lastName + \' (\' + dg.email + \')\'  for dg in vm.getDgs($viewValue, 1)" typeahead-no-results="vm.dgsNoResults1" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.dgsNoResults1" style="color: red">Nous n\'avons pas ce dg dans nos bases de donn\xE9es.</div></div><div class="form-group"><label class="control-label" for="field_dg_2">DG 2</label><input id="field_dg_2" name="dg2" type="text" ng-model="vm.ec.dgs[1]" autocomplete="off" uib-typeahead="dg as dg.firstName + \' \' + dg.lastName + \' (\' + dg.email + \')\'  for dg in vm.getDgs($viewValue, 2)" typeahead-no-results="vm.dgsNoResults2" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.dgsNoResults2" style="color: red">Nous n\'avons pas ce dg dans nos bases de donn\xE9es.</div></div><div class="form-group"><label class="control-label" for="field_dg_3">DG 3</label><input id="field_dg_3" name="dg3" type="text" ng-model="vm.ec.dgs[2]" autocomplete="off" uib-typeahead="dg as dg.firstName + \' \' + dg.lastName + \' (\' + dg.email + \')\'  for dg in vm.getDgs($viewValue, 3)" typeahead-no-results="vm.dgsNoResults3" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.dgsNoResults3" style="color: red">Nous n\'avons pas ce dg dans nos bases de donn\xE9es.</div></div><div class="form-group"><label class="control-label" for="field_dg_4">DG 4</label><input id="field_dg_4" name="dg4" type="text" ng-model="vm.ec.dgs[3]" autocomplete="off" uib-typeahead="dg as dg.firstName + \' \' + dg.lastName + \' (\' + dg.email + \')\'  for dg in vm.getDgs($viewValue,4)" typeahead-no-results="vm.dgsNoResults4" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.dgsNoResults4" style="color: red">Nous n\'avons pas ce dg dans nos bases de donn\xE9es.</div></div><div class="form-group"><label class="control-label" for="field_dg_5">DG 5</label><input id="field_dg_5" name="dg5" type="text" ng-model="vm.ec.dgs[4]" autocomplete="off" uib-typeahead="dg as dg.firstName + \' \' + dg.lastName + \' (\' + dg.email + \')\'  for dg in vm.getDgs($viewValue, 5)" typeahead-no-results="vm.dgsNoResults5" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.dgsNoResults5" style="color: red">Nous n\'avons pas ce dg dans nos bases de donn\xE9es.</div></div><div class="form-group"><label class="control-label">Division</label><input name="division" type="text" ng-model="vm.ec.division" autocomplete="off" uib-typeahead="division as division.name for division in vm.getDivisions($viewValue)" typeahead-no-results="vm.divisionsNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.divisionsNoResults" style="color:red">Nous n\'avons pas cette division dans nos bases de donn\xE9es.</div></div><div class="form-group"><label for="field_max_users">Max commerciaux <span class="required">*</span></label><input class="form-control" id="field_max_users" name="maxUsers" type="number" ng-model="vm.ec.maxUsers" required><div ng-show="vm.editForm.maxUsers.$invalid"><p class="help-block" ng-show="vm.editForm.maxUsers.$error.required">Ce champ est requis.</p></div></div><div class="form-group"><label for="field_credit_value">Valeur d\'un cr\xE9dit <span class="required">*</span></label><input class="form-control" id="field_credit_value" name="creditValue" type="number" ng-model="vm.ec.creditValue" required><div ng-show="vm.editForm.credit_value.$invalid"><p class="help-block" ng-show="vm.editForm.credit_value.$error.required">Ce champ est requis.</p></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="field_credits">Nombre de cr\xE9dits restants<span class="required">*</span></label><input class="form-control" id="field_credits" name="credits" type="number" ng-model="vm.ec.credits" required><div ng-show="vm.editForm.credits.$invalid"><p class="help-block" ng-show="vm.editForm.credits.$error.required">Ce champ est requis.</p></div></div></div><div class="col-md-6"><div class="form-group"><label for="field_credits_spent">Nombre de cr\xE9dits d\xE9pens\xE9s <span class="required">*</span></label><input class="form-control" id="field_credits_spent" name="creditsSpent" type="number" ng-model="vm.ec.creditsSpent" required disabled="disabled"><div ng-show="vm.editForm.creditsSpent.$invalid"><p class="help-block" ng-show="vm.editForm.creditsSpent.$error.required">Ce champ est requis.</p></div></div></div></div><div class="form-group"><label for="field_dashboard">URL dashboard Kibana</label><input class="form-control" id="field_dashboard" name="dashboardUrl" type="url" ng-model="vm.ec.dashboardUrl"></div><div class="form-group"><label for="field_elastic_index">Elastic index</label><input class="form-control" id="field_elastic_index" name="elasticIndex" type="text" ng-model="vm.ec.elasticIndex"></div><div class="form-group"><label for="oauth2"><input type="checkbox" id="oauth2" name="oauth2" ng-model="vm.ec.oauth2"> <span>Okta par d\xE9faut</span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="vm.editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/admin/ec-management/ec-management.html','<div><h2>Gestion \xE9quipes commerciales</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="ec-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Cr\xE9er une nouvelle \xE9quipe commerciale</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="text-align: center" jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center" jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th style="text-align: center" jh-sort-by="maxUsers"><span>Max utilisateurs</span></th><th style="text-align: center" jh-sort-by="creditsValue"><span>Valeur cr\xE9dit</span></th><th style="text-align: center" jh-sort-by="credits"><span>Nb cr\xE9dits restants</span></th><th style="text-align: center" jh-sort-by="division.name"><span>Division</span></th><th style="text-align: center" jh-sort-by="oauth2"><span>Okta</span></th><th></th></tr></thead><tbody><tr ng-repeat="ec in vm.equipeCommerciales track by ec.id"><td style="vertical-align: middle"><a ui-sref="ec-management-detail({id:ec.id})">{{ec.id}}</a></td><td style="vertical-align: middle">{{ec.name}}</td><td style="text-align: right;vertical-align: middle">{{ec.maxUsers}}</td><td style="text-align: right;vertical-align: middle">{{ec.creditValue}}</td><td style="text-align: right;vertical-align: middle">{{ec.credits}}</td><td style="text-align: right;vertical-align: middle"><span ng-if="ec.division">{{ec.division.name}}</span></td><td style="text-align: right;vertical-align: middle">{{ec.oauth2}}</td><td class="text-right" style="vertical-align: middle"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ec-management.edit({id:ec.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="ec-management.delete({id:ec.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/moderation-collectivity/moderation-collectivity-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.moderationCollectivity.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette mod\xE9ration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/admin/moderation-collectivity/moderation-collectivity.html','<div><h2>Mod\xE9ration Collectivit\xE9</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Cr\xE9e/Modifi\xE9 par</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Cr\xE9e/Modifi\xE9 le</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="moderationType"><span>type</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Action</span></th><th></th></tr></thead><tbody><tr ng-repeat="moderationCollectivity in vm.moderationCompanies track by moderationCollectivity.id"><td style="vertical-align: middle"><a ui-sref="collectivity({id: moderationCollectivity.referencedOrganisation.id})">{{moderationCollectivity.id}}</a></td><td style="vertical-align: middle">{{moderationCollectivity.name}}</td><td style="vertical-align: middle">{{moderationCollectivity.lastModifiedBy}}</td><td style="vertical-align: middle">{{moderationCollectivity.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td style="vertical-align: middle">{{moderationCollectivity.moderationType}}</td><td class="text-right" style="vertical-align: middle"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.directApprove(moderationCollectivity)" class="btn btn-primary btn-sm" title="Acc\xE9pter & sauvegarder le collectivity en base"><span class="glyphicon glyphicon-ok"></span> <span class="hidden-xs hidden-sm"></span></button> <a ui-sref="moderation-collectivity.edit({id:moderationCollectivity.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></a> <button type="submit" ui-sref="moderation-collectivity.delete({id:moderationCollectivity.id})" class="btn btn-danger btn-sm" title="Refuser la mod\xE9ration"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/moderation-company/moderation-company-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.moderationCompany.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette mod\xE9ration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/admin/moderation-company/moderation-company.html','<div><h2>Mod\xE9ration Company</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Cr\xE9e/Modifi\xE9 par</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Cr\xE9e/Modifi\xE9 le</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="moderationType"><span>type</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Action</span></th><th></th></tr></thead><tbody><tr ng-repeat="moderationCompany in vm.moderationCompanies track by moderationCompany.id"><td style="vertical-align: middle"><a ui-sref="company({id: moderationCompany.referencedOrganisation.id})">{{moderationCompany.id}}</a></td><td style="vertical-align: middle">{{moderationCompany.name}}</td><td style="vertical-align: middle">{{moderationCompany.lastModifiedBy}}</td><td style="vertical-align: middle">{{moderationCompany.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td style="vertical-align: middle">{{moderationCompany.moderationType}}</td><td class="text-right" style="vertical-align: middle"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.directApprove(moderationCompany)" class="btn btn-primary btn-sm" title="Acc\xE9pter & sauvegarder le company en base"><span class="glyphicon glyphicon-ok"></span> <span class="hidden-xs hidden-sm"></span></button> <a ui-sref="moderation-company.edit({id:moderationCompany.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></a> <button type="submit" ui-sref="moderation-company.delete({id:moderationCompany.id})" class="btn btn-danger btn-sm" title="Refuser la mod\xE9ration"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/moderation-profile/moderation-profile-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.moderationProfile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette mod\xE9ration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/admin/moderation-profile/moderation-profile.html','<div><h2>Mod\xE9ration Profile</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span>Pr\xE9nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Cr\xE9e/Modifi\xE9 par</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Cr\xE9e/Modifi\xE9 le</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="moderationType"><span>type</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Action</span></th><th></th></tr></thead><tbody><tr ng-repeat="moderationProfile in vm.moderationProfiles track by moderationProfile.id"><td style="vertical-align: middle"><a ui-sref="profile({id: moderationProfile.referencedProfile.id, position: \'\' })">{{moderationProfile.id}}</a></td><td style="vertical-align: middle">{{moderationProfile.lastName}}</td><td style="vertical-align: middle">{{moderationProfile.firstName}}</td><td style="vertical-align: middle">{{moderationProfile.lastModifiedBy}}</td><td style="vertical-align: middle">{{moderationProfile.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td style="vertical-align: middle">{{moderationProfile.moderationType}}</td><td class="text-right" style="vertical-align: middle"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.directApprove(moderationProfile)" class="btn btn-primary btn-sm" title="Acc\xE9pter & sauvegarder le profile en base"><span class="glyphicon glyphicon-ok"></span> <span class="hidden-xs hidden-sm"></span></button> <a ui-sref="moderation-profile.edit({id:moderationProfile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></a> <button type="submit" ui-sref="moderation-profile.delete({id:moderationProfile.id})" class="btn btn-danger btn-sm" title="Refuser la mod\xE9ration"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/profile-info-management/profile-info-management.html','<div class="padding15"><div class="row"><nav><div class="list-group list-group-horizontal"><a class="list-group-item" ui-sref-active="active" ui-sref="city"><i class="fas fa-building fa-fw"></i> Villes </a><a class="list-group-item" ui-sref-active="active" ui-sref="collectivity-size"><i class="fas fa-building fa-fw"></i>Tailles des collectivit\xE9s </a><a class="list-group-item" ui-sref-active="active" ui-sref="collectivity-type"><i class="fas fa-building fa-fw"></i>Types des collectivit\xE9s </a><a class="list-group-item" ui-sref-active="active" ui-sref="company"><i class="fas fa-suitcase fa-fw"></i> Entreprises </a><a class="list-group-item" ui-sref-active="active" ui-sref="collectivity"><i class="fas fa-university fa-fw"></i> Collectivit\xE9s </a><a class="list-group-item" ui-sref-active="active" ui-sref="company-status"><i class="fas fa-address-card fa-fw"></i> Statuts entreprises </a><a class="list-group-item" ui-sref-active="active" ui-sref="degree"><i class="fas fa-pencil fa-fw"></i> Dipl\xF4mes </a><a class="list-group-item" ui-sref-active="active" ui-sref="department"><i class="fas fa-window-restore fa-fw"></i> D\xE9partements </a><a class="list-group-item" ui-sref-active="active" ui-sref="establishment"><i class="fas fa-graduation-cap fa-fw"></i> Universit\xE9s, \xE9coles </a><a class="list-group-item" ui-sref-active="active" ui-sref="sector"><i class="fas fa-suitcase fa-fw"></i> Secteurs d\'activit\xE9 </a><a class="list-group-item" ui-sref-active="active" ui-sref="title"><i class="fas fa-check fa-fw"></i> Titres professionnels </a><a class="list-group-item" ui-sref-active="active" ui-sref="delete-profile-request"><i class="fas fa-check fa-fw"></i> Demandes de suppression de profil</a></div></nav></div><div class="row" ui-view="content"><!-- Angular views --></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.email)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cet utilisateur ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div class="container"><h2><span>User</span> {{vm.user.firstName + \' \' + vm.user.lastName}}</h2><dl class="dl-horizontal"><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd><dt><span>Oauth2 (Okta)</span></dt><dd>{{vm.user.oauth2}}</dd></dl><button onclick="history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Cr\xE9er ou modifier un utilisateur</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Email<span class="required">*</span></label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="vm.editForm.email.$invalid"><p class="help-block" ng-show="vm.editForm.email.$error.required">Ce champ est requis.</p><p class="help-block" ng-show="vm.editForm.email.$error.maxlength">Ce champ ne doit pas d\xE9passer 100 caract\xE8res.</p><p class="help-block" ng-show="vm.editForm.email.$error.email">Cet email est invalide.</p></div></div><div class="form-group"><label class="control-label">Pr\xE9nom<span class="required">*</span></label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" required ng-maxlength="50"><div ng-show="vm.editForm.firstName.$invalid"><p class="help-block" ng-show="vm.editForm.firstName.$error.required">Ce champ est requis.</p><p class="help-block" ng-show="vm.editForm.firstName.$error.maxlength">Ce champ ne doit pas d\xE9passer 50 caract\xE8res.</p></div></div><div class="form-group"><label>Nom<span class="required">*</span></label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" required ng-maxlength="50"><div ng-show="vm.editForm.lastName.$invalid"><p class="help-block" ng-show="vm.editForm.lastName.$error.required">Ce champ est requis.</p><p class="help-block" ng-show="vm.editForm.lastName.$error.maxlength">Ce champ ne doit pas d\xE9passer 50 caract\xE8res.</p></div></div><div class="form-group"><label class="control-label">Entreprise/Collectivit\xE9</label><input name="initOrganisation" type="text" ng-model="vm.user.initOrganisation" autocomplete="off" uib-typeahead="initOrganisation as initOrganisation.name for initOrganisation in vm.getOrganizations($viewValue)" typeahead-no-results="vm.initOrganisationsNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.initOrganisationsNoResults" style="color:red">Nous n\'avons pas cette entreprise/collectivit\xE9 dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div><div class="form-group"><label class="control-label" for="field_initTitle">Titre professionnel</label><input type="text" class="form-control" name="initTitle" id="field_initTitle" ng-model="vm.user.initTitle" ng-maxlength="100"></div><div class="form-group"><label class="control-label">Sup\xE9rieur hi\xE9rarchique</label><input name="initSuperior" type="text" ng-model="vm.user.initSuperior" autocomplete="off" uib-typeahead="initProfile as initProfile.firstName + \' \' + initProfile.lastName for initProfile in vm.getProfiles($viewValue)" typeahead-no-results="vm.initProfilesNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.initProfilesNoResults" style="color:red">Nous n\'avons pas cette personne dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div><div ng-if="vm.isAdmin()" class="form-group" has-any-authority="ROLE_ADMIN"><label class="control-label">Division</label><select class="form-control" id="field_division" name="division" ng-model="vm.user.division" ng-options="division as division.name for division in vm.divisions track by division.id"><option value=""></option></select><div class="search-no-results well" ng-show="vm.divisionsNoResults" style="color:red">Nous n\'avons pas cette division dans nos bases de donn\xE9es.</div></div><!-- Affich\xE9 dans tous les cas pour l\'administrateur, affich\xE9 seulement en modification sinon--><div has-any-authority="ROLE_ADMIN, ROLE_DIVISION_ADMIN"><div ng-if="vm.isAdmin() || (!vm.isAdmin() && vm.user.id)" class="form-group"><label class="control-label">Equipe commerciale<span class="required">*</span></label><input name="ec" type="text" ng-model="vm.user.ec" autocomplete="off" uib-typeahead="ec as ec.name for ec in vm.getEcs($viewValue)" typeahead-no-results="vm.ecsNoResults" class="form-control typeahead-input" typeahead-editable="false" typeahead-on-select="vm.ecChanged($item)" required><div class="search-no-results well" ng-show="vm.ecsNoResults" style="color:red">Nous n\'avons pas cette \xE9quipe commerciale dans nos bases de donn\xE9es.</div><div ng-show="vm.editForm.ec.$invalid"><p class="help-block" ng-show="vm.editForm.ec.$error.required">Ce champ est requis.</p></div></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activ\xE9</span></label></div><div class="form-group"><label for="oauth2"><input type="checkbox" id="oauth2" name="oauth2" ng-model="vm.user.oauth2"> <span>Okta</span></label></div><div class="form-group"><label>R\xF4les<span class="required">*</span></label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities" required></select><div ng-show="vm.editForm.authority.$invalid"><p class="help-block" ng-show="vm.editForm.authority.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="vm.editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-reset-dialog.html','<form name="deleteForm" ng-submit="vm.confirmReset(vm.profileId)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de remise \xE0 z\xE9ro</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="alert" ng-show="vm.alert">{{ vm.alert }}</p><p ng-hide="vm.profileId">Cet utilisateur n\'est reli\xE9 \xE0 aucun profil, il est impossible de supprimer ses donn\xE9es.</p><p ng-show="vm.profileId">\xCAtes-vous s\xFBr(e) de vouloir supprimer les modifications de cet utilisateur ? Cette action est irr\xE9versible.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger" ng-disabled="!vm.profileId"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Remettre \xE0 z\xE9ro</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Gestion des utilisateurs</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Cr\xE9er un nouvel utilisateur</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Equipe commerciale</span></th><th></th><th>Okta</th><th><span>R\xF4les</span></th><th jh-sort-by="createdDate"><span>Cr\xE9\xE9 le</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Modifi\xE9 par</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Modifi\xE9 le</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({email:user.email})">{{user.id}}</a></td><td>{{user.email}}</td><td><span ng-show="user.ec">{{user.ec.name}}</span></td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" style="cursor: pointer">D\xE9sactiv\xE9</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" style="cursor: pointer">Activ\xE9</span></td><td><span ng-show="!user.oauth2" style="cursor: pointer">Non</span> <span ng-show="user.oauth2" style="cursor: pointer">Oui</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({email:user.email})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.edit({email:user.email})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.reset({email:user.email})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-floppy-remove"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({email:user.email})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.email==user.email"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="row"><div class="well" style="float: none; margin: 0 auto; display: table;margin-top:60px"><div class="well-header panel-heading" style="text-align: center"><span style="font-weight: bolder;font-size: 24px">Welcome Back</span><br><span style="font-size: 14px">Connectez-vous pour maximiser votre r\xE9seau et votre performance commerciale.</span></div><div class="col-xs-12 col-md-10 col-md-offset-1"><div class="alert alert-danger" ng-show="vm.authenticationError && vm.authenticationErrorMessage" style="width:100%"><div>{{vm.authenticationErrorMessage}}</div></div><div class="alert alert-danger" ng-show="vm.authenticationError && !vm.authenticationErrorMessage"><strong>Impossible de se connecter !</strong> V\xE9rifiez vos identifiants.</div></div><div class="col-xs-12"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="email">Adresse e-mail</label><input type="text" class="form-control" id="username" ng-model="vm.username"></div><div class="form-group"><label for="password">Mot de passe</label><input type="password" class="form-control" id="password" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span>Se rappeler de moi</span></label></div><div class="form-group" style="text-align: center"><button type="submit" class="btn btn-primary" style="width: 70%">Connexion</button><br><br><button type="button" class="btn btn-secondary" style="width: 70%" ng-click="vm.oktaLogin()"><span class="glyphicon glyphicon-flash"></span> <span>Se connecter avec OKTA</span></button><br><br><a class="alert-link" href="" ng-click="vm.requestResetPassword()">Mot de passe oubli\xE9 ?</a><br>Nouveau chez Axenteev ? <a class="alert-link" href="https://www.axenteev.com/#comp-irujafzq">Nous contacter</a></div></form></div></div></div>');
$templateCache.put('app/components/organisation-network/envoyer-message-commercial-dialog.html','<form name="sendForm" ng-submit="vm.confirmSend(vm.profile)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation d\'envoi de message</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Le message suivant sera envoy\xE9 par mail \xE0 <b>{{vm.commercial.firstName}} {{vm.commercial.lastName}} :</b><br><br>"Axenteev vous informe que {{vm.currentAccount.firstName}} {{vm.currentAccount.lastName}} souhaite vous contacter \xE0 propos de {{vm.profile.firstName}} {{vm.profile.lastName}}. Pouvez-vous le rappeler s\u2019il vous plait."<br><br></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="sendForm.$invalid" class="btn btn-primary"><span class="fal fa-check-circle"></span>&nbsp;<span>Confirmer</span></button></div></form>');
$templateCache.put('app/components/organisation-network/external-network-request-dialog.html','<form name="sendForm" ng-submit="vm.confirmSend(vm.profile)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de mise en relation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Vous \xEAtes sur le point de confirmer votre demande de mise en contact avec <b>{{vm.profile.firstName}} {{vm.profile.lastName}}</b>. Une fois votre demande faite, notre \xE9quipe d\xE9terminera le meilleur point de contact et reviendra vers vous dans les plus brefs d\xE9lais.<br><br>Une fois le meilleur relais confirm\xE9, nous vous confirmerons le profil du consultant ainsi que ces coordonn\xE9es afin que vous puissiez lancer votre d\xE9marche.<br><br>Enfin, si vous avez besoin d\u2019assistance tout au long du processus, n\u2019h\xE9sitez pas \xE0 joindre notre \xE9quipe d\u2019experts.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="sendForm.$invalid" class="btn btn-primary"><span class="fal fa-check-circle"></span>&nbsp;<span>Valider</span></button></div></form>');
$templateCache.put('app/components/organisation-network/organisation-network.html','<div class="well network-well"><!--\n            <div ng-show="vd.profile.id" class="well-header" style="margin-top: 10px;">\n                <i class="fal fa-code-branch fa-2x" style="vertical-align: middle;padding-right: 8px;"></i>Internal Network (<b>{{vd.people.length}}</b>)\n            </div>\n            <div ng-hide="vd.profile.id" class="well-header" >\n               <i class="fal fa-users fa-2x" style="vertical-align: middle;padding-right: 8px;"></i>Mon Network (<b>{{vd.people.length}}</b>)\n            </div>\n         --><!--\n    <div class="row">\n        <div class="col-md-6" ng-show="!vd.profile.id">\n            <div class="well-header">\n                <i class="fal fa-users fa-2x fa-fw" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Mon Network (<b>{{vd.myNetworkOrganisationPeople.length}}</b>)\n            </div>\n        </div>\n\n        <div class="col-md-6"  has-any-authority="ROLE_COMMERCIAL, ROLE_DG, ROLE_CONSULTANT">\n            <div class="well-header" title="Vos coll\xE8gues">\n                <div has-any-authority="ROLE_COMMERCIAL, ROLE_DG">\n                    <i class="fal fa-code-branch fa-fw fa-2x" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Mon Internal Network (<b>{{vd.people.length}}</b>)\n                </div>\n                <div has-any-authority="ROLE_CONSULTANT" style="height: 25px;">\n\n                </div>\n            </div>\n        </div>\n\n        <div class="col-md-6" ng-show="vd.profile.id ">\n            <div class="well-header">\n                <div has-any-authority="ROLE_COMMERCIAL, ROLE_DG, ROLE_CONSULTANT, ROLE_ADMIN">\n                    <i class="fal fa-chart-network fa-fw fa-2x" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>External network</b>\n                </div>\n            </div>\n        </div>\n\n        <div class="col-md-6" ng-show="!vd.profile.id" has-any-authority="ROLE_ADMIN">\n            <div class="well-header" title="Employ\xE9s connu par Consultant Axenteev">\n                <div has-any-authority="ROLE_ADMIN">\n                    <i class="fal fa-chart-network fa-fw fa-2x" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Employ\xE9s connus Consultant</b>\n                </div>\n            </div>\n        </div>\n\n\n\n\n    </div>\n    --><div class="row"><!-- ORGANISATION MON NETWORK --><div ng-show="!vd.profile.id"><div class="col-md-6" style="margin-top: 10px"><div class="well-header"><i class="fal fa-users fa-2x fa-fw" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Mon r\xE9seau (<b>{{vd.myNetworkOrganisationPeople.length}}</b>)</div><div class="internal-network"><table ng-show="vd.myNetworkOrganisationPeople.length" style="margin-top: 20px; margin-bottom: 20px;overflow: scroll;max-height: 140px"><tr ng-repeat="employee in vd.myNetworkOrganisationPeople | limitTo:200"><td><a ui-sref="profile({id: employee.id, position : employee.currentPosition.id})" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.firstName + \' \' + employee.lastName | characters:30 }} <span ng-show="employee.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" style="color: #273C5C" title="Source : Base cliente Linkedin"></i> </span></a><a class="pull-right" ng-show="employee.grade === 1"><img src="content/images/level1.png" width="20"> </a><a class="pull-right" ng-show="employee.grade === 2"><img src="content/images/level2.png" width="20"></a></td></tr></table><p ng-show="!vd.profile.id  && vd.myNetworkOrganisationPeople.length === 0" class="organisation-network-no-connection">Aucune de mes relations dans {{ vd.organisation.name }}</p></div></div></div><!-- INTERNAL NETWORK --><div class="col-md-6" style="margin-top: 10px" has-any-authority="ROLE_COMMERCIAL, ROLE_DG"><div ng-show="vd.profile.id" class="well-header" title="Mon \xE9quipe commerciale"><i class="fal fa-code-branch fa-fw fa-2x" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Mon \xE9quipe commerciale</div><div ng-show="!vd.profile.id" class="well-header" title="Mon \xE9quipe commerciale conna\xEEt"><i class="fal fa-code-branch fa-fw fa-2x" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Mon \xE9quipe conna\xEEt ici :</div><div class="internal-network"><table ng-show="vd.people && vd.people.length" style="margin-top: 20px; margin-bottom: 20px;max-height: 140px;overflow: scroll"><tr ng-repeat="employee in vd.people | limitTo:200"><td><a ui-sref="profile({id: employee.id, position : employee.currentPosition.id})" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.firstName + \' \' + employee.lastName | characters:30 }} <span ng-show="employee.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" style="color: #273C5C" title="Source : Base cliente Linkedin"></i> </span></a><a ui-sref="profile.envoyer-message-commercial({commercialId:employee.id})" ng-show="vd.profile.id" style="margin-left:3px" title="Envoyer un message"><i class="far fa-envelope"></i> </a><a class="pull-right" ng-show="employee.grade === 1"><img src="content/images/level1.png" width="20"> </a><a class="pull-right" ng-show="employee.grade === 2"><img src="content/images/level2.png" width="20"></a></td></tr></table><p ng-show="!vd.people" class="organisation-network-no-connection">Chargement en cours...</p><p ng-show="!vd.profile.id && vd.people && vd.people.length === 0" class="organisation-network-no-connection">Mon \xE9quipe commerciale n\'a pas de relations dans {{ vd.organisation.name }}</p><p ng-show="vd.profile.id && vd.people && vd.people.length === 0" class="organisation-network-no-connection">Mon \xE9quipe commerciale ne conna\xEEt pas {{ vd.profile.firstName + \' \' + vd.profile.lastName | characters:30 }}</p></div></div><!-- ADMIN --><div class="col-md-6" has-any-authority="ROLE_ADMIN" ng-show="vd.profile.id" style="margin-top: 10px;float: right"><div class="well-header"><div><i class="fal fa-chart-network fa-fw fa-2x" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Nos consultants connect\xE9s</div></div><div class="internal-network" style="margin-top: 20px; margin-bottom: 20px;overflow: scroll;max-height: 140px"><table ng-show="vd.externalPeople.length>0"><tr ng-repeat="consultant in vd.externalPeople | limitTo:200"><td><a ui-sref="profile({id: consultant.id, position : consultant.currentPosition.id})">{{ consultant.firstName + \' \' + consultant.lastName | characters:30 }} </a><a class="pull-right" ng-show="consultant.grade === 1"><img src="content/images/level1.png" width="20"> </a><a class="pull-right" ng-show="consultant.grade === 2"><img src="content/images/level2.png" width="20"></a></td></tr></table><p ng-show="vd.externalPeople.length === 0">Aucun r\xE9sultat</p></div></div><!-- ADMIN --><!-- EMPLOYES DE L\'ORGANISATION CONNU PAR LES CONSULTANTS--><div class="col-md-6" style="border-left: solid 1px;float: right; margin-top: 10px" has-any-authority="ROLE_ADMIN" ng-show="!vd.profile.id"><div class="well-header" title="Employ\xE9s connus par Axenteev"><div><i class="fal fa-chart-network fa-fw fa-2x" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Nos consultants connaissent :</div></div><div class="internal-network" style="max-height: 140px;overflow: scroll"><table ng-show="vd.networkOrganisationConnuParConsultantPeople && vd.networkOrganisationConnuParConsultantPeople.length" style="margin-top: 20px; margin-bottom: 20px"><tr ng-repeat="employeeConnuParconsultant in vd.networkOrganisationConnuParConsultantPeople | limitTo:200"><td><a ui-sref="profile({id: employeeConnuParconsultant.id, position : employeeConnuParconsultant.currentPosition.id})">{{ employeeConnuParconsultant.firstName + \' \' + employeeConnuParconsultant.lastName | characters:30 }} </a><a class="pull-right" ng-show="employeeConnuParconsultant.grade === 1"><img src="content/images/level1.png" width="20"> </a><a class="pull-right" ng-show="employeeConnuParconsultant.grade === 2"><img src="content/images/level2.png" width="20"></a></td></tr></table><p ng-show="!vd.networkOrganisationConnuParConsultantPeople" class="organisation-network-no-connection">Chargement en cours...</p><p ng-show="!vd.profile.id && vd.organisation.type === \'collectivity\' && vd.networkOrganisationConnuParConsultantPeople && vd.networkOrganisationConnuParConsultantPeople.length === 0" class="organisation-network-no-connection">Aucun consultant Axenteev n\'a de relations dans cette collectivit\xE9</p><p ng-show="!vd.profile.id && vd.organisation.type === \'company\' && vd.networkOrganisationConnuParConsultantPeople && vd.networkOrganisationConnuParConsultantPeople.length === 0" class="organisation-network-no-connection">Aucun consultant Axenteev n\'a de relations dans cette entreprise</p></div></div><!-- quick connect EXTERNAL NETWORK, PERSONNES QUE CONNAIT AXENTEEV --><div class="col-md-6" ng-show="!vd.isAdmin && vd.profile.id" style="border-left: solid 1px;float: right;margin-top: 10px"><div class="well-header"><div><i class="fal fa-chart-network fa-fw fa-2x" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Quick Connect Axenteev</div></div><div class="internal-network" style="max-height: 140px" ng-show="!vd.isAdmin"><p ng-show="vd.profile.id && vd.externalPeople.length === 0" class="organisation-network-no-connection">Besoin d\'un quick connect? contact@axenteev.com</p><p style="text-align:left" ng-show="vd.profile.id && vd.externalPeople.length > 0" class="organisation-network-no-connection"><i>Axenteev</i> conna\xEEt en <span style="padding: 4px" ng-show="vd.minGrade === 1"><img src="content/images/1_transparent.png" width="20"></span><span style="padding: 4px" ng-show="vd.minGrade === 2"><img src="content/images/2_transparent.png" width="20"></span><span style="padding: 4px" ng-show="vd.minGrade === 3"><img src="content/images/3_transparent.png" width="20"></span>cette personne.<!-- Tout le monde doit pouvoir faire une demande external quand axenteev connait (Consultants, commerciaux, ...)--> <span><br><b>Voulez-vous vous connecter ?</b><br><i style="color:red" class="float-right fal fa-times-circle fa-2x"></i> <a class="float-right" ui-sref="profile.request-external-network({id:vd.profile.id})"><i style="padding-right:5px" class="float-right fal fa-check-circle fa-2x"></i></a></span></p></div></div></div></div>');
$templateCache.put('app/components/organisation-squares/organisation-squares.html','<style>ul#orgas {\n        display: table;\n        width: 93%;\n        padding: 0;\n    }\n\n    ul#orgas li {\n        display: table-cell;\n        text-align: center;\n        width: 30%;\n    }\n\n    .quickconnect-btn{\n        background-color :#48719D;\n        border-radius: 50px;\n        font-size: 12px;\n        box-shadow: 0 0 0 1px rgba(0,0,0,.15), 0 2px 3px rgba(0,0,0,.2);\n        padding: 6px;\n        padding-right: 12px;\n        padding-left: 12px;\n        margin-left: 12px;\n    }</style><div class="well text-center" ng-hide="vd.organisation"><p><i>Aucune entreprise n\'a \xE9t\xE9 renseign\xE9e pour cet utilisateur</i></p></div><div class="well organization-well" ng-show="vd.organisation"><p class="title" style="float:left"><i class="fal fa-building fa-2x fa-fw" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i><ul id="orgas" ng-show="vd.profile && vd.currentPositions.length>1"><li class="title zoom" ng-repeat="position in vd.slicedPositions"><a ng-class="{ \'text-muted\': position.id!=vd.selectedPosition.id }" ng-click="vd.selectedPosition = position">{{ position.organisation.name }}</a></li><li ng-show="vd.currentPositions.length>3" class="title zoom" style="text-align: right"><a class="text-muted" ng-click="vd.slicePositions()">. . .</a></li></ul><span ng-show="!vd.profile || vd.currentPositions.length == 1"><span class="title">{{ vd.organisation.name }}</span></span></p><div class="company-squares-container"><div uib-dropdown on-toggle="toggled(open)" class="square-wrapper"><div class="top-left" id="dropdown-toggle-1" uib-dropdown-toggle><div class="border"><a href class="focus-out" ng-click="vd.switchSquare(1)"><div class="outer-container highlighted"><img class="company-arrow" src="content/images/company-arrow.png" width="40"><p><span ng-hide="vd.organisation.type === \'company\'">Pr\xE9sident/Maire </span><span ng-show="vd.organisation.type === \'company\'">Direction<br>G\xE9n\xE9rale /<br>Strat\xE9gique</span></p></div></a></div></div><div class="inner-container top-left" uib-dropdown-menu aria-labelledby="dropdown-toggle-1"><div class="list-header highlighted"><div class="title"><p><span ng-hide="vd.organisation.type === \'company\'">Pr\xE9sident/Maire </span><span ng-show="vd.organisation.type === \'company\'">Direction<br>G\xE9n\xE9rale /<br>Strat\xE9gique</span></p></div><div class="count"><p><span>{{ vd.totalCount[1] }} membres</span></p></div></div><ul infinite-scroll-parent infinite-scroll="vd.loadPage(vd.page[1] + 1, 1)" infinite-scroll-disabled="!vd.hasNextPage[1]"><li ng-repeat="employee in vd.organisation.employees[1]"><img src="content/images/no-picture.png" width="30" class="img-circle"><p><a ui-sref="profile({id: employee.id, position : employee.currentPosition.id})" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.firstName + \' \' + employee.lastName | characters:20 }} <span ng-show="employee.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" style="color: #273C5C" title="Source : Base cliente Linkedin"></i></span></a><br><span class="title" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.currentPosition.title | characters:20 }}</span></p><div class="connection-levels" ng-click="$event.stopPropagation()"><span class="level-image level-1" ng-click="vd.connect(employee, 1)" ng-class="employee.grade === 1 ? \'active\' : \'inactive\'"></span> <span class="level-image level-2" ng-click="vd.connect(employee, 2)" ng-class="employee.grade === 2 ? \'active\' : \'inactive\'"></span> <span class="level-image level-3" ng-click="vd.connect(employee, 3)" ng-class="employee.grade === 3 ? \'active\' : \'inactive\'"></span></div></li><li ng-hide="vd.organisation.employees[1].length" class="text-center"><p>Aucun profil n\'a \xE9t\xE9 ajout\xE9 dans cette cat\xE9gorie.</p></li></ul></div></div><div uib-dropdown on-toggle="toggled(open)" class="square-wrapper"><div class="top-right" id="dropdown-toggle-2" uib-dropdown-toggle><div class="border"><a href class="focus-out" ng-click="vd.switchSquare(2)"><div class="outer-container"><img class="company-arrow" src="content/images/company-arrow.png" width="40"><p><span ng-hide="vd.organisation.type === \'company\'">Cabinet /<br>Communication </span><span ng-show="vd.organisation.type === \'company\'">Direction<br>Commerciale/<br>Marketing</span></p></div></a></div></div><div class="inner-container top-right" uib-dropdown-menu aria-labelledby="dropdown-toggle-2" ng-class="vd.mode === 2 ? \'active\' : \'\'"><div class="list-header"><div class="count"><p><span>{{ vd.totalCount[2] }} membres</span></p></div><div class="title"><p><span ng-hide="vd.organisation.type === \'company\'">Cabinet /<br>Communication </span><span ng-show="vd.organisation.type === \'company\'">Direction<br>Commerciale/<br>Marketing</span></p></div></div><ul infinite-scroll-parent infinite-scroll="vd.loadPage(vd.page[2] + 1, 2)" infinite-scroll-disabled="!vd.hasNextPage[2]"><li ng-repeat="employee in vd.organisation.employees[2]"><img src="content/images/no-picture.png" width="30" class="img-circle"><p><a ui-sref="profile({id: employee.id, position : employee.currentPosition.id})" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.firstName + \' \' + employee.lastName | characters:20 }} <span ng-show="employee.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" style="color: #273C5C" title="Source : Base cliente Linkedin"></i></span></a><br><span class="title" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.currentPosition.title | characters:20 }}</span></p><div class="connection-levels" ng-click="$event.stopPropagation()"><span class="level-image level-1" ng-click="vd.connect(employee, 1)" ng-class="employee.grade === 1 ? \'active\' : \'inactive\'"></span> <span class="level-image level-2" ng-click="vd.connect(employee, 2)" ng-class="employee.grade === 2 ? \'active\' : \'inactive\'"></span> <span class="level-image level-3" ng-click="vd.connect(employee, 3)" ng-class="employee.grade === 3 ? \'active\' : \'inactive\'"></span></div></li><li ng-hide="vd.organisation.employees[2].length" class="text-center"><p>Aucun profil n\'a \xE9t\xE9 ajout\xE9 dans cette cat\xE9gorie.</p></li></ul></div></div><div uib-dropdown on-toggle="toggled(open)" class="square-wrapper"><div class="bottom-left" id="dropdown-toggle-3" uib-dropdown-toggle><div class="border"><a href class="focus-out" ng-click="vd.switchSquare(3)"><div class="outer-container"><img class="company-arrow" src="content/images/company-arrow.png" width="40"><p><span ng-hide="vd.organisation.type === \'company\'">Elus / Conseillers municipaux,<br>d\xE9partementaux, r\xE9gionaux </span><span ng-show="vd.organisation.type === \'company\'">Direction<br>Achats / Supply</span></p></div></a></div></div><div class="inner-container bottom-left" uib-dropdown-menu aria-labelledby="dropdown-toggle-3"><div class="list-header"><div class="title"><p><span ng-hide="vd.organisation.type === \'company\'">Elus / Conseillers municipaux,<br>d\xE9partementaux, r\xE9gionaux </span><span ng-show="vd.organisation.type === \'company\'">Direction<br>Achats / Supply</span></p></div><div class="count"><p><span>{{ vd.totalCount[3] }} membres</span></p></div></div><ul infinite-scroll-parent infinite-scroll="vd.loadPage(vd.page[3] + 1, 3)" infinite-scroll-disabled="!vd.hasNextPage[3]"><li ng-repeat="employee in vd.organisation.employees[3]"><img src="content/images/no-picture.png" width="30" class="img-circle"><p><a ui-sref="profile({id: employee.id, position : employee.currentPosition.id})" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.firstName + \' \' + employee.lastName | characters:20 }} <span ng-show="employee.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" style="color: #273C5C" title="Source : Base cliente Linkedin"></i></span></a><br><span class="title" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.currentPosition.title | characters:20 }}</span></p><div class="connection-levels" ng-click="$event.stopPropagation()"><span class="level-image level-1" ng-click="vd.connect(employee, 1)" ng-class="employee.grade === 1 ? \'active\' : \'inactive\'"></span> <span class="level-image level-2" ng-click="vd.connect(employee, 2)" ng-class="employee.grade === 2 ? \'active\' : \'inactive\'"></span> <span class="level-image level-3" ng-click="vd.connect(employee, 3)" ng-class="employee.grade === 3 ? \'active\' : \'inactive\'"></span></div></li><li ng-hide="vd.organisation.employees[3].length" class="text-center"><p>Aucun profil n\'a \xE9t\xE9 ajout\xE9 dans cette cat\xE9gorie.</p></li></ul></div></div><div uib-dropdown on-toggle="toggled(open)" class="square-wrapper"><div class="bottom-right" id="dropdown-toggle-4" uib-dropdown-toggle><div class="border"><a href class="focus-out" ng-click="vd.switchSquare(4)"><div class="outer-container"><img class="company-arrow" src="content/images/company-arrow.png" width="40"><p><span ng-hide="vd.organisation.type === \'company\'">Direction G\xE9n\xE9rale<br>des Services </span><span ng-show="vd.organisation.type === \'company\'">Autres<br>directions</span></p></div></a></div></div><div class="inner-container bottom-right" uib-dropdown-menu aria-labelledby="dropdown-toggle-4"><div class="list-header"><div class="count"><p><span>{{ vd.totalCount[4] }} membres</span></p></div><div class="title"><p><span ng-hide="vd.organisation.type === \'company\'">Direction G\xE9n\xE9rale<br>des Services </span><span ng-show="vd.organisation.type === \'company\'">Direction<br>Financi\xE8re</span></p></div></div><ul infinite-scroll-parent infinite-scroll="vd.loadPage(vd.page[4] + 1, 4)" infinite-scroll-disabled="!vd.hasNextPage[4]"><li ng-repeat="employee in vd.organisation.employees[4]"><img src="content/images/no-picture.png" width="30" class="img-circle"><p><a ui-sref="profile({id: employee.id, position : employee.currentPosition.id})" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.firstName + \' \' + employee.lastName | characters:20 }} <span ng-show="employee.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" style="color: #273C5C" title="Source : Base cliente Linkedin"></i></span></a><br><span class="title" title="{{ employee.firstName + \' \' + employee.lastName + \' : \' + employee.currentPosition.title}}">{{ employee.currentPosition.title | characters:20 }}</span></p><div class="connection-levels" ng-click="$event.stopPropagation()"><span class="level-image level-1" ng-click="vd.connect(employee, 1)" ng-class="employee.grade === 1 ? \'active\' : \'inactive\'"></span> <span class="level-image level-2" ng-click="vd.connect(employee, 2)" ng-class="employee.grade === 2 ? \'active\' : \'inactive\'"></span> <span class="level-image level-3" ng-click="vd.connect(employee, 3)" ng-class="employee.grade === 3 ? \'active\' : \'inactive\'"></span></div></li><li ng-hide="vd.organisation.employees[4].length" class="text-center"><p>Aucun profil n\'a \xE9t\xE9 ajout\xE9 dans cette cat\xE9gorie.</p></li></ul></div></div></div><div style="height: 39px"><button ng-show="vd.state.current.name == \'company-detail\' || vd.state.current.name == \'company-detail.quickconnect-new\'" type="button" ui-sref="company-detail.quickconnect-new({organisation: vd.organisation.name})" class="btn btn-primary quickconnect-btn"><i class="far fa-link"></i> <span class="hidden-xs hidden-sm">Quick Connect</span></button> <button ng-show="vd.state.current.name == \'collectivity-detail\' || vd.state.current.name == \'collectivity-detail.quickconnect-new\'" type="button" ui-sref="collectivity-detail.quickconnect-new({organisation: vd.organisation.name})" class="btn btn-primary quickconnect-btn"><i class="far fa-link"></i> <span class="hidden-xs hidden-sm">Quick Connect</span></button> <a ng-show="vd.state.current.name == \'company-detail\'" class="pull-right" ui-sref="company-detail.contribution.new-profile" title="Ajouter une personne" style="padding-top:4px"><i class="fal fa-user-plus" style="font-size: 24px"></i> </a><a ng-show="vd.state.current.name == \'collectivity-detail\'" class="pull-right" ui-sref="collectivity-detail.contribution.new-profile" title="Ajouter une personne" style="padding-top:4px"><i class="fal fa-user-plus" style="font-size: 24px"></i> </a><a ng-show="vd.state.current.name == \'profile\'" class="pull-right" ui-sref="profile.contribution.new-profile" title="Ajouter une personne" style="padding-top:4px"><i class="fal fa-user-plus" style="font-size: 24px"></i></a></div></div>');
$templateCache.put('app/director/sales-management/sales-management-activate-dialog.html','<form name="deleteForm" ng-submit="vm.confirmActivate(vm.user.email)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de d\xE9sactivation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir activer ce commercial de nouveau ? Celui-ci sera notifi\xE9 par e-mail.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-primary"><i class="fas fa-thumbs-up"></i>&nbsp;<span>Activer</span></button></div></form>');
$templateCache.put('app/director/sales-management/sales-management-desactivate-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDesactivate(vm.user.email)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de d\xE9sactivation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir d\xE9sactiver ce commercial ? Vous pourrez le r\xE9activer par la suite.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" class="btn btn-danger"><i class="fas fa-hand-pager"></i>&nbsp;<span>D\xE9sactiver</span></button></div></form>');
$templateCache.put('app/director/sales-management/sales-management.html','<style>.dashboard-credits{\n    min-height: 250px;\n    position: relative;\n    min-height: 1px;\n    padding-left: 15px;\n    padding-right:15px;\n    float: right;\n    width: 225px;\n    background-color: #273C5C;\n    color: white;\n    font-size: 18px;\n    padding-bottom: 0px;\n    margin-bottom: 10px;\n}\n\n.dashboard-business{\n    min-height: 250px;\n    position: relative;\n    min-height: 1px;\n    padding-left: 15px;\n    padding-right:15px;\n    float: right;\n    width: 225px;\n    background-color: white;\n    color: black;\n    font-size: 18px;\n}\n\n#sales-table td {\n    padding:4px;\n}</style><div class="col-md-9 well" style="margin-right: 10px;min-height: 534px"><h2>Mon \xE9quipe commerciale</h2><h4>{{vm.ec.name}}</h4><br><jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><button class="btn btn-primary" ui-sref="sales-management.new" style="background-color:#263B5C"><span class="glyphicon glyphicon-flash"></span> <span>Cr\xE9er un nouvel utilisateur</span></button> <a href="https://www.axenteev.com" target="_blank" class="btn btn-primary" style="background-color:#263B5C"><span class="glyphicon glyphicon-flash"></span> <span>Ajouter des cr\xE9dits</span></a></div></div><br><div id="sales-table" class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="text-align: center"><span>Utilisateur</span></th><th style="text-align: center"><span>Relations</span></th><!--\n                <th style="text-align: center;"><span>Note</span> </th>\n\n                <th style="text-align: center;"><span  style="white-space: nowrap;" title="Nombre de cr\xE9dits gagn\xE9s par le commercial">Cr\xE9dits collect\xE9s</span> </th>\n                --><!--\n                <th style="text-align: center;"><span>Classement</span></th>\n                --><th></th><th></th><th>Okta</th><th></th></tr></thead><tbody><tr ng-repeat="sale in vm.sales track by sale.user.id"><td style="vertical-align: middle"><span ng-style="sale.user.ecDg && {\'font-weight\': \'bold\', \'color\': \'black\'}">{{sale.user.firstName}} {{sale.user.lastName}}</span><br>({{sale.user.email}})</td><td style="text-align: right;vertical-align: middle">{{sale.nbConnexions}}</td><!--\n                <td style="text-align: right;vertical-align: middle;">{{sale.credits.notes}}</td>\n\n                <td style="text-align: right;vertical-align: middle;">{{sale.credits.creditsCount}}</td>\n                 --><!--\n                <td style="text-align: right;vertical-align: middle;">{{sale.credits.classement}}</td>\n                --><td></td><td style="vertical-align: middle"><span class="label label-danger" ng-show="!sale.user.activated">Desactiv\xE9</span> <span class="label label-success" ng-show="sale.user.activated">Activ\xE9</span></td><td style="vertical-align: middle"><span ng-show="!sale.user.oauth2" style="cursor: pointer">Non</span> <span ng-show="sale.user.oauth2" style="cursor: pointer">Oui</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sales-management-detail({email:sale.user.email})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="sales-management.edit({email:sale.user.email})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="sales-management.delete({email:sale.user.email})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.email==sale.user.email"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div><div class="well dashboard-credits"><div class="well-header" style="text-align: center">Dashboard</div><hr style="border-top: 1px solid white"><div><div class="row" style="padding-bottom: 18px"><div class="col-md-3"><span style="font-size: 32px" class="fa fa-users fa-fw" name="user"></span></div><div class="col-md-9"><b>{{vm.totalItems}}</b> <span style="font-size:18px">/{{vm.ec.maxUsers}}</span></div></div><div style="text-align:center">Commerciaux</div><hr style="border-top: 1px solid white"><div class="row" style="padding-bottom: 18px"><div class="col-md-3"><i class="fal fa-copyright fa-2x fa-fw" style="vertical-align: middle; margin-top: 14px"></i></div><div class="col-md-9"><b>{{vm.ec.credits - vm.ec.sumCreditCollectes}}</b> <span title="Nombre totale de cr\xE9dit allou\xE9s \xE0 l\'\xE9quipe - nombre de cr\xE9dits collect\xE9s par les commerciaux" style="font-size:18px">restants</span><br><b>{{vm.sumCreditCollectes}}</b> <span style="font-size:18px">distribu\xE9s</span></div></div><div style="text-align:center">Cr\xE9dits Entreprise</div><br></div></div><div class="well dashboard-business"><div class="well-header"></div><div style="text-align: center"><img width="85%" class="logo-img" src="content/images/logo-white.png"><br>Axenteev <span style="color:green">BUSINESS</span> <a href="https://www.axenteev.com" target="_blank" class="btn" style="color: black;border-color: black;margin-top:10px">Plus</a></div></div>');
$templateCache.put('app/entities/alert/alert-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.alert.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Alert?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/alert/alert-detail.html','<div><h2><span>Alert</span> {{vm.alert.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Seen</span></dt><dd><span>{{vm.alert.seen}}</span></dd><dt><span>Aud</span></dt><dd><span>{{vm.alert.aud}}</span></dd><dt><span>Type</span></dt><dd><span>{{vm.alert.type}}</span></dd><dt><span>Subscription</span></dt><dd><a ui-sref="subscription-detail({id:vm.alert.subscription.id})">{{vm.alert.subscription.id}}</a></dd><dt><span>User</span></dt><dd>{{vm.alert.user.id}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="alert-detail.edit({id:vm.alert.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/alert/alert-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAlertLabel">Create or edit a Alert</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.alert.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.alert.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_seen">Seen</label><input type="checkbox" class="form-control" name="seen" id="field_seen" ng-model="vm.alert.seen"><div ng-show="editForm.seen.$invalid"><p class="help-block" ng-show="editForm.seen.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_aud">Aud</label><input type="number" class="form-control" name="aud" id="field_aud" ng-model="vm.alert.aud"></div><div class="form-group"><label class="control-label" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.alert.type" id="field_type" required><option value="profile">profile</option><option value="organisation">organisation</option><option value="lastModification">lastModification</option><option value="connexion">connexion</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required">This field is required.</p></div></div><div class="form-group"><label for="field_subscription">Subscription</label><select class="form-control" id="field_subscription" name="subscription" ng-model="vm.alert.subscription" ng-options="subscription as subscription.id for subscription in vm.subscriptions track by subscription.id" required><option value=""></option></select></div><div ng-show="editForm.subscription.$invalid"><p class="help-block" ng-show="editForm.subscription.$error.required">This field is required.</p></div><div class="form-group"><label for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.alert.user" ng-options="user as user.id for user in vm.users track by user.id" required><option value=""></option></select></div><div ng-show="editForm.user.$invalid"><p class="help-block" ng-show="editForm.user.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/alert/alerts.html','<div><h2>Alerts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="alert.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Alert</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="seen"><span>Seen</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="aud"><span>Aud</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span>Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="subscription.id"><span>Subscription</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.id"><span>User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="alert in vm.alerts track by alert.id"><td><a ui-sref="alert-detail({id:alert.id})">{{alert.id}}</a></td><td>{{alert.seen}}</td><td>{{alert.aud}}</td><td>{{alert.type}}</td><td><a ui-sref="subscription-detail({id:alert.subscription.id})">{{alert.subscription.id}}</a></td><td>{{alert.user.id}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="alert-detail({id:alert.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="alert.edit({id:alert.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="alert.delete({id:alert.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/category-ranking/category-ranking-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.categoryRanking.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Category Ranking?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/category-ranking/category-ranking-detail.html','<div><h2><span>Category Ranking</span> {{vm.categoryRanking.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Matching Text</span></dt><dd><span>{{vm.categoryRanking.matchingText}}</span></dd><dt><span>Priority</span></dt><dd><span>{{vm.categoryRanking.priority}}</span></dd><dt><span>Profile Category</span></dt><dd><a ui-sref="profile-category-detail({id:vm.categoryRanking.profileCategory.id})">{{vm.categoryRanking.profileCategory.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="category-ranking-detail.edit({id:vm.categoryRanking.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/category-ranking/category-ranking-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCategoryRankingLabel">Create or edit a Category Ranking</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.categoryRanking.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.categoryRanking.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_matchingText">Matching Text</label><input type="text" class="form-control" name="matchingText" id="field_matchingText" ng-model="vm.categoryRanking.matchingText"></div><div class="form-group"><label class="control-label" for="field_priority">Priority</label><input type="number" class="form-control" name="priority" id="field_priority" ng-model="vm.categoryRanking.priority"></div><div class="form-group"><label for="field_profileCategory">Profile Category</label><select class="form-control" id="field_profileCategory" name="profileCategory" ng-model="vm.categoryRanking.profileCategory" ng-options="profileCategory as profileCategory.id for profileCategory in vm.profilecategories track by profileCategory.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/category-ranking/category-rankings.html','<div><h2>Category Rankings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="category-ranking.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Category Ranking</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Matching Text</span></th><th><span>Priority</span></th><th><span>Profile Category</span></th><th></th></tr></thead><tbody><tr ng-repeat="categoryRanking in vm.categoryRankings track by categoryRanking.id"><td><a ui-sref="category-ranking-detail({id:categoryRanking.id})">{{categoryRanking.id}}</a></td><td>{{categoryRanking.matchingText}}</td><td>{{categoryRanking.priority}}</td><td><a ui-sref="profile-category-detail({id:categoryRanking.profileCategory.id})">{{categoryRanking.profileCategory.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="category-ranking-detail({id:categoryRanking.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="category-ranking.edit({id:categoryRanking.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="category-ranking.delete({id:categoryRanking.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/city/cities.html','<div><h2>Villes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="city.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er une nouvelle ville</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="city in vm.cities track by city.id"><td><a ui-sref="city-detail({id:city.id})">{{city.id}}</a></td><td>{{city.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="city-detail({id:city.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="city.edit({id:city.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="city.delete({id:city.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/city/city-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.city.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette ville ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/city/city-detail.html','<div><h2><span>Ville</span> {{vm.city.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.city.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="city-detail.edit({id:vm.city.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/city/city-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel">Cr\xE9er ou modifier une ville</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.city.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.city.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.city.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/collectivity-size/collectivity-size-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.collectivitySize.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette taille de collectivit\xE9 ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/collectivity-size/collectivity-size-detail.html','<div><h2><span>Taille de collectivit\xE9</span> {{vm.collectivitySize.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.collectivitySize.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="collectivity-size-detail.edit({id:vm.collectivitySize.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/collectivity-size/collectivity-size-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCollectivitySizeLabel">Cr\xE9er ou modifier cette taille de collectivit\xE9</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.collectivitySize.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.collectivitySize.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.collectivitySize.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/collectivity-size/collectivity-sizes.html','<div><h2>Tailles des collectivit\xE9s</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="collectivity-size.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er une nouvelle taille de collectivit\xE9</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="collectivitySize in vm.collectivitySizes track by collectivitySize.id"><td><a ui-sref="collectivity-size-detail({id:collectivitySize.id})">{{collectivitySize.id}}</a></td><td>{{collectivitySize.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="collectivity-size-detail({id:collectivitySize.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="collectivity-size.edit({id:collectivitySize.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="collectivity-size.delete({id:collectivitySize.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/collectivity/collectivities.html','<div><h2>Collectivit\xE9s</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="collectivity.contribution.new-collectivity"><span class="glyphicon glyphicon-plus"></span> <span>Create new Collectivity</span></button></div></div></div><br><div class="text-center" style="min-height: 90px"><jhi-item-count ng-show="vm.totalItems>vm.itemsPerPage" page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-show="vm.totalItems>vm.itemsPerPage" class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="equipeCommerciale"><span>Equipe commerciale</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="collectivityTize.id"><span>Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city.id"><span>City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sector.id"><span>Sector</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="collectivitySize.id"><span>Collectivity Size</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="!vm.hasNextPage"><tr ng-repeat="collectivity in vm.collectivities track by collectivity.id"><td><a ui-sref="collectivity-detail({id:collectivity.id})">{{collectivity.id}}</a></td><td><span ng-show="collectivity.importId === \'linked\'" style="margin-right:4px"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin"></i> </span><span ng-show="collectivity.importId === \'guidep\'" style="margin-right:4px"><i class="fal fa-file-user" title="Source : Guide du pouvoir"></i> </span><span ng-show="collectivity.importId === \'datago\'" style="margin-right:4px"><i class="fal fa-book-open" title="Source : data.gouf.fr"></i> </span>{{collectivity.name}}</td><td><span *ngif="collectivity.equipeCommerciale">{{collectivity.equipeCommerciale.name}}</span></td><td><a ui-sref="collectivity-type-detail({id:collectivity.collectivityType.id})">{{collectivity.collectivityType.id}}</a></td><td><a ui-sref="city-detail({id:collectivity.city.id})">{{collectivity.city.id}}</a></td><td><a ui-sref="sector-detail({id:collectivity.sector.id})">{{collectivity.sector.id}}</a></td><td><a ui-sref="collectivity-size-detail({id:collectivity.collectivitySize.id})">{{collectivity.collectivitySize.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="collectivity-detail({id:collectivity.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="collectivity.contribution.edit({id:collectivity.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ng-click="vm.confirmMerge(collectivity.id)" class="btn btn-warning btn-sm"><span class="fas fa-copy"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="collectivity.delete({id:collectivity.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center" style="min-height: 90px"><jhi-item-count ng-show="vm.totalItems>vm.itemsPerPage" page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-show="vm.totalItems>vm.itemsPerPage" class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/collectivity/collectivity-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.collectivity.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Collectivity?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/collectivity/collectivity-detail.html','<div class="company-page-wrapper"><div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body col-xs-12"><!--\n                <div class="well company-top-buttons">\n                    <a ui-sref="collectivity-detail.contribution.new-collectivity" >\n                        <div class="add-job-well">\n                            <img class="button-logo" src="content/images/add-job.png">\n                            <div class="button-title">\n                                Ajouter une collectivit\xE9\n                            </div>\n                            <div class="company-logo"\n                                 ng-style="{\'background-image\': \'url(\\\'data:\' + vm.collectivity.logoContentType + \';base64,\' + vm.collectivity.logo }">\n                                <span class="transparent">.</span>\n                            </div>\n                        </div>\n                    </a>\n                    <a ui-sref="collectivity-detail.contribution.new-profile">\n                        <div class="add-people-well">\n                            <img class="button-logo" src="content/images/add-people.png">\n                            <div class="button-title">\n                                Ajouter une personne\n                            </div>\n                            <div class="company-logo"\n                                 ng-style="{\'background-image\': \'url(\\\'data:\' + vm.collectivity.logoContentType + \';base64,\' + vm.collectivity.logo }">\n                                <span class="transparent">.</span>\n                            </div>\n                        </div>\n                    </a>\n                </div>\n                --><organisation-squares organisation="vm.collectivity"></organisation-squares><organisation-network organisation="vm.collectivity"></organisation-network></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><div class="public-profile-card-container" style="min-height: 275px"><div class="public-profile-card well"><div class="square-picture" ng-show="vm.collectivity.logoContentType" style="background-image: url(\'data: {{ vm.collectivity.logoContentType }};base64,{{ vm.collectivity.logo }}\')"></div><div class="square-picture" ng-hide="vm.collectivity.logoContentType" style="background-image: url(\'content/images/no-picture-company.png\')"></div><div class="company-infos"><p class="organigramme">Organigramme</p><p class="number">{{vm.countProfilesForOrganisation}}</p><p class="quilinkee">Axenteevers</p><p class="number">{{vm.countAxenteeversForOrganisation}}</p></div><div class="company-description"><p class="name">Nom : {{ vm.collectivity.name }} <span ng-show="vm.collectivity.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin {{ vm.collectivity.equipeCommerciale? vm.collectivity.equipeCommerciale.name : \'\' }}"></i> </span><span ng-show="vm.collectivity.importId === \'guidep\'" style="margin-left:4px"><i class="fal fa-file-user" title="Source : Guide du pouvoir"></i> </span><span ng-show="vm.collectivity.importId === \'datago\'" style="margin-left:4px"><i class="fal fa-book-open" title="Source : data.gouf.fr"></i></span></p><p ng-show="vm.collectivity.collectivityType">Type : {{ vm.collectivity.collectivityType.name }}</p><p ng-hide="vm.collectivity.collectivityType">Type : <i>Type de la collectivit\xE9 inconnu</i></p><!--\n                                <p>\n                                    D\xE9partement/Ville : {{ vm.collectivity.city.name }}\n\n                                </p>\n                                --><p ng-show="vm.website" style="line-break: anywhere"><i class="fal fa-globe fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i> <a href="{{ vm.website }}" style="color:white" target="_blank">{{ vm.website }}</a></p><!--\n                                <p ng-show="vm.collectivity.citizens">\n                                    Nombre habitants : {{ vm.collectivity.citizens }}\n                                </p>\n                                <p ng-hide="vm.collectivity.citizens">\n                                    Nombre habitants : <i>Nombre d\'habitants inconnu</i>\n                                </p>\n                                --><p ng-show="vm.collectivity.collectivitySize">Taille : {{ vm.collectivity.collectivitySize.name }} habitants</p><p ng-hide="vm.collectivity.collectivitySize">Taille : <i>Taille de la collectivit\xE9 inconnu</i></p><p class="description">{{ vm.collectivity.description }}</p></div><style>.buttonEdit{\n                                    color: white;\n                                    margin-right: 6px;\n                                    margin-bottom: -12px;\n                                }\n                                .buttonEditDisabled {\n                                    opacity: 0.3;\n                                    cursor: not-allowed;\n                                }</style><a ng-show="!vm.collectivity.hasModeration  && (vm.isAdmin() || vm.collectivity.mine || vm.collectivity.myContribution)" class="float-right buttonEdit" ui-sref="collectivity-detail.contribution.edit-collectivity({collectivity: vm.collectivity})"><i class="fal fa-edit fa-2x"></i></a> <a ng-show="vm.collectivity.hasModeration" title="Modification impossible car cette collectivit\xE9 est en cours de mod\xE9ration" class="float-right buttonEdit buttonEditDisabled"><i class="fal fa-edit fa-2x"></i></a></div></div><div class="right-addon-container hidden-xs hidden-sm" style="padding-left: 3px;  padding-right: 10px"><div ng-show="vm.collectivity.hasModeration" class="alert alert-warning"><i>Cette collectivit\xE9 est en cours de mod\xE9ration.</i></div></div><copyright-addon></copyright-addon></div></div></div></div></div>');
$templateCache.put('app/entities/collectivity/collectivity-dialog.html','<style>.kv-avatar .krajee-default.file-preview-frame,\n    .kv-avatar .krajee-default.file-preview-frame:hover {\n        margin: 0;\n        padding: 0;\n        border: none;\n        box-shadow: none;\n        text-align: center;\n    }\n\n    .kv-avatar {\n        display: inline-block;\n    }\n\n    .file-preview {\n        border-radius: 5px;\n        border: 1px solid #ddd;\n        padding: 8px;\n        width: 100%;\n        margin-bottom: 5px;\n    }\n\n    .file-drop-zone {\n        border: 1px dashed #aaa;\n        border-radius: 4px;\n        height: 100%;\n        text-align: center;\n        vertical-align: middle;\n        margin: 12px 15px 12px 12px;\n        padding: 5px;\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-8"><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_name">Nom <span class="required">*</span></label><input type="text" class="form-control" name="name" id="field_name" ng-disabled="vm.collectivity.id && !vm.isAdmin" ng-model="vm.collectivity.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis</p></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea rows="4" class="form-control" name="description" id="field_description" ng-model="vm.collectivity.description"></textarea></div></div></div></div><div class="col-md-4"><div class="col-sm-4 text-center"><div class="col-sm-4 text-center"><div class="kv-avatar"><div class="file-input file-input-ajax-new"><div class="file-preview"><div class="file-drop-zone"><div class="file-preview-thumbnails"><div class="file-default-preview" style="cursor: pointer"><img ngf-select ngf-change="vm.setLogo($file, vm.collectivity)" accept="image/*" data-ng-src="{{\'data:\' + vm.collectivity.logoContentType + \';base64,\' + vm.collectivity.logo}}" style="max-width: 160px" ng-if="vm.collectivity.logo"> <img ngf-select ngf-change="vm.setLogo($file, vm.collectivity)" accept="image/*" width="160px" src="content/images/no-picture-company.png" alt="Logo" ng-if="!vm.collectivity.logo"></div></div><div class="clearfix"></div><div class="file-preview-status text-center text-success"></div></div><input type="hidden" class="form-control" name="logo" id="field_picture" ng-model="vm.collectivity.logo" maxbytes="5000000"> <input type="hidden" class="form-control" name="logoContentType" id="field_logoContentType" ng-model="vm.collectivity.logoContentType"><div ng-if="vm.collectivity.logo" class="help-block clearfix" style="padding-left: 13px; padding-right: 17px; vertical-align: middle"><div ng-show="editForm.logo.$invalid"><p class="help-block" ng-show="editForm.logo.$error.maxbytes">La taille de l\'image ne doit pas d\xE9passer 5MB.</p></div><span class="pull-left">{{vm.collectivity.logoContentType}}, {{vm.byteSize(vm.collectivity.logo)}}</span> <button type="button" ng-click="vm.collectivity.logo=null;vm.collectivity.logoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="field_collectivitySize">Type de la collectivit\xE9 <span class="required">*</span></label><select class="form-control" id="field_collectivityType" name="collectivityType" ng-model="vm.collectivity.collectivityType" ng-options="collectivityType as collectivityType.name for collectivityType in vm.collectivityTypes track by collectivityType.id" required><option value=""></option></select></div></div><!--\n        <div class="col-md-12">\n            <div class="form-group">\n                <label for="field_city">Ville<span class="required">*</span></label>\n                <input id="field_city" name="city" type="text" ng-model="vm.collectivity.city" autocomplete="off" uib-typeahead="city as city.name for city in vm.getCities($viewValue)" typeahead-no-results="vm.citiesNoResults" class="form-control typeahead-input" />\n                <div class="search-no-results well" ng-show="vm.citiesNoResults">\n                    Aucun r\xE9sultat\n                </div>\n\n            </div>\n        </div>\n        --><div class="col-md-12"><div class="form-group"><label for="field_collectivitySize">Taille de la collectivit\xE9</label><select class="form-control" id="field_collectivitySize" name="collectivitySize" ng-model="vm.collectivity.collectivitySize" ng-options="collectivitySize as collectivitySize.name for collectivitySize in vm.collectivitysizes track by collectivitySize.id"><option value=""></option></select></div></div><!--\n        <div class="col-md-12">\n            <div class="form-group">\n                <label for="field_citizens">Nombre d\'habitants</label>\n                <input class="form-control" id="field_citizens" id="citizens" name="citizens" type="number" ng-model="vm.collectivity.citizens"/>\n            </div>\n        </div>\n        --><div class="col-md-12"><div class="form-group"><label for="field_website">Site web</label><input class="form-control" id="field_website" id="country" name="website" type="texts" ng-model="vm.collectivity.website"></div></div></div><div class="modal-footer" ng-show="vm.isAdmin || vm.collectivity.myContribution"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button ng-show="!vm.collectivity.hasModeration" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button> <button ng-show="vm.collectivity.hasModeration" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Modifer et accepter</span></button> <button type="button" class="btn btn-danger pull-left" data-dismiss="modal" ng-click="vm.deleteOrganisation()"><span class="fal fa-minus-circle"></span>&nbsp;<span>Supprimer</span></button></div><div class="modal-footer" ng-show="!vm.isAdmin && !vm.collectivity.myContribution"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button ng-show="!vm.collectivity.importId || vm.collectivity.importId === \'linked\'" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/collectivity-type/collectivity-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.collectivityType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce type de collectivit\xE9 ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/collectivity-type/collectivity-type-detail.html','<div><h2><span>Type de collectivit\xE9</span> {{vm.collectivityType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.collectivityType.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="collectivity-type-detail.edit({id:vm.collectivityType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/collectivity-type/collectivity-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCollectivityTypeLabel">Cr\xE9er ou modifier ce type de collectivit\xE9</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.collectivityType.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.collectivityType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.collectivityType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/collectivity-type/collectivity-types.html','<div><h2>Types des collectivit\xE9s</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="collectivity-type.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er un nouveau type de collectivit\xE9</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="collectivityType in vm.collectivityTypes track by collectivityType.id"><td><a ui-sref="collectivity-type-detail({id:collectivityType.id})">{{collectivityType.id}}</a></td><td>{{collectivityType.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="collectivity-type-detail({id:collectivityType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="collectivity-type.edit({id:collectivityType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="collectivity-type.delete({id:collectivityType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/company/companies.html','<div><h2>Entreprises</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="company.contribution.new-company"><span class="glyphicon glyphicon-plus"></span> <span>Create new Company</span></button></div></div></div><br><div class="text-center" style="min-height: 90px"><jhi-item-count ng-show="vm.totalItems>vm.itemsPerPage" page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-show="vm.totalItems>vm.itemsPerPage" class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="equipeCommerciale"><span>Equipe commerciale</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="logo"><span>Logo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="companyStatus.id"><span>Company Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sector.id"><span>Sector</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="!vm.hasNextPage"><tr ng-repeat="company in vm.companies track by company.id"><td><a ui-sref="company-detail({id:company.id})">{{company.id}}</a></td><td><span ng-show="company.importId === \'linked\'" style="margin-right:4px"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin"></i> </span><span ng-show="company.importId === \'guidep\'" style="margin-right:4px"><i class="fal fa-file-user" title="Source : Guide du pouvoir"></i> </span><span ng-show="company.importId === \'datago\'" style="margin-right:4px"><i class="fal fa-book-open" title="Source : data.gouf.fr"></i> </span><span ng-show="company.importId && company.importId !== \'linked\'" style="margin-left:4px"><i class="fal fa-file-check" title="Source : The Official Board"></i> </span>{{company.name}}</td><td><span *ngif="company.equipeCommerciale">{{company.equipeCommerciale.name}}</span></td><td><a ng-if="company.logo" ng-click="vm.openFile(company.logoContentType, company.logo)"><img data-ng-src="{{\'data:\' + company.logoContentType + \';base64,\' + company.logo}}" style="max-height: 30px"> </a><span ng-if="company.logo">{{company.logoContentType}}, {{vm.byteSize(company.logo)}}</span></td><td><a ui-sref="company-status-detail({id:company.companyStatus.id})">{{company.companyStatus.id}}</a></td><td><a ui-sref="sector-detail({id:company.sector.id})">{{company.sector.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="company-detail({id:company.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="company.contribution.edit({id:company.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ng-click="vm.confirmMerge(company.id)" class="btn btn-warning btn-sm"><span class="fas fa-copy"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="company.delete({id:company.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center" style="min-height: 90px"><jhi-item-count ng-show="vm.totalItems>vm.itemsPerPage" page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination ng-show="vm.totalItems>vm.itemsPerPage" class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/company/company-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.company.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Company?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/company/company-detail.html','<div class="company-page-wrapper"><div class="container padding15"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body col-xs-12"><div cg-busy="{promise:profileCardBusyPromise,wrapperClass:\'\', templateUrl: \'cgbusy-medium.html\', minDuration:200}" style="position:relative;width: 100%;height: 100%"></div><div ng-hide="vm.hideProfileCard"><!--\n                    <div class="well company-top-buttons" ng-show="vm.organisation">\n                        <a ui-sref="profile.contribution.new-company" >\n                            <div class="add-job-well">\n                                <img class="button-logo" src="content/images/add-job.png">\n                                <div class="button-title">\n                                    Ajouter une entreprise\n                                </div>\n                                <div class="company-logo"\n                                     ng-style="{\'background-image\': \'url(\\\'data:\' + vm.organisation.logoContentType + \';base64,\' + vm.organisation.logo }">\n                                    <span class="transparent">.</span>\n                                </div>\n                            </div>\n                        </a>\n                        <a ui-sref="profile.contribution.new-profile">\n                            <div class="add-people-well">\n                                <img class="button-logo" src="content/images/add-people.png">\n                                <div class="button-title">\n                                    Ajouter une personne\n                                </div>\n                                <div class="company-logo"\n                                     ng-style="{\'background-image\': \'url(\\\'data:\' + vm.organisation.logoContentType + \';base64,\' + vm.organisation.logo }">\n                                    <span class="transparent">.</span>\n                                </div>\n                            </div>\n                        </a>\n                    </div>\n                    --><organisation-squares organisation="vm.company"></organisation-squares><organisation-network organisation="vm.company"></organisation-network></div></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><div class="public-profile-card-container" style="min-height: 275px"><div class="public-profile-card well"><div class="square-picture" ng-show="vm.company.logoContentType" style="background-image: url(\'data: {{ vm.company.logoContentType }};base64,{{ vm.company.logo }}\')"></div><div class="square-picture" ng-hide="vm.company.logoContentType" style="background-image: url(\'content/images/no-picture-company.png\')"></div><div class="company-infos"><p class="organigramme">Organigramme</p><p class="number">{{vm.countProfilesForOrganisation}}</p><p class="quilinkee">Axenteevers</p><p class="number">{{vm.countAxenteeversForOrganisation}}</p></div><div class="company-description"><p class="name">Nom : {{ vm.company.name }} <span ng-show="vm.company.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin {{ vm.company.equipeCommerciale? vm.company.equipeCommerciale.name : \'\' }}"></i> </span><span ng-show="vm.company.importId && vm.company.importId !== \'linked\'" style="margin-left:4px"><i class="fal fa-file-check" title="Source : The Official Board"></i></span></p><p ng-show="vm.company.holding">Holding : {{ vm.company.holding.name }}</p><p ng-show="vm.company.selfHolding">Holding : {{ vm.company.name }}</p><p ng-hide="vm.company.holding || vm.company.selfHolding">Holding : <i>Holding inconnu</i></p><p ng-show="vm.company.country">Pays : {{ vm.company.country }}</p><p ng-hide="vm.company.country">Pays : <i>Pays inconnu</i></p><p ng-show="vm.company.sector">Secteur : {{ vm.company.sector.name }}</p><p ng-hide="vm.company.sector">Secteur : <i>Secteur inconnu</i></p><p class="description">{{ vm.company.description }}</p><p ng-show="vm.website" style="line-break: anywhere"><i class="fal fa-globe fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i> <a href="{{ vm.website }}" style="color:white" target="_blank">{{ vm.website }}</a></p></div><style>.buttonEdit{\n                                    color: white;\n                                    margin-right: 6px;\n                                    margin-bottom: -12px;\n                                }\n                                .buttonEditDisabled {\n                                    opacity: 0.3;\n                                    cursor: not-allowed;\n                                }</style><a ng-show="!vm.company.hasModeration  && (vm.isAdmin() || vm.company.mine || vm.company.myContribution)" class="float-right buttonEdit" ui-sref="company-detail.contribution.edit-company({company: vm.company})"><i class="fal fa-edit fa-2x"></i></a> <a ng-show="vm.company.hasModeration" title="Modification impossible car cette soci\xE9t\xE9 est en cours de mod\xE9ration" class="float-right buttonEdit buttonEditDisabled"><i class="fal fa-edit fa-2x"></i></a></div></div><div class="right-addon-container hidden-xs hidden-sm" style="padding-left: 3px;  padding-right: 10px"><div ng-show="vm.company.hasModeration" class="alert alert-warning"><i>Cette soci\xE9t\xE9 est en cours de mod\xE9ration.</i></div></div><copyright-addon></copyright-addon></div></div></div></div></div>');
$templateCache.put('app/entities/company/company-dialog.html','<style>.kv-avatar .krajee-default.file-preview-frame,.kv-avatar .krajee-default.file-preview-frame:hover {\n        margin: 0;\n        padding: 0;\n        border: none;\n        box-shadow: none;\n        text-align: center;\n    }\n    .kv-avatar {\n        display: inline-block;\n    }\n    .file-preview {\n        border-radius: 5px;\n        border: 1px solid #ddd;\n        padding: 8px;\n        width: 100%;\n        margin-bottom: 5px;\n    }\n    .file-drop-zone {\n        border: 1px dashed #aaa;\n        border-radius: 4px;\n        height: 100%;\n        text-align: center;\n        vertical-align: middle;\n        margin: 12px 15px 12px 12px;\n        padding: 5px;\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-8"><div class="row"><div class="col-md-5"><div class="form-group"><label class="control-label" for="field_name">Nom <span class="required">*</span></label><input type="text" class="form-control" name="name" id="field_name" ng-disabled="vm.company.id && !vm.isAdmin" ng-model="vm.company.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis</p></div></div></div><div class="col-md-7"><div class="form-group"><label class="control-label" for="field_description">Holding <span class="small">(NB: Si la holding n\'existe pas dans la base, pensez \xE0 la cr\xE9er)</span></label><input id="field_holding" name="holding" type="text" ng-model="vm.company.holding" autocomplete="off" uib-typeahead="company as company.name for company in vm.getCompanies($viewValue)" typeahead-no-results="vm.companiesNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.companiesNoResults">Aucun r\xE9sultat</div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea rows="4" class="form-control" name="description" id="field_description" ng-model="vm.company.description"></textarea></div></div></div></div><div class="col-md-4"><div class="col-sm-4 text-center"><div class="col-sm-4 text-center"><div class="kv-avatar"><div class="file-input file-input-ajax-new"><div class="file-preview"><div class="file-drop-zone"><div class="file-preview-thumbnails"><div class="file-default-preview" style="cursor: pointer"><img ngf-select ngf-change="vm.setLogo($file, vm.company)" accept="image/*" data-ng-src="{{\'data:\' + vm.company.logoContentType + \';base64,\' + vm.company.logo}}" style="max-width: 160px" ng-if="vm.company.logo"> <img ngf-select ngf-change="vm.setLogo($file, vm.company)" accept="image/*" width="160px" src="content/images/no-picture-company.png" alt="Logo" ng-if="!vm.company.logo"></div></div><div class="clearfix"></div><div class="file-preview-status text-center text-success"></div></div><input type="hidden" class="form-control" name="logo" id="field_picture" ng-model="vm.company.logo" maxbytes="5000000"> <input type="hidden" class="form-control" name="logoContentType" id="field_logoContentType" ng-model="vm.company.logoContentType"><div ng-if="vm.company.logo" class="help-block clearfix" style="padding-left: 13px; padding-right: 17px; vertical-align: middle"><div ng-show="editForm.logo.$invalid"><p class="help-block" ng-show="editForm.logo.$error.maxbytes">La taille de l\'image ne doit pas d\xE9passer 5MB.</p></div><span class="pull-left">{{vm.company.logoContentType}}, {{vm.byteSize(vm.company.logo)}}</span> <button type="button" ng-click="vm.company.logo=null;vm.company.logoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="field_companyStatus">Cat\xE9gorie<span class="required">*</span></label><select class="form-control" id="field_companyStatus" name="companyStatus" ng-model="vm.company.companyStatus" ng-options="companyStatus as companyStatus.name for companyStatus in vm.companystatuses track by companyStatus.id" required><option value=""></option></select></div></div><div class="col-md-12"><div class="form-group"><label for="field_sector">Secteur d\'activit\xE9<span class="required">*</span></label><select class="form-control" id="field_sector" name="sector" ng-model="vm.company.sector" ng-options="sector as sector.name for sector in vm.sectors track by sector.id" required><option value=""></option></select></div></div><div class="col-md-12"><div class="form-group"><label for="field_country">Pays</label><input class="form-control" id="field_country" id="country" name="country" type="text" ng-model="vm.company.country"></div></div><div class="col-md-12"><div class="form-group"><label for="field_website">Site web</label><input class="form-control" id="field_website" id="country" name="website" type="texts" ng-model="vm.company.website"></div></div></div><div class="modal-footer" ng-show="vm.isAdmin || vm.company.myContribution"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button ng-show="!vm.company.hasModeration" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button> <button ng-show="vm.company.hasModeration" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Modifer et accepter</span></button> <button type="button" class="btn btn-danger pull-left" data-dismiss="modal" ng-click="vm.deleteOrganisation()"><span class="fal fa-minus-circle"></span>&nbsp;<span>Supprimer</span></button></div><div class="modal-footer" ng-show="!vm.isAdmin && !vm.company.myContribution"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button ng-show="!vm.company.importId || vm.company.importId === \'linked\'" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/company-status/company-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.companyStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce statut d\'entreprise ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/company-status/company-status-detail.html','<div><h2><span>Statut d\'entreprise</span> {{vm.companyStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.companyStatus.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="company-status-detail.edit({id:vm.companyStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/company-status/company-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCompanyStatusLabel">Cr\xE9er ou modifier ce statut d\'entreprise</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.companyStatus.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.companyStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.companyStatus.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/company-status/company-statuses.html','<div><h2>Statuts entreprises</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="company-status.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er un nouveau statut entreprise</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="companyStatus in vm.companyStatuses track by companyStatus.id"><td><a ui-sref="company-status-detail({id:companyStatus.id})">{{companyStatus.id}}</a></td><td>{{companyStatus.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="company-status-detail({id:companyStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="company-status.edit({id:companyStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="company-status.delete({id:companyStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/contribution/contribution-dialog.html','<div class="modal-header" ng-show="!vm.edit"><div class="row"><div class="col-md-3"><h4 class="modal-title" id="contributionLabel">Cr\xE9er</h4><!--\n            <h4 ng-show="!vm.isAdmin()" class="modal-title" id="contributionLabel">Demande de cr\xE9ation</h4>\n            --></div><div class="col-md-9"><select ng-disabled="!vm.multiple" class="form-control" id="contribution" ng-model="vm.selectedContribution" ng-change="vm.change()" ng-options="opt.value as opt.label for opt in options"></select></div></div></div><div class="modal-header" ng-show="vm.edit"><div class="row"><div class="col-md-4"><!--\n            <h4 ng-show="!vm.isAdmin()" class="modal-title" id="contributionLabel">Demande de modification</h4>\n            --><h4 class="modal-title" id="contributionLabel">Modifier</h4></div></div></div><div class="modal-body"><div ui-view="contrib"></div></div>');
$templateCache.put('app/entities/connexion/connexion-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.connexion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Connexion?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/connexion/connexion-detail.html','<div><h2><span>Connexion</span> {{vm.connexion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Grade</span></dt><dd><span>{{vm.connexion.grade}}</span></dd><dt><span>Creator</span></dt><dd><a ui-sref="profile-detail({id:vm.connexion.creator.id})">{{vm.connexion.creator.id}}</a></dd><dt><span>Target</span></dt><dd><a ui-sref="profile-detail({id:vm.connexion.target.id})">{{vm.connexion.target.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="connexion-detail.edit({id:vm.connexion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/connexion/connexion-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConnexionLabel">Create or edit a Connexion</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.connexion.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.connexion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_grade">Grade</label><input type="number" class="form-control" name="grade" id="field_grade" ng-model="vm.connexion.grade" required min="1" max="3"><div ng-show="editForm.grade.$invalid"><p class="help-block" ng-show="editForm.grade.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.grade.$error.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.grade.$error.max">This field cannot be more than 3.</p><p class="help-block" ng-show="editForm.grade.$error.number">This field should be a number.</p></div></div><div class="form-group"><label for="field_creator">Creator</label><select class="form-control" id="field_creator" name="creator" ng-model="vm.connexion.creator" ng-options="profile as profile.id for profile in vm.profiles track by profile.id" required><option value=""></option></select></div><div ng-show="editForm.creator.$invalid"><p class="help-block" ng-show="editForm.creator.$error.required">This field is required.</p></div><div class="form-group"><label for="field_target">Target</label><select class="form-control" id="field_target" name="target" ng-model="vm.connexion.target" ng-options="profile as profile.id for profile in vm.profiles track by profile.id" required><option value=""></option></select></div><div ng-show="editForm.target.$invalid"><p class="help-block" ng-show="editForm.target.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/connexion/connexions.html','<div><h2>Connexions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="connexion.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Connexion</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Grade</span></th><th><span>Creator</span></th><th><span>Target</span></th><th></th></tr></thead><tbody><tr ng-repeat="connexion in vm.connexions track by connexion.id"><td><a ui-sref="connexion-detail({id:connexion.id})">{{connexion.id}}</a></td><td>{{connexion.grade}}</td><td><a ui-sref="profile-detail({id:connexion.creator.id})">{{connexion.creator.id}}</a></td><td><a ui-sref="profile-detail({id:connexion.target.id})">{{connexion.target.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="connexion-detail({id:connexion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="connexion.edit({id:connexion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="connexion.delete({id:connexion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/deal/deal-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.deal.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Deal?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/deal/deal-detail.html','<div><h2><span>Deal</span> {{vm.deal.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Amount</span></dt><dd><span>{{vm.deal.amount}}</span></dd><dt><span>Commission</span></dt><dd><span>{{vm.deal.commission}}</span></dd><dt><span>Dg</span></dt><dd>{{vm.deal.dg.id}}</dd><dt><span>Consultant</span></dt><dd>{{vm.deal.consultant.id}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="deal-detail.edit({id:vm.deal.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/deal/deal-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDealLabel">Create or edit a Deal</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.deal.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.deal.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.deal.amount" required min="0"><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.amount.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_commission">Commission</label><input type="number" class="form-control" name="commission" id="field_commission" ng-model="vm.deal.commission" required min="0"><div ng-show="editForm.commission.$invalid"><p class="help-block" ng-show="editForm.commission.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.commission.$error.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.commission.$error.number">This field should be a number.</p></div></div><div class="form-group"><label for="field_dg">Dg</label><select class="form-control" id="field_dg" name="dg" ng-model="vm.deal.dg" ng-options="user as user.id for user in vm.users track by user.id" required><option value=""></option></select></div><div ng-show="editForm.dg.$invalid"><p class="help-block" ng-show="editForm.dg.$error.required">This field is required.</p></div><div class="form-group"><label for="field_consultant">Consultant</label><select class="form-control" id="field_consultant" name="consultant" ng-model="vm.deal.consultant" ng-options="user as user.id for user in vm.users track by user.id" required><option value=""></option></select></div><div ng-show="editForm.consultant.$invalid"><p class="help-block" ng-show="editForm.consultant.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/deal/deals.html','<div><h2>Deals</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="deal.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Deal</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span>Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commission"><span>Commission</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dg.id"><span>Dg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="consultant.id"><span>Consultant</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="deal in vm.deals track by deal.id"><td><a ui-sref="deal-detail({id:deal.id})">{{deal.id}}</a></td><td>{{deal.amount}}</td><td>{{deal.commission}}</td><td>{{deal.dg.id}}</td><td>{{deal.consultant.id}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="deal-detail({id:deal.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="deal.edit({id:deal.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="deal.delete({id:deal.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/degree/degree-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.degree.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce dipl\xF4me ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/degree/degree-detail.html','<div><h2><span>Dipl\xF4me</span> {{vm.degree.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.degree.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="degree-detail.edit({id:vm.degree.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/degree/degree-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDegreeLabel">Cr\xE9er ou modifier un dipl\xF4me</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.degree.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.degree.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.degree.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/degree/degrees.html','<div><h2>Dipl\xF4mes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="degree.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er un nouveau dipl\xF4me</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="degree in vm.degrees track by degree.id"><td><a ui-sref="degree-detail({id:degree.id})">{{degree.id}}</a></td><td>{{degree.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="degree-detail({id:degree.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="degree.edit({id:degree.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="degree.delete({id:degree.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/delete-profile-request/delete-profile-request-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.deleteProfileRequest.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette demande de suppression de profil ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/delete-profile-request/delete-profile-request-detail.html','<div><h2><span>Demande de suppression de profil</span> {{vm.deleteProfileRequest.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.deleteProfileRequest.lastName}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span>Pr\xE9nom</span></dt><dd><span>{{vm.deleteProfileRequest.firstName}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span>Email</span></dt><dd><span>{{vm.deleteProfileRequest.email}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="delete-profile-request-detail.edit({id:vm.deleteProfileRequest.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/delete-profile-request/delete-profile-request-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTitleLabel">Cr\xE9er ou modifier un titre professionnel</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.deleteProfileRequest.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.deleteProfileRequest.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_lastName">Nom</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.deleteProfileRequest.lastName" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required">Ce champ est requis.</p></div></div><div class="form-group"><label class="control-label" for="field_firstName">Pr\xE9nom</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.deleteProfileRequest.firstName" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required">Ce champ est requis.</p></div></div><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.deleteProfileRequest.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/delete-profile-request/delete-profile-request.html','<div><h2>Demandes de suppression de profil</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="delete-profile-request.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er une demande de suppression de profile</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Pr\xE9nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span>Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="deleteProfileRequest in vm.deleteProfileRequests track by deleteProfileRequest.id"><td><a ui-sref="delete-profile-request-detail({id:deleteProfileRequest.id})">{{deleteProfileRequest.id}}</a></td><td>{{deleteProfileRequest.lastName}}</td><td>{{deleteProfileRequest.firstName}}</td><td>{{deleteProfileRequest.email}}</td><td>{{deleteProfileRequest.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="delete-profile-request-detail({id:deleteProfileRequest.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="delete-profile-request.edit({id:deleteProfileRequest.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="delete-profile-request.delete({id:deleteProfileRequest.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/department/department-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.department.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce d\xE9partement ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/department/department-detail.html','<div><h2><span>D\xE9partement</span> {{vm.department.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.department.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="department-detail.edit({id:vm.department.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/department/department-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDepartmentLabel">Cr\xE9er ou modifier un d\xE9partement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.department.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.department.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.department.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/department/departments.html','<div><h2>D\xE9partements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="department.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er un nouveau d\xE9partement</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="department in vm.departments track by department.id"><td><a ui-sref="department-detail({id:department.id})">{{department.id}}</a></td><td>{{department.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="department-detail({id:department.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="department.edit({id:department.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="department.delete({id:department.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/discussion/discussion-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.discussion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Discussion?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/discussion/discussion-detail.html','<div><h2><span>Discussion</span> {{vm.discussion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Title</span></dt><dd><span>{{vm.discussion.title}}</span></dd><dt><span>Closed</span></dt><dd><span>{{vm.discussion.closed}}</span></dd><dt><span>Admin</span></dt><dd><span>{{vm.discussion.admin}}</span></dd><dt><span>Member</span></dt><dd><span ng-repeat="member in vm.discussion.members">{{member.}}{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="discussion-detail.edit({id:vm.discussion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/discussion/discussion-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiscussionLabel">Create or edit a Discussion</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.discussion.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.discussion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.discussion.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_closed">Closed</label><input type="checkbox" class="form-control" name="closed" id="field_closed" ng-model="vm.discussion.closed"><div ng-show="editForm.closed.$invalid"><p class="help-block" ng-show="editForm.closed.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_admin">Admin</label><input type="checkbox" class="form-control" name="admin" id="field_admin" ng-model="vm.discussion.admin"><div ng-show="editForm.admin.$invalid"><p class="help-block" ng-show="editForm.admin.$error.required">This field is required.</p></div></div><div class="form-group"><label for="field_member">Member</label><select class="form-control" id="field_member" multiple="multiple" name="member" ng-model="vm.discussion.members" ng-options="user as user. for user in vm.users track by user.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/discussion/discussions.html','<div><h2>Discussions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="discussion.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Discussion</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Title</span></th><th><span>Closed</span></th><th><span>Admin</span></th><th><span>Member</span></th><th></th></tr></thead><tbody><tr ng-repeat="discussion in vm.discussions track by discussion.id"><td><a ui-sref="discussion-detail({id:discussion.id})">{{discussion.id}}</a></td><td>{{discussion.title}}</td><td>{{discussion.closed}}</td><td>{{discussion.admin}}</td><td><span ng-repeat="member in discussion.members">{{member.}}{{$last ? \'\' : \', \'}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="discussion-detail({id:discussion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="discussion.edit({id:discussion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="discussion.delete({id:discussion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/division/division-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.division.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette division ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/division/division-detail.html','<div><h2><span>Division</span> {{vm.division.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.division.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="division-detail.edit({id:vm.division.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/division/division-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDivisionLabel">Cr\xE9er ou modifier une division</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.division.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.division.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.division.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/division/divisions.html','<div><h2>Divisions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="division.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er une nouvelle division</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="division in vm.divisions track by division.id"><td><a ui-sref="division-detail({id:division.id})">{{division.id}}</a></td><td>{{division.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="division-detail({id:division.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="division.edit({id:division.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="division.delete({id:division.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/education/education-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.education.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Education?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/education/education-detail.html','<div><h2><span>Education</span> {{vm.education.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Start Date</span></dt><dd><span>{{vm.education.startDate}}</span></dd><dt><span>End Date</span></dt><dd><span>{{vm.education.endDate}}</span></dd><dt><span>Degree</span></dt><dd><span>{{vm.education.degree}}</span></dd><dt><span>Establishment</span></dt><dd><a ui-sref="establishment-detail({id:vm.education.establishment.id})">{{vm.education.establishment.id}}</a></dd><dt><span>Profile</span></dt><dd><a ui-sref="profile-detail({id:vm.education.profile.id})">{{vm.education.profile.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="education-detail.edit({id:vm.education.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/education/education-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEducationLabel">Create or edit a Education</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.education.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.education.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><input type="number" class="form-control" name="startDate" id="field_startDate" ng-model="vm.education.startDate" min="1920" max="2100"><div ng-show="editForm.startDate.$invalid"><p class="help-block" ng-show="editForm.startDate.$error.min" translate-value-min="1920">This field should be more than 1920.</p><p class="help-block" ng-show="editForm.startDate.$error.max">This field cannot be more than 2100.</p><p class="help-block" ng-show="editForm.startDate.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_endDate">End Date</label><input type="number" class="form-control" name="endDate" id="field_endDate" ng-model="vm.education.endDate" min="1920" max="2100"><div ng-show="editForm.endDate.$invalid"><p class="help-block" ng-show="editForm.endDate.$error.min" translate-value-min="1920">This field should be more than 1920.</p><p class="help-block" ng-show="editForm.endDate.$error.max">This field cannot be more than 2100.</p><p class="help-block" ng-show="editForm.endDate.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_degree">Degree</label><input type="text" class="form-control" name="degree" id="field_degree" ng-model="vm.education.degree"></div><div class="form-group"><label for="field_establishment">Establishment</label><select class="form-control" id="field_establishment" name="establishment" ng-model="vm.education.establishment" ng-options="establishment as establishment.id for establishment in vm.establishments track by establishment.id"><option value=""></option></select></div><div class="form-group"><label for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.education.profile" ng-options="profile as profile.id for profile in vm.profiles track by profile.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/education/educations.html','<div><h2>Educations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="education.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Education</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate"><span>Start Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endDate"><span>End Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="degree"><span>Degree</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="establishment.id"><span>Establishment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span>Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="education in vm.educations track by education.id"><td><a ui-sref="education-detail({id:education.id})">{{education.id}}</a></td><td>{{education.startDate}}</td><td>{{education.endDate}}</td><td>{{education.degree}}</td><td><a ui-sref="establishment-detail({id:education.establishment.id})">{{education.establishment.id}}</a></td><td><a ui-sref="profile-detail({id:education.profile.id})">{{education.profile.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="education-detail({id:education.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="education.edit({id:education.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="education.delete({id:education.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/establishment/establishment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.establishment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer cette universit\xE9 ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/establishment/establishment-detail.html','<div><h2><span>Universit\xE9</span> {{vm.establishment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.establishment.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="establishment-detail.edit({id:vm.establishment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/establishment/establishment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEstablishmentLabel">Cr\xE9er ou modifier une universit\xE9</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.establishment.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.establishment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.establishment.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/establishment/establishments.html','<div><h2>Universit\xE9, \xE9cole</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="establishment.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er une nouvelle universit\xE9</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="establishment in vm.establishments track by establishment.id"><td><a ui-sref="establishment-detail({id:establishment.id})">{{establishment.id}}</a></td><td>{{establishment.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="establishment-detail({id:establishment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="establishment.edit({id:establishment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="establishment.delete({id:establishment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/message/message-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.message.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Message?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/message/message-detail.html','<div><h2><span>Message</span> {{vm.message.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Content</span></dt><dd><span>{{vm.message.content}}</span></dd><dt><span>Discussion</span></dt><dd><a ui-sref="discussion-detail({id:vm.message.discussion.id})">{{vm.message.discussion.id}}</a></dd><dt><span>Sent By</span></dt><dd>{{vm.message.sentBy.id}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="message-detail.edit({id:vm.message.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/message/message-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMessageLabel">Create or edit a Message</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.message.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.message.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_content">Content</label><textarea class="form-control" name="content" id="field_content" ng-model="vm.message.content" required></textarea><div ng-show="editForm.content.$invalid"><p class="help-block" ng-show="editForm.content.$error.required">This field is required.</p></div></div><div class="form-group"><label for="field_discussion">Discussion</label><select class="form-control" id="field_discussion" name="discussion" ng-model="vm.message.discussion" ng-options="discussion as discussion.id for discussion in vm.discussions track by discussion.id" required><option value=""></option></select></div><div ng-show="editForm.discussion.$invalid"><p class="help-block" ng-show="editForm.discussion.$error.required">This field is required.</p></div><div class="form-group"><label for="field_sentBy">Sent By</label><select class="form-control" id="field_sentBy" name="sentBy" ng-model="vm.message.sentBy" ng-options="user as user.id for user in vm.users track by user.id" required><option value=""></option></select></div><div ng-show="editForm.sentBy.$invalid"><p class="help-block" ng-show="editForm.sentBy.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/message/messages.html','<div><h2>Messages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="message.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Message</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Content</span></th><th><span>Discussion</span></th><th><span>Sent By</span></th><th></th></tr></thead><tbody><tr ng-repeat="message in vm.messages track by message.id"><td><a ui-sref="message-detail({id:message.id})">{{message.id}}</a></td><td>{{message.content}}</td><td><a ui-sref="discussion-detail({id:message.discussion.id})">{{message.discussion.id}}</a></td><td>{{message.sentBy.id}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="message-detail({id:message.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="message.edit({id:message.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="message.delete({id:message.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/message-libre/message-libre-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDepartmentLabel">Envoyer un message \xE0 {{vm.user.firstName}} {{vm.user.lastName}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_messagee">Message</label><textarea class="form-control" name="message" id="field_message" ng-model="vm.message" required>\n            </textarea><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Envoyer</span></button></div></form>');
$templateCache.put('app/entities/organisation/organisation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.organisation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Organisation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/organisation/organisation-detail.html','<div><h2><span>Organisation</span> {{vm.organisation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.organisation.name}}</span></dd><dt><span>Logo</span></dt><dd><div ng-if="vm.organisation.logo"><a ng-click="vm.openFile(vm.organisation.logoContentType, vm.organisation.logo)"><img data-ng-src="{{\'data:\' + vm.organisation.logoContentType + \';base64,\' + vm.organisation.logo}}" style="max-width: 100%"> </a>{{vm.organisation.logoContentType}}, {{vm.byteSize(vm.organisation.logo)}}</div></dd><dt><span>Sector</span></dt><dd><a ui-sref="sector-detail({id:vm.organisation.sector.id})">{{vm.organisation.sector.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="organisation-detail.edit({id:vm.organisation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/organisation/organisation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrganisationLabel">Create or edit a Organisation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.organisation.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.organisation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.organisation.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setLogo($file, vm.organisation)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_logo">Logo</label><div><img data-ng-src="{{\'data:\' + vm.organisation.logoContentType + \';base64,\' + vm.organisation.logo}}" style="max-height: 100px" ng-if="vm.organisation.logo"><div ng-if="vm.organisation.logo" class="help-block clearfix"><span class="pull-left">{{vm.organisation.logoContentType}}, {{vm.byteSize(vm.organisation.logo)}}</span> <button type="button" ng-click="vm.organisation.logo=null;vm.organisation.logoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setLogo($file, vm.organisation)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="logo" id="field_logo" ng-model="vm.organisation.logo" maxbytes="5000000"> <input type="hidden" class="form-control" name="logoContentType" id="field_logoContentType" ng-model="vm.organisation.logoContentType"><div ng-show="editForm.logo.$invalid"><p class="help-block" ng-show="editForm.logo.$error.maxbytes">This field cannot be more than 5000000.</p></div></div><div class="form-group"><label for="field_sector">Sector</label><select class="form-control" id="field_sector" name="sector" ng-model="vm.organisation.sector" ng-options="sector as sector.id for sector in vm.sectors track by sector.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-danger pull-left" data-dismiss="modal" ng-click="vm.deleteOrganisation()" ng-show="vm.isAdmin()"><span class="fal fa-minus-circle"></span>&nbsp;<span>Supprimer</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/organisation/organisation-switch-dialog.html','<form name="switchForm" ng-submit="vm.merge(vm.organisation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Etes-vous s\xFBre de convertir cette organisation ({{vm.organisation.name}}) ?</p><div class="form-group"><label class="control-label" for="field_collectivity">Collectivit\xE9 cible</label><input id="field_collectivity" type="text" ng-model="vm.collectivityTarget" autocomplete="off" uib-typeahead="collectivity as collectivity.name for collectivity in vm.getCollectivities($viewValue)" typeahead-no-results="vm.collectivitysNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.collectivitysNoResults">Nous n\'avons pas cette collectivit\xE9 dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div><p>OU</p><div class="form-group"><label class="control-label" for="field_company">Entreprise cible</label><input id="field_company" type="text" ng-model="vm.companyTarget" autocomplete="off" uib-typeahead="company as company.name for company in vm.getCompanies($viewValue)" typeahead-no-results="vm.companiesNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.companiesNoResults">Nous n\'avons pas cette entreprise dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="switchForm.$invalid || (!vm.collectivityTarget && !vm.companyTarget) || (vm.collectivityTarget && vm.companyTarget)" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Convertir</span></button></div></form>');
$templateCache.put('app/entities/organisation/organisations.html','<div><h2>Organisations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="organisation.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Organisation</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="logo"><span>Logo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sector.id"><span>Sector</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="organisation in vm.organisations track by organisation.id"><td><a ui-sref="organisation-detail({id:organisation.id})">{{organisation.id}}</a></td><td>{{organisation.name}}</td><td><a ng-if="organisation.logo" ng-click="vm.openFile(organisation.logoContentType, organisation.logo)"><img data-ng-src="{{\'data:\' + organisation.logoContentType + \';base64,\' + organisation.logo}}" style="max-height: 30px"> </a><span ng-if="organisation.logo">{{organisation.logoContentType}}, {{vm.byteSize(organisation.logo)}}</span></td><td><a ui-sref="sector-detail({id:organisation.sector.id})">{{organisation.sector.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="organisation-detail({id:organisation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="organisation.edit({id:organisation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="organisation.delete({id:organisation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/position/position-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.position.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Position?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/position/position-detail.html','<div><h2><span>Position</span> {{vm.position.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Start Date</span></dt><dd><span>{{vm.position.startDate}}</span></dd><dt><span>End Date</span></dt><dd><span>{{vm.position.endDate}}</span></dd><dt><span>Title</span></dt><dd><span>{{vm.position.title}}</span></dd><dt><span>Company</span></dt><dd><a ui-sref="company-detail({id:vm.position.company.id})">{{vm.position.company.id}}</a></dd><dt><span>Collectivity</span></dt><dd><a ui-sref="collectivity-detail({id:vm.position.collectivity.id})">{{vm.position.collectivity.id}}</a></dd><dt><span>Sector</span></dt><dd><a ui-sref="sector-detail({id:vm.position.sector.id})">{{vm.position.sector.id}}</a></dd><dt><span>Department</span></dt><dd><a ui-sref="department-detail({id:vm.position.department.id})">{{vm.position.department.id}}</a></dd><dt><span>Profile</span></dt><dd><a ui-sref="profile-detail({id:vm.position.profile.id})">{{vm.position.profile.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="position-detail.edit({id:vm.position.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/position/position-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPositionLabel">Create or edit a Position</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.position.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.position.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><input type="number" class="form-control" name="startDate" id="field_startDate" ng-model="vm.position.startDate" min="1920" max="2100"><div ng-show="editForm.startDate.$invalid"><p class="help-block" ng-show="editForm.startDate.$error.min" translate-value-min="1920">This field should be more than 1920.</p><p class="help-block" ng-show="editForm.startDate.$error.max">This field cannot be more than 2100.</p><p class="help-block" ng-show="editForm.startDate.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_endDate">End Date</label><input type="number" class="form-control" name="endDate" id="field_endDate" ng-model="vm.position.endDate" min="1920" max="2100"><div ng-show="editForm.endDate.$invalid"><p class="help-block" ng-show="editForm.endDate.$error.min" translate-value-min="1920">This field should be more than 1920.</p><p class="help-block" ng-show="editForm.endDate.$error.max">This field cannot be more than 2100.</p><p class="help-block" ng-show="editForm.endDate.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.position.title"></div><div class="form-group"><label for="field_company">Company</label><select class="form-control" id="field_company" name="company" ng-model="vm.position.company" ng-options="company as company.id for company in vm.companies track by company.id"><option value=""></option></select></div><div class="form-group"><label for="field_collectivity">Collectivity</label><select class="form-control" id="field_collectivity" name="collectivity" ng-model="vm.position.collectivity" ng-options="collectivity as collectivity.id for collectivity in vm.collectivities track by collectivity.id"><option value=""></option></select></div><div class="form-group"><label for="field_sector">Sector</label><select class="form-control" id="field_sector" name="sector" ng-model="vm.position.sector" ng-options="sector as sector.id for sector in vm.sectors track by sector.id"><option value=""></option></select></div><div class="form-group"><label for="field_department">Department</label><select class="form-control" id="field_department" name="department" ng-model="vm.position.department" ng-options="department as department.id for department in vm.departments track by department.id"><option value=""></option></select></div><div class="form-group"><label for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.position.profile" ng-options="profile as profile.id for profile in vm.profiles track by profile.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/position/positions.html','<div><h2>Positions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="position.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Position</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate"><span>Start Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endDate"><span>End Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span>Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="company.id"><span>Company</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="collectivity.id"><span>Collectivity</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sector.id"><span>Sector</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="department.id"><span>Department</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span>Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="position in vm.positions track by position.id"><td><a ui-sref="position-detail({id:position.id})">{{position.id}}</a></td><td>{{position.startDate}}</td><td>{{position.endDate}}</td><td>{{position.title}}</td><td><a ui-sref="company-detail({id:position.company.id})">{{position.company.id}}</a></td><td><a ui-sref="collectivity-detail({id:position.collectivity.id})">{{position.collectivity.id}}</a></td><td><a ui-sref="sector-detail({id:position.sector.id})">{{position.sector.id}}</a></td><td><a ui-sref="department-detail({id:position.department.id})">{{position.department.id}}</a></td><td><a ui-sref="profile-detail({id:position.profile.id})">{{position.profile.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="position-detail({id:position.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="position.edit({id:position.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="position.delete({id:position.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/quickconnect/quickconnect-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.quickconnect.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce Quick Connect ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/quickconnect/quickconnect-detail.html','<style>@media (min-width: 768px){\n    .dl-horizontal dt {\n        width: 260px;\n    }\n}\n@media (min-width: 768px){\n    .dl-horizontal dd {\n        margin-left: 280px;\n    }\n}</style><div><h2><span>Quick Connect</span> {{vm.quickconnect.id}}</h2><hr><jhi-alert-error></jhi-alert-error><h4>Informations du demandeur</h4><dl class="dl-horizontal jh-entity-details"><dt><span>Utilisateur \xE0 l\'origine de la demande</span></dt><dd><span>{{vm.quickconnect.user.email}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.quickconnect.mylastname}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span>Pr\xE9nom</span></dt><dd><span>{{vm.quickconnect.myfirstname}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span>Organisation</span></dt><dd><span>{{vm.quickconnect.mycompany}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span>Equipe commerciale</span></dt><dd><span>{{vm.quickconnect.myec}}</span></dd></dl><br><h4>Mise en relation</h4><dl class="dl-horizontal jh-entity-details"><dt><span>Type de mise en relation</span></dt><dd><span>{{vm.quickconnect.quickconnectType}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span>Organisation \xE0 rencontrer</span></dt><dd><span>{{vm.quickconnect.quickconnectOrganisation}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span>Raison de la rencontre</span></dt><dd><span>{{vm.quickconnect.quickconnectRaison}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button></div>');
$templateCache.put('app/entities/quickconnect/quickconnect-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQuickconnectLabel">Quick Connect - Demande de mise en relation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.quickconnect.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.quickconnect.id" readonly="readonly"></div><h4>Mes informations</h4><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_mylastname">Mon nom</label><input type="text" class="form-control" name="mylastname" id="field_mylastname" ng-model="vm.quickconnect.mylastname" required disabled="true"><div ng-show="editForm.mylastname.$invalid"><p class="help-block" ng-show="editForm.mylastname.$error.required">Ce champ est requis.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_myfirstname">Mon pr\xE9nom</label><input type="text" class="form-control" name="myfirstname" id="field_myfirstname" ng-model="vm.quickconnect.myfirstname" required disabled="true"><div ng-show="editForm.myfirstname.$invalid"><p class="help-block" ng-show="editForm.myfirstname.$error.required">Ce champ est requis.</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_mycompany">Mon entreprise</label><input type="text" class="form-control" name="mycompany" id="field_mycompany" ng-model="vm.quickconnect.mycompany" required><div ng-show="editForm.mycompany.$invalid"><p class="help-block" ng-show="editForm.mycompany.$error.required">Ce champ est requis.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_myec">Mon \xE9quipe commerciale</label><input type="text" placeholder="Optionnel " class="form-control" name="myec" id="field_myec" ng-model="vm.quickconnect.myec"></div></div></div><br><h4>Ma mise en relation</h4><div class="form-group"><label class="control-label" for="field_quickconnectType">Fonction de la personne \xE0 connecter</label><input type="text" class="form-control" name="quickconnectType" id="field_quickconnectType" ng-model="vm.quickconnect.quickconnectType" required><div ng-show="editForm.quickconnectType.$invalid"><p class="help-block" ng-show="editForm.quickconnectType.$error.required">Ce champ est requis.</p></div></div><div class="form-group"><label class="control-label" for="field_quickconnectOrganisation">Entreprise/Collectivit\xE9 \xE0 rencontrer</label><input type="text" class="form-control" name="quickconnectOrganisation" id="field_quickconnectOrganisation" ng-model="vm.quickconnect.quickconnectOrganisation" required><div ng-show="editForm.quickconnectOrganisation.$invalid"><p class="help-block" ng-show="editForm.quickconnectOrganisation.$error.required">Ce champ est requis.</p></div></div><div class="form-group"><label class="control-label" for="field_quickconnectRaison">Objet de la rencontre</label><textarea rows="4" class="form-control" name="quickconnectRaison" id="field_quickconnectRaison" ng-model="vm.quickconnect.quickconnectRaison" required></textarea><div ng-show="editForm.quickconnectRaison.$invalid"><p class="help-block" ng-show="editForm.quickconnectRaison.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/quickconnect/quickconnects.html','<div><h2>Quick Connect</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mylastname"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="myfirstname"><span>Pr\xE9nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mycompany"><span>Organisation</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quickconnectOrganisation"><span>Quick Connect</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quickconnectType"><span>Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="quickconnect in vm.quickconnects track by quickconnect.id"><td><a ui-sref="quickconnect-detail({id:quickconnect.id})">{{quickconnect.id}}</a></td><td>{{quickconnect.mylastname}}</td><td>{{quickconnect.myfirstname}}</td><td>{{quickconnect.mycompany}}</td><td>{{quickconnect.quickconnectOrganisation}}</td><td>{{quickconnect.quickconnectType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="quickconnect-detail({id:quickconnect.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="quickconnect.edit({id:quickconnect.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="quickconnect.delete({id:quickconnect.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/profile/profile-credit.html','<style>.credit-profile-card-up {\n    background: #283C5C;\n    color: #fff;\n    float: left;\n    border: none !important;\n    height: 80px;\n    margin-bottom : 0px;\n    border-radius: 3px 3px 0px 0px;\n}\n.credit-profile-card-down {\n    background:white;\n    color: black;\n    float: left;\n    border: none !important;\n    height: 80px;\n    border-radius: 0px 0px 3px 3px;\n    padding: 0;\n}\n.credit-profile-card-down td {\n    width: 20%;\n    padding: 15px;\n    border-right: solid 1px;\n}\n\n.isochrome{\n    min-height: 250px;\n    position: relative;\n    min-height: 1px;\n    padding-left: 15px;\n    padding-right:15px;\n    float: left;\n    width: 253px;\n}\n.well-header {\n    color: black;\n    font-size: 15px;\n    padding: 4px 0px;\n    margin-bottom: 10px;\n}\n.text-credit{\n    color:green;\n}\n.text-highlight{\n    padding-top: 9px;\n    padding-left: 25px;\n    color: #48719D;\n    font-size: 14pt;\n    font-weight: bold;\n}\n@media (min-width: 992px) {\n    .col-md-10 {\n        width: 80%;\n    }\n}\n.square-picture-credits {\n    width: 110px;\n    height: 115px;\n    background: white center center no-repeat;\n    background-size: cover;\n    border: solid 1px white;\n    position: absolute;\n    margin-left: 260px;\n    margin-top: 20px;\n    z-index: 1;\n    transition: 0.1s filter ease-in-out;\n}</style><div class="container"><div class="row"><div class="left-addon-container hidden-xs hidden-sm col-md-3"><!--<div class="left-addon-fixed">--><contribution-loop-addon></contribution-loop-addon><!--</div>--></div><div class="square-picture-credits" ng-hide="vm.profile.picture" style="background-image: url(\'../../content/images/no-picture.png\')"></div><div class="square-picture-credits" ng-show="vm.profile.picture" ng-style="{\'background-image\': \'url(data:\'+vm.profile.pictureContentType+\';base64,\' + vm.profile.picture }"></div><div class="col-md-10 col-sm-12 credit-profile-card-up well" style="padding:0"><table style="width: 100%;padding: 15px"><tr><td style="width: 40%;border-right: solid 1px;padding: 15px;padding-left: 200px;font-weight: bolder"><p class="profile-name">{{ vm.profile.firstName }} {{ vm.profile.lastName }}</p></td><td style="width: 60%;padding: 15px"><i><span style="font-weight: bolder">Merci de vos contributions !</span></i><br><span style="font-weight: normal">Pour vous remercier de vos contributions, vous pouvez utiliser vos cr\xE9dits gagn\xE9s sur </span><span style="font-weight: bolder">Axenteev</span><span style="font-weight: normal"> sur notre site partenaire. </span><span style="font-weight: bolder">Enjoy !</span></td></tr></table></div><div class="col-md-10 col-sm-12 credit-profile-card-down well"><table style="width: 100%;height: 100%"><tr><td style="width:40%;padding-left: 200px">Site partenaire :<br><a href="www.axenteev.com">www.axenteev.com</a></td><td style="width:20%"><div class="text-highlight"></div></td><!--\n                    <td style="width:20%">Ma note\n                       <div class="text-highlight">{{ vm.credits.note }} / 10<div>\n                        <div class="text-highlight">- / 10<div>\n                    </td>\n                    --><td style="width:20%;border:none">Mes cr\xE9dits restants<div class="text-highlight">{{ vm.credits.creditsCount - vm.credits.creditsSpent }}</div></td></tr></table></div><div style="padding-left: 0px" class="col-md-7 col-sm-12"><div class="col-md-12 well"><div class="well-header"><i class="fal fa-copyright fa-2x fa-fw" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>R\xE9sum\xE9 du mois (<b>{{ vm.creditsLastMonth.monthStr }}</b>)</div><div><table style="width: 80%;float:left"><tr><td style="padding: 4px"><b>{{ vm.creditsLastMonth.entity.add.count }}</b><span style="margin-left: 3px">cr\xE9ations de fiches</span></td><td><span class="text-credit">+{{ vm.creditsLastMonth.entity.add.credits }} cr\xE9dits</span></td><td><b>{{ vm.creditsLastMonth.connexion.add.count }}</b><span style="margin-left: 3px">indices renseign\xE9s</span></td><td><span class="text-credit">+{{ vm.creditsLastMonth.connexion.add.credits }} cr\xE9dits</span></td></tr><tr><td style="padding: 4px"><b>{{ vm.creditsLastMonth.entity.mod.count }}</b><span style="margin-left: 3px">modifications</span></td><td><span class="text-credit">+{{ vm.creditsLastMonth.entity.mod.credits }} cr\xE9dits</span></td><td><b>{{ vm.creditsLastMonth.myProfile.mod.count }}</b><span style="margin-left: 3px"></span>modifications de mon profil</td><td><span class="text-credit">+{{ vm.creditsLastMonth.myProfile.mod.credits }} cr\xE9dits</span></td></tr></table><table style="width: 20%"><tr><td style="text-align: left">Total en <b>{{ vm.creditsLastMonth.monthStr }}</b><div style="padding-top: 2px;padding-left: 10px"><span style="font-weight: bolder; font-size: 22px">{{ vm.creditsLastMonth.creditsCount }}</span><i class="fal fa-copyright fa-2x fa-fw" style="padding-left: 8px;width: 1.6em"></i></div></td></tr></table></div></div><div class="col-md-12 well"><div class="well-header"><i class="fal fa-chart-bar fa-2x fa-fw" style="vertical-align: middle;padding-right: 8px;width: 1.6em"></i>Tendance sur les 6 derniers mois</div><canvas width="620px" height="250px" class="chart-bar" chart-data="vm.data1" chart-labels="vm.labels1" chart-dataset-override="vm.datasetOverride"></canvas></div></div><div class="well isochrome"><div class="well-header">Isochrone cr\xE9dits</div><div>- <img src="content/images/1_transparent.png" width="20"> 5 cr\xE9dits<br><br>- <img src="content/images/2_transparent.png" width="20"> 3 cr\xE9dits<br><br>- <img src="content/images/3_transparent.png" width="20"> 1 cr\xE9dits<br><br>- Cr\xE9ation de fiche : 5 cr\xE9dits<br><br>- Modification de fiche : 3 cr\xE9dits<br><br>- Mise en relation : 50 cr\xE9dits<!--\n                <br><br>- Note maintenue \xE0 plus de 9 : 20 cr\xE9dits/mois\n                --><br><br>- Import connexions linkedin: 10 cr\xE9dits</div></div></div></div>');
$templateCache.put('app/entities/profile/profile-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.profile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Profile?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-detail.html','<div><h2><span>Profile</span> {{vm.profile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>First Name</span></dt><dd><span>{{vm.profile.firstName}}</span></dd><dt><span>Last Name</span></dt><dd><span>{{vm.profile.lastName}}</span></dd><dt><span>Picture</span></dt><dd><div ng-if="vm.profile.picture"><a ng-click="vm.openFile(vm.profile.pictureContentType, vm.profile.picture)"><img data-ng-src="{{\'data:\' + vm.profile.pictureContentType + \';base64,\' + vm.profile.picture}}" style="max-width: 100%"> </a>{{vm.profile.pictureContentType}}, {{vm.byteSize(vm.profile.picture)}}</div></dd><!-- D\xE9sactivation rgpd\n            <dt><span>Phone Number</span></dt>\n            <dd>\n                <span>{{vm.profile.phoneNumber}}</span>\n            </dd>\n            <dt><span>Email</span></dt>\n            <dd>\n                <span>{{vm.profile.email}}</span>\n            </dd>\n        --><dt><span>User</span></dt><dd>{{vm.profile.user.id}}</dd><dt><span>Superior</span></dt><dd><a ui-sref="profile-detail({id:vm.profile.superior.id})">{{vm.profile.superior.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="profile-detail.edit({id:vm.profile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/profile/profile-dialog.html','<style>.kv-avatar .krajee-default.file-preview-frame,\n    .kv-avatar .krajee-default.file-preview-frame:hover {\n        margin: 0;\n        padding: 0;\n        border: none;\n        box-shadow: none;\n        text-align: center;\n    }\n\n    .kv-avatar {\n        display: inline-block;\n    }\n\n    .file-preview {\n        border-radius: 5px;\n        border: 1px solid #ddd;\n        padding: 8px;\n        width: 100%;\n        margin-bottom: 5px;\n    }\n\n    .file-drop-zone {\n        border: 1px dashed #aaa;\n        border-radius: 4px;\n        height: 100%;\n        text-align: center;\n        vertical-align: middle;\n        margin: 12px 15px 12px 12px;\n        padding: 5px;\n    }</style><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="row"><div class="col-md-8"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_lastName">Nom <span class="required">*</span></label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-disabled="vm.profile.id && !vm.isAdmin()" ng-model="vm.profile.lastName" required ng-maxlength="30"><div ng-show="vm.editForm.lastName.$invalid"><p class="help-block" ng-show="vm.editForm.lastName.$error.maxlength">Ce champ ne peut pas d\xE9passer 30 caract\xE8res.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_firstName">Pr\xE9nom <span class="required">*</span></label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-disabled="vm.profile.id && !vm.isAdmin()" ng-model="vm.profile.firstName" required ng-maxlength="30"><div ng-show="vm.editForm.firstName.$invalid"><p class="help-block" ng-show="vm.editForm.firstName.$error.maxlength">Ce champ ne peut pas d\xE9passer 30 caract\xE8res.</p></div></div></div></div><div class="row" style="padding-left: 268px"><i class="fal fa-plus" style="vertical-align: middle;color:#4A729B"></i> <a style="color:#4A729B" ng-click="vm.addCurrentPosition()">Ajouter une exp\xE9rience</a> &nbsp; <i class="fal fa-plus" style="vertical-align: middle;color:#4A729B"></i> <a style="color:#4A729B" ng-click="vm.addPastPosition()">Ajouter une exp\xE9rience pass\xE9e</a><br></div><div ng-repeat="currentPosition in vm.currentPositions"><div class="row"><div class="col-md-10"><div class="form-group"><label class="control-label" for="field_organization">Entreprise/Collectivit\xE9<span class="required">*</span></label><input id="field_organization" name="organisation" type="text" ng-model="currentPosition.organisation" autocomplete="off" required uib-typeahead="organization as organization.name for organization in vm.getOrganizations($viewValue)" ng-blur="vm.organizationsNoResults = false" typeahead-no-results="vm.organizationsNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.organizationsNoResults" style="color:red">Nous n\'avons pas cette entreprise/collectivit\xE9 dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div><div class="form-group"><label class="control-label" for="field_title">Titre professionnel<span class="required">*</span></label><input type="text" name="title" class="form-control" id="field_title" required ng-model="currentPosition.title" ng-maxlength="255"><div ng-show="vm.editForm.title.$invalid"><p class="help-block" ng-show="vm.editForm.title.$error.maxlength">Ce champ ne peut pas d\xE9passer 255 caract\xE8res.</p></div></div><div class="form-group"><label class="control-label" for="field_superiors">Sup\xE9rieur hi\xE9rarchique</label><input id="field_superior" name="superior" type="text" ng-model="currentPosition.superior" autocomplete="off" uib-typeahead="profile as profile.firstName + \' \' + profile.lastName for profile in vm.getProfiles($viewValue)" ng-blur="vm.profilesNoResults = false" typeahead-no-results="vm.profilesNoResults" typeahead-min-length="2" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.profilesNoResults" style="color:red">Nous n\'avons pas cette personne dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div></div><div class="col-md-2"><div style="border-left: 1px solid #ccc;height: 100%;width: 100%;display: table;height: 176px;padding: 20px;vertical-align: middle;text-align: center;padding-top: 20px;margin-top: 22px">Exp\xE9rience actuelle {{$index + 1}}<br><br><span><a style="font-size: 9px; color:#4A729B" ng-click="vm.setInActive($index)">Marquer cette exp\xE9rience comme inactive</a></span><br><br><i class="fal fa-minus-circle fa-2x" ng-click="vm.currentPositions.splice($index,1)" title="Supprimer l\'exp\xE9rience"></i></div></div></div></div><div ng-repeat="pastPosition in vm.pastPositions"><div class="row"><div class="col-md-10"><div class="form-group"><label class="control-label" for="field_organization">Entreprise/Collectivit\xE9<span class="required">*</span></label><input id="field_organization" name="organisation" type="text" ng-model="pastPosition.organisation" autocomplete="off" required uib-typeahead="organization as organization.name for organization in vm.getOrganizations($viewValue)" typeahead-no-results="vm.organizationsNoResults" class="form-control typeahead-input"><div class="search-no-results well" ng-show="vm.organizationsNoResults" style="color:red">Nous n\'avons pas cette entreprise/collectivit\xE9 dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div><div class="form-group"><label class="control-label" for="field_title">Titre professionnel<span class="required">*</span></label><input type="text" name="title" class="form-control" id="field_title" required ng-model="pastPosition.title" ng-maxlength="255"><div ng-show="vm.editForm.title.$invalid"><p class="help-block" ng-show="vm.editForm.title.$error.maxlength">Ce champ ne peut pas d\xE9passer 255 caract\xE8res.</p></div></div><div class="form-group"><label class="control-label" for="field_superiors">Sup\xE9rieur hi\xE9rarchique</label><input id="field_superior" name="superior" type="text" ng-model="pastPosition.superior" autocomplete="off" uib-typeahead="profile as profile.firstName + \' \' + profile.lastName for profile in vm.getProfiles($viewValue)" typeahead-no-results="vm.profilesNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.profilesNoResults" style="color:red">Nous n\'avons pas cette personne dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div></div><div class="col-md-2"><div style="border-left: 1px solid #ccc;height: 100%;width: 100%;display: table;height: 176px;padding: 20px;vertical-align: middle;text-align: center;padding-top: 20px;margin-top: 22px">Exp\xE9rience pass\xE9e {{$index + 1}}<br><br><span><a style="font-size: 9px; color:#4A729B" ng-click="vm.setActive($index)">Marquer cette exp\xE9rience comme active</a></span><br><br><i class="fal fa-minus-circle fa-2x" ng-click="vm.pastPositions.splice($index,1)" title="Supprimer l\'exp\xE9rience"></i></div></div></div></div></div><div class="col-md-4"><div class="col-sm-4 text-center"><div class="col-sm-4 text-center"><div class="kv-avatar"><div class="file-input file-input-ajax-new"><div class="file-preview"><div class="file-drop-zone"><div class="file-preview-thumbnails"><div class="file-default-preview" ng-style="{\'cursor\': vm.profile.mine ? \'pointer\' : \'default\' }"><img ng-disabled="!vm.profile.mine" ngf-select ngf-change="vm.setPicture($file, vm.profile)" accept="image/*" data-ng-src="{{\'data:\' + vm.profile.pictureContentType + \';base64,\' + vm.profile.picture}}" style="max-width: 160px" ng-if="vm.profile.picture"> <img ng-disabled="!vm.profile.mine" ngf-select ngf-change="vm.setPicture($file, vm.profile)" accept="image/*" width="160px" src="content/images/no-picture.png" alt="Photo de profil" ng-if="!vm.profile.picture"></div></div><div class="clearfix"></div><div class="file-preview-status text-center text-success"></div></div><input type="hidden" class="form-control" name="picture" id="field_picture" ng-model="vm.profile.picture" maxbytes="5000000"> <input type="hidden" class="form-control" name="pictureContentType" id="field_pictureContentType" ng-model="vm.profile.pictureContentType"><div ng-if="vm.profile.picture" class="help-block clearfix" style="padding-left: 13px; padding-right: 17px; vertical-align: middle"><div ng-show="vm.editForm.picture.$invalid"><p class="help-block" ng-show="vm.editForm.picture.$error.maxbytes">La taille de l\'image ne doit pas d\xE9passer 5MB.</p></div><span ng-show="vm.profile.mine" class="pull-left">{{vm.profile.pictureContentType}}, {{vm.byteSize(vm.profile.picture)}}</span> <button ng-show="vm.profile.mine" type="button" ng-click="vm.profile.picture=null;vm.profile.pictureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div></div></div></div></div></div></div></div><div class="row"><!-- TODO: Ajouter un champ sup\xE9rieur hierarchique --><!-- TODO: Modifier design pour avoir un champ double contact et la photo de profil --><div class="col-md-4" ng-if="!vm.profile.id && !vm.profile.mine"><div class="form-group"><label class="control-label" for="field_grade">Indice <span class="required">*</span></label><select class="form-control" id="field_grade" name="grade" ng-model="vm.grade" required><option value="" selected="selected">- S\xE9lectionner un indice -</option><option value="3">3</option><option value="2">2</option><option value="1">1</option></select></div></div><div class="col-md-4" ng-show="vm.profile.mine || vm.isAdmin()"><div class="form-group"><label class="control-label" for="field_phoneNumber">Num\xE9ro de t\xE9l\xE9phone</label><input type="text" class="form-control" name="phoneNumber" id="field_phoneNumber" ng-disabled="vm.profile.id && !vm.isAdmin() && !vm.profile.mine" ng-model="vm.profile.phoneNumber"></div></div><div class="col-md-4" ng-show="vm.profile.mine || vm.isAdmin()"><div class="form-group"><label class="control-label" for="field_email">Adresse email</label><input type="text" class="form-control" name="email" id="field_email" ng-disabled="vm.profile.id && !vm.isAdmin()" ng-model="vm.profile.email" ng-maxlength="100"><div ng-show="vm.editForm.email.$invalid"><p class="help-block" ng-show="vm.editForm.email.$error.maxlength">Ce champ ne peut pas d\xE9passer 100 caract\xE8res.</p></div></div></div><div class="col-md-4" ng-show="vm.profile.mine || vm.isAdmin()"><div class="form-group"><label class="control-label" for="field_deparementElection">D\xE9partement</label><select class="form-control" id="field_deparementElection" name="departementElection" ng-model="vm.profile.departementElection" ng-options="departement.codeDepartement as departement.codeDepartement + \' \' + departement.nom for departement in vm.departements"><option value=""></option></select></div></div><div class="col-md-12"><div class="form-group" style="display: flex"><input style="height: 30px;width: 60px;margin-right: 8px" type="checkbox" name="conditions" id="field_conditions" ng-model="vm.conditions" required><label class="control-label" for="field_conditions">En int\xE9grant votre contact, vous acceptez de transmettre volontairement \xE0 Axenteev des donn\xE9es personnelles conformes \xE0 la r\xE9glementation en vigueur. Conform\xE9ment \xE0 la RGPD, nous prot\xE9geons toutes les donn\xE9es personnelles en notre possession et nous interdisons de les commercialiser \xE0 des fins de prospection commerciale.</label></div></div></div><div class="modal-footer" ng-show="vm.isAdmin() || vm.profile.mine || vm.profile.myContribution"><button type="button" class="btn btn-danger pull-left" data-dismiss="modal" ng-click="vm.deleteProfile()"><span class="fal fa-minus-circle"></span>&nbsp;<span>Supprimer</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button ng-show="!vm.profile.hasModeration" type="submit" ng-disabled="vm.editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button> <button ng-show="vm.profile.hasModeration" type="submit" ng-disabled="vm.editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Modifer et accepter</span></button></div><div class="modal-footer" ng-show="!vm.isAdmin() && !vm.profile.mine && !vm.profile.myContribution"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button ng-show="!vm.profile.importId || vm.profile.importId === \'linked\'" type="submit" ng-disabled="vm.editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-education-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEducationLabel">Cr\xE9er ou modifier une Formation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_startDate">Date de d\xE9but</label><input type="number" class="form-control" name="startDate" id="field_startDate" ng-model="vm.education.startDate" min="1920" max="2100"><div ng-show="editForm.startDate.$invalid"><p class="help-block" ng-show="editForm.startDate.$error.min" translate-value-min="1920">Cette date ne peut \xEAtre inf\xE9rieure \xE0 1920.</p><p class="help-block" ng-show="editForm.startDate.$error.max">Cette date ne peut \xEAtre sup\xE9rieure \xE0 2100.</p><p class="help-block" ng-show="editForm.startDate.$error.number">Veuillez renseigner un nombre.</p></div></div><div class="form-group"><label class="control-label" for="field_endDate">Date de fin</label><input type="number" class="form-control" name="endDate" id="field_endDate" ng-model="vm.education.endDate" min="1920" max="2100"><div ng-show="editForm.endDate.$invalid"><p class="help-block" ng-show="editForm.endDate.$error.min" translate-value-min="1920">Cette date ne peut \xEAtre inf\xE9rieure \xE0 1920.</p><p class="help-block" ng-show="editForm.endDate.$error.max">Cette date ne peut \xEAtre sup\xE9rieure \xE0 2100.</p><p class="help-block" ng-show="editForm.endDate.$error.number">Veuillez renseigner un nombre.</p></div></div><div class="form-group"><label class="control-label" for="field_degree">Dipl\xF4me</label><input type="text" class="form-control" name="degree" id="field_degree" ng-model="vm.education.degree"></div><div class="form-group typeahead-group"><label for="field_establishment">\xC9tablissement</label><input type="text" class="form-control" name="establishment" id="field_establishment" ng-model="vm.education.establishment.name" uib-typeahead="establishment.name for establishment in vm.getEstablishments($viewValue)" typeahead-loading="vm.loadingEstablishments" typeahead-editable="false"> <i ng-show="vm.loadingEstablishments" class="glyphicon glyphicon-refresh"></i></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-init.html','<div class="container"><div style="margin-top:65px"><jhi-alert-error></jhi-alert-error></div><div ng-if="!vm.authenticationError" id="profile-init-header" class="text-center"><h1>Compl\xE9tez votre profil Axenteev</h1><a ng-hide="vm.mode" class="btn btn-primary btn-big" ng-click="vm.switchTo(\'linkedin\')">Etape suivante</a></div><div ng-if="!vm.authenticationError" ng-switch="vm.mode" id="profile-init-body"><div ng-switch-when="linkedin" class="row"><div class="col-xs-6"><p class="import-description"><b>Synchronisez</b> vos donn\xE9es avec vos connections LinkedIn pour b\xE9n\xE9ficiez \xE0 100% d\'<em><b>Axenteev</b></em>. Cliquez sur le lien ci-contre, connectez-vous \xE0 LinkedIn si ce n\'est pas d\xE9j\xE0 fait, puis s\xE9l\xE9ctionner le fichier "<b>Connections</b>".</p><p class="import-description"><b>Et voil\xE0, </b>vous devriez recevoir dans les 5 prochaines minutes un email de linkedIn. <b>Suivez le lien et t\xE9l\xE9chargez votre archive</b>.</p><p class="import-description">Cliquez maintenant sur "<b>Continuer</b>" en bas de page et aller sur votre profil pour <b>t\xE9l\xE9charger vos connections linkedin sur votre profil</b>.</p></div><div class="col-xs-6"><p class="text-center"><a href="https://www.linkedin.com/settings/data-export-page" target="_blank"><img src="content/images/linkedin_import.png" class="linkedin-image" alt="LinkedIn import"></a></p><a ng-show="vm.mode" class="btn btn-default" ng-click="vm.switchTo(\'manual\')">Continuer <i class="fas fa-arrow-right"></i></a></div></div><div ng-switch-when="manual" class="row well"><div class="col-xs-12 col-md-12"><form name="vm.profileInitForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="alert alert-danger" ng-show="vm.doNotMatch">Le mot de passe et sa confirmation ne concordent pas.</div><div class="form-group" ng-show="vm.profile.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.profile.id" readonly="readonly"></div><div class="row"><div class="col-md-8"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_lastName">Nom <span class="required">*</span></label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.profile.lastName" required ng-maxlength="30"><div ng-show="vm.profileInitForm.lastName.$invalid"><p class="help-block" ng-show="vm.profileInitForm.lastName.$error.maxlength">Ce champ ne peut pas d\xE9passer 30 caract\xE8res.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_firstName">Pr\xE9nom <span class="required">*</span></label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.profile.firstName" required ng-maxlength="30"><div ng-show="vm.profileInitForm.firstName.$invalid"><p class="help-block" ng-show="vm.profileInitForm.firstName.$error.maxlength">Ce champ ne peut pas d\xE9passer 30 caract\xE8res.</p></div></div></div></div><div class="row" ng-if="!vm.profile.user.oauth2"><div class="col-md-6"><div class="form-group"><label class="control-label" for="password">Nouveau mot de passe</label><input type="password" class="form-control" id="password" name="password" placeholder="Nouveau mot de passe" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Un mot de passe est requis.</p><p class="help-block" ng-show="form.password.$error.minlength">Le mot de passe doit contenir au moins 4 caract\xE8res.</p><p class="help-block" ng-show="form.password.$error.maxlength">Le mot de passe ne peut exc\xE9der 50 caract\xE8res.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="confirmPassword">Confirmation du nouveau mot de passe</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirmation du nouveau mot de passe" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">La confirmation du mot de passe est requise.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">La confirmation du mot de passe doit contenir au moins 4 caract\xE8res.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">La confirmation du mot de passe ne peut exc\xE9der 50 caract\xE8res.</p></div></div></div></div><!--\n                                <div class="row" style="padding-left: 268px;">\n                                 <i class="fal fa-plus" style="vertical-align: middle;color:#4A729B"></i> <a style="color:#4A729B" ng-click="vm.addCurrentPosition()"> Ajouter une exp\xE9rience</a>\n                                 &nbsp;\n                                 <i class="fal fa-plus" style="vertical-align: middle;color:#4A729B"></i> <a style="color:#4A729B" ng-click="vm.addPastPosition()"> Ajouter une exp\xE9rience pass\xE9e</a>\n\n                                 <br>\n                                </div>\n                                --><div ng-repeat="currentPosition in vm.currentPositions"><div class="row"><div class="col-md-10"><div class="form-group"><label class="control-label" for="field_organization">Entreprise/Collectivit\xE9<span class="required">*</span></label><input name="organisation" id="field_organization" type="text" ng-model="currentPosition.organisation" autocomplete="off" required ng-disabled="currentPosition.readOnlyInitOrganisation === true" uib-typeahead="organization as organization.name for organization in vm.getOrganizations($viewValue)" typeahead-no-results="vm.organizationsNoResults" class="form-control typeahead-input" ng-blur="vm.organizationsNoResults = false" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.organizationsNoResults" style="color:red">Cette organisation n\'existe pas sur notre plateforme. Vous pourrez la cr\xE9er apr\xE8s cette \xE9tape et une fois votre compte confirm\xE9. En attendant, vous pouvez vous renseigner en Ind\xE9pendant.</div></div><div class="form-group"><label class="control-label" for="field_title">Titre professionnel<span class="required">*</span></label><input type="text" class="form-control" name="title" id="field_title" required ng-disabled="currentPosition.readOnlyInitTitle === true" ng-model="currentPosition.title" ng-maxlength="100"><div ng-show="vm.profileInitForm.title.$invalid"><p class="help-block" ng-show="vm.profileInitForm.title.$error.maxlength">Ce champ ne peut pas d\xE9passer 100 caract\xE8res.</p></div></div><div class="form-group"><label class="control-label" for="field_superiors">Sup\xE9rieur hi\xE9rarchique</label><input name="superior" id="field_superior" type="text" ng-model="currentPosition.superior" autocomplete="off" ng-disabled="currentPosition.readOnlyInitSuperior === true" uib-typeahead="profile as profile.firstName + \' \' + profile.lastName for profile in vm.getProfiles($viewValue)" typeahead-no-results="vm.profilesNoResults" typeahead-min-length="2" class="form-control typeahead-input" ng-blur="vm.profilesNoResults = false" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.profilesNoResults" style="color:red">Nous n\'avons pas cette personne dans nos bases de donn\xE9es mais vous pourrez la cr\xE9\xE9e dans "Mes contributions" afin de renseigner ce champ.</div></div></div><div class="col-md-2" ng-if="currentPosition.readOnlyInitOrganisation === false"><div style="border-left: 1px solid #ccc;height: 100%;width: 100%;display: table;height: 176px;padding: 20px;vertical-align: middle;text-align: center;padding-top: 60px;margin-top: 22px">Exp\xE9rience actuelle {{$index + 1}}<br><!--\n                                            <br /><i class="fal fa-minus-circle fa-2x" ng-click="vm.currentPositions.splice($index,1)" title="Supprimer l\'exp\xE9rience"></i>\n                                             --></div></div></div></div></div><div class="col-md-4"><div class="col-sm-4 text-center"><div class="col-sm-4 text-center"><div class="kv-avatar"><div class="file-input file-input-ajax-new"><div class="file-preview"><div class="file-drop-zone"><div class="file-preview-thumbnails"><div class="file-default-preview" style="cursor: pointer"><img ngf-select ngf-change="vm.setPicture($file, vm.profile)" accept="image/*" data-ng-src="{{\'data:\' + vm.profile.pictureContentType + \';base64,\' + vm.profile.picture}}" style="max-width: 160px" ng-if="vm.profile.picture"> <img ngf-select ngf-change="vm.setPicture($file, vm.profile)" accept="image/*" width="160px" src="content/images/no-picture.png" alt="Photo de profil" ng-if="!vm.profile.picture"></div></div><div class="clearfix"></div><div class="file-preview-status text-center text-success"></div></div><input type="hidden" class="form-control" name="picture" id="field_picture" ng-model="vm.profile.picture" maxbytes="5000000"> <input type="hidden" class="form-control" name="pictureContentType" id="field_pictureContentType" ng-model="vm.profile.pictureContentType"><div ng-if="vm.profile.picture" class="help-block clearfix" style="padding-left: 13px; padding-right: 17px; vertical-align: middle"><div ng-show="vm.profileInitForm.picture.$invalid"><p class="help-block" ng-show="vm.profileInitForm.picture.$error.maxbytes">La taille de l\'image ne doit pas d\xE9passer 5MB.</p></div><span class="pull-left">{{vm.profile.pictureContentType}}, {{vm.byteSize(vm.profile.picture)}}</span> <button type="button" ng-click="vm.profile.picture=null;vm.profile.pictureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div></div></div></div></div></div></div></div><div class="row"><!-- TODO: Ajouter un champ sup\xE9rieur hierarchique --><!-- TODO: Modifier design pour avoir un champ double contact et la photo de profil --><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_phoneNumber">Num\xE9ro de t\xE9l\xE9phone</label><input type="text" class="form-control" name="phoneNumber" id="field_phoneNumber" ng-model="vm.profile.phoneNumber"></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_email">Adresse email</label><input type="text" class="form-control" name="email" id="field_email" disabled="true" ng-model="vm.profile.email" ng-maxlength="100"><div ng-show="vm.profileInitForm.email.$invalid"><p class="help-block" ng-show="vm.profileInitForm.email.$error.maxlength">Ce champ ne peut pas d\xE9passer 100 caract\xE8res.</p></div></div></div></div><div class="form-inline"><div class="form-group"><input style="height: 30px;width: 60px" type="checkbox" class="form-control checkbox" name="conditions" id="field_conditions" ng-model="vm.conditions" required><label class="control-label" for="field_conditions">J\'ai lu et et j\'accepte les conditions g\xE9n\xE9rales du site.</label></div></div><button type="submit" ng-disabled="vm.profileInitForm.$invalid || vm.isSaving" class="btn btn-primary pull-right"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></form></div></div></div></div>');
$templateCache.put('app/entities/profile/profile-linkedin-dialog.html','<style>.linkedin-step {\n        margin-bottom: 20px;\n        font-size: 16px;\n    }\n    .linkedin-info {\n        font-size: 12px;\n    }\n    .progress-bar-animated {\n    -webkit-animation: progress-bar-stripes 1s linear infinite;\n    animation: progress-bar-stripes 1s linear infinite;\n    }\n    .bg-danger {\n        background-color: #dc3545!important;\n    }\n    .bg-success {\n        background-color: #28a745!important;\n    }</style><div class="container"><form name="linkedinForm" role="form" ng-submit="vm.save()" show-validation><div class="row"><jhi-alert-error></jhi-alert-error><div class="col-md-6 well"><h3 style="margin-bottom: 25px">R\xE9cup\xE9rons vos relations LinkedIn</h3><p style="margin-bottom: 25px">Lors de cette \xE9tape, uniquement vos relations LinkedIn seront collect\xE9es et import\xE9es. Pour cela, suivez les instructions suivantes :</p><ul><li class="linkedin-step">1. Connectez vous \xE0 LinkedIn, et ouvrez votre page d\'archive : <a href="https://www.linkedin.com/psettings/member-data" target="_bkank" style="color: #196AD4;text-decoration: underline">Ouvrir</a></li><li class="linkedin-step">2. T\xE9l\xE9chargez vos relations :</li><ul><li class="linkedin-step">- Choisissez <b>"Vous recherchez quelque chose en particulier ?"</b> et <b>"Mes relations"</b></li><li class="linkedin-step">- Cliquez sur le bouton <b>"T\xE9l\xE9charger les archives"</b><br><i class="linkedin-info">NB : Cette \xE9tape peut prendre plusieurs minutes. Linkedin vous enverra un e-mail lorsque le t\xE9l\xE9chargement sera termin\xE9.</i></li></ul><li class="linkedin-step">3. Une fois r\xE9cup\xE9r\xE9e, d\xE9zippez l\'archive, puis importez le fichier Connections.csv :<br><br><input style="font-size: 16px; line-height: 1em" ngf-select type="file" name="file" placeholder="Aucun fichier CSV" ng-model="vm.file" accept=".csv"></li><li style="display: flex"><input style="height: 30px;width: 60px;margin-right: 8px" type="checkbox" name="conditions" id="field_conditions" ng-model="vm.conditions" required><label class="control-label" for="field_conditions">En int\xE9grant votre fichier de contacts, vous acceptez de transmettre volontairement \xE0 Axenteev des donn\xE9es personnelles conformes \xE0 la r\xE9glementation en vigueur. Conform\xE9ment \xE0 la RGPD, nous prot\xE9geons toutes les donn\xE9es personnelles en notre possession et nous interdisons de les commercialiser \xE0 des fins de prospection commerciale.</label></li></ul><br><div class="row"><div class="col-md-12"><span ng-show="vm.isSaving" style="font-weight:bold;padding-right: 5px">Import Linkedin en cours... Cette action peut prendre quelques minutes. Merci de patienter.</span><div ng-show="vm.isSaving" class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="width: 25%"></div></div><span ng-show="vm.isSuccess" style="color:#28a745;font-weight:bold;padding-right: 5px">Votre import a bien \xE9t\xE9 pris en compte et est en cours de traitement.</span><div ng-show="vm.isSuccess" class="progress"><div class="progress-bar bg-success" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div><span ng-show="vm.isError" style="color:#dc3545;font-weight:bold;padding-right: 5px">Une erreur est survenue. Merci de renouveler votre import.</span><div ng-show="vm.isError" class="progress"><div class="progress-bar bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div><button ng-disabled="vm.isSaving || vm.isSuccess" type="button" class="btn btn-default" ui-sref="my-profile"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="linkedinForm.$invalid || !vm.file || vm.isSaving || vm.isSuccess" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Importer</span></button> <button ng-show="vm.isSuccess" type="button" class="btn btn-default" ui-sref="my-profile"><span class="glyphicon glyphicon-home"></span>&nbsp;<span>Retour</span></button></div></div></div><div class="col-md-6"><img src="content/images/linkedin-import.png" width="100%"></div></div></form></div>');
$templateCache.put('app/entities/profile/profile-picture-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPositionLabel">Modifier votre photo de profil</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ngf-drop ngf-change="vm.setPicture($file, vm.profile)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_picture">Photo de profil</label><div><img data-ng-src="{{\'data:\' + vm.profile.pictureContentType + \';base64,\' + vm.profile.picture}}" style="max-height: 100px" ng-if="vm.profile.picture"><div ng-if="vm.profile.picture" class="help-block clearfix"><span class="pull-left">{{vm.profile.pictureContentType}}, {{vm.byteSize(vm.profile.picture)}}</span> <button type="button" ng-click="vm.profile.picture=null;vm.profile.pictureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPicture($file, vm.profile)" accept="image/*">Ajouter une photo de profil</button></div><input type="hidden" class="form-control" name="picture" id="field_picture" ng-model="vm.profile.picture" maxbytes="5000000"> <input type="hidden" class="form-control" name="pictureContentType" id="field_pictureContentType" ng-model="vm.profile.pictureContentType"><div ng-show="editForm.picture.$invalid"><p class="help-block" ng-show="editForm.picture.$error.maxbytes">La photo ne doit pas exc\xE9der 5MB.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-position-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPositionLabel">Cr\xE9er ou modifier une exp\xE9rience</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_startDate">Date de d\xE9but</label><input type="number" class="form-control" name="startDate" id="field_startDate" ng-model="vm.position.startDate" min="1920" max="2100"><div ng-show="editForm.startDate.$invalid"><p class="help-block" ng-show="editForm.startDate.$error.min" translate-value-min="1920">Cette date ne peut \xEAtre inf\xE9rieure \xE0 1920.</p><p class="help-block" ng-show="editForm.startDate.$error.max">Cette date ne peut \xEAtre sup\xE9rieure \xE0 2100.</p><p class="help-block" ng-show="editForm.startDate.$error.number">Veuillez renseigner un nombre.</p></div></div><div class="form-group"><label class="control-label" for="field_endDate">Date de fin</label><input type="number" class="form-control" name="endDate" id="field_endDate" ng-model="vm.position.endDate" min="1920" max="2100"><div ng-show="editForm.endDate.$invalid"><p class="help-block" ng-show="editForm.endDate.$error.min" translate-value-min="1920">Cette date ne peut \xEAtre inf\xE9rieure \xE0 1920.</p><p class="help-block" ng-show="editForm.endDate.$error.max">Cette date ne peut \xEAtre sup\xE9rieure \xE0 2100.</p><p class="help-block" ng-show="editForm.endDate.$error.number">Veuillez renseigner un nombre.</p></div></div><div class="form-group"><label class="control-label" for="field_title">Titre professionnel</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.position.title"></div><div class="form-group typeahead-group"><label for="field_organization">Entreprise ou collectivit\xE9</label><input id="field_organization" name="organization" type="text" autocomplete="off" ng-model="vm.position.organisation" uib-typeahead="organization as organization.name for organization in vm.getOrganizations($viewValue)" typeahead-loading="vm.loadingOrganizations" class="form-control" typeahead-editable="false"> <i ng-show="vm.loadingOrganizations" class="glyphicon glyphicon-refresh"></i></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-stats.html','<div class="profile-stats-wrapper"><div class="row"><div class="col-xs-3 profile-stats-panel-col"><div class="profile-stats-panel"><p class="profile-stats-panel-title">Graphique <span class="profile-stats-close" ng-click="vm.isStatOpen = false; $event.stopPropagation();">Fermer</span></p><ul><li ng-click="vm.statMode = \'rank\'"><input type="radio" ng-checked="vm.statMode === \'rank\'"> Classement</li><li ng-click="vm.statMode = \'rate\'"><input type="radio" ng-checked="vm.statMode === \'rate\'"> Note</li><li ng-click="vm.statMode = \'deals\'"><input type="radio" ng-checked="vm.statMode === \'deals\'"> Deals</li><li ng-click="vm.statMode = \'contributions\'"><input type="radio" ng-checked="vm.statMode === \'contributions\'"> Contributions</li><li ng-click="vm.statMode = \'network\'"><input type="radio" ng-checked="vm.statMode === \'network\'"> Network</li></ul></div></div><div class="col-xs-9 profile-stats-charts-col"><div class="profile-stats-charts" ng-show="vm.statMode === \'rank\'"><canvas class="chart chart-line" height="110" chart-data="vm.stats.ranks" chart-labels="vm.statLabels" chart-series="vm.series.ranks" chart-options="vm.lineOptions" chart-colors="vm.rankColors"></canvas></div><div class="profile-stats-charts" ng-show="vm.statMode === \'rate\'"><canvas class="chart chart-line" height="110" chart-data="vm.stats.rates" chart-labels="vm.statLabels" chart-series="vm.series.rates" chart-options="vm.lineOptions" chart-colors="vm.rateColors"></canvas></div><div class="profile-stats-charts" ng-show="vm.statMode === \'deals\'"><canvas class="chart chart-bar" height="110" chart-data="vm.stats.deals" chart-labels="vm.statLabels" chart-series="vm.series.deals" chart-options="vm.barOptions" chart-colors="vm.dealColors"></canvas></div><div class="profile-stats-charts" ng-show="vm.statMode === \'contributions\'"><canvas class="chart chart-bar" height="110" chart-data="vm.stats.contributions" chart-labels="vm.statLabels" chart-series="vm.series.contributions" chart-options="vm.barOptions" chart-colors="vm.contributionColors"></canvas></div><div class="profile-stats-charts" ng-show="vm.statMode === \'network\'"><canvas class="chart chart-bar" height="110" chart-data="vm.stats.network" chart-labels="vm.statLabels" chart-series="vm.series.network" chart-options="vm.barOptions" chart-colors="vm.contributionColors"></canvas></div></div></div></div>');
$templateCache.put('app/entities/profile/profile.html','<div id="profile-page"><div class="profile-header"><!--\n        <div class="profile-stats-container" ng-click="vm.isStatOpen = true" ng-class="vm.isStatOpen ? \'opened\': \'\'">\n            <p ng-hide="vm.isStatOpen" class="profile-stats-container-hover">\n                Acc\xE9dez aux performances g\xE9n\xE9rales\n            </p>\n            <div ng-show="vm.isStatOpen" ng-include="\'app/entities/profile/profile-stats.html\'"></div>\n        </div>\n        --><div class="profile-stats-container" ui-sref="comingsoon" ng-class="vm.isStatOpen ? \'opened\': \'\'" style="cursor: pointer"><p ng-hide="vm.isStatOpen" class="profile-stats-container-hover">Acc\xE9dez aux performances g\xE9n\xE9rales</p><div ng-show="vm.isStatOpen" ng-include="\'app/entities/profile/profile-stats.html\'"></div></div><div class="profile-infos"><div class="container"><div class="row"><div class="col-xs-6 col-sm-2"><a ui-sref="picture-edit"><div class="square-picture" ng-show="vm.picture" ng-style="{\'background-image\': \'url(\\\'data:png;base64,\' + vm.picture }"></div><div class="square-picture" ng-hide="vm.picture" style="background-image: url(\'content/images/no-picture.png\')"></div></a></div><div class="col-xs-6 col-sm-3 profile-name-container" style="max-width: 250px"><p class="profile-name">{{ vm.profile.firstName }} {{ vm.profile.lastName }} &nbsp; <a style="color: white" ui-sref="my-profile.contribution.edit-profile({profile: vm.profile})" title="Modifier mon profil"><i class="fal fa-edit" style="font-size: 16px"></i></a> &nbsp; <a ng-if="!vm.currentAccount.oauth2" style="color: white" ui-sref="password" title="Modifier mon mot de passe"><i class="fal fa-key" style="font-size: 16px"></i></a></p><p class="member-since"></p></div><div class="col-sm-7 col-xs-12 table-container"><table class="profile-infos-table"><tr><td class="table-icon"><i class="fal fa-building fa-2x fa-fw"></i></td><td class="table-field-name"><span ng-show="vm.currentPosition">{{ vm.currentPosition.organisation.name }}</span></td></tr><tr><td class="table-icon"><i class="fal fa-suitcase fa-2x fa-fw"></i></td><td class="table-field-name"><span ng-show="vm.currentPosition">{{ vm.currentPosition.title }}</span></td></tr></table><!--\n                        <table class="profile-infos-table">\n                            <tr>\n                                <td class="table-icon">\n                                    <i class="fal fa-sort-numeric-down fa-2x fa-fw"></i>\n                                </td>\n                                <td class="table-field-name">\n                                    Ma note\n                                </td>\n                                <td class="table-score">\n                                    -\n                                </td>\n                            </tr>\n                            <tr>\n\n                                <td class="table-icon" has-any-authority="ROLE_DG">\n                                    <i class="fal fa-handshake fa-2x fa-fw"></i>\n                                </td>\n                                <td class="table-field-name" has-any-authority="ROLE_DG">\n                                    Mes deals\n                                </td>\n                                <td class="table-score" has-any-authority="ROLE_DG">\n                                    -\n                                </td>\n                            </tr>\n                        </table>\n                        --><table class="profile-infos-table"><tr><td class="table-icon"><i class="fal fa-user-plus fa-2x fa-fw"></i></td><td class="table-field-name">\xC0 qualifier</td><td class="table-score">{{vm.statsAccount.aConnecterCount}}</td></tr><tr><td class="table-icon"><i class="fal fa-users fa-2x fa-fw"></i></td><td class="table-field-name">Mon r\xE9seau</td><td class="table-score">{{vm.statsAccount.network.count}} / {{vm.statsAccount.networkWithGrade3.count}}</td></tr></table></div></div></div></div></div><div class="profile-body"><div class="container"><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><!--<div class="left-addon-fixed">--><contribution-loop-addon></contribution-loop-addon><!--</div>--></div><div class="col-xs-12 page-body"><div cg-busy="{promise:profileBusyPromise,wrapperClass:\'\', templateUrl: \'cgbusy-big.html\',}" style="position:relative;width: 100%;height: 100%"></div><!-- DESACTIVE\n                <div id="profile-panel-stats" class="panel panel-default panel-stats">\n                    <div class="panel-heading">Mes performances en f\xE9vrier</div>\n                    <table class="table table-striped">\n                        <tr>\n                            <td class="first-cell">\n                                Mon Classement\n                            </td>\n                            <td class="progression">\n                                <span class="darker progression-bar"\n                                      ng-style="{\'width\': vm.statsAccount.position.width + \'%\'}">\n                                    {{ vm.statsAccount.position.count }}\n                                    <sup ng-if="vm.statsAccount.position.count > 1">\n                                        e\n                                    </sup>\n                                    <sup ng-if="vm.statsAccount.position.count === 1">\n                                        er\n                                    </sup>\n                                </span>\n                            </td>\n                            <td class="td-arrow">\n                                <img src="content/images/arrow-up.png" width="30"\n                                     ng-if="vm.statsAccount.position.rate > 0">\n                                <img src="content/images/arrow-constant.png" width="30"\n                                     ng-if="vm.statsAccount.position.rate == 0">\n                                <img src="content/images/arrow-down.png" width="30"\n                                     ng-if="vm.statsAccount.position.rate < 0">\n                            </td>\n                            <td class="rate">\n                                <span ng-if="vm.statsAccount.position.rate > 0">\n                                    +\n                                </span>\n                                {{ vm.statsAccount.position.rate }} % (ao\xFBt)\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>\n                                Mes deals\n                            </td>\n                            <td class="progression">\n                                <span class="dark progression-bar"\n                                      ng-style="{\'width\': vm.statsAccount.deals.width + \'%\'}">\n                                    {{ vm.statsAccount.deals.count }}\n                                </span>\n                            </td>\n                            <td class="td-arrow">\n                                <img src="content/images/arrow-up.png" width="30"\n                                     ng-if="vm.statsAccount.deals.rate > 0">\n                                <img src="content/images/arrow-constant.png" width="30"\n                                     ng-if="vm.statsAccount.deals.rate == 0">\n                                <img src="content/images/arrow-down.png" width="30"\n                                     ng-if="vm.statsAccount.deals.rate < 0">\n                            </td>\n                            <td class="rate">\n                                <span ng-if="vm.statsAccount.deals.rate > 0">\n                                    +\n                                </span>\n                                {{ vm.statsAccount.deals.rate }} % (ao\xFBt)\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>\n                                Mes Contributions\n                            </td>\n                            <td class="progression">\n                                <span class="regular progression-bar"\n                                      ng-style="{\'width\': vm.statsAccount.contributions.width + \'%\'}">\n                                    {{ vm.statsAccount.contributions.count }}\n                                </span>\n                            </td>\n                            <td class="td-arrow">\n                                <img src="content/images/arrow-up.png" width="30"\n                                     ng-if="vm.statsAccount.contributions.rate > 0">\n                                <img src="content/images/arrow-constant.png" width="30"\n                                     ng-if="vm.statsAccount.contributions.rate == 0">\n                                <img src="content/images/arrow-down.png" width="30"\n                                     ng-if="vm.statsAccount.contributions.rate < 0">\n                            </td>\n                            <td class="rate">\n                                <span ng-if="vm.statsAccount.contributions.rate > 0">\n                                    +\n                                </span>\n                                {{ vm.statsAccount.contributions.rate }} % (ao\xFBt)\n                            </td>\n                        </tr>\n                        <tr>\n                            <td>\n                                Mon r\xE9seau\n                            </td>\n                            <td class="progression">\n                                <span class="light progression-bar"\n                                      ng-style="{\'width\': vm.statsAccount.indices.width + \'%\'}">\n                                    {{ vm.statsAccount.indices.count }}\n                                </span>\n                            </td>\n                            <td class="td-arrow">\n                                <img src="content/images/arrow-up.png" width="30"\n                                     ng-if="vm.statsAccount.indices.rate > 0">\n                                <img src="content/images/arrow-constant.png" width="30"\n                                     ng-if="vm.statsAccount.indices.rate == 0">\n                                <img src="content/images/arrow-down.png" width="30"\n                                     ng-if="vm.statsAccount.indices.rate < 0">\n                            </td>\n                            <td class="rate">\n                                <span ng-if="vm.statsAccount.indices.rate > 0">\n                                    +\n                                </span>\n                                {{ vm.statsAccount.indices.rate }} % (ao\xFBt)\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n                --><div class="panel panel-default panel-stats"><div class="panel-heading" style="display: contents"><p class="text-center">Connectez votre fichier <img style="width: 66px; vertical-align: text-top" src="/content/images/582px-LinkedIn_Logo.png"> afin de gagner des cr\xE9dits et rester \xE0 jour ! <a ui-sref="linkedin" style="margin-left:6px" class="btn btn-primary">Continuer</a></p></div></div><div id="profile-panel-position" class="panel panel-default panel-stats"><div class="panel-heading">Mes Exp\xE9riences <a class="add-btn" style="color: black" ui-sref="my-profile.contribution.edit-profile({id: vm.profile})" title="Modifier mon profil"><i class="fal fa-edit" style="font-size: 18px"></i></a></div><table class="table table-striped"><tr ng-hide="vm.positions.length"><td><p class="nothing-to-show">Vous n\'avez renseign\xE9 aucune exp\xE9rience.<br><a ui-sref="my-position-new">Ajouter une exp\xE9rience</a></p></td></tr><tr ng-repeat="position in vm.positions | orderBy:\'-startDate\'"><td>{{ position.startDate }} - {{ position.endDate }}</td><td><a ng-show="position.organisation.type === \'company\'" ui-sref="company-detail({ id: position.organisation.id })">{{ position.organisation.name }} </a><a ng-show="position.organisation.type === \'collectivity\'" ui-sref="collectivity-detail({ id: position.organisation.id })">{{ position.organisation.name }}</a></td><td>{{ position.title }}</td><!--\n                            <td>\n                                <a class="pull-right add-btn" ui-sref="my-position-edit({ id: position.id })">\n                                    <i class="fas fa-pencil fa-fw"></i> Mon compte\n                                    Modifier\n                                </a>\n                            </td>\n                            --></tr></table></div><!--\n                <div id="profile-panel-education" class="panel panel-default panel-stats">\n                    <div class="panel-heading">\n                        Mes Formations\n                        <a href class="add-btn" ui-sref="my-education-new">\n                           <i class="fas fa-square fa-fw"></i> Mon compte\n                            Ajouter une formation\n                        </a>\n                    </div>\n                    <table class="table table-striped">\n                        <tr ng-hide="vm.educations.length">\n                            <td>\n                                <p class="nothing-to-show">\n                                    Vous n\'avez renseign\xE9 aucune formation.\n                                    <br>\n                                    <a ui-sref="my-education-new">Ajouter une formation</a>\n                                </p>\n                            </td>\n                        </tr>\n                        <tr ng-repeat="education in vm.educations | orderBy:\'-startDate\'">\n                            <td>\n                                {{ education.startDate }} - {{ education.endDate }}\n                            </td>\n                            <td>\n                                {{ education.establishment.name }}\n                            </td>\n                            <td>\n                                {{ education.degree }}\n                            </td>\n                            <td>\n                                <a class="pull-right add-btn" ui-sref="my-education-edit({ id: education.id })">\n                                    <i class="fas fa-pencil fa-fw"></i> Mon compte\n                                    Modifier\n                                </a>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n--><!--\n                    <div id="profile-mark" class="well">\n                        <div class="mark-heading">\n                            Ma Note\n                        </div>\n                        <div class="mark-body row">\n                            <div class="col-xs-3">\n                                <div class="mark-picture-container">\n                                    <img class="rank-img" width="70" src="content/images/credits-triangle.png">\n                                    <span class="dashed-line"></span>\n                                    <p class="rate">\n\n                                    </p>\n                                    <p class="month-rate text-light">\n\n                                    </p>\n                                </div>\n                            </div>\n                            <div class="col-xs-9">\n                                <div class="mark-table-container">\n                                    <table class="table table-striped plus-table">\n                                        <tr>\n                                            <td>\n                                                <span class="plus">\n                                                +\n                                            </span>\n                                            </td>\n                                            <td>\n                                                <b></b> Cr\xE9ations de fiche\n                                            </td>\n                                            <td class="percentage">\n\n                                            </td>\n                                        </tr>\n                                        <tr>\n                                            <td>\n                                            </td>\n                                            <td>\n                                                <b></b> Modifications\n                                            </td>\n                                            <td>\n\n                                            </td>\n                                        </tr>\n                                        <tr>\n                                            <td>\n                                            </td>\n                                            <td>\n                                                <b></b> Alertes donn\xE9es\n                                            </td>\n                                            <td>\n\n                                            </td>\n                                        </tr>\n                                    </table>\n                                    <table class="table table-striped minus-table">\n                                        <tr>\n                                            <td>\n                                                <span class="minus">\n                                                -\n                                            </span>\n                                            </td>\n                                            <td>\n                                                <b></b> Contributions erron\xE9es\n                                            </td>\n                                            <td class="percentage">\n                                            </td>\n                                        </tr>\n                                        <tr>\n                                            <td>\n                                            </td>\n                                            <td>\n                                                <b></b> Cr\xE9ation obsol\xE8te\n                                            </td>\n                                            <td>\n                                            </td>\n                                        </tr>\n                                        <tr>\n                                            <td>\n                                            </td>\n                                            <td>\n                                                <b></b> Modifications l\xE9g\xE8res\n                                            </td>\n                                            <td>\n\n                                            </td>\n                                        </tr>\n                                    </table>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                --></div><div class="right-addon-container hidden-xs hidden-sm"><!--<div class="right-addon-fixed">--><suggestion-addon></suggestion-addon><discover-addon></discover-addon><copyright-addon></copyright-addon><!--</div>--></div></div></div></div></div>');
$templateCache.put('app/entities/profile/profiles.html','<div><h2>Profiles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="profile.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Profile</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span>First Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Last Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="picture"><span>Picture</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneNumber"><span>Phone Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.id"><span>User</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="superior.id"><span>Superior</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="profile in vm.profiles track by profile.id"><td><a ui-sref="profile-detail({id:profile.id})">{{profile.id}}</a></td><td>{{profile.firstName}}</td><td>{{profile.lastName}}</td><td><a ng-if="profile.picture" ng-click="vm.openFile(profile.pictureContentType, profile.picture)"><img data-ng-src="{{\'data:\' + profile.pictureContentType + \';base64,\' + profile.picture}}" style="max-height: 30px"> </a><span ng-if="profile.picture">{{profile.pictureContentType}}, {{vm.byteSize(profile.picture)}}</span></td><td>{{profile.phoneNumber}}</td><td>{{profile.email}}</td><td>{{profile.user.id}}</td><td><a ui-sref="profile-detail({id:profile.superior.id})">{{profile.superior.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="profile-detail({id:profile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="profile.edit({id:profile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="profile.delete({id:profile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/rectify-profile/rectify-profile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDepartmentLabel">Corriger les informations de {{vm.profileToRectify.firstName}} {{vm.profileToRectify.lastName}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="alert alert-info">Veuillez pr\xE9ciser votre demande de correction. Un message nous sera envoy\xE9 pour prendre en compte votre demande.<br><br><span ng-show="vm.profileToRectify.domain === \'datago\'" style="margin-left:4px; font-weight:bolder">Source des donn\xE9es \xE0 corriger : data.gouf.fr </span><span ng-show="vm.profileToRectify.domain === \'guidep\'" style="margin-left:4px; font-weight:bolder">Source des donn\xE9es \xE0 corriger : Guide du pouvoir </span><span ng-show="vm.profileToRectify.domain === \'tob\'" style="margin-left:4px; font-weight:bolder">Source des donn\xE9es \xE0 corriger : The Official Board </span><span ng-show="vm.profileToRectify.domain === \'legacy\'" style="margin-left:4px; font-weight:bolder">Source des donn\xE9es \xE0 corriger : Legacy </span><span ng-show="vm.profileToRectify.domain === \'linked\'" style="margin-left:4px; font-weight:bolder">Source des donn\xE9es \xE0 corriger : LinkedIn</span></div><div class="form-group"><label class="control-label" for="field_messagee">Message</label><textarea rows="7" class="form-control" name="message" id="field_message" ng-model="vm.message" placeholder="Saisissez ici votre demande de correction." required>\n            </textarea><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Envoyer</span></button></div></form>');
$templateCache.put('app/entities/sector/sector-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sector.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce secteur d\'activit\xE9 ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/sector/sector-detail.html','<div><h2><span>Secteur d\'activit\xE9</span> {{vm.sector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.sector.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="sector-detail.edit({id:vm.sector.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/sector/sector-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySectorLabel">Cr\xE9er ou modifier un secteur d\'activit\xE9</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sector.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sector.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.sector.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/sector/sectors.html','<div><h2>Secteurs d\'activit\xE9</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sector.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er un nouveau secteur d\'activit\xE9</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="sector in vm.sectors track by sector.id"><td><a ui-sref="sector-detail({id:sector.id})">{{sector.id}}</a></td><td>{{sector.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sector-detail({id:sector.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="sector.edit({id:sector.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="sector.delete({id:sector.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/subscription/subscription-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.subscription.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Subscription?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/subscription/subscription-detail.html','<div><h2><span>Subscription</span> {{vm.subscription.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Active</span></dt><dd><span>{{vm.subscription.active}}</span></dd><dt><span>Subscriber</span></dt><dd>{{vm.subscription.subscriber.id}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="subscription-detail.edit({id:vm.subscription.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/subscription/subscription-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySubscriptionLabel">Create or edit a Subscription</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.subscription.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.subscription.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_active">Active</label><input type="checkbox" class="form-control" name="active" id="field_active" ng-model="vm.subscription.active"><div ng-show="editForm.active.$invalid"><p class="help-block" ng-show="editForm.active.$error.required">This field is required.</p></div></div><div class="form-group"><label for="field_subscriber">Subscriber</label><select class="form-control" id="field_subscriber" name="subscriber" ng-model="vm.subscription.subscriber" ng-options="user as user.id for user in vm.users track by user.id" required><option value=""></option></select></div><div ng-show="editForm.subscriber.$invalid"><p class="help-block" ng-show="editForm.subscriber.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/subscription/subscriptions.html','<div><h2>Subscriptions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="subscription.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Subscription</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span>Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="subscriber.id"><span>Subscriber</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="subscription in vm.subscriptions track by subscription.id"><td><a ui-sref="subscription-detail({id:subscription.id})">{{subscription.id}}</a></td><td>{{subscription.active}}</td><td>{{subscription.subscriber.id}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="subscription-detail({id:subscription.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="subscription.edit({id:subscription.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="subscription.delete({id:subscription.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/title/title-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.title.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmation de suppression</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes-vous s\xFBr(e) de vouloir supprimer ce titre professionnel ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer</span></button></div></form>');
$templateCache.put('app/entities/title/title-detail.html','<div><h2><span>Titre professionnel</span> {{vm.title.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.title.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Retour</span></button> <button type="button" ui-sref="title-detail.edit({id:vm.title.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Modifier</span></button></div>');
$templateCache.put('app/entities/title/title-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTitleLabel">Cr\xE9er ou modifier un titre professionnel</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.title.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.title.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.title.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Ce champ est requis.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annuler</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Enregistrer</span></button></div></form>');
$templateCache.put('app/entities/title/titles.html','<div><h2>Titres professionnels</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="title.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er un nouveau titre professionnel</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="title in vm.titles track by title.id"><td><a ui-sref="title-detail({id:title.id})">{{title.id}}</a></td><td>{{title.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="title-detail({id:title.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="title.edit({id:title.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="title.delete({id:title.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<br><br><div ng-cloak><div class="container"><div class="row"><div class="col-md-12"><h1>Acc\xE8s non autoris\xE9</h1><div class="alert alert-danger">Vous n\'\xEAtes pas authoris\xE9 \xE0 acc\xE9der \xE0 cette page.</div></div></div></div></div>');
$templateCache.put('app/layouts/error/comingsoon.html','<div ng-cloak><div class="container" style="margin-top: 125px"><div class="row"><div class="col-md-12" style="text-align: center"><img src="content/images/comingsoon.svg" width="180"><h1 style="color:black;font-weight: bold">Coming soon</h1><p style="color:#595959;font-size: 18px">Cette fonctionnalit\xE9 est en cours de d\xE9veloppement.</p><br><br><a ui-sref="home" class="btn btn-primary">Retour</a></div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<br><br><div ng-cloak><div class="container"><div class="row"><div class="col-md-8"><h1>Une erreur est survenue.</h1><div class="alert alert-danger">Merci de r\xE9\xE9ssayer ult\xE9rieurement.</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/alerts-popup.html','<div class="alerts-popup navbar-popup well dropdown-menu" aria-labelledby="alertsDropdownBtn"><div class="arrow-up"></div><div class="navbar-popup-header"><span>Alertes </span><a ui-sref="alerts" class="navbar-popup-link">Voir toutes mes alertes</a></div><div class="navbar-popup-container" id="alerts-popup-container"><div class="list-alerts-wrapper"><div ng-repeat="alert in vm.alerts | filter:{ seen: false } | orderBy:\'-createdAt\' : false"><div ng-switch="alert.type"><div ng-switch-when="profile" class="alert-item"><p class="alert-message">{{ alert.message }}</p><p class="alert-submessage">{{ alert.submessage }}</p><a ui-sref="profile({ id: alert.profile.id, position: \'\' })" class="go-to-page-btn"><i class="fas fa-arrow-circle-right"></i> </a><img src="content/images/delete.svg" width="20" class="delete-btn" ng-click="vm.markAlertAsSeen(alert)"></div></div></div><p class="no-alerts" ng-show="vm.alerts.filter(vm.seenFilter).length === 0">Vous \xEAtes \xE0 jour !</p></div></div></div>');
$templateCache.put('app/layouts/navbar/inbox-popup.html','<div class="inbox-popup navbar-popup well"><div class="arrow-up"></div><div class="navbar-popup-header"><span>Messages </span><a ui-sref="inbox" class="navbar-popup-link">Voir toutes mes discussions</a></div><div class="navbar-popup-container" id="inbox-popup-container"><div class="navbar-popup-wrapper"><div ng-repeat="discussion in vm.discussions"><a ui-sref="inbox({discussionId: discussion.id})" ng-click="vm.inboxPopupOpen = false"><div class="navbar-popup-discussion"><div class="img" ng-hide="discussion.contact.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="img" ng-show="discussion.contact.picture" ng-style="{\'background-image\': \'url(\\\'data:png;base64,\' + discussion.contact.picture }"></div><div class="navbar-popup-discussion-informations"><p class="navbar-popup-discussion-contact">{{ discussion.contact.firstName + \' \' + discussion.contact.lastName }}</p><p class="navbar-popup-discussion-name">{{ discussion.title | characters:38:true }}</p></div><a ui-sref="inbox.close({id:discussion.id})"><img has-authority="ROLE_ADMIN" class="close-discussion-icon" src="content/images/bin.svg"> <img has-authority="ROLE_DG" class="close-discussion-icon" src="content/images/bin.svg"></a></div></a></div><p class="no-message" ng-show="vm.discussions.length === 0">Aucune conversation \xE0 afficher.</p></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav id="upper-navbar" ng-show="!vm.isAuthenticated() || !vm.hasProfile()" class="navbar navbar-inverted navbar-fixed-top"><div class="container"><div class="row"><div class="col-sm-12 navbar-header" style="text-align:center"><a ui-sref="home" ui-sref-opts="{reload: true}" du-smooth-scroll ng-click="vm.collapseNavbar()"><img src="content/images/axenteev-white.svg" alt="Axenteev logo" id="home-logo" style="width: 220px;padding: 15px"></a></div></div><a href="" ng-click="vm.logout()" id="logout" ng-show="vm.isAuthenticated() && !vm.hasProfile()" style="color: white; position: absolute;right: 50px; top: 34px"><div><span class="fas fa-sign-out-alt fa-2x fa-fw dropdown-gestion" style="color:white"></span><span style="font-size: 12px">D\xE9connexion</span></div></a></div></nav><nav id="upper-navbar" ng-show="vm.isAuthenticated() && vm.hasProfile()" class="navbar navbar-inverted navbar-fixed-top"><div class="container"><div class="row"><div class="col-md-2 navbar-header"><a class="navbar-brand logo" href="/" du-smooth-scroll ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/axenteev-white.svg"> </a><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></div><div class="col-xs-10 col-sm-2 col-md-4 navbar-form-container"><script>$(\'.input\').keypress(function (e) {\n                      if (e.which == 13) {\n                        $(\'form#searchForm\').submit();\n                        return false;    //<---- Add this line\n                      }\n                    });</script><form id="searchForm" class="navbar-form navbar-left no-padding" role="search"><div class="input-group"><input ng-model-options="{ debounce: 500 }" type="text" class="form-control" placeholder="&#xf002; Rechercher sur Axenteev..." uib-typeahead="result as result.name for result in vm.search($viewValue)" ng-model="vm.query" typeahead-popup-template-url="app/layouts/navbar/search-popup.html" typeahead-no-results="vm.noResults" style="font-family: \'Lato\', \'Font Awesome 5 Pro\'"></div><div class="search-no-results well" ng-show="vm.noResults">Aucun r\xE9sultat</div></form></div><div class="col-xs-12 col-sm-6 col-md-6" style="display:flex"><!-- User logged in --><ul class="nav navbar-nav nav-circles" style="margin-left:auto"><!--\n                        <li ui-sref-active="active">\n                            <a ui-sref="contact">\n                                <span class="nav-circle">\n                                    <i class="fas fa-phone fa-fw"></i> Mon compte\n                                </span>\n                            </a>\n                        </li>\n                     --><li ui-sref-active="active"><a ui-sref="my-profile"><div class="row" style="line-height: 0"><!--\n                                <span class="fas fa-user fa-2x text-center" style="color: white;"> </span>\n                                --> <span ng-show="vm.myPicture" ng-style="{\'background-image\': \'url(\\\'data:png;base64,\' + vm.myPicture }" class="my-picture"></span> <span ng-hide="vm.myPicture" style="background-image: url(content/images/no-picture.png)" class="my-picture"></span></div><div class="row"><span class="text-center" style="color: white">Mon profil</span></div></a></li><li ng-show="!vm.isAdmin()" has-any-authority="ROLE_DG"><a ui-sref="dashboard"><div class="row"><span class="fas fa-chart-bar fa-2x fa-fw text-center" style="color: white"></span></div><div class="row"><span class="text-center" style="color: white">Stats</span></div></a></li><li uib-dropdown on-toggle="toggled(open)" ng-show="vm.isAdmin()"><a href id="inboxDropdownBtn" uib-dropdown-toggle><div class="row"><span class="fas fa-envelope fa-2x fa-fw text-center" style="color: white"></span></div><div class="row"><span class="text-center" style="color: white">Mes messages</span></div></a><ul class="dropdown-menu" uib-dropdown-menu template-url="app/layouts/navbar/inbox-popup.html" aria-labelledby="inboxDropdownBtn"></ul></li><li ng-show="!vm.isAdmin()" has-any-authority="ROLE_COMMERCIAL, ROLE_DG"><a ui-sref="whoswho-map"><div class="row"><span class="fas fa-users fa-2x fa-fw text-center" style="color: white"></span></div><div class="row"><span class="text-center" style="color: white">Who\'s who</span></div></a></li><!--\n                    <li>\n                        <a ui-sref="comingsoon">\n                            <div class="row">\n                                    <span class="fas fa-bell fa-2x fa-fw text-center" style="color: white;"> </span>\n                            </div>\n                            <div class="row">\n                                <span class="text-center" style="color: white;">Mes alertes</span>\n                            </div>\n                        </a>\n                    </li>\n                    --><!--\n                     <li uib-dropdown on-toggle="toggled(open)">\n\n                        <a href id="alertsDropdownBtn" uib-dropdown-toggle>\n                            <div class="row">\n                                <span class="fas fa-bell fa-2x fa-fw text-center" style="color: white;"> </span>\n                            </div>\n                            <div class="row">\n                                <span class="text-center" style="color: white;">Mes alertes</span>\n                            </div>\n                        </a>\n\n                        <a href id="alertsDropdownBtn" uib-dropdown-toggle>\n                            <div class="row">\n                                <span class="fas fa-bell fa-2x fa-fw text-center" style="color: white;"> </span>\n                            </div>\n                            <div class="row">\n                                <span class="text-center" style="color: white;">Mes alertes</span>\n                            </div>\n                        </a>\n\n                        <ul class="dropdown-menu" uib-dropdown-menu template-url="app/layouts/navbar/alerts-popup.html"\n                            aria-labelledby="alertsDropdownBtn">\n                        </ul>\n\n                    </li>\n                     --><!--\n\n                        <li ui-sref-active="active">\n                            <a ui-sref="my-profile">\n                                <span class="nav-circle profile">\n                                    <i class="fas fa-user fa-fw"></i> Mon compte\n                                </span>\n                            </a>\n                        </li>\n                    --><li><a href="https://www.dropbox.com/s/efgs4g3dfkgk8ol/Tutoriel%20-%20Axenteev%202022-12-15.pdf?dl=1"><div class="row"><span class="fas fa-info fa-2x fa-fw text-center" style="color: white"></span></div><div class="row"><span class="text-center" style="color: white">Tutoriel</span></div></a></li><li uib-dropdown on-toggle="toggled(open)"><a href id="gestionDropdownBtn" uib-dropdown-toggle><div class="row"><span class="fas fa-cog fa-2x fa-fw text-center" style="color: white"></span></div><div class="row"><span ng-if="vm.currentAccount.ec" title="{{vm.currentAccount.ec.name}}" class="text-center" style="color: white;display: block;  white-space: nowrap;  overflow: hidden;  text-overflow: ellipsis; width: 100px">{{vm.currentAccount.ec.name}}</span> <span ng-if="!vm.currentAccount.ec" class="text-center" style="color: white">Gestion</span></div></a><ul uib-dropdown-menu style="top:47px;padding:10px" role="menu" aria-labelledby="gestionDropdownBtn"><li role="menuitem" style="margin-bottom: 10px" has-authority="ROLE_DG"><a ui-sref="sales-management"><div><span class="fas fa-cog fa-2x fa-fw dropdown-gestion"></span><span style="color: black;font-size: 12px">Gestion</span></div></a></li><li role="menuitem" style="margin-bottom: 10px" has-authority="ROLE_ADMIN"><a ui-sref="user-management"><div><span class="fas fa-unlock-alt fa-2x fa-fw dropdown-gestion"></span><span style="color: black;font-size: 12px">Administration</span></div></a></li><li role="menuitem"><a href="" ng-click="vm.logout()" id="logout"><div><span class="fas fa-sign-out-alt fa-2x fa-fw dropdown-gestion"></span><span style="color: black;font-size: 12px">D\xE9connexion</span></div></a></li></ul></li><!--\n                    <li has-authority="ROLE_ADMIN" ui-sref-active="active">\n                        <a ui-sref="user-management">\n                            <div class="row">\n                                <span class="fas fa-unlock-alt fa-2x text-center" style="color: white;"> </span>\n                            </div>\n                            <div class="row">\n                              <span class="text-center" style="color: white;">Administration</span>\n                            </div>\n                         </a>\n                    </li>\n\n\n                     <li ui-sref-active="active">\n                        <a href="" ng-click="vm.logout()" id="logout">\n                            <div class="row">\n                                <span class="fas fa-sign-out-alt fa-2x text-center" style="color: white;"> </span>\n                            </div>\n                            <div class="row">\n                              <span class="text-center" style="color: white;">D\xE9connexion</span>\n                            </div>\n                        </a>\n                    </li>\n                --></ul></div></div></div></nav><!--\n<nav id="lower-navbar" class="navbar navbar-default navbar-fixed-top" role="navigation" ng-show="vm.isAuthenticated()">\n    <div class="container">\n        <div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed">\n            <ul class="nav navbar-nav">\n                <li>\n                    <a href="/" du-smooth-scroll>\n                        Home\n                    </a>\n                </li>\n                <li>\n                    <a href="/#/#news" du-smooth-scroll>\n                        News\n                    </a>\n                </li>\n                <li>\n                    <a ui-sref="my-profile" href="" ui-sref-active="active">\n                        Mon Profil\n                    </a>\n                </li>\n                <li uib-dropdown>\n                    <a href id="network-dropdown" uib-dropdown-toggle ui-sref-active="active">\n                        Mon Network\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu aria-labelledby="network-dropdown">\n                        <li>\n                            <a ui-sref="network">Mon r\xE9seau</a>\n                        </li>\n                        <li>\n                            <a ui-sref="flow">Discover</a>\n                        </li>\n                    </ul>\n                </li>\n                <li >\n                    <a href="#" ui-sref-active="active">\n                        Mes Cr\xE9dits\n                    </a>\n                </li>\n                <li has-authority="ROLE_ADMIN">\n                    <a ui-sref="user-management" href="">\n                        <span>\n                            <span class="hidden-md hidden-lg glyphicon glyphicon-tower"></span>\n                            <span class="hidden-sm">Administration</span>\n                        </span>\n                    </a>\n                </li>\n                <li has-authority="ROLE_DG">\n                    <a ui-sref="sales-management" href="">\n                        <span>\n                            <span class="hidden-md hidden-lg glyphicon glyphicon-tower"></span>\n                            <span class="hidden-sm">Gestion</span>\n                        </span>\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</nav>\n-->');
$templateCache.put('app/layouts/navbar/search-collectivity.html','<a class="match-link" ui-sref="collectivity-detail({id: match.model.id})"><div class="square-picture" ng-hide="match.model.pictureContentType" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="square-picture" ng-show="match.model.pictureContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + match.model.logoContentType + \';base64,\' + match.model.logo }"></div><div class="text-container"><span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span><br><span class="subtitle">{{ match.model.sector }}</span></div></a>');
$templateCache.put('app/layouts/navbar/search-company.html','<a class="match-link" ui-sref="company-detail({id: match.model.id})"><div class="square-picture" ng-hide="match.model.logoContentType" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="square-picture" ng-show="match.model.logoContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + match.model.logoContentType + \';base64,\' + match.model.logo }"></div><div class="text-container"><span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span><br><span class="subtitle">{{ match.model.sector.name }}</span></div></a>');
$templateCache.put('app/layouts/navbar/search-people.html','<a class="match-link" tabindex="-1" ui-sref="profile({id: match.model.id, position:\'\'})"><div class="square-picture" ng-hide="match.model.pictureContentType" style="background-image: url(\'../../content/images/no-picture.png\')"></div><div class="square-picture" ng-show="match.model.pictureContentType" ng-style="{\'background-image\':\'url(/api/profiles/\'+match.model.id+\'/picture/bytes)\'}"></div><div class="text-container"><span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span><br><span class="subtitle"><span ng-repeat="positionGrouped in match.model.positions | groupBy:\'organisation.name\' "><span ng-show="positionGrouped.length===1" ng-bind-html="positionGrouped[0].organisation.name | uibTypeaheadHighlight:query"></span> <span ng-show="positionGrouped.length>1">{{positionGrouped.length}} positions \xE0 <span ng-bind-html="positionGrouped[0].organisation.name | uibTypeaheadHighlight:query"></span> </span><span ng-show="!$last" style="padding-left: 2px;padding-right: 2px">/</span></span></span></div></a>');
$templateCache.put('app/layouts/navbar/search-popup.html','<div class="typeahead-wrapper well" style="display: block" ng-show="isOpen() && !moveInProgress" aria-hidden="{{!isOpen()}}"><div class="category-wrapper" ng-show="(matches|filter:{ model : { dropdownType: \'profile\' } }).length > 0"><div class="category-label">Personnes</div><ul class="dropdown-menu" role="listbox"><li class="uib-typeahead-match" ng-repeat="match in matches | filter:{ model : { dropdownType: \'profile\' } } track by $index" ng-class="{active: isActive(matches.indexOf(match)) }" ng-mouseenter="selectActive(matches.indexOf(match))" role="option"><div uib-typeahead-match index="$index" match="match" query="query" template-url="\'app/layouts/navbar/search-people.html\'"></div></li></ul></div><div class="category-wrapper" ng-show="(matches|filter:{ model : { dropdownType: \'company\' } }).length > 0"><div class="category-label">Entreprises</div><ul class="dropdown-menu" role="listbox"><li class="uib-typeahead-match" ng-repeat="match in matches | filter:{ model : { dropdownType: \'company\' } } track by $index" ng-class="{active: isActive(matches.indexOf(match)) }" ng-mouseenter="selectActive(matches.indexOf(match));" role="option"><div uib-typeahead-match index="$index" match="match" query="query" template-url="\'app/layouts/navbar/search-company.html\'"></div></li></ul></div><div class="category-wrapper" ng-show="(matches|filter:{ model : { dropdownType: \'collectivity\' } }).length > 0"><div class="category-label">Collectivit\xE9s</div><ul class="dropdown-menu" role="listbox"><li class="uib-typeahead-match" ng-repeat="match in matches | filter:{ model : { dropdownType: \'collectivity\' } } track by $index" ng-class="{active: isActive(matches.indexOf(match)) }" ng-mouseenter="selectActive(matches.indexOf(match))" role="option"><div uib-typeahead-match index="$index" match="match" query="query" template-url="\'app/layouts/navbar/search-collectivity.html\'"></div></li></ul></div></div>');
$templateCache.put('app/network/contributions/contributions-later.html','<div class="network-list row"><div class="list-header col-xs-12 well"><div class="col-xs-4"><label>Filtrer par :</label><select><option>Contacts</option></select></div><div class="col-xs-4"><label>Trier par :</label><select><option>Nom</option></select></div><div class="col-xs-4 filter-section"><label><input type="text" placeholder="&#xf002 Recherche..." ng-model="vm.searchText" style="font-family: \'Lato\', \'Font Awesome 5 Pro\'"></label></div></div><div class="col-xs-12 no-padding"><ul><li ng-repeat="contact in filtered = (vm.contributionsLater | filter: vm.search)"><div class="square-picture" ng-hide="contact.picture" style="background-image: url(\'content/images/robinson.png\')"></div><div class="square-picture" ng-show="contact.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + vm.profile.pictureContentType + \';base64,\' + vm.profile.picture }"></div><div class="connection-informations"><span class="name">{{ contact.name }}</span><br><span class="title">{{ contact.title }} \xE0 {{ contact.company }}</span><br><span class="location">{{ contact.location }}</span></div><div class="connection-levels"><img src="content/images/level1.png" ng-show="contact.level === 1" class="level-image"> <img src="content/images/level2.png" ng-show="contact.level === 2" class="level-image"> <img src="content/images/level3.png" ng-show="contact.level === 3" class="level-image"></div></li><li ng-hide="filtered.length"><p class="no-items text-center"><i>Il n\'y a pas de contribution correspondante</i></p></li></ul></div></div>');
$templateCache.put('app/network/contributions/contributions-menu.html','<div class="row" style="background-color: #283C5C;color: white;padding:15px;margin-top: 15px">Les profils suivants ont \xE9t\xE9 valid\xE9s automatiquement suite \xE0 l\'import de votre fichier LinkedIn. Cliquez sur 1, 2, 3 afin de qualifier ces profils. Merci de favoriser les profils que vous connaissez bien et souhaitez renseigner en 1.</div><div class="network-sub-tabs row"><a ui-sref="my-contributions-profile" ui-sref-active="active"><div class="col-xs-6 network-sub-tab"><p>Profiles</p></div></a><a ui-sref="my-contributions-organisation" ui-sref-active="active"><div class="col-xs-6 network-sub-tab"><p>Organisations</p></div></a></div><div ui-view="content"><!-- Angular views --></div>');
$templateCache.put('app/network/contributions/my-contributions-organisation.html','<div class="network-list row"><!--\n    <div class="list-header col-xs-12 well">\n        <div class="col-xs-4">\n            <label>\n                Filtrer par :\n            </label>\n            <select>\n                <option>\n                    Contacts\n                </option>\n            </select>\n        </div>\n        <div class="col-xs-4">\n            <label>\n                Trier par :\n            </label>\n            <select>\n                <option>\n                    Nom\n                </option>\n            </select>\n        </div>\n        <div class="col-xs-4 filter-section">\n            <label>\n                    <input type="text" placeholder="&#xf002 Recherche..." ng-model="vm.searchText" style="font-family: \'Lato\', \'Font Awesome 5 Pro\'">\n            </label>\n        </div>\n    </div>\n    --><br><div ng-hide="vm.hide" class="col-xs-12 no-padding well"><ul infinite-scroll="vm.loadMoreContributionsOrganisation()" infinite-scroll-disabled="!vm.hasNextPageContributionsOrganisation || vm.busyLoadingContributionsOrganisation"><li ng-repeat="contrib in vm.contributionsOrganisation track by  contrib.id "><div class="connection-information-container" ng-show="contrib.companyStatus !== undefined"><div class="square-picture" ng-hide="contrib.logoContentType" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="square-picture" ng-show="contrib.logoContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + contrib.logoContentType + \';base64,\' + result.logo }"></div><div class="connection-informations"><a ui-sref="company-detail({id: contrib.id})"><span class="name bold">{{ contrib.name }}</span></a><br><span class="subtitle">{{ contrib.sector.name }}</span></div></div><div class="connection-information-container" ng-show="contrib.companyStatus  === undefined"><div class="square-picture" ng-hide="contrib.logoContentType" style="background-image: url(\'../../content/images/no-picture-company.png\')"></div><div class="square-picture" ng-show="contrib.logoContentType" ng-style="{\'background-image\': \'url(\\\'data:\' + contrib.logoContentType + \';base64,\' + contrib.logo }"></div><div class="connection-informations"><a ui-sref="collectivity-detail({id: contrib.id})"><span class="name bold">{{ contrib.name }}</span></a><br><span class="subtitle">{{ contrib.sector.name }}</span></div></div></li></ul></div></div>');
$templateCache.put('app/network/contributions/my-contributions-profile.html','<div class="network-list row"><!--\n    <div class="list-header col-xs-12 well">\n        <div class="col-xs-4">\n            <label>\n                Filtrer par :\n            </label>\n            <select>\n                <option>\n                    Contacts\n                </option>\n            </select>\n        </div>\n        <div class="col-xs-4">\n            <label>\n                Trier par :\n            </label>\n            <select>\n                <option>\n                    Nom\n                </option>\n            </select>\n        </div>\n        <div class="col-xs-4 filter-section">\n            <label>\n                    <input type="text" placeholder="&#xf002 Recherche..." ng-model="vm.searchText" style="font-family: \'Lato\', \'Font Awesome 5 Pro\'">\n            </label>\n        </div>\n    </div>\n    --><br><div ng-hide="vm.hide" class="col-xs-12 no-padding well"><ul infinite-scroll="vm.loadMoreContributionsProfile()" infinite-scroll-disabled="!vm.hasNextPageContributionsProfile || vm.busyLoadingContributionsProfile" infinite-scroll-listen-for-event="contributionsProfile:updated"><li ng-repeat="contrib in vm.contributionsProfileValues track by $index"><div class="connection-information-container" ng-show="contrib.currentPosition !== undefined"><div class="square-picture" ng-hide="contrib.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="square-picture" ng-show="contrib.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + contrib.pictureContentType + \';base64,\' + contrib.picture }"></div><div class="connection-informations"><div style="display:inline-block"><span ng-show="contrib.importId === \'linked\'" style="margin-right:2px"><a ng-href="https://www.linkedin.com/search/results/all/?keywords={{contrib.firstName}} {{contrib.lastName}}" target="_blank" style="color:#337AC1"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin"></i></a> </span><a ui-sref="profile({id: contrib.id, position: \'\' })"><span class="name">{{ contrib.firstName }} <span class="bold">{{ contrib.lastName }}</span> <span ng-show="contrib.myContribution === true" class="bold" title="C\'est un profile que j\'ai cr\xE9e">*</span></span></a></div><br><span class="title bold" ng-show="contrib.currentPosition.organisation.name "><a ng-show="contrib.currentPosition.organisation.type === \'company\'" ui-sref="company-detail({id: contrib.currentPosition.organisation.id})">{{ contrib.currentPosition.organisation.name | characters:50 }}</a> <a ng-show="contrib.currentPosition.organisation.type === \'collectivity\'" ui-sref="collectivity-detail({id: contrib.currentPosition.organisation.id})">{{ contrib.currentPosition.organisation.name | characters:50 }}</a> </span><span class="title bold" ng-hide="contrib.currentPosition.organisation.name ">Entreprise inconnue</span><br><span class="title" ng-show="contrib.currentPosition.title">{{ contrib.currentPosition.title | characters:50 }} </span><span class="title" ng-hide="contrib.currentPosition.title">Poste inconnu</span></div><div class="connection-levels"><span class="level-image level-1" ng-click="vm.connect(contrib, 1, $index)" ng-class="contrib.grade === 1 ? \'active\' : \'inactive\'" uib-tooltip="Me connecter en 1"></span> <span class="level-image level-2" ng-click="vm.connect(contrib, 2, $index)" ng-class="contrib.grade === 2 ? \'active\' : \'inactive\'" uib-tooltip="Me connecter en 2"></span> <span class="level-image level-3" ng-click="vm.connect(contrib, 3, $index)" ng-class="contrib.grade === 3 ? \'active\' : \'inactive\'" uib-tooltip="Me connecter en 3"></span> <span ng-show="contrib.importId === \'linked\'" class="level-image fa fa-trash" ng-click="vm.deleteAQualifierProfile(contrib.id)" style="color:red; margin-left:10px;font-size: 20px;line-height: 1.5em" uib-tooltip="Supprimer"></span> <span ng-show="contrib.importId !== \'linked\'" class="level-image fa fa-trash" style="color:lightgray; margin-left:10px;font-size: 20px;line-height: 1.5em"></span></div></div></li></ul></div></div>');
$templateCache.put('app/network/connections/my-connections.html','<div class="row" style="background-color: #283C5C;color: white;padding:15px;margin-top: 15px">Les profils suivants sont int\xE9gr\xE9s \xE0 votre r\xE9seau. Cliquez sur 1, 2, 3 pour modifier l\'importance de la relation. Merci de favoriser les profils que vous connaissez bien en 1.</div><br><div class="network-list row"><div cg-busy="{promise:networkBusyPromise,wrapperClass:\'\', templateUrl: \'cgbusy-big.html\',}" style="position:relative;width: 100%;height: 100%"></div><!--\n    <div ng-hide="vm.hide" class="list-header col-xs-12 well">\n        <div class="col-xs-4">\n            <label>\n                Filtrer par :\n            </label>\n            <select>\n                <option>\n                    Contacts\n                </option>\n            </select>\n        </div>\n        <div class="col-xs-4">\n            <label>\n                Trier par :\n            </label>\n            <select ng-options="sortBy as sortBy.label for sortBy in vm.sortingTypes"\n                    ng-change="vm.loadMoreConnexions(true)"\n                    ng-model="vm.sortBy"></select>\n        </div>\n        <div class="col-xs-4 filter-section">\n            <label>\n                    <input type="text" placeholder="&#xf002 Recherche..." ng-model="vm.searchText" style="font-family: \'Lato\', \'Font Awesome 5 Pro\'">\n            </label>\n        </div>\n    </div>\n    --><div ng-hide="vm.hide" class="col-xs-12 no-padding well"><ul infinite-scroll="vm.loadMoreConnexions()" infinite-scroll-disabled="!vm.hasNextPageConnexion || vm.busyLoadingConnexions"><li ng-repeat="contact in vm.people"><div class="connection-information-container"><div class="square-picture" ng-hide="contact.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="square-picture" ng-show="contact.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + contact.pictureContentType + \';base64,\' + contact.picture }"></div><div class="connection-informations"><div style="display:inline-block"><span ng-show="contact.importId === \'linked\'" style="margin-right:2px"><a ng-href="https://www.linkedin.com/search/results/all/?keywords={{contact.firstName }} {{contact.lastName}}" target="_blank" style="color:#337AC1" uib-tooltip="Voir sur LinkedIn"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin"></i></a> </span><a ui-sref="profile({id: contact.id, position: \'\' })"><span class="name">{{ contact.firstName }} <span class="bold">{{ contact.lastName }}</span></span></a></div><br><span class="title bold" ng-show="contact.currentPosition.organisation.name "><a ng-show="contact.currentPosition.organisation.type === \'company\'" ui-sref="company-detail({id: contact.currentPosition.organisation.id})">{{ contact.currentPosition.organisation.name | characters:50 }}</a> <a ng-show="contact.currentPosition.organisation.type === \'collectivity\'" ui-sref="collectivity-detail({id: contact.currentPosition.organisation.id})">{{ contact.currentPosition.organisation.name | characters:50 }}</a> </span><span class="title bold" ng-hide="contact.currentPosition.organisation.name ">Entreprise inconnue</span><br><span class="title" ng-show="contact.currentPosition.title">{{ contact.currentPosition.title | characters:50 }} </span><span class="title" ng-hide="contact.currentPosition.title">Poste inconnu</span></div><div class="connection-levels"><span class="level-image level-1" ng-click="vm.updateGrade(contact, 1, false)" ng-class="contact.grade === 1 ? \'active\' : \'inactive\'"></span> <span class="level-image level-2" ng-click="vm.updateGrade(contact, 2, false)" ng-class="contact.grade === 2 ? \'active\' : \'inactive\'"></span> <span class="level-image level-3" ng-click="vm.updateGrade(contact, 3, false)" ng-class="contact.grade === 3 ? \'active\' : \'inactive\'"></span></div></div></li><li ng-hide="vm.people.length || vm.busyLoadingConnexions  "><p class="no-items text-center"><i>Il n\'y a pas de contact correspondant</i></p></li><li ng-show="vm.busyLoadingConnexions  "><p class="no-items text-center"><i>Chargement...</i></p></li></ul></div></div>');
$templateCache.put('app/network/contributions-pending/my-contributions-pending-profile.html','<div class="row" style="background-color: #283C5C;color: white;padding:15px;margin-top: 15px">Les profils suivants sont en attente de votre validation suite \xE0 l\'import de votre fichier LinkedIn. Cliquez sur 1, 2 afin de cr\xE9er le profil en base. Merci de favoriser les profils que vous connaissez bien et souhaitez renseigner en 1.</div><div class="network-list row"><br><div ng-hide="vm.hide" class="col-xs-12 no-padding well"><ul infinite-scroll="vm.loadMorePendingContributionsProfile()" infinite-scroll-disabled="!vm.hasNextPagePendingContributionsProfile || vm.busyLoadingPendingContributionsProfile"><li ng-repeat="contrib in vm.pendingContributionsProfile track by $index"><div class="connection-information-container"><div class="square-picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="connection-informations"><span style="margin-right:2px"><a ng-href="https://www.linkedin.com/search/results/all/?keywords={{contrib.firstName}} {{contrib.lastName}}" target="_blank" style="color:#337AC1"><i class="fab fa-linkedin"></i></a> </span><span class="name">{{ contrib.firstName }} <span class="bold">{{ contrib.lastName }}</span></span><br><span class="title bold">{{ contrib.company}}</span><br><span class="title">{{ contrib.position | characters:80 }}</span></div><div class="connection-levels"><span class="level-image level-1" ng-click="vm.createProfileFromPendingContribution(contrib, 1)" ng-class="\'inactive\'" uib-tooltip="Cr\xE9er le profil en 1"></span> <span class="level-image level-2" ng-click="vm.createProfileFromPendingContribution(contrib, 2)" ng-class="\'inactive\'" uib-tooltip="Cr\xE9er le profil en 2"></span> <span class="level-image level-3" ng-click="vm.createProfileFromPendingContribution(contrib, 3)" ng-class="\'inactive\'" uib-tooltip="Cr\xE9er le profil en 3"></span><!--\n                        <span class="level-image level-3" ng-click="vm.createProfileFromPendingContribution(contrib, 3)" ng-class="\'inactive\'"></span>\n                        --> <span class="level-image fa fa-trash" ng-click="vm.deletePendingContribution(contrib)" style="margin-left:10px;font-size: 20px;line-height: 1.5em" uib-tooltip="Ignorer"></span></div></div></li></ul></div></div>');
$templateCache.put('app/network/homonyms-pending/my-homonyms-pending-profile.html','<div class="row" style="background-color: #283C5C;color: white;padding:15px;margin-top: 15px">Les homonymes suivants sont en attente de votre validation suite \xE0 l\'import de votre fichier LinkedIn. Cliquez sur Oui pour vous connecter avec la personne existante, ou sur Non pour la cr\xE9er. Merci de favoriser les profils que vous connaissez bien et souhaitez renseigner en 1.</div><div class="network-list row"><br><div ng-hide="vm.hide" class="col-xs-12 no-padding well"><ul infinite-scroll="vm.loadMorePendingHomonymsProfile()" infinite-scroll-disabled="!vm.hasNextPagePendingHomonymsProfile || vm.busyLoadingPendingHomonymsProfile"><li ng-attr-id="{{ \'line-\' + $index }}" ng-repeat="contrib in vm.pendingHomonymsProfile track by $index" style="height:145px"><div class="connection-information-container" style="height:70px"><div class="square-picture" style="margin-top: 28px;background-image: url(\'content/images/no-picture.png\'); height:60px"></div><div class="connection-informations import" ng-style="contrib.memePersonne && contrib.memePersonne === \'oui\' && {\'opacity\': 0.3}"><span style="margin-right:2px"><a ng-href="https://www.linkedin.com/search/results/all/?keywords={{contrib.firstName}} {{contrib.lastName}}" target="_blank" style="color:#337AC1"><i uib-tooltip="Votre import LinkedIn" class="fab fa-linkedin"></i></a> </span><span class="name">{{ contrib.firstName }} <span class="bold">{{ contrib.lastName }}</span></span><br><span class="title bold">{{ contrib.company}}</span><br><span class="title">{{ contrib.position | characters:80 }}</span></div><div ng-hide="contrib.memePersonne && (contrib.memePersonne === \'non\' || contrib.memePersonne === \'oui\')" class="homonyme-sub-tabs" style="margin-right: 0px;float: right; margin-top: 48px" uib-tooltip="M\xEAme personne ?"><a ng-click="vm.memePersonne(contrib, \'oui\')"><div class="col-xs-6 homonyme-sub-tab"><p>Oui</p></div></a><a ng-click="vm.memePersonne(contrib, \'non\')"><div class="col-xs-6 homonyme-sub-tab"><p>Non</p></div></a></div><div class="connection-levels" ng-show="contrib.memePersonne && contrib.memePersonne === \'non\'"><span class="level-image level-1" ng-click="vm.createProfileFromPendingHomonym(contrib, 1)" ng-class="\'inactive\'" uib-tooltip="Cr\xE9er le profil en 1"></span> <span class="level-image level-2" ng-click="vm.createProfileFromPendingHomonym(contrib, 2)" ng-class="\'inactive\'" uib-tooltip="Cr\xE9er le profil en 2"></span> <span class="level-image level-3" ng-click="vm.createProfileFromPendingHomonym(contrib, 3)" ng-class="\'inactive\'" uib-tooltip="Cr\xE9er le profil en 3"></span><!--\n                        <span class="level-image level-3" ng-click="vm.createProfileFromPendingHomonym(contrib, 3)" ng-class="\'inactive\'"></span>\n                        --> <span class="level-image fa fa-trash" ng-click="vm.deletePendingHomonym(contrib)" style="margin-left:10px;font-size: 20px;line-height: 1.5em" uib-tooltip="Ignorer"></span></div></div><div ng-style="contrib.memePersonne && contrib.memePersonne === \'non\' && {\'opacity\': 0.3}" class="connection-information-container" style="height:70px; padding-left:60px"><div class="connection-informations base"><span ng-show="contrib.similarProfile.domain === \'linked\' || contrib.similarProfile.importId === \'linked\'"><i class="fab fa-linkedin" uib-tooltip="Source : Base cliente LinkedIn"></i> </span><span ng-show="contrib.similarProfile.domain === \'datago\'"><i class="fal fa-book-open" uib-tooltip="Source : data.gouf.fr"></i> </span><span ng-show="contrib.similarProfile.domain === \'guidep\'"><i class="fal fa-file-user" uib-tooltip="Source : Guide du pouvoir"></i> </span><span ng-show="contrib.similarProfile.domain === \'legacy\'"><i class="fal fa-scroll-old" uib-tooltip="Source : Legacy"></i> </span><span ng-show="contrib.similarProfile.domain === \'tob\'"><i class="fal fa-file-check" uib-tooltip="Source : The Official Board"></i> </span><a ui-sref="profile({id: contrib.similarProfile.id, position: \'\' })"><span class="name">{{ contrib.similarProfile.firstName }} <span class="bold">{{ contrib.similarProfile.lastName }}</span></span></a><br><span class="title bold" ng-show="contrib.similarProfile.currentPosition.organisation.name"><a ng-show="contrib.similarProfile.currentPosition.organisation.type === \'company\'" ui-sref="company-detail({id: contrib.similarProfile.currentPosition.organisation.id})">{{ contrib.similarProfile.currentPosition.organisation.name | characters:50 }}</a> <a ng-show="contrib.similarProfile.currentPosition.organisation.type === \'collectivity\'" ui-sref="collectivity-detail({id: contrib.similarProfile.currentPosition.organisation.id})">{{ contrib.similarProfile.currentPosition.organisation.name | characters:50 }}</a></span><br><span class="title">{{ contrib.similarProfile.currentPosition.title | characters:70 }}</span></div><div class="connection-levels" ng-show="contrib.memePersonne && contrib.memePersonne === \'oui\'"><span class="level-image level-1" ng-click="vm.connectProfileFromPendingHomonym(contrib, 1)" ng-class="contrib.existingConnexion && contrib.existingConnexion.grade === 1 ? \'active\' : \'inactive\'" uib-tooltip="Me connecter en 1"></span> <span class="level-image level-2" ng-click="vm.connectProfileFromPendingHomonym(contrib, 2)" ng-class="contrib.existingConnexion && contrib.existingConnexion.grade === 2 ? \'active\' : \'inactive\'" uib-tooltip="Me connecter en 2"></span> <span class="level-image level-3" ng-click="vm.connectProfileFromPendingHomonym(contrib, 3)" ng-class="contrib.existingConnexion && contrib.existingConnexion.grade === 3 ? \'active\' : \'inactive\'" uib-tooltip="Me connecter en 3"></span> <span class="level-image fa fa-trash" style="margin-left:10px;font-size: 20px;line-height: 1.5em;color:lightgray"></span></div></div></li></ul></div></div>');
$templateCache.put('app/network/internal-network/archived-sales.html','<div class="network-list row"><div class="list-header col-xs-12 well"><div class="col-xs-4"><label>Filtrer par :</label><select><option>Contacts</option></select></div><div class="col-xs-4"><label>Trier par :</label><select><option>Nom</option></select></div><div class="col-xs-4 filter-section"><label><input type="text" placeholder="&#xf002 Recherche..." ng-model="vm.searchText" style="font-family: \'Lato\', \'Font Awesome 5 Pro\'"></label></div></div><div class="col-xs-12 no-padding well"><ul><li ng-repeat="contact in filtered = (vm.archivedSales)"><div class="connection-information-container"><div class="square-picture" ng-hide="value[0].creator.picture" style="background-image: url(\'content/images/no-picture.png\')" aria-hidden="false"></div><div class="square-picture ng-hide" ng-show="value[0].creator.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + value[0].creator.pictureContentType + \';base64,\' + value[0].creator.picture }" aria-hidden="true" style="background-image: url(&quot;data:image/png;base64,null&quot;)"></div><div class="connection-informations"><span class="name">{{ contact.firstName }} {{ contact.lastName }}</span><br><span class="title bold" ng-hide="value[0].creator.currentPosition.organisation.name ">Entreprise inconnue</span><br><span class="title" ng-hide="value[0].creator.currentPosition.title">Poste inconnu</span></div></div></li><li ng-hide="filtered.length"><p class="no-items text-center"><i>Il n\'y a pas de commerciaux correspondants</i></p></li></ul></div></div>');
$templateCache.put('app/network/internal-network/invited-sales.html','<div class="network-list row"><div class="list-header col-xs-12 well"><div class="col-xs-4"><label>Filtrer par :</label><select><option>Contacts</option></select></div><div class="col-xs-4"><label>Trier par :</label><select><option>Nom</option></select></div><div class="col-xs-4 filter-section"><label><input type="text" placeholder="&#xf002 Recherche..." ng-model="vm.searchText" style="font-family: \'Lato\', \'Font Awesome 5 Pro\'"></label></div></div><div class="col-xs-12 no-padding well"><ul><li ng-repeat="contact in filtered = (vm.invitedSales)"><div class="connection-information-container"><div class="square-picture" ng-hide="value[0].creator.picture" style="background-image: url(\'content/images/no-picture.png\')" aria-hidden="false"></div><div class="square-picture ng-hide" ng-show="value[0].creator.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + value[0].creator.pictureContentType + \';base64,\' + value[0].creator.picture }" aria-hidden="true" style="background-image: url(&quot;data:image/png;base64,null&quot;)"></div><div class="connection-informations"><span class="name">{{ contact.firstName }} {{ contact.lastName }} ({{ contact.email }})</span><br><span class="title bold" ng-hide="value[0].creator.currentPosition.organisation.name ">Entreprise inconnue</span><br><span class="title" ng-hide="value[0].creator.currentPosition.title">Poste inconnu</span></div></div></li><li ng-hide="filtered.length"><p class="no-items text-center"><i>Il n\'y a pas de commerciaux correspondants</i></p></li></ul></div></div>');
$templateCache.put('app/network/internal-network/registered-sales.html','<div class="network-list row"><div class="list-header col-xs-12 well"><div class="col-xs-4"><label>Filtrer par :</label><select><option>Contacts</option></select></div><div class="col-xs-4"><label>Trier par :</label><select><option>Nom</option></select></div><div class="col-xs-4 filter-section"><label><input type="text" placeholder="&#xf002 Recherche..." ng-model="vm.searchText" style="font-family: \'Lato\', \'Font Awesome 5 Pro\'"></label></div></div><div class="col-xs-12 no-padding"><ul ng-repeat="(key, value) in vm.registeredSales | groupBy: \'creator.id\' track by $index"><li ng-show="value[0].connectionId == null" class="panel"><div class="connection-information-container"><div class="square-picture" ng-hide="value[0].creator.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="square-picture" ng-show="value[0].creator.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + value[0].creator.pictureContentType + \';base64,\' + value[0].creator.picture }"></div><div class="connection-informations"><a ui-sref="profile({id: value[0].creator.id, position: \'\' })"><span class="name">{{value[0].creator.firstName}} <span class="bold">{{value[0].creator.lastName}}</span></span></a><br><span class="title bold" ng-show="value[0].creator.currentPosition.organisation.name "><a ng-show="value[0].creator.currentPosition.organisation.type === \'company\'" ui-sref="company-detail({id: value[0].creator.currentPosition.organisation.id})">{{ value[0].creator.currentPosition.organisation.name | characters:50 }}</a> <a ng-show="value[0].creator.currentPosition.organisation.type === \'collectivity\'" ui-sref="collectivity-detail({id: value[0].creator.currentPosition.organisation.id})">{{ value[0].creator.value[0].creator.organisation.name | characters:50 }}</a> </span><span class="title bold" ng-hide="value[0].creator.currentPosition.organisation.name ">Entreprise inconnue</span><br><span class="title" ng-show="value[0].creator.currentPosition.title">{{ value[0].creator.currentPosition.title | characters:50 }} </span><span class="title" ng-hide="value[0].creator.currentPosition.title">Poste inconnu</span></div></div></li><div ng-show="value[0].connectionId"><uib-accordion close-others="false"><div uib-accordion-group id="contribution-addon" class="panel-default" is-open="accordionArray[$index]"><uib-accordion-heading><li><div class="connection-information-container"><div class="square-picture" ng-hide="value[0].creator.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="square-picture" ng-show="value[0].creator.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + value[0].creator.pictureContentType + \';base64,\' + value[0].creator.picture }"></div><div class="connection-informations"><a ui-sref="profile({id: value[0].creator.id, position: \'\' })"><span class="name">{{value[0].creator.firstName}} <span class="bold">{{value[0].creator.lastName}}</span></span></a><br><span class="title bold" ng-show="value[0].creator.currentPosition.organisation.name "><a ng-show="value[0].creator.currentPosition.organisation.type === \'company\'" ui-sref="company-detail({id: value[0].creator.currentPosition.organisation.id})">{{ value[0].creator.currentPosition.organisation.name | characters:50 }}</a> <a ng-show="value[0].creator.currentPosition.organisation.type === \'collectivity\'" ui-sref="collectivity-detail({id: value[0].creator.currentPosition.organisation.id})">{{ value[0].creator.value[0].creator.organisation.name | characters:50 }}</a> </span><span class="title bold" ng-hide="value[0].creator.currentPosition.organisation.name ">Entreprise inconnue</span><br><span class="title" ng-show="value[0].creator.currentPosition.title">{{ value[0].creator.currentPosition.title | characters:50 }} </span><span class="title" ng-hide="value[0].creator.currentPosition.title">Poste inconnu</span></div><div class="connection-levels"><span style="margin:15px 5px" class="pull-right glyphicon custom-chevron" ng-class="{\'glyphicon-chevron-down\': accordionArray[$index],\n                                        \'glyphicon-chevron-right\': !accordionArray[$index]}"></span></div></div></li></uib-accordion-heading><li ng-repeat="contact in value" ng-show="contact.connectionId"><div class="connection-information-container"><div class="square-picture" ng-hide="contact.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="square-picture" ng-show="contact.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + contact.pictureContentType + \';base64,\' + contact.picture }"></div><div class="connection-informations"><a ui-sref="profile({id: contact.id, position: \'\' })"><span class="name">{{ contact.firstName }} <span class="bold">{{ contact.lastName }}</span></span></a><br><span class="title bold" ng-show="contact.currentPosition.organisation.name "><a ng-show="contact.currentPosition.organisation.type === \'company\'" ui-sref="company-detail({id: contact.currentPosition.organisation.id})">{{ contact.currentPosition.organisation.name | characters:50 }}</a> <a ng-show="contact.currentPosition.organisation.type === \'collectivity\'" ui-sref="collectivity-detail({id: contact.currentPosition.organisation.id})">{{ contact.currentPosition.organisation.name | characters:50 }}</a> </span><span class="title bold" ng-hide="contact.currentPosition.organisation.name ">Entreprise inconnue</span><br><span class="title" ng-show="contact.currentPosition.title">{{ contact.currentPosition.title | characters:50 }} </span><span class="title" ng-hide="contact.currentPosition.title">Poste inconnu</span></div><div class="connection-levels"><span ng-show="contact.grade === 1" class="level-image level-1 active"></span> <span ng-show="contact.grade === 2" class="level-image level-2 active"></span> <span ng-show="contact.grade === 3" class="level-image level-3 active"></span></div></div></li></div></uib-accordion></div></ul><ul><!--\n\n            <li ng-repeat="contact in filtered = (vm.registeredSales | filter: vm.search)">\n                <div class="square-picture" ng-hide="contact.picture"\n                     style="background-image: url(\'content/images/robinson.png\');">\n                </div>\n                <div class="square-picture" ng-show="contact.picture"\n                     ng-style="{\'background-image\': \'url(\\\'data:\' + vm.profile.pictureContentType + \';base64,\' + vm.profile.picture }">\n                </div>\n                <div class="connection-informations">\n                    <span class="name">\n                        {{ contact.name }}\n                    </span> <br>\n                    <span class="title">\n                        {{ contact.title }} \xE0 {{ contact.company }}\n                    </span> <br>\n                    <span class="location">\n                        {{ contact.location }}\n                    </span>\n                </div>\n                <div class="connection-levels">\n                    <img src="content/images/level1.png" ng-show="contact.level === 1"\n                         class="level-image">\n                    <img src="content/images/level2.png"  ng-show="contact.level === 2"\n                         class="level-image">\n                    <img src="content/images/level3.png" ng-show="contact.level === 3"\n                         class="level-image">\n                </div>\n            </li>\n--><li ng-hide="vm.registeredSales.length"><p class="no-items text-center"><i>Il n\'y a pas de commerciaux correspondants</i></p></li></ul></div></div>');
$templateCache.put('app/network/internal-network/sales-menu.html','<div class="network-sub-tabs row"><a ui-sref="registered-sales" ui-sref-active="active"><div class="col-xs-4 network-sub-tab"><p>Mes commerciaux inscrits</p></div></a><a ui-sref="invited-sales" ui-sref-active="active"><div class="col-xs-4 network-sub-tab"><p>Mes commerciaux invit\xE9s</p></div></a><a ui-sref="archived-sales" ui-sref-active="active"><div class="col-xs-4 network-sub-tab"><p>Mes commerciaux archiv\xE9s</p></div></a></div><div ui-view="content"><!-- Angular views --></div>');
$templateCache.put('app/whoswho/list/whoswho-list.html','<style>#sales-table td {\n        padding:4px;\n    }</style><div class="col-md-12 well" style="margin-right: 10px;min-height: 534px"><h2>Who\'s Who</h2><jhi-alert></jhi-alert><div id="sales-table" class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="text-align: center"><span>Personne</span></th><th style="text-align: left"><span>Fonction</span></th><th style="text-align: left"><span>Localisation</span></th><th style="text-align: left"><span>Indices</span></th></tr></thead><tbody><tr ng-repeat="sale in vm.sales track by sale.user.id"><td style="vertical-align: middle">{{sale.user.firstName}} {{sale.user.lastName}}</td><td style="text-align: lett;vertical-align: middle">{{sale.profile.currentPosition? (sale.profile.currentPosition.title | characters:50) : \'\'}}</td><td style="text-align: left;vertical-align: middle">{{sale.profile.departementElection? (sale.profile.departementElection | characters:50) : \'\'}}</td><td style="text-align: lett;vertical-align: middle">{{sale.nbConnexions}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/whoswho/map/whoswho-map.html','<style>#map {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        width: 100%;\n        height: 900px;\n        border: 4px solid white\n    }\n\n    .marker {\n        display: block;\n        border: none;\n        border-radius: 50%;\n        cursor: pointer;\n        padding: 0;\n    }\n    .mapboxgl-popup-content, .maplibregl-popup-content {\n        min-width: 170px;\n    }\n    .my-picture {\n        background-size: 30px;\n        background-position: center;\n        background-repeat: no-repeat;\n        display: inline-block;\n        width: 30px;\n        height: 30px;\n        line-height: 1;\n        padding: 0;\n        border-radius: 50%;\n        margin: 0;\n        vertical-align: middle;\n    }\n\n    #persons-section .item-list-container .item-list {\n        padding-right: 15px;\n    }</style><jhi-alert></jhi-alert><div class="row" style="display: flex"><div class="col-xs-12 col-md-3" style="max-width: 300px"><div class="row"><div class="text-center active" id="persons-section" style="background-color: #132439;height:900px;z-index:1000"><div class="header-container"><h3 style="font-size: 18px" class="white">Who\'s who</h3></div><div class="item-list-container row"><div class="search-top input-group"><input type="text" ng-model="vm.searchTextPersons" class="form-control" ng-model-options="{ debounce: 10 }" placeholder="Ex : Pierre Martin..."></div><div class="item-list" id="person-container"><div class="item-wrapper" infinite-scroll="vm.loadMorePersons()" infinite-scroll-parent infinite-scroll-disabled="!vm.hasNextPagePersons"><div class="item" ng-repeat="person in vm.persons  | filter:vm.searchTextPersons track by person.user.id  "><div class="item item-divider" ng-if="vm.firstLetter(person.user.lastName) != vm.firstLetter(vm.persons[$index-1].user.lastName)">{{ vm.firstLetter(person.user.lastName) }}</div><div style="height: 40px" ;><span ng-show="person.profile && person.profile.picture" ng-style="{\'background-image\': \'url(\\\'data:png;base64,\' + person.profile.picture }" class="my-picture"></span> <span ng-hide="person.profile && person.profile.picture" style="background-image: url(content/images/avatar2-44.png)" class="my-picture"></span> <a ng-click="vm.flyToPerson(person)" style="vertical-align: middle;margin-left: 2px" title="Voir sur la carte">{{ person.user.firstName + \' \' + person.user.lastName}}</a> <a ui-sref="whoswho-map.message-libre({userId: person.user.id})" style="float:right; vertical-align: middle;padding-top: 6px" title="Envoyer un message"><span class="far fa-envelope"></span></a></div></div><div ng-hide="vm.persons.length" class="no-items"><div><p class="text-center"><i>Chargement...</i></p></div></div></div></div></div></div></div></div><div class="col-xs-12 col-md-9" style="flex-grow: 1"><div id="map"></div><script>var map;\n        var popup;\n        function loadMap(geoJSONcontent) {\n            var urlParams = new URLSearchParams(window.location.search);\n\n            var jwtToken = window.localStorage.getItem(\'jhi-authenticationToken\')?.replace(/"/g, \'\');\n\n            map = new maplibregl.Map({\n                container: \'map\',\n                style: `https://api.maptiler.com/maps/streets/style.json?key=2S2Fjz8DXFHIgkaWKp4D`,\n                center: [1.81368, 46.79009],\n                zoom: 5.6,\n                transformRequest: (url, resourceType) => {\n                    if (resourceType === \'Source\' && url.indexOf(\'whoswho\') !== -1) {\n                        return {\n                            url: url,\n                            headers: { \'Authorization\': \'Bearer \' + jwtToken }\n                        }\n                    }\n                }\n            });\n\n            map.on(\'load\', function () {\n\n                map.addSource(\'userClusters\', {\n                    type: \'geojson\',\n                    data:\n                        geoJSONcontent,\n                    cluster: true,\n                    clusterMaxZoom: 14, // Max zoom to cluster points on\n                    clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)\n                });\n\n                map.addLayer({\n                    id: \'clusters\',\n                    type: \'circle\',\n                    source: \'userClusters\',\n                    filter: [\'has\', \'point_count\'],\n                    paint: {\n                        // Use step expressions (https://maplibre.org/maplibre-gl-js-docs/style-spec/#expressions-step)\n                        // with three steps to implement three types of circles:\n                        //   * Blue, 20px circles when point count is less than 100\n                        //   * Yellow, 30px circles when point count is between 100 and 750\n                        //   * Pink, 40px circles when point count is greater than or equal to 750\n                        \'circle-color\': [\n                            \'step\',\n                            [\'get\', \'point_count\'],\n                            \'#51bbd6\',\n                            100,\n                            \'#f1f075\',\n                            750,\n                            \'#f28cb1\'\n                        ],\n                        \'circle-radius\': [\n                            \'step\',\n                            [\'get\', \'point_count\'],\n                            20,\n                            100,\n                            30,\n                            750,\n                            40\n                        ]\n                    }\n                });\n\n                map.addLayer({\n                    id: \'cluster-count\',\n                    type: \'symbol\',\n                    source: \'userClusters\',\n                    filter: [\'has\', \'point_count\'],\n                    layout: {\n                        \'text-field\': \'{point_count_abbreviated}\',\n                        \'text-font\': [\'DIN Offc Pro Medium\', \'Arial Unicode MS Bold\'],\n                        \'text-size\': 12\n                    }\n                });\n\n                map.loadImage(\n                    \'content/images/avatar2-44.png\',\n                    function (error, image) {\n                        if (error) throw error;\n\n                        map.addImage(\'user\', image);\n                        map.addLayer({\n                            id: \'unclustered-point\',\n                            type: \'symbol\',\n                            source: \'userClusters\',\n                            filter: [\'!\', [\'has\', \'point_count\']],\n                            \'paint\': {\n                                \'text-color\': \'#132439\',\n                                \'text-halo-color\': \'#fff\',\n                                \'text-halo-width\': 3\n                            },\n                            \'layout\': {\n                                \'icon-image\': \'user\',\n                                \'icon-size\': 0.85,\n                                \'text-field\': [\'get\', \'label\'],\n                                \'text-variable-anchor\': [\'top\'],\n                                \'text-radial-offset\': 1.6,\n                                \'text-justify\': \'auto\',\n                                \'text-size\': 14\n                            }\n                        });\n                    }\n                );\n\n            });\n\n\n            // inspect a cluster on click\n            map.on(\'click\', \'clusters\', function (e) {\n                var features = map.queryRenderedFeatures(e.point, {\n                    layers: [\'clusters\']\n                });\n                var clusterId = features[0].properties.cluster_id;\n                map.getSource(\'userClusters\').getClusterExpansionZoom(\n                    clusterId,\n                    function (err, zoom) {\n                        if (err) return;\n\n                        map.easeTo({\n                            center: features[0].geometry.coordinates,\n                            zoom: zoom\n                        });\n                    }\n                );\n            });\n\n            // When a click event occurs on a feature in\n            // the unclustered-point layer, open a popup at\n            // the location of the feature, with\n            // description HTML from its properties.\n            map.on(\'click\', \'unclustered-point\', function (e) {\n                var coordinates = e.features[0].geometry.coordinates.slice();\n                var message = e.features[0].properties.message;\n\n                // Ensure that if the map is zoomed out such that\n                // multiple copies of the feature are visible, the\n                // popup appears over the copy being pointed to.\n                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {\n                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;\n                }\n                if (popup) {\n                    popup.remove();\n                }\n                popup = new maplibregl.Popup()\n                    .setLngLat(coordinates)\n                    .setHTML(\n                        message\n                    )\n                    .addTo(map);\n            });\n\n            map.on(\'mouseenter\', \'clusters\', function () {\n                map.getCanvas().style.cursor = \'pointer\';\n            });\n            map.on(\'mouseleave\', \'clusters\', function () {\n                map.getCanvas().style.cursor = \'\';\n            });\n\n\n            map.addControl(new maplibregl.FullscreenControl());\n            // add markers to map\n            /*\n            geojson.features.forEach(function (marker) {\n                // create a DOM element for the marker\n                var el = document.createElement(\'div\');\n                el.className = \'marker\';\n                el.style.backgroundImage = \'url(content/images/avatar2-40.png)\';\n                el.style.width = marker.properties.iconSize[0] + \'px\';\n                el.style.height = marker.properties.iconSize[1] + \'px\';\n\n\n                // create the popup\n                var popup = new maplibregl.Popup({ offset: 25 }).setHTML(\n                    marker.properties.message\n                );\n\n                // add marker to map\n                new maplibregl.Marker(el)\n                    .setLngLat(marker.geometry.coordinates)\n                    .setPopup(popup) // sets a popup on this marker\n                    .addTo(map);\n            });\n            */\n\n\n        }\n        function flyTo (longitude, latitude, message) {\n            map.flyTo({\n            center: [\n                longitude,\n                latitude\n            ],\n            zoom: 13,\n            essential: true // this animation is considered essential with respect to prefers-reduced-motion\n            });\n\n            if (popup) {\n                popup.remove();\n            }\n            popup = new maplibregl.Popup()\n                .setLngLat([longitude, latitude])\n                .setHTML(\n                    message\n                )\n                .addTo(map);\n\n        }</script></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Cr\xE9ation / R\xE9initialisation du mot de passe</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>La cl\xE9 de r\xE9initialisation est manquante.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choisissez un nouveau mot de passe</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Votre mot de passe n\'a pas pu \xEAtre r\xE9initialis\xE9. Votre requ\xEAte de r\xE9initialisation n\'est valable que 7 jours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Votre mot de passe a \xE9t\xE9 r\xE9initialis\xE9.</strong> Vous pouvez d\xE9sormais vous <a class="alert-link" href="" ng-click="vm.logout()">connecter</a>.</p></div><div ng-show="vm.success"><button type="submit" class="btn btn-primary" ng-click="vm.logout()">Continuer</button></div><div class="alert alert-danger" ng-show="vm.doNotMatch">Le mot de passe et sa confirmation ne correspondent pas !</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">Nouveau mot de passe</label><input type="password" class="form-control" id="password" name="password" placeholder="Nouveau mot de passe" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Un mot de passe est requis.</p><p class="help-block" ng-show="form.password.$error.minlength">Le mot de passe doit contenir au moins 4 caract\xE8res.</p><p class="help-block" ng-show="form.password.$error.maxlength">Le mot de passe ne peut exc\xE9der 50 caract\xE8res.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">Confirmation du nouveau mot de passe</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirmation du nouveau mot de passe" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">La confirmation du mot de passe est requise.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">La confirmation du mot de passe doit contenir au moins 4 caract\xE8res.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">La confirmation du mot de passe ne peut exc\xE9der 50 caract\xE8res.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">R\xE9initialiser le mot de passe</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<br><br><div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>R\xE9initialisation du mot de passe</h1><div class="alert alert-danger" ng-show="vm.errorMessage">{{vm.errorMessage}}</div><div class="alert alert-warning" ng-hide="vm.success"><p>Saisissez l\'adresse e-mail utilis\xE9e pour vous inscrire.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Un email vient de vous \xEAtre envoy\xE9. Suivez les indications afin de r\xE9initialiser votre mot de passe.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">Adresse e-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Votre adresse e-mail" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Votre adresse e-mail est requise.</p><p class="help-block" ng-show="form.email.$error.email">Votre adresse e-mail est invalide.</p><p class="help-block" ng-show="form.email.$error.minlength">Votre adresse e-mail doit contenir au moins 5 caract\xE8res.</p><p class="help-block" ng-show="form.email.$error.maxlength">Votre adresse e-mail ne doit pas exc\xE9der 50 caract\xE8res.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">R\xE9initialiser</button></form></div></div></div>');
$templateCache.put('app/components/addon/copyright/copyright-addon.html','<p class="copyright-addon"><a href="https://www.axenteev.com/mentions-legales" target="_blank">Mentions l\xE9gales</a> . <a href="https://www.axenteev.com/politique-de-confidentialit%C3%A9" target="_blank">Politique de confidentialit\xE9</a></p>');
$templateCache.put('app/components/addon/contribution-loop/contribution-loop-addon.html','<style></style><div id="left-nav"><div class="left-nav-header"><p>Mes options</p></div><nav class="nav-group"><a class="nav-group-item" ui-sref="home" du-smooth-scroll><i class="fal fa-home fa-fw nav-group-item-icon"></i> <span aria-hidden="true" name="user"></span> Home </a><!--\n        <a class="nav-group-item" href="/#/#news" du-smooth-scroll>\n            <i class="fal fa-newspaper fa-fw nav-group-item-icon"></i>\n            <span aria-hidden="true" name="user"></span> News\n        </a>\n        --> <a class="nav-group-item" ui-sref="quilist"><i class="fal fa-database fa-fw nav-group-item-icon"></i> <span aria-hidden="true" name="user"></span> La database </a><!--\n        <a class="nav-group-item" ui-sref="my-profile" >\n            <i class="fal fa-user fa-fw nav-group-item-icon"></i>\n            <span aria-hidden="true" name="user"></span> Mon profil\n        </a>\n        --> <a class="nav-group-item" ui-sref="network"><i class="fal fa-users fa-fw nav-group-item-icon"></i> <span aria-hidden="true" name="user"></span> Mon network </a><a class="nav-group-item" ui-sref="my-profile-credits" du-smooth-scroll><i class="fal fa-usd-circle fa-fw nav-group-item-icon"></i> <span aria-hidden="true" name="user"></span> Mes Cr\xE9dits </a><a class="nav-group-item" ui-sref="new-contribution" du-smooth-scroll><i class="fal fa-user-edit fa-fw nav-group-item-icon"></i> <span aria-hidden="true" name="contributions"></span> Faire une contribution</a></nav></div><!--\n<div id="contribution-loop-addon">\n    <div class="contribution-loop-header">\n        <p>Mes options</p>\n    </div>\n    <uib-accordion close-others="false">\n        <div uib-accordion-group id="contribution-addon" class="panel-default" is-open="vm.isContributionsOpen">\n            <uib-accordion-heading>\n                Contributions\n                <i class="pull-right glyphicon custom-chevron"\n                   ng-class="{\'glyphicon-chevron-down\': vm.isContributionsOpen,\n                   \'glyphicon-chevron-right\': !vm.isContributionsOpen}"></i>\n            </uib-accordion-heading>\n            <table>\n                <tr>\n                    <td>\n                        <a ui-sref="company.new-company">\n                            <img class="contribution-image" src="content/images/companies-blue.svg" width="30">\n                        </a>\n                    </td>\n                    <td>\n                        <a ui-sref="company.new-company">\n                            <p>Ajouter une entreprise</p>\n                        </a>\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                        <a ui-sref="collectivity.new-collectivity">\n                            <img class="contribution-image" src="content/images/companies-blue.svg" width="30">\n                        </a>\n                    </td>\n                    <td>\n                        <a ui-sref="collectivity.new-collectivity">\n                            <p>Ajouter une collectivit\xE9</p>\n                        </a>\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                        <a ui-sref="profile.new">\n                            <img class="contribution-image" src="content/images/profile-blue.svg" width="30">\n                        </a>\n                    </td>\n                    <td>\n                        <a ui-sref="profile.new">\n                            <p>Ajouter une personne</p>\n                        </a>\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                        <a ui-sref="my-contributions">\n                            <img class="contribution-image" src="content/images/people-blue.svg" width="30">\n                        </a>\n                    </td>\n                    <td>\n                        <a ui-sref="my-contributions">\n                            <p>Mes Contributions</p>\n                        </a>\n                    </td>\n                </tr>\n            </table>\n        </div>\n        <div uib-accordion-group is-disabled="true" id="loop-addon" class="panel-default" is-open="vm.isSuperLoopOpen">\n            <uib-accordion-heading>\n                Super Loop\n                <a ui-sref="super-loop">\n                    <i class="pull-right glyphicon custom-chevron"\n                       ng-class="{\'glyphicon-chevron-down\': vm.isSuperLoopOpen,\n                       \'glyphicon-chevron-right\': !vm.isSuperLoopOpen}"></i>\n                </a>\n            </uib-accordion-heading>\n            <form>\n                <div class="super-loop-header">\n                    <button ng-click="vm.switchToCompany()"\n                            ng-class="vm.superLoopForm.isCompany ? \'active\' : \'\'"\n                            class="btn btn-primary super-loop-header-company">\n                        Entreprises\n                    </button>\n                    <button ng-click="vm.switchToCollectivity()"\n                            ng-class="!vm.superLoopForm.isCompany ? \'active\' : \'\'"\n                            class="btn btn-primary super-loop-header-collectivity">\n                        Collectivit\xE9s\n                    </button>\n                </div>\n                <table ng-show="vm.superLoopForm.isCompany">\n                    <tr>\n                        <td>\n                            <label for="company-status-select">\n                                Cat\xE9gorie :\n                            </label>\n                        </td>\n                        <td>\n                            <select class="pull-right" name="companyStatus" id="company-status-select"\n                                    ng-model="vm.superLoopForm.companyStatus">\n                                <option ng-repeat="option in vm.companyStatuses" value="{{option.id}}">{{option.name}}</option>\n                            </select>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            <label for="sector-select">\n                                Secteur :\n                            </label>\n                        </td>\n                        <td>\n                            <select class="pull-right" name="sector" id="sector-select" ng-model="vm.superLoopForm.sector">\n                                <option ng-repeat="option in vm.sectors" value="{{option.id}}">{{option.name}}</option>\n                            </select>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td>\n                            <button ng-click="vm.search()" class="pull-right btn btn-primary" type="submit">Rechercher</button>\n                        </td>\n                    </tr>\n                </table>\n                <table ng-hide="vm.superLoopForm.isCompany">\n                    <tr>\n                        <td>\n                            <label for="city-size-select">\n                                Taille ville :\n                            </label>\n                        </td>\n                        <td>\n                            <select class="pull-right"\n                                    name="collectivitySize"\n                                    id="city-size-select"\n                                    ng-model="vm.superLoopForm.collectivitySize">\n                                <option ng-repeat="option in vm.collectivitySizes" value="{{option.id}}">{{option.name}}</option>\n                            </select>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td>\n                            <label for="city-select">\n                                Ville :\n                            </label>\n                        </td>\n                        <td>\n                            <select class="pull-right" name="city" id="city-select" ng-model="vm.superLoopForm.city">\n                                <option ng-repeat="option in vm.cities" value="{{option.id}}">{{option.name}}</option>\n                            </select>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td></td>\n                        <td>\n                            <button ng-click="vm.search()" class="pull-right btn btn-primary" type="submit">Rechercher</button>\n                        </td>\n                    </tr>\n                </table>\n            </form>\n        </div>\n    </uib-accordion>\n</div>\n-->');
$templateCache.put('app/components/addon/credits/credits-addon.html','<div class="padding15 credits-addon well well-inverted"><h4>Mes Cr\xE9dits</h4><h3 title="Mes cr\xE9dits restants \xE0 d\xE9penser" class="text-right credits-value">{{vc.credits.creditsCount - vc.credits.creditsSpent }} <i title="Mes cr\xE9dits restants \xE0 d\xE9penser" class="fas fa-copyright"></i></h3></div>');
$templateCache.put('app/components/addon/discover/discover-addon.html','<div class="discover-container"><h3><span class="discover-wrapper"><a ui-sref="flow" class="discover-link"><span class="discover-border"><span class="discover">Discover</span></span></a></span></h3></div>');
$templateCache.put('app/components/addon/rank/rank-addon.html','<div class="rank-addon"><div class="col-md-7 no-padding"><style>.triangle {\n\t\t    width: 75px;\n\t\t    height: 75px;\n\t     \tmargin-top: 10px;\n\t    }</style><div class="triangle"><svg><g><path stroke="#7b8287" id="svg_7" d="m0.122129,74.850472l37.408275,-74.697615l37.408275,74.697615l-74.816549,0z" fill-opacity="null" stroke-opacity="null" fill="#a4d1ff"/></g></svg></div><span class="dashed-line"></span></div><div class="col-md-5 padding-light"><p>Axenteever Pro</p><!--<p class="text-light">( Ma note )</p>--><p class="month-rate text-light">{{ vb.creditsLastMonth.evolSinceLastMonth >= 0 ? \'+\' : \'\'}}{{ vb.creditsLastMonth.evolSinceLastMonth | number:0 }}% en {{ vb.creditsLastMonth.monthStr }}</p></div></div>');
$templateCache.put('app/components/addon/select-division/select-division-addon.html','<div id="left-nav"><div class="left-nav-header"><p>Choisir une \xE9quipe</p></div><nav class="nav-group"><select class="form-control" id="field_ec" name="ec" ng-model="vb.currentAccount.ec" ng-options="ec as ec.name for ec in vb.ecs track by ec.id" ng-change="vb.selectEc()" style="font-size: 12px"></select></nav></div>');
$templateCache.put('app/components/addon/suggestion/suggestion-addon.html','<div class="suggestion-addon-list" style="min-height: 260px"><!-- Use the simple syntax --><div cg-busy="{promise:suggestionBusyPromise,wrapperClass:\'\', templateUrl: \'cgbusy.html\'}" style="position:relative;width: 100%;height: 100%"></div><div class="well no-padding" ui-sref="profile({id: profile.id, position: \'\' })" ng-repeat="profile in vd.displayedPeople"><div class="content"><div class="picture" ng-hide="profile.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="picture" ng-show="profile.picture" ng-style="{\'background-image\': \'url(\\\'data:\' + profile.pictureContentType + \';base64,\' + profile.picture }"></div><div class="text-container"><p>{{ profile.firstName }} {{ profile.lastName }}</p><p class="text-light" ng-show="profile.currentPosition.title">{{ profile.currentPosition.title }}<br>\xE0 {{ profile.currentPosition.organisation.name }}</p><p class="text-light" ng-hide="profile.currentPosition.title"><i>Poste inconnu</i></p></div></div><div class="levels-container"><a href ng-click="vd.connect(profile.id, 1); $event.stopPropagation();"><div class="level one"><img src="content/images/1_transparent.png" width="20"></div></a><a href ng-click="vd.connect(profile.id, 2); $event.stopPropagation();"><div class="level two"><img src="content/images/2_transparent.png" width="20"></div></a><a href ng-click="vd.connect(profile.id, 3); $event.stopPropagation();"><div class="level three"><img src="content/images/3_transparent.png" width="20"></div></a></div></div></div>');
$templateCache.put('app/entities/profile/public/profile-public-position.html','<form name="editForm" role="form" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPositionLabel">Modifier le poste de {{ vm.profile.firstName + \' \' + vm.profile.lastName }}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row" style="padding-left: 268px"><i class="fal fa-plus" style="vertical-align: middle;color:#4A729B"></i> <a style="color:#4A729B" ng-click="vm.addCurrentPosition()">Ajouter une exp\xE9rience</a> &nbsp; <i class="fal fa-plus" style="vertical-align: middle;color:#4A729B"></i> <a style="color:#4A729B" ng-click="vm.addPastPosition()">Ajouter une exp\xE9rience pass\xE9e</a><br></div><div ng-repeat="currentPosition in vm.currentPositions"><div class="row"><div class="col-md-10"><div class="form-group"><label class="control-label" for="field_organization">Entreprise/Collectivit\xE9</label><input id="field_organization" type="text" ng-model="currentPosition.organisation" autocomplete="off" uib-typeahead="organization as organization.name for organization in vm.getOrganizations($viewValue)" typeahead-no-results="vm.organizationsNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.organizationsNoResults">Nous n\'avons pas cette entreprise/collectivit\xE9 dans nos bases de donn\xE9es mais vous pouvez la cr\xE9er dans "Mes contributions" afin de renseigner ce champ.</div></div><div class="form-group"><label class="control-label" for="field_title">Titre professionnel</label><input type="text" class="form-control" name="title" id="field_title" ng-model="currentPosition.title" ng-maxlength="100"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.maxlength">Ce champ ne peut pas d\xE9passer 100 caract\xE8res.</p></div></div><div class="form-group"><label class="control-label" for="field_superiors">Sup\xE9rieur hi\xE9rarchique</label><input id="field_superior" type="text" ng-model="currentPosition.superior" autocomplete="off" uib-typeahead="profile as profile.firstName + \' \' + profile.lastName for profile in vm.getProfiles($viewValue)" typeahead-no-results="vm.profilesNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.profilesNoResults">Aucun r\xE9sultat</div></div></div><div class="col-md-2"><div style="border-left: 1px solid #ccc;height: 100%;width: 100%;display: table;height: 176px;padding: 20px;vertical-align: middle;text-align: center;padding-top: 60px;margin-top: 22px">Exp\xE9rience actuelle {{$index + 1}}<br><br><i class="fal fa-minus-circle fa-2x" ng-click="vm.currentPositions.splice($index,1)" title="Supprimer l\'exp\xE9rience"></i></div></div></div></div><div ng-repeat="pastPosition in vm.pastPositions"><div class="row"><div class="col-md-10"><div class="form-group"><label class="control-label" for="field_organization">Entreprise/Collectivit\xE9</label><input id="field_organization" type="text" ng-model="pastPosition.organisation" autocomplete="off" uib-typeahead="organization as organization.name for organization in vm.getOrganizations($viewValue)" typeahead-no-results="vm.organizationsNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.organizationsNoResults">Aucun r\xE9sultat</div></div><div class="form-group"><label class="control-label" for="field_title">Titre professionnel</label><input type="text" class="form-control" name="title" id="field_title" ng-model="pastPosition.title" ng-maxlength="100"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.maxlength">Ce champ ne peut pas d\xE9passer 100 caract\xE8res.</p></div></div><div class="form-group"><label class="control-label" for="field_superiors">Sup\xE9rieur hi\xE9rarchique</label><input id="field_superior" type="text" ng-model="currentPosition.superior" autocomplete="off" uib-typeahead="profile as profile.firstName + \' \' + profile.lastName for profile in vm.getProfiles($viewValue)" typeahead-no-results="vm.profilesNoResults" class="form-control typeahead-input" typeahead-editable="false"><div class="search-no-results well" ng-show="vm.profilesNoResults">Aucun r\xE9sultat</div></div></div><div class="col-md-2"><div style="border-left: 1px solid #ccc;height: 100%;width: 100%;display: table;height: 176px;padding: 20px;vertical-align: middle;text-align: center;padding-top: 60px;margin-top: 22px">Exp\xE9rience pass\xE9e {{$index + 1}}<br><br>/<i class="fal fa-minus-circle fa-2x" ng-click="vm.pastPositions.splice($index,1)" title="Supprimer l\'exp\xE9rience"></i></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/profile/public/profile-public.html','<div class="company-page-wrapper"><div class="container padding15"><jhi-alert></jhi-alert><div class="row"><div class="left-addon-container hidden-xs hidden-sm"><div class="left-addon-fixed"><contribution-loop-addon></contribution-loop-addon></div></div><div class="page-body col-xs-12"><!--\n                <div cg-busy="{promise:profileCardBusyPromise,wrapperClass:\'\', templateUrl: \'cgbusy-medium.html\', minDuration:200}" style="position:relative;width: 100%;height: 100%"></div>\n                --><div ng-hide="vm.hideProfileCard"><!--\n                    <div class="well company-top-buttons" ng-show="vm.organisation">\n                        <a ui-sref="profile.contribution.new-company" >\n                            <div class="add-job-well">\n                                <img class="button-logo" src="content/images/add-job.png">\n                                <div class="button-title">\n                                    Ajouter une entreprise\n                                </div>\n                                <div class="company-logo"\n                                     ng-style="{\'background-image\': \'url(\\\'data:\' + vm.organisation.logoContentType + \';base64,\' + vm.organisation.logo }">\n                                    <span class="transparent">.</span>\n                                </div>\n                            </div>\n                        </a>\n                        <a ui-sref="profile.contribution.new-profile">\n                            <div class="add-people-well">\n                                <img class="button-logo" src="content/images/add-people.png">\n                                <div class="button-title">\n                                    Ajouter une personne\n                                </div>\n                                <div class="company-logo"\n                                     ng-style="{\'background-image\': \'url(\\\'data:\' + vm.organisation.logoContentType + \';base64,\' + vm.organisation.logo }">\n                                    <span class="transparent">.</span>\n                                </div>\n                            </div>\n                        </a>\n                    </div>\n                    --><organisation-squares organisation="vm.selectedPosition.organisation" profile="vm.profile" selected-position="vm.selectedPosition"></organisation-squares><organisation-network organisation="vm.selectedPosition.organisation" profile="vm.profile"></organisation-network></div></div><div class="right-addon-container hidden-xs hidden-sm"><div class="right-addon-fixed"><div class="public-profile-card-container" style="min-height: 275px"><!--\n                        <div cg-busy="{promise:profileCardBusyPromise,wrapperClass:\'\', templateUrl: \'cgbusy.html\', minDuration:200}" style="position:relative;width: 100%;height: 100%;z-index: 0;"></div>\n                        --><div ng-hide="vm.hideProfileCard" class="public-profile-card well"><div class="square-picture" ng-show="vm.profile.picture" style="background-image: url(\'data: {{ vm.profile.pictureContentType }};base64,{{ vm.profile.picture }}\')"></div><div class="square-picture" ng-show="!vm.profile.picture" style="background-image: url(\'content/images/no-picture.png\')"></div><div class="levels-container"><span class="level-image level-1" ng-click="vm.updateGrade(1)" ng-class="vm.connexion.grade === 1 ? \'active\' : \'inactive\'"></span> <span class="level-image level-2" ng-click="vm.updateGrade(2)" ng-class="vm.connexion.grade === 2 ? \'active\' : \'inactive\'"></span> <span class="level-image level-3" ng-click="vm.updateGrade(3)" ng-class="vm.connexion.grade === 3 ? \'active\' : \'inactive\'"></span></div><h3><span uib-tooltip="{{vm.clipTooltip}}" clipboard text="vm.fullName" on-copied="vm.copied()">{{ vm.profile.firstName }} {{ vm.profile.lastName }}</span> <a ng-if="vm.profile.userId && vm.profile.userEcId && vm.profile.userEcId === vm.myProfile.userEcId" ui-sref="profile.message-libre({userId: vm.profile.userId})" style="font-size: 14px;margin-left: 3px" uib-tooltip="Envoyer un message"><span style="color:white" class="far fa-envelope"></span> </a><span ng-show="vm.profile.domain === \'linked\' || vm.profile.importId === \'linked\'" uib-tooltip="Voir sur LinkedIn" style="margin-left:4px"><a ng-href="https://www.linkedin.com/search/results/all/?keywords={{vm.profile.firstName}} {{vm.profile.lastName}}" target="_blank" style="color:white"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin {{ vm.profile.equipeCommercialeName? vm.profile.equipeCommercialeName : \'\' }}"></i> </a></span><span ng-show="vm.profile.domain === \'datago\'" style="margin-left:4px"><i class="fal fa-book-open" title="Source : data.gouf.fr"></i> </span><span ng-show="vm.profile.domain === \'guidep\'" style="margin-left:4px"><i class="fal fa-file-user" title="Source : Guide du pouvoir"></i> </span><span ng-show="vm.profile.domain === \'legacy\'" style="margin-left:4px"><i class="fal fa-scroll-old" title="Source : Legacy"></i> </span><span ng-show="vm.profile.domain === \'tob\'" style="margin-left:4px"><i class="fal fa-file-check" title="Source : The Official Board"></i></span></h3><p ng-show="vm.selectedPosition.organisation.name"><i class="fal fa-building fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i>{{ vm.selectedPosition.organisation.name }} <span ng-show="vm.selectedPosition.organisation.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin {{ vm.selectedPosition.organisation.equipeCommerciale? vm.selectedPosition.organisation.equipeCommerciale.name : \'\' }}"></i> </span><span ng-show="vm.selectedPosition.organisation.type === \'company\' && vm.selectedPosition.organisation.importId && vm.selectedPosition.organisation.importId !== \'linked\'" style="margin-left:4px"><i class="fal fa-file-check" title="Source : The Official Board"></i> </span><span ng-show="vm.selectedPosition.organisation.importId === \'guidep\'" style="margin-left:4px"><i class="fal fa-file-user" title="Source : Guide du pouvoir"></i> </span><span ng-show="vm.selectedPosition.organisation.importId === \'datago\'" style="margin-left:4px"><i class="fal fa-book-open" title="Source : data.gouf.fr"></i></span></p><p ng-hide="vm.selectedPosition.organisation.name"><i class="fal fa-building fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i><i>Entreprise inconnue</i></p><p ng-show="vm.selectedPosition.title"><i class="fal fa-briefcase fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i>{{ vm.selectedPosition.title }} <span ng-show="vm.selectedPosition.importId === \'linked\'" style="margin-left:4px"><i class="fab fa-linkedin" title="Source : Base cliente Linkedin {{ vm.selectedPosition.organisation.equipeCommerciale? vm.selectedPosition.organisation.equipeCommerciale.name : \'\' }}"></i> </span><span ng-show="vm.selectedPosition.importId === \'datago\'" style="margin-left:4px"><i class="fal fa-book-open" title="Source : data.gouf.fr"></i> </span><span ng-show="vm.selectedPosition.importId === \'guidep\'" style="margin-left:4px"><i class="fal fa-file-user" title="Source : Guide du pouvoir"></i> </span><span ng-show="vm.selectedPosition.importId === \'legacy\'" style="margin-left:4px"><i class="fal fa-scroll-old" title="Source : Legacy"></i> </span><span ng-show="vm.selectedPosition.organisation.type === \'company\' && vm.selectedPosition.importId && vm.selectedPosition.importId !== \'linked\'" style="margin-left:4px"><i class="fal fa-file-check" title="Source : The Official Board"></i></span></p><p ng-hide="vm.selectedPosition.title"><i class="fal fa-briefcase fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i><i>Poste inconnu</i></p><p ng-show="vm.selectedPosition.superior"><i class="fal fa-user-tie fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i>{{ vm.selectedPosition.superior.firstName }} {{ vm.selectedPosition.superior.lastName }}</p><p ng-show="vm.profile.website"><i class="fal fa-globe fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i> <a href="{{ vm.profile.website }}" style="color:white" target="_blank">Biographie The Official Board</a></p><p ng-show="vm.websiteGuidePouvoir"><i class="fal fa-globe fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i> <a href="{{ vm.websiteGuidePouvoir }}" style="color:white" target="_blank">Biographie Guide du Pouvoir</a></p><p ng-show="vm.websiteDataGouv(vm.selectedPosition)"><i class="fal fa-globe fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i> <a href="{{vm.websiteDataGouv(vm.selectedPosition) }}" style="color:white" target="_blank">Fichier opensource data.gouv.fr</a></p><p ng-show="vm.websiteForOrganisation(vm.selectedPosition)"><span ng-show="vm.selectedPosition.organisation.type === \'collectivity\'"><i class="fal fa-globe fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i> <a href="{{ vm.websiteForOrganisation(vm.selectedPosition) }}" style="color:white" target="_blank">Site web</a></span></p><p ng-show="vm.websiteForOrganisation(vm.selectedPosition)"><span ng-show="vm.selectedPosition.organisation.type === \'company\'"><i class="fal fa-globe fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i> <a href="{{ vm.websiteForOrganisation(vm.selectedPosition) }}" style="color:white" target="_blank">Organigramme The Official Board</a></span></p><p><i class="fal fa-globe fa-2x fa-fw" style="padding-right:8px;vertical-align: middle"></i> <a ng-href="https://www.linkedin.com/search/results/all/?keywords={{vm.profile.firstName}} {{vm.profile.lastName}}" target="_blank" style="color:white">Voir sur LinkedIn</a></p><style>.buttonEdit,  .buttonEdit:focus {\n                                    color: white;\n                                    margin-right: 6px;\n                                    margin-bottom: -12px;\n                               }\n                               .buttonEdit:hover{\n                                color: #e6e6e6;\n                               }\n                               .buttonEditDisabled {\n                                opacity: 0.3;\n                                cursor: not-allowed;\n                               }</style><a ng-show="!vm.profile.mine && !vm.profile.myContribution" class="float-right buttonEdit" ui-sref="profile.rectify({id: vm.profile.id})" uib-tooltip="Corriger"><i class="fal fa-comment-edit fa-2x"></i></a> <a ng-show="!vm.profile.hasModeration  && (vm.isAdmin() || vm.profile.mine || vm.profile.myContribution)" class="float-right buttonEdit" ui-sref="profile.contribution.edit-profile({id: vm.profile.id})" uib-tooltip="Modifier"><i class="fal fa-edit fa-2x"></i></a> <a ng-show="vm.profile.hasModeration" title="Modification impossible car ce profile est en cours de mod\xE9ration" class="float-right buttonEdit buttonEditDisabled"><i class="fal fa-edit fa-2x"></i></a></div></div><div class="right-addon-container hidden-xs hidden-sm" style="padding-left: 3px;  padding-right: 10px"><div ng-show="vm.profile.hasModeration" class="alert alert-warning"><i>Ce profile est en cours de mod\xE9ration.</i></div></div><copyright-addon></copyright-addon></div></div></div></div></div>');}]);})();